(function() {

/* eslint angular/window-service: 0 */
/* eslint angular/di: 0 */
nowStage = (window.location.hostname.match(/local\./i) ? 'local' : (window.location.hostname.match(/staging\./i) ? 'staging' : (window.location.hostname.match(/\.abnahme\./i) ? 'abnahme' : 'production')));
nowIsProduction = (nowStage === 'production');
nowIsStaging = (nowStage === 'staging' || nowStage === 'abnahme');

})();

(function() {

/* eslint angular/window-service: 0 */
if(window.Bugsnag){
    if (!Bugsnag) {
        var Bugsnag = {};
    }
    window.Bugsnag.releaseStage = nowStage;
    window.Bugsnag.notifyReleaseStages = ['abnahme', 'staging', 'production'];
    window.Bugsnag.appVersion = '1.4.0';
    window.Bugsnag.endpoint = 'https://notify-bugs-fra1.rtl.de/js';
    window.Bugsnag.filter = 'tvnow.de|tvnow.at|tvnow.ch|static-fra.de|tvnowstatic-a.akamaihd.net';
    window.Bugsnag.blacklist = 'static-fra.de/ip|tvnowstatic-a.akamaihd.net/ip';
    window.Bugsnag.beforeNotify = function (payload) {

        if (typeof payload.file !== 'undefined') {
            var match = payload.file.match(new RegExp(window.Bugsnag.blacklist, 'i'));
            if (!!(match && match[0].length > 0)) {
                return false;
            }
        }

        // Only notify Scripts by RTL Interactive
        if (typeof payload.file !== 'undefined') {
            var match = payload.file.match(new RegExp(window.Bugsnag.filter, 'i'));
            return !!(match && match[0].length > 0);
        }
        console.log("Bugsnag - Drop Exception", payload);
        return false;
    };
}


})();

(function() {



})();

(function() {

/* eslint angular/window-service: 0 */
window.ageCheck = {
    'allow12': false,
    'allow16': false,
    'allow18': false,
};
(function () {
    var checks = [12, 16, 18];
    for (var key in checks) {
        var age = checks[key];

    }
}());

})();

(function() {



})();

(function() {

angular.module('NowApi', []);

})();

(function() {

/*! 
 *  v2.2.0
 * Copyright (c) 2018 Patric Wilms - patric.wilms@rtl.de
 * License: RTLi :)
 */

angular.module("NowApi").factory("backend",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.accountCancelationReasons=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/cancelationreasons";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.accountDeletionReasons=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/deletionreasons";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveUserByEmailByGet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/email";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.value&&(h.value=c.value),void 0===c.value)return d.reject(new Error("Missing required query parameter: value")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.loginByTokenByGet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/login";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.recoverByGet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/recover";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.email&&(h.email=c.email),void 0===c.email)return d.reject(new Error("Missing required query parameter: email")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.registrationmailByGet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/registrationmail";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.list=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.remove=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/delete/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.deletionReversal=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/deletionreversal/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveUserByEmailByPost=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/email";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveFskVerification=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/fskVerification";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.login=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/login";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.loginByGigyaToken=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/loginByGigyaToken";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.loginByToken=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/loginByToken";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.reAuth=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/reauth";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.recoverByPost=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/recover";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.register=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/register";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.registrationmailByPost=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/registrationmail";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.changePassword=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/changepassword/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.changePasswordWithToken=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/changepasswordtoken";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateFskVerification=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/fskVerification/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.update=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/backend/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("channels",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveChannels=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveChannelsByStation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/station/{station}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{station}",c.station),void 0===c.station)return d.reject(new Error("Missing required path parameter: station")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveChannelById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveChannelEntriesByChannelId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/{id}/entries";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMoviesByChannelId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/{id}/movies";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createChannel=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createChannelEntry=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/entry";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateChannelEntry=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/entry/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateChannel=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),
void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeChannelEntry=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/entry/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeChannel=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/channels/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("container",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveContainers=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/containers";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveContainerById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/containers/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMoviesByContainerId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/containers/{id}/movies";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveContainerCollectionById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/containers/{id}/tree";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("countries",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveCountries=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/countries/{language}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{language}",c.language),void 0===c.language)return d.reject(new Error("Missing required path parameter: language")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("epgs",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveMovies=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/epgs/movies";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveNowAndNextMovies=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/epgs/movies/nownext";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveEpgMovieById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/epgs/movies/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveNowAndNextMoviesByStation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/epgs/movies/{station}/nownext";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{station}",c.station),void 0!==c.dateTime&&(h.dateTime=c.dateTime),void 0!==c.fields&&(h.fields=c.fields),void 0!==c.limit&&(h.limit=c.limit),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMoviesByDate=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/epgs/movies/{station}/{date}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{station}",c.station),f=f.replace("{date}",c.date),void 0!==c.fields&&(h.fields=c.fields),void 0!==c.order&&(h.order=c.order),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("format",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieve=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFormatByFlowId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/flow/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.genre=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/genre/{genre}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{genre}",c.genre),void 0===c.genre)return d.reject(new Error("Missing required path parameter: genre")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFormatPaymentTeaserById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/paymentteaser/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.search=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/search";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.query&&(h.query=c.query),void 0===c.query)return d.reject(new Error("Missing required query parameter: query")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.searchGenre=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/search/genre/{genre}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{genre}",c.genre),void 0===c.genre)return d.reject(new Error("Missing required path parameter: genre")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.searchTag=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/search/tag/{tag}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{tag}",c.tag),void 0===c.tag)return d.reject(new Error("Missing required path parameter: tag")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFormatBySeoLink=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/seo";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.name&&(h.name=c.name),void 0!==c.station&&(h.station=c.station),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFormatsByTagId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/tag/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFormatById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.moviesNowNext=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}/movies/nownext";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.type&&(h.type=c.type),void 0===c.type)return d.reject(new Error("Missing required query parameter: type")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveAnnualNavigation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}/navigation";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrievePaymentTeaserByFormatId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}/paymentteaser";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.order&&(h.order=c.order),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.seasons=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}/seasons";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTabsByFormatId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}/tabs";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTabByFormatIdAndSeoHeadline=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}/tabs/{seoHeadline}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(f=f.replace("{seoHeadline}",c.seoHeadline),void 0===c.seoHeadline)return d.reject(new Error("Missing required path parameter: seoHeadline")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){
d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.create=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createFormatWithFlowId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/flow/{flowId}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{flowId}",c.flowId),void 0===c.flowId)return d.reject(new Error("Missing required path parameter: flowId")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.purge=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{formatId}/ais/purge";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{formatId}",c.formatId),void 0===c.formatId)return d.reject(new Error("Missing required path parameter: formatId")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.update=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formats/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("formatlists",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveFormatTabs=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFormatTabById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{id}",c.id),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMoviesByFormatListId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/{id}/movies";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{id}",c.id),void 0!==c.fields&&(h.fields=c.fields),void 0!==c.moviePage&&(h.moviePage=c.moviePage),void 0!==c.movieMaxPerPage&&(h.movieMaxPerPage=c.movieMaxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewFormatTab=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/tab";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewFormatTabPage=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/tabpage";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateFormatTab=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/tab/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateFormatTabPage=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/tabpage";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeFormatTab=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/tab/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeFormatTabPage=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/formatlists/tabpage/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("helpcenter",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveArticles=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveLabels=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/labels";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveLabelById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/labels/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveArticlesBySearch=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/{category}/search/{terms}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{category}",c.category),void 0===c.category)return d.reject(new Error("Missing required path parameter: category")),d.promise;if(f=f.replace("{terms}",c.terms),void 0===c.terms)return d.reject(new Error("Missing required path parameter: terms")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveArticlesById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveLabelsByArticleId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/{id}/labels";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createLabelByArticleId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/{id}/labels";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeLabel=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/helpcenter/articles/{articleId}/labels{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{articleId}",c.articleId),void 0===c.articleId)return d.reject(new Error("Missing required path parameter: articleId")),d.promise;if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("localizations",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveRegions=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/regions";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveRegionsByStationAndCountry=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/regions/{station}/{country}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{station}",c.station),f=f.replace("{country}",c.country),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTags=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/tags";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTranslations=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/translations";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewRegion=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/regions";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewTag=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/tags";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewTranslation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/translations";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateRegion=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/regions/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateTag=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/tags/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),
void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateTranslation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/translations/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeRegion=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/regions/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeTag=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/tags/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeTranslation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/localizations/translations/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("movie",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieve=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMoviesByFormatTabId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/formatTabPage/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{id}",c.id),void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.genre=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/genre/{genre}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{genre}",c.genre),void 0===c.genre)return d.reject(new Error("Missing required path parameter: genre")),d.promise;void 0!==c.station&&(h.station=c.station),void 0!==c.categories&&(h.categories=c.categories),void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveHdsManifest=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/hdsmanifest/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.userId&&(h.userId=c.userId),void 0===c.userId)return d.reject(new Error("Missing required query parameter: userId")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveHlsManifest=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/hlsmanifest/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.userId&&(h.userId=c.userId),void 0===c.userId)return d.reject(new Error("Missing required query parameter: userId")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.picture=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/picture/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveRecommendations=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/recommendations";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.ids&&(h.ids=c.ids),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.search=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/search";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.query&&(h.query=c.query),void 0===c.query)return d.reject(new Error("Missing required query parameter: query")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMovieStatistics=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/statistics";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMovieBySeoLink=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{formatSeoLink}/{movieSeoLink}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{formatSeoLink}",c.formatSeoLink),f=f.replace("{movieSeoLink}",c.movieSeoLink),void 0!==c.station&&(h.station=c.station),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.list=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.context=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/context";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.previousCount&&(h.previousCount=c.previousCount),void 0!==c.nextCount&&(h.nextCount=c.nextCount),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.hasValidLicence=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/licence";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{id}",c.id),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.manifestHds=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/manifest-hds";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.manifestHls=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/manifest-hls";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.next=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/next";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.payments=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/payments";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.pictures=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/pictures";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMovieStatistic=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/statistic/{userId}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;f=f.replace("{userId}",c.userId),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.trailers=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/trailers";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.videos=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/videos";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.filter&&(h.filter=c.filter),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.create=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.movie&&(g=c.movie),void 0===c.movie)return d.reject(new Error("Missing required body parameter: movie")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateMovieViews=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/view";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.licenseValidationCall=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/licence";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{id}",c.id),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.manifestHdsPost=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/manifest-hds";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.manifestHlsPost=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/manifest-hls";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,
l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveOrUpdateMovieStatistic=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}/statistic";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.purge=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{movieId}/ais/purge";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{movieId}",c.movieId),void 0===c.movieId)return d.reject(new Error("Missing required path parameter: movieId")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.update=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/movies/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{id}",c.id),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("myprogramme",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveFormatsByUserId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/myprogramme/formats/{userId}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{userId}",c.userId),void 0===c.userId)return d.reject(new Error("Missing required path parameter: userId")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createFormatEntry=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/myprogramme/formats/newitem";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeFormatEntry=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/myprogramme/formats/delete";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.userId&&(h.userId=c.userId),void 0===c.userId)return d.reject(new Error("Missing required query parameter: userId")),d.promise;if(void 0!==c.formatId&&(h.formatId=c.formatId),void 0===c.formatId)return d.reject(new Error("Missing required query parameter: formatId")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("page",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrievePages=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.redirect=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/redirect";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.url&&(h.url=c.url),void 0===c.url)return d.reject(new Error("Missing required query parameter: url")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.sitemap=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/sitemap";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrievePageById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrievePagesByStationAndPath=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{station}/{pagepath}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};f=f.replace("{station}",c.station),f=f.replace("{pagepath}",c.pagepath),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewPage=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.saveNewPageByStationAndPagePath=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{station}/{pagepath}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{station}",c.station),void 0===c.station)return d.reject(new Error("Missing required path parameter: station")),d.promise;if(f=f.replace("{pagepath}",c.pagepath),void 0===c.pagepath)return d.reject(new Error("Missing required path parameter: pagepath")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updatePage=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updatePageByStationAndPagePath=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{station}/{pagepath}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{station}",c.station),void 0===c.station)return d.reject(new Error("Missing required path parameter: station")),d.promise;if(f=f.replace("{pagepath}",c.pagepath),void 0===c.pagepath)return d.reject(new Error("Missing required path parameter: pagepath")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removePage=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removePageByStationAndPagePath=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/pages/{station}/{pagepath}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{station}",c.station),void 0===c.station)return d.reject(new Error("Missing required path parameter: station")),d.promise;if(f=f.replace("{pagepath}",c.pagepath),void 0===c.pagepath)return d.reject(new Error("Missing required path parameter: pagepath")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("paymentproviders",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieve=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/paymentproviders";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.list=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/paymentproviders/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.cancelRecurring=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/paymentproviders/{id}/cancelRecurring";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.startTransaction=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/paymentproviders/{id}/startTransaction";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateRecurring=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/paymentproviders/{id}/updateRecurring";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.verifyTransaction=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/paymentproviders/{id}/verifyTransaction";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("playoutelements",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveAdvertisements=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/playoutelements";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("tags",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieve=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/tags";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTagByKey=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/tags/{key}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{key}",c.key),void 0===c.key)return d.reject(new Error("Missing required path parameter: key")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createTag=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/tags";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateTag=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/tags/{key}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));
var g,h={},i={},j={};if(f=f.replace("{key}",c.key),void 0===c.key)return d.reject(new Error("Missing required path parameter: key")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeTagByKey=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/tags/{key}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{key}",c.key),void 0===c.key)return d.reject(new Error("Missing required path parameter: key")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("teasers",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieve=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTeaserByRefId=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers/ref/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTeaserById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveRecommendations=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers/{station}/recommendation";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{station}",c.station),void 0===c.station)return d.reject(new Error("Missing required path parameter: station")),d.promise;if(void 0!==c.recommendationItems&&(h.recommendationItems=c.recommendationItems),void 0===c.recommendationItems)return d.reject(new Error("Missing required query parameter: recommendationItems")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createTeaser=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateSorting=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers/sort";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.ids&&(g=c.ids),void 0===c.ids)return d.reject(new Error("Missing required body parameter: ids")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateTeaser=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeTeaserSetInformation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasers/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("teasersets",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieveTeaserSets=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTeaserSetsByPageStation=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets/station/{station}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{station}",c.station),void 0===c.station)return d.reject(new Error("Missing required path parameter: station")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTeaserSetById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveTeaserSetPreviewById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets/{id}/preview";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.automaticType&&(h.automaticType=c.automaticType),void 0!==c.automaticTypeConfiguration&&(h.automaticTypeConfiguration=c.automaticTypeConfiguration),void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.createTeaserSet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateSorting=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets/sort";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updateTeaserSet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.platform&&(h.platform=c.platform),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeTeaserSet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/teasersets/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]),angular.module("NowApi").factory("users",["$q","$http","$rootScope",function(a,b,c){"use strict";var d=function(){function d(a,b){if("string"!=typeof a)throw new Error("Domain parameter must be specified as a string.");this.domain=a,this.replaceversion=b}return d.prototype.$on=function(a,b,c){var d;return d=this.domain+b,a.$on(d,function(){c()}),this},d.prototype.$broadcast=function(a){var b;return b=this.domain+a,c.$broadcast(b),this},d.prototype.retrieve=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveUserByEmailByGet=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/email";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.email&&(h.email=c.email),void 0===c.email)return d.reject(new Error("Missing required query parameter: email")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.list=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.devices=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/devices";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveFavorites=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/favorite";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveUserFskVerification=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/fskVerification";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveMovieStatistics=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/movieStatistics";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.order&&(h.order=c.order),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.optOut=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/optout/{type}/{action}/{hash}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(f=f.replace("{type}",c.type),void 0===c.type)return d.reject(new Error("Missing required path parameter: type")),d.promise;if(f=f.replace("{action}",c.action),void 0===c.action)return d.reject(new Error("Missing required path parameter: action")),d.promise;if(f=f.replace("{hash}",c.hash),void 0===c.hash)return d.reject(new Error("Missing required path parameter: hash")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.paydata=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/paydata";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.purchases_=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/purchases";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.purchases=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/transactions";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.fields&&(h.fields=c.fields),void 0!==c.filter&&(h.filter=c.filter),void 0!==c.page&&(h.page=c.page),void 0!==c.maxPerPage&&(h.maxPerPage=c.maxPerPage),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"GET",
url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveUserById=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.fields&&(h.fields=c.fields),void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.retrieveUserByEmailByPost=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/email";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.checkAuthenticationUserFskVerification=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/fskVerification";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.optOutByToken=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/optout/{token}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{token}",c.token),void 0===c.token)return d.reject(new Error("Missing required path parameter: token")),d.promise;if(void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),void 0===c.REQUEST_BODY)return d.reject(new Error("Missing required body parameter: REQUEST_BODY")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeStatisticsAndFavorites=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/deleteUsageData";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.addFavorite=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/favorite";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.hideAllMovieStatistics=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/movieStatistics/hideAll";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"POST",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updatePaydata=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/paydata";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.updatePrivacy=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/privacy";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;void 0!==c.REQUEST_BODY&&(g=c.REQUEST_BODY),c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"PUT",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeAllFavorites=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/allFavorites";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.favoriteType&&(h.favoriteType=c.favoriteType),void 0===c.favoriteType)return d.reject(new Error("Missing required query parameter: favoriteType")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeAllDevices=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/devices";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeDevice=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/devices/{deviceId}";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(f=f.replace("{deviceId}",c.deviceId),void 0===c.deviceId)return d.reject(new Error("Missing required path parameter: deviceId")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d.prototype.removeFavorite=function(c){void 0===c&&(c={});var d=a.defer(),e=this.domain,f="/v3/users/{id}/favorite";"string"==typeof this.replaceversion&&(f=f.replace("v3/",this.replaceversion));var g,h={},i={},j={};if(f=f.replace("{id}",c.id),void 0===c.id)return d.reject(new Error("Missing required path parameter: id")),d.promise;if(void 0!==c.favoriteId&&(h.favoriteId=c.favoriteId),void 0===c.favoriteId)return d.reject(new Error("Missing required query parameter: favoriteId")),d.promise;if(void 0!==c.favoriteType&&(h.favoriteType=c.favoriteType),void 0===c.favoriteType)return d.reject(new Error("Missing required query parameter: favoriteType")),d.promise;c.$queryParameters&&Object.keys(c.$queryParameters).forEach(function(a){var b=c.$queryParameters[a];h[a]=b});var k=e+f,l={timeout:c.$timeout,method:"DELETE",url:k,params:h,data:g,headers:i};return Object.keys(j).length>0&&(l.data=j,l.headers["Content-Type"]="application/x-www-form-urlencoded",l.transformRequest=function(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}),b(l).then(function(a){d.resolve(a.data),void 0!==c.$cache&&c.$cache.put(k,data,c.$cacheItemOpts?c.$cacheItemOpts:{})})["catch"](function(a){d.reject({status:a.status,headers:a.headers,config:a.config,body:a.data})}),d.promise},d}();return d}]);
//# sourceMappingURL=api.min.js.map

})();

(function() {



})();

(function() {

/**
 * @ngdoc service
 * @name NowApi.NowApi
 * @description
 * Factory for access api
 */

angular.module('NowApi')
    .factory('NowApi', NowApi);

NowApi.$inject = ['AppConfig', 'NowConfig', 'STAGE', 'format', 'movie', 'backend', 'helpcenter', 'container', 'teasersets', 'teasers', 'formatlists', 'page', 'localizations', 'paymentproviders', 'myprogramme', 'epgs', 'channels', 'playoutelements', 'users', 'tags'];

/**
 *
 * @param AppConfig
 * @param NowConfig
 * @param STAGE
 * @param {NowApi.format} format
 * @param {NowApi.movie} movie
 * @param backend
 * @param helpcenter
 * @param container
 * @param teasersets
 * @param teasers
 * @param formatlists
 * @param page
 * @param localizations
 * @param paymentproviders
 * @param myprogramme
 * @param epgs
 * @param channels
 * @param playoutelements
 * @param users
 * @returns {{getMovie: NowApi.NowApi.getMovie, getFormat: getFormat, getBackend: getBackend, getHelpcenter: getHelpcenter, getContainer: getContainer, getTeasersets: getTeasersets, getTeasers: getTeasers, getFormatlists: getFormatlists, getPage: getPage, getLocalizations: getLocalizations, getPaymentProviders: getPaymentProviders, getMyProgramme: getMyProgramme, getChannels: getChannels, getEpgs: getEpgs, getAdvertisements: getAdvertisements, getUsers: getUsers}}
 * @constructor
 */
function NowApi(AppConfig, NowConfig, STAGE, format, movie, backend, helpcenter, container, teasersets, teasers, formatlists, page, localizations, paymentproviders, myprogramme, epgs, channels, playoutelements, users, tags) {
    var domain = AppConfig.api;
    return {
        getMovie: getMovie,
        getFormat: getFormat,
        getBackend: getBackend,
        getHelpcenter: getHelpcenter,
        getContainer: getContainer,
        getTeasersets: getTeasersets,
        getTeasers: getTeasers,
        getFormatlists: getFormatlists,
        getPage: getPage,
        getLocalizations: getLocalizations,
        getPaymentProviders: getPaymentProviders,
        getMyProgramme: getMyProgramme,
        getChannels: getChannels,
        getEpgs: getEpgs,
        getPlayoutelements: getPlayoutelements,
        getUsers: getUsers,
        getTags: getTags

    };


    /**
     *
     * @returns {movie}
     */
    function getMovie() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.movie.useversion', STAGE.stage)) {
            return new movie(AppConfig.apigw, '');
        }
        return new movie(domain);
    }


    /**
     *
     * @returns {helpcenter}
     */
    function getHelpcenter() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.helpcenter.useversion', STAGE.stage)) {
            return new helpcenter(AppConfig.apigw, '');
        }
        return new helpcenter(domain);
    }

    /**
     *
     * @returns {format}
     */
    function getFormat() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.format.useversion', STAGE.stage)) {
            return new format(AppConfig.apigw, '');
        }
        return new format(domain);
    }

    /**
     *
     * @returns {backend}
     */
    function getBackend() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.backend.useversion', STAGE.stage)) {
            return new backend(AppConfig.apigw, '');
        }
        return new backend(domain);
    }

    /**
     *
     * @returns {container}
     */
    function getContainer() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.container.useversion', STAGE.stage)) {
            return new container(AppConfig.apigw, '');
        }
        return new container(domain);
    }


    /**
     *
     * @returns {teasers}
     */
    function getTeasers() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.teasers.useversion', STAGE.stage)) {
            return new teasers(AppConfig.apigw, '');
        }
        return new teasers(domain);
    }

    /**
     *
     * @returns {teasersets}
     */
    function getTeasersets() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.teasersets.useversion', STAGE.stage)) {
            return new teasersets(AppConfig.apigw, '');
        }
        return new teasersets(domain);
    }

    /**
     *
     * @returns {formatlists}
     */
    function getFormatlists() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.formatlists.useversion', STAGE.stage)) {
            return new formatlists(AppConfig.apigw, '');
        }
        return new formatlists(domain);
    }

    /**
     *
     * @returns {page}
     */
    function getPage() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.pages.useversion', STAGE.stage)) {
            return new page(AppConfig.apigw, '');
        }
        return new page(domain);
    }


    /**
     *
     * @returns {localizations}
     */
    function getLocalizations() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.localizations.useversion', STAGE.stage)) {
            return new localizations(AppConfig.apigw, '');
        }
        return new localizations(domain);
    }

    /**
     *
     * @returns {paymentproviders}
     */
    function getPaymentProviders() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.paymentproviders.useversion', STAGE.stage)) {
            return new paymentproviders(AppConfig.apigw, '');
        }
        return new paymentproviders(domain);
    }

    /**
     *
     * @returns {myprogramme}
     */
    function getMyProgramme() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.myprogramme.useversion', STAGE.stage)) {
            return new myprogramme(AppConfig.apigw, '');
        }
        return new myprogramme(domain);
    }

    /**
     *
     * @returns {epgs}
     */
    function getEpgs() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.epgs.useversion', STAGE.stage)) {
            return new epgs(AppConfig.apigw, '');
        }
        return new epgs(domain);
    }

    /**
     *
     * @returns {channels}
     */
    function getChannels() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.channels.useversion', STAGE.stage)) {
            return new channels(AppConfig.apigw, '');
        }
        return new channels(domain);
    }

    /**
     *
     * @returns {playoutelements}
     */
    function getPlayoutelements() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.playoutelements.useversion', STAGE.stage)) {
            return new playoutelements(AppConfig.apigw, '');
        }
        return new playoutelements(domain);
    }

    /**
     *
     * @returns {advertisements}
     */
    function getUsers() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.users.useversion', STAGE.stage)) {
            return new users(AppConfig.apigw, '');
        }
        return new users(domain);
    }

    /**
     *
     * @returns {tags}
     */
    function getTags() {
        if (!STAGE.editMode && NowConfig.checkSettingValue('v4', 'api.tags.useversion', STAGE.stage)) {
            return new tags(AppConfig.apigw, '');
        }
        return new tags(domain);
    }
}

})();

(function() {



})();

(function() {

angular.module('NowShared', ['ngRoute', 'NowStation', 'angular.filter', 'angularMoment', 'NowAccount']);

})();

(function() {

'use strict';

/**
 * @ngdoc service
 * @name NowShared.AutoimgUrlHelper
 * @description
 * Service for concatenating autoimg urls
 */

angular.module('NowShared')
    .factory('AutoimgUrlHelper', AutoimgUrlHelper);

function AutoimgUrlHelper() {
    this.station = 'rtl';
    this.movieid = 0;
    this.formatid = 0;
    this.epgid = 0;
    this.formattype = '';
    this.imagesize = '300x169';
    this.service = 'tvnow';
    this.hash = '';
    this.position = null;

    this.setParams = setParams;
    this.getAutoimgUrl = getAutoimgUrl;

    return this;

    /**
     * @ngdoc
     * @name NowShared.AutoimgUrlHelper#setParams
     * @methodOf NowShared.AutoimgUrlHelper
     *
     * @description
     * set params for generating url
     * @example
     * AutoimgUrlHelper.setParams('rtl',1123)
     * @param {number=} movieid Id of movie
     * @param {number=} formatid Id of format
     * @param {string=}  formattype  default_image_169_logo or default_image_169
     * @param {string=} imagesize size of the image like 300x169
     * @param {string=} hash Picture upload hash
     * @param {number=} epgid Id of epg entry
     * @param {number=} Position Id of epg entry
     */
    function setParams(movieid, formatid, formattype, imagesize, hash, epgid, position) {
        this.movieid = movieid;
        this.formatid = formatid;
        this.epgid = epgid;
        this.formattype = formattype;
        this.imagesize = imagesize;
        this.hash = hash ? hash : '';
        this.position = position;
    }

    /**
     * @ngdoc
     * @name NowShared.AutoimgUrlHelper#getAutoimgUrl
     * @methodOf NowShared.AutoimgUrlHelper
     *
     * @description
     * returns the autoimg url based of the set parameters
     *
     * @returns {string} url
     */
    function getAutoimgUrl() {
        if (this.epgid > 0) {
            return ('//aistvnow-a.akamaihd.net/' + this.service + '/epg/' + this.epgid + '/' + this.imagesize + '/epg.jpg');
        } else if (this.movieid > 0 && angular.isString(this.position)) {
            return ('//aistvnow-a.akamaihd.net/' + this.service + '/movie/' + this.movieid + '_' + this.position + '/' + this.imagesize + '/title.jpg');
        } else if (this.movieid > 0) {
            return ('//aistvnow-a.akamaihd.net/' + this.service + '/movie/' + this.movieid + '/' + this.imagesize + '/title.jpg');
        } else if (this.hash !== '') {
            return ('//aistvnow-a.akamaihd.net/' + this.service + '/cms/' + this.hash + '/' + this.imagesize + '/image2.jpg');
        } else {
            var formattype = this.formattype ? '_' + this.formattype : '';
            return ('//aistvnow-a.akamaihd.net/' + this.service + '/format/' + this.formatid + formattype + '/' + this.imagesize + '/format.jpg');
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('BreadcrumbHelper', BreadcrumbHelper);

BreadcrumbHelper.$inject = ['StationMonitor'];

/**
 *
 * @constructor
 */
function BreadcrumbHelper(StationMonitor) {
    var self = this;

    self.items = [];

    self.resetItems = resetItems;
    self.setItems = setItems;
    self.getBreadcrumbItems = getBreadcrumbItems;

    return self;

    function getBreadcrumbItems() {
        return self.items;
    }

    function setItems(items, suppressStation) {
        if (!angular.isArray(items)) {
            items = [items];
        }

        self.resetItems(suppressStation);

        angular.forEach(items, function (item) {
            var last = self.items[self.items.length - 1];
            if (last.url.slice(-1) !== '/') {
                item.url = last.url + '/' + item.url;
            } else {
                item.url = last.url + item.url;
            }
            self.items.push(item);
        });
    }

    function resetItems(suppressStation) {
        self.items = [
            {
                'url': '/',
                'title': 'TV NOW'
            }
        ];

        if (StationMonitor.getStation()) {
            if (StationMonitor.getStation() !== 'nowtv' && !suppressStation) {
                var brands = {
                    rtl: {title: 'RTL', link: true},
                    superrtl: {title: 'SUPER RTL', link: true},
                    vox: {title: 'VOX', link: true},
                    nowus: {title: 'NOW US', link: true},
                    nitro: {title: 'NITRO', link: true},
                    ntv: {title: 'n-tv', link: true},
                    rtl2: {title: 'RTL II', link: true},
                    rtlplus: {title: 'RTLplus', link: true},
                    toggoplus: {title: 'TOGGO plus', link: false},
                    tvnow: {title: '', link: true},
                    watchbox: {title: 'WATCHBOX', link: true}
                };

                self.items.push({
                    'title': brands[StationMonitor.getStation()].title,
                    'url': (brands[StationMonitor.getStation()].link) ? '/' + StationMonitor.getStation(true) : ''
                });
            }
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .service('NowConfig', NowConfig);

NowConfig.$inject = ['AppConfig', '$log'];

function NowConfig(AppConfig, $log) {
    var self = this;

    self.settings = AppConfig.settings;

    self.getSetting = getSetting;
    self.checkSettingValue = checkSettingValue;

    return self;

    function getSetting(key, env, station) {
        var parts = key.split('.'),
            undef = false;
        if (env) {
            parts.unshift(env);
        }
        if (station) {
            parts.unshift(station);
        } else {
            parts.unshift('nowtv');
        }
        var confObj = angular.copy(self.settings);
        angular.forEach(parts, function (part) {
            if (angular.isDefined(confObj[part])) {
                confObj = confObj[part]
            } else {
                $log.debug('Try to get undefined setting - ' + parts.join('.'));
                undef = true;
            }
        });

        return (undef) ? undefined : confObj;
    }

    function checkSettingValue(value, key, env, station) {
        var setting = self.getSetting(key, env, station);

        return (setting && setting === value);
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .service('ContentblockerService', ContentblockerService);

ContentblockerService.$inject = ['AppConfig', 'STAGE', '$log', '$route', '$window', 'Accounting', '$q', '$rootScope'];

function ContentblockerService(AppConfig, STAGE, $log, $route, $window, Accounting, $q, $rootScope) {
    var self = this;

    self.block = null;
    self.blockDetectionDone = false;
    self.initialblock = null;

    self.setBlock = setBlock;
    self.getBlock = getBlock;
    self.getAbc = getAbc;
    self.initContentBlocker = initContentBlocker;

    initEventhandler();

    return self;

    function initEventhandler() {
        var ivwReady = $rootScope.$on('ivw::ready', function (event, szm) {
            $log.debug('initContentBlocker after ivw::ready');
            self.initContentBlocker(szm.ivw).then(
                function(){
                    $log.debug("initContentBlocker after ivw::ready --> done")
                },
                function(){
                    $log.debug("initContentBlocker after ivw::ready --> failed")
                }
            );
        });
        $rootScope.$on('$destroy', ivwReady);
    }

    function initContentBlocker(ivwTag, doNotTrack, retest) {
        var deferred = $q.defer(),
            gaCode = (!doNotTrack) ? 'UA-48267743-21' : null;

        if (AppConfig.settings.nowtv[STAGE.stage].player.abd !== 'true') {
            $log.debug('service_contentblocker ContentblockDetection disabled by config');
            return;
        }

        $log.debug('service_contentblocker initContentBlocker() AppConfig abd=true', {'$route': $route, ivwTag: ivwTag});

        var cbl = new $window.ContentblockDetection;
        $log.debug('service_contentblocker init',cbl);
        cbl.onDetect(function () {
            if (!retest) {
                self.setBlock(true);
            }
            if (!doNotTrack) {
                self.blockDetectionDone = true;
            }

            $log.debug('service_contentblocker adblocker found, self.getBlock says', self.getBlock());
            deferred.resolve();
        }).onFinish(function () {
            if (!retest) {
                self.setBlock(false);
            }
            if (!doNotTrack) {
                self.blockDetectionDone = true;
            }

            $log.debug('service_contentblocker adblocker not found');
            deferred.reject();
            //$route.current.locals.movie.format.szm.player.ivw
        }).run(gaCode, ivwTag, false, retest);

        return deferred.promise;
    }

    function setBlock(newval) {
        self.block = newval;
    }

    function getBlock() {
        $log.debug('service_contentblocker getBlock() requests, status: ', self.block);

        //in den flashvars wünscht der flashplayer sich 1/0
        if (AppConfig.settings.nowtv[STAGE.stage].player.abdTransmit !== 'true') {
            $log.debug('service_contentblocker getBlock() not allowed to block');
            return 0;
        }

        if (self.block !== null) {
            return (self.block) ? 1 : 0;
        }

        //if we do not know the status yet, initialize contentblocker.
        self.initContentBlocker(null, true).then(
            function () {
                return 1;
            },
            function () {
                return 0;
            }
        );
    }

    function getAbc(format) {
        retest();
        var abc = !!(self.getBlock() && format.downscaling && !Accounting.isPremiumUser());
        $log.debug('service_contentblocker getAbc() returns ', abc, {format: format, 'Accounting.isPremiumUser()': Accounting.isPremiumUser()});
        return abc;
    }

    function retest() {
        if (self.block === null) {
            $log.debug('service_contentblocker retest() - no last block');
        }

        if (!self.initialblock) {
            //no need for retesting
            //self.initialblock = self.block;

            //because of ie11, wie initiate the cbl another time, to get a tracking result to test against -- otherwise this routine leads to reloads even if adblock stays ON
            self.initContentBlocker(null, true, true).then(
                function () {
                    $log.debug('service_contentblocker retest() - setting self.initialblock to true');
                    self.initialblock = true;
                },
                function () {
                    $log.debug('service_contentblocker retest() - setting self.initialblock to false');
                    self.initialblock = false;
                }
            );

            return;
        }

        //self.initialblock = self.block;

        self.initContentBlocker(null, true, true).then(
            function () {
                if (self.initialblock === false) {
                    $log.debug('service_contentblocker retest() - last block was negative, so adblocker is now present');
                }
            },
            function () {
                if (self.initialblock === true) {
                    $log.debug('service_contentblocker retest() - last block was positive, so adblocker is now gone. initiating reload');
                    location.reload();
                }
            }
        ).catch(function (error) {
            $log.error('error::CONTENTBLOCK init',error);
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('$exceptionHandler', ExceptionHandler);

ExceptionHandler.$inject = ['$log', '$injector', '$window'];

function ExceptionHandler($log, $injector, $window) {
    return ExceptionFunction;

    function ExceptionFunction(exception, cause) {
        var lastRoute = $injector.get('LastRoute').getRouteBeforeLastRoute();

        var lastRouteController = (angular.isDefined(lastRoute.controller)) ? lastRoute.controller.toString() : '(first controller)';
        if ($window.Bugsnag) {
            Bugsnag.metaData = {
                routeInformation: {
                    name: 'Route Information',
                    lastRouteController: lastRouteController
                }
            };
        }



        if ($window.Bugsnag && exception instanceof Error) {
            $log.debug('ExceptionHandler / Bugsnag notifyException', exception, cause, lastRoute, lastRouteController);
            Bugsnag.notifyException(exception, {diagnostics: {cause: cause}});
        } else {
            $log.debug('ExceptionHandler wrong Exception', exception, cause, lastRoute, lastRouteController);
        }

    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .service('GlobalFormatService', GlobalFormatService);

GlobalFormatService.$inject = ['NowApi', '$localStorage', '$q', '$rootScope', '$location', 'moment'];

function GlobalFormatService(NowApi, $localStorage, $q, $rootScope, $location, moment) {
    var self = this,
        page = [],
        formats = [],
        writeLock = [],
        promises = [],
        percent = 0,
        loadInactiveFormats = false,
        storageKey = 'formats',
        storageKeyPrefix = 'gfs_';

    self.getFormats = getFormats;
    self.extractGenres = _extractGenres;
    self.flushCache = flushCache;
    self.percent = percent;

    initService();

    return self;

    function initService() {
        var loadInactiveFormats = $rootScope.$on('gfs::loadInactiveFormats', function () {
            self.flushCache();
            loadInactiveFormats = true;
            $rootScope.loadInactiveFormats = true;
            $rootScope.$broadcast('gfs::reloadFormats');
        });
        $rootScope.$on('$destroy', loadInactiveFormats);

        var reloadByLogin = $rootScope.$on('account::login', function () {
            self.flushCache();
            $rootScope.$broadcast('gfs::reloadFormats');
        });

        $rootScope.$on('$destroy', reloadByLogin);
    }

    function init(sKey) {
        page[sKey] = 1;
        formats[sKey] = [];
        writeLock[sKey] = true;
    }

    function getFormats(key, fields, filter) {
        storageKey = storageKeyPrefix + key;
        if (writeLock[storageKey]) {
            return promises[storageKey];
        }
        init(storageKey);
        if (!loadInactiveFormats) {
            filter['Disabled'] = 0;
        }
        promises[storageKey] = $q(function (resolve, reject) {
            _loadFormatsRecursive(storageKey, fields, filter, function (formats) {
                resolve(formats);
            }, function () {
                reject();
            })
        });

        return promises[storageKey];
    }

    function flushCache() {
        for (var key in $localStorage) {
            if (key.indexOf('gfs_') >= 0) {
                delete $localStorage[key];
            }
        }
    }

    function _loadFormatsRecursive(sKey, fields, filter, success, error) {
        if ($localStorage[sKey] && moment($localStorage[sKey].date).isAfter(moment()) && !$location.search()['resetLocalcache']) {
            writeLock[sKey] = false;
            $rootScope.loadInactiveFormats = $localStorage[sKey].loadInactiveFormats;
            success($localStorage[sKey]);
        } else {
            if ($location.search()['resetLocalcache']) {
                self.flushCache();
                $location.search('resetLocalcache', null);
            }
            NowApi.getFormat().retrieve(
                {
                    'maxPerPage': 500,
                    'fields': fields,
                    'page': page[sKey],
                    'filter': filter
                }
            ).then(function (data) {
                formats[sKey] = formats[sKey].concat(data.items);
                percent = Math.ceil((formats[sKey].length / (data.total / 100)));
                $rootScope.$broadcast('dialogs.wait.progress', {'progress': percent});
                if (formats[sKey].length < data.total) {
                    page[sKey]++;
                    _loadFormatsRecursive(sKey, fields, filter, success, error);
                } else {
                    var newdata = {
                        formats: formats[sKey],
                        genres: _extractGenres(formats[sKey]),
                        date: moment().add(1, 'h'),
                        loadInactiveFormats: loadInactiveFormats
                    };
                    writeLock[sKey] = false;
                    $localStorage[sKey] = newdata;
                    success($localStorage[sKey]);
                }
            }, function () {
                writeLock[sKey] = false;
                error();
            });
        }
    }

    function _extractGenres(formats) {
        var genres = [];
        var returnGenres = {};
        for (var i = 0; i < formats.length; i++) {
            var format = formats[i];
            if (format.genres && format.genres.length > 0) {
                for (var j = 0; j < format.genres.length; j++) {
                    var genre = format.genres[j];
                    if (genres.indexOf(genre) === -1) {
                        genres.push(genre);
                        var uri = genre.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '_');
                        if(uri==='t_gliche_serien'){
                            uri='taegliche_serien';
                        }
                        returnGenres[uri] = {
                            name: genre,
                            uri: uri
                        };
                    }
                }
            }
        }

        return returnGenres;
    }
}


})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('GarbageCollector', GarbageCollector);
function GarbageCollector() {
    var self = this;

    self.domElements = []; //contains all root elements from page
    self.wrapperElements = []; //contains all wrapper elements with special class

    self.domExceptions = [
        {id: 'loading-bar'},
        {id: 'fb-root'},
        {id: 'loading-bar-spinner'}
        //or {class: 'exclude-this-class'}
    ];

    self.setup = setup;
    self.addedToDom = addedToDom;
    self.cleanDom = cleanDom;

    return self;

    /**
     * get all root elements
     * @returns {boolean}
     */
    function setup() {
        var children = $('body').children();
        $.each(children, function (key, val) {
            //$log.debug('GarbageCollector.setup adding child',val);
            self.domElements.push(val);
        });

        var wrapperElements = $('.now-dom-clean-children');
        $.each(wrapperElements, function (key, val) {
            //$log.debug('GarbageCollector.setup adding element',val);
            self.wrapperElements.push(val);
        });

        return true;
    }

    function addedToDom(element) {
        //$log.debug('GarbageCollector.addedToDom adding child',element);
        self.domElements.push(element);
    }

    /**
     * remove all dom root elements that were not part of the dom at the beginning...
     * @returns {boolean}
     */
    function cleanDom() {
        if (!self.domElements.length) {
            self.setup();
            return true;
        }

        var children = $('body').children();
        $.each(children, function (key, val) {
            if (self.domElements.indexOf(val) > -1) {
                //found, keep & do not destroy
                return;
            }

            //check for exceptions
            if (self.domExceptions.length) {
                var thisObject = $(val),
                    matchFound = false;
                //get dom element identifier
                $.each(self.domExceptions, function (key, val) {
                    if (
                        (val.id && thisObject[0].id === val.id) ||
                        (val.class && thisObject[0].classList.indexOf(val.class) > -1)
                    ) {
                        //$log.debug('GarbageCollector.cleanDom EXCLUDING ELEMENT',val,thisObject);
                        matchFound = true;
                        return false;
                    }
                });
                if (matchFound) {
                    return;
                }
            }
            $(val).remove();
        });

         $.each(self.wrapperElements,function(key,val) {
             $(val).children().remove();
         });

        return true;
    }
}

})();

(function() {

/* eslint angular/no-private-call: 0 */
/* eslint angular/on-watch: 0 */
'use strict';

angular
    .module('NowShared')
    .factory('LastRoute', LastRoute);

LastRoute.$inject = ['$rootScope', '$route'];

function LastRoute($rootScope, $route) {
    var self = this,
        lastRoute = {},
        routeBeforeLastRoute = {};

    $rootScope.$on('$routeChangeSuccess', onRouteChangeSuccess);

    self.getLastRoute = getLastRoute;
    self.getRouteBeforeLastRoute = getRouteBeforeLastRoute;
    self.isInitialRoute = isInitialRoute;

    return self;

    function onRouteChangeSuccess() {
        if (lastRoute) {
            angular.copy(lastRoute, routeBeforeLastRoute);
        }

        lastRoute = angular.copy($route.current.$$route, lastRoute);
    }

    function getLastRoute() {
        return lastRoute;
    }

    function getRouteBeforeLastRoute() {
        return routeBeforeLastRoute;
    }

    function isInitialRoute() {
        return angular.toJson(routeBeforeLastRoute) === angular.toJson({});
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('nowlog', nowlog);

nowlog.$inject = ['$log'];

function nowlog($log) {
    var self = this;
    self.log = log;
    self.getLastLog = getLastLog;

    var lastLog;

    return self;
    function log(info) {
        $log.log(info);
        lastLog = info;
    }

    function getLastLog() {
        return lastLog;
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('Metadata', Metadata);

Metadata.$inject = ['AutoimgUrlHelper', '$log', '$location', '$window', 'NowApi', '$q', 'STAGE', 'AppConfig'];

function Metadata(AutoimgUrlHelper, $log, $location, $window, NowApi, $q, STAGE, AppConfig) {
    var title = 'tvnow.de',
        self = this,
        hreflang = [],
        customHeader = [];

    self.getTitle = getTitle;
    self.setTitle = setTitle;
    self.setDescription = setDescription;
    self.setTitleAndMeta = setTitleAndMeta;
    self.setHreflang = setHreflang;
    self.getHreflang = getHreflang;
    self.setOgMovie = setOgMovie;
    self.setOgPage = setOgPage;
    self.setOgFormat = setOgFormat;
    self.setOgFormatTitleAndDescription = setOgFormatTitleAndDescription;
    self.setSeoRedirect = setSeoRedirect;
    self.setSeoStatuscode = setSeoStatuscode;
    self.isSearchEngine = isSearchEngine;
    self.getFullUrl = getFullUrl;
    self.tryGlobalRedirect = tryGlobalRedirect;

    self.setMeta = setMeta;
    self.setOg = setOg;
    self.getHeader = getHeader;
    self.setHeader = setHeader;

    self.getMobileAlt = getMobileAlt;

    self.setMobileAltEnable = setMobileAltEnable;
    self.getMobileAltEnable = getMobileAltEnable;

    self.getCanonical = getCanonical;

    init();

    return self;

    function init() {
        if (isSearchEngine() && $window.isWebview) {
            setSeoRedirect(location.href.replace(/m\.tvnow\.de/, 'www.tvnow.de'));
        }
    }

    function getFullUrl(url) {
        if (url.indexOf('http') !== 0) {
            var slash = (url.charAt(0) === '/') ? '' : '/';

            return 'https://www.tvnow.de' + slash + url;
        }

        return url;
    }

    function tryGlobalRedirect(url) {
        var deferred = $q.defer();
        NowApi
            .getPage()
            .redirect({url: url})
            .then(function (data) {
                $log.debug('tryGlobalRedirect() - redirect to ' + data.redirectUrl);
                self.setSeoRedirect(self.getFullUrl(data.redirectUrl));
                if(isSearchEngine()){
                    $location.path(AppConfig.notFoundPage);
                    return deferred.resolve();
                }
                if(data.redirectUrl.indexOf("http") === 0){
                    document.location.href = data.redirectUrl;
                    return deferred.resolve();
                }
                var slash = (data.redirectUrl.charAt(0) === '/') ? '' : '/';
                $location.path(slash + data.redirectUrl);
                return deferred.resolve();
            }, function () {
                deferred.reject();
            });

        return deferred.promise;
    }

    function getTitle() {
        return title;
    }

    function setTitle(newTitle) {
        title = (newTitle) ? newTitle : 'tvnow.de';

        if ($window.$AC) {
            $window.$AC.titleBackup = newTitle;
        }
    }

    function setDescription(newDescription) {
        newDescription = (newDescription) ? newDescription : '';

        self.setHeader('description', newDescription, true);
    }

    function setTitleAndMeta(title, description, tags, image) {
        if (angular.isUndefined(title) || angular.isUndefined(description)) {
            return;
        }

        self.setTitle(title);
        self.setMeta(description, tags);
        self.setOg({
            title: title,
            description: description,
            image: image
        });
    }

    function setHreflang(uri) {
        var alternateDoms =
            {
                'de-de': 'www.tvnow.de',
                'de-ch': 'www.tvnow.ch',
                'de-at': 'www.tvnow.at',
                'x-default': 'www.tvnow.de'
            };
        for (var key in alternateDoms) {
            if (alternateDoms.hasOwnProperty(key)) {
                hreflang.push({lang: key, url: 'https://' + alternateDoms[key] + uri});
            }
        }
    }

    function setMobileAltEnable(alt) {
        self.mobileAlt = alt;
    }

    function getMobileAltEnable() {
        return self.mobileAlt;
    }

    function getMobileAlt() {
        if (AppConfig.webclient !== "mobile") {
            return "https://mobile.tvnow.de" + $location.path();
        }
        return false;
    }

    function getHreflang() {
        return hreflang;
    }

    function setOgMovie(movie) {
        if (movie && movie.pictures && movie.pictures.default.length > 0) {
            AutoimgUrlHelper.setParams(movie.id, null, null, '720x405');
        } else {
            AutoimgUrlHelper.setParams(null, movie.format.id, null, '720x405');
        }

        var newTitle = movie.title + ' aus ' + movie.format.title + ' online schauen als Stream bei TV NOW';
        self.setTitle(newTitle);
        self.setMeta(movie.articleShort, movie.format.metaTags);
        self.setOg({
            title: newTitle,
            type: (movie.format.categoryId === 'movie') ? 'movie' : 'tv_show',
            description: movie.articleShort,
            image: 'https:' + AutoimgUrlHelper.getAutoimgUrl()
        });
    }

    function setOgPage(page) {
        //$log.debug('page',page);
        self.setMeta(page.metaDescription);
        self.setOg({
            title: page.metaTitle,
            description: page.metaDescription
        });
    }

    function setOgFormat(format) {
        AutoimgUrlHelper.setParams(null, format.id, null, '720x405');

        self.setTitle((format.metaTitle && format.metaTitle.length > 0) ? format.metaTitle : format.title);
        self.setMeta(format.metaDescription, format.metaTags);
        self.setOg({
            title: (format.metaTitle && format.metaTitle.length > 0) ? format.metaTitle : format.title,
            type: (format.categoryId === 'movie') ? 'movie' : 'tv_show',
            description: format.metaDescription,
            image: 'https:' + AutoimgUrlHelper.getAutoimgUrl()
        });
    }

    function setOgFormatTitleAndDescription(seasonTitle, metaDescription) {
        self.setTitle(seasonTitle);
        self.setMeta(metaDescription);
        self.setOg({
            title: seasonTitle,
            description: metaDescription
        });
    }

    /**
     * sets these headers
     * <meta name='prerender-status-code' content='301'>
     * <meta name='prerender-header' content='Location: http://www.example.com'>
     * @param url
     */
    function setSeoRedirect(url) {
        $log.debug('PRERENDER: Setting Status code 301, Redirect URL ' + url + ', source: ', $location.path());
        self.setSeoStatuscode(301);
        self.setHeader('prerender-header', 'Location: ' + url, true);
    }

    /**
     * <meta name='prerender-status-code' content='301'>
     */
    function setSeoStatuscode(code) {
        self.setHeader('prerender-status-code', code, true);
    }

    function isSearchEngine() {
        return $window.nowSEDetected;
    }

    function setMeta(description, tags) {
        tags = (tags) ? tags : '';

        self.setDescription(description);

        if (tags) {
            self.setHeader('keywords', tags);
        }
    }

    function setOg(vars) {
        var url = 'tvnowshare:/' + $window.location.pathname + $window.location.search;
        var appName = 'TV NOW PLUS';

        self.setHeader('al:ios:url', url);
        self.setHeader('al:ios:app_store_id', '1057991212');
        self.setHeader('al:ios:app_name', appName);

        self.setHeader('al:android:url', url);
        self.setHeader('al:android:package', 'de.rtli.tvnow');
        self.setHeader('al:android:app_name', appName);

        self.setHeader('apple-itunes-app', 'app-id=1057991212, app-argument=' + self.getCanonical());

        if (vars.title) {
            self.setHeader('og:title', vars.title);
        }
        if (vars.description) {
            self.setHeader('og:description', vars.description);
        }
        if (vars.type) {
            self.setHeader('og:type', vars.type);
        } else {
            self.setHeader('og:type', 'website');
        }
        if (vars.image) {
            self.setHeader('og:image', vars.image);
        }
    }

    function getHeader() {
        //$log.debug('customHeader,og,og.concat(customHeader)',customHeader,og,og.concat(customHeader));
        return customHeader;
    }

    function getCanonical() {
        if (AppConfig.webclient === "mobile") {
            return "https://www.tvnow.de" + $location.path();
        }
        return false;
    }

    function setHeader(type, content, meta) {
        //check for existing values!
        for (var i = 0; i < customHeader.length; i++) {
            if (customHeader[i].type === type) {
                customHeader[i].content = content;
                customHeader[i].meta = meta;

                return;
            }
        }

        customHeader = customHeader.concat([
            {type: type, content: content, meta: meta}
        ])
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('PageHistory', PageHistory);

PageHistory.$inject = ['$rootScope', '$route', '$log', 'StationMonitor'];

function PageHistory($rootScope, $route, $log, StationMonitor) {
    var self = this;

    self.currentPage = {};
    self.lastPage = {};
    self.latestMovie = {};
    self.hideTeaserset = false;
    self.queuedTeaserset = {};
    self.savedTeaserset = false;

    var routeChange = $rootScope.$on('$routeChangeSuccess', onRouteChangeSuccess);
    $rootScope.$on('$destroy', routeChange);

    self.setPage = setPage;
    self.getCurrentPage = getCurrentPage;
    self.getLastPage = getLastPage;
    self.setMovie = setMovie;
    self.getLatestMovie = getLatestMovie;
    self.queueTeaserset = queueTeaserset;
    self.hideQueuedTeaserset = hideQueuedTeaserset;
    self.saveTeasersetData = saveTeasersetData;
    self.getSavedTeasersetData = getSavedTeasersetData;

    return self;

    function setPage(pagetype, additionalData) {
        //$log.debug('pagehistory save', $route, pagetype, additionalData);
        self.currentPage = {
            page: $route.current.locals.page,
            station: StationMonitor.getStation(),
            pagetype: pagetype,
            additionalData: additionalData
        };
    }

    function getCurrentPage() {
        //$log.debug('pagehistory getCurrentPage', self.currentPage);
        return self.currentPage;
    }

    function getLastPage() {
        //$log.debug('pagehistory getLastPage', self.lastPage);
        return self.lastPage;
    }

    function onRouteChangeSuccess() {
        angular.copy(self.currentPage, self.lastPage);
        self.currentPage = {};
        //$log.debug('pagehistory $routeChangeSuccess', self.currentPage, self.lastPage);
    }

    function setMovie(movie) {
        if (angular.isObject(movie)) self.latestMovie = movie;
    }

    function getLatestMovie() {
        return self.latestMovie;
    }

    function queueTeaserset(teaserset) {
        self.queuedTeaserset = teaserset;
        if (self.hideTeaserset) {
            self.hideQueuedTeaserset();
        }
    }

    function hideQueuedTeaserset() {
        self.hideTeaserset = true;
        if (self.queuedTeaserset) {
            self.queuedTeaserset.hide = true;
        }
    }

    function saveTeasersetData(teaserset) {
        self.savedTeaserset = angular.copy(teaserset);
    }

    function getSavedTeasersetData() {
        return self.savedTeaserset;
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .service('RecommendationService', RecommendationService);

RecommendationService.$inject = ['$cookies', 'uuid4', '$sessionStorage', '$rootScope', 'NowApi', 'AppConfig', 'StationMonitor', '$log', '$window', '$interval', '$q', '$document', '$http', '$route', 'GlobalFormatService', 'NowGoogleAnalytics'];

function RecommendationService($cookies, uuid4, $sessionStorage, $rootScope, NowApi, AppConfig, StationMonitor, $log, $window, $interval, $q, $document, $http, $route, GlobalFormatService, NowGoogleAnalytics) {
    var self = this;

    this.cookies = $cookies;
    this.guid = uuid4;
    this.sessionStorage = $sessionStorage;
    this.rootScope = $rootScope;
    this.nowApi = NowApi;
    this.appConfig = AppConfig;
    this.stationMonitor = StationMonitor;
    this.log = $log;
    this.window = $window;
    this.interval = $interval;
    this.q = $q;
    this.document = $document;
    this.$route = $route;
    this.GlobalFormatService = GlobalFormatService;
    this.NowGoogleAnalytics = NowGoogleAnalytics;
    this.recoPrediction = "na";

    this.opt = null;
    this.timedRecommendations = [];
    this.referrer = '';
    this.cachedRecommendationRequests = [];

    this.getCurrentStation = getCurrentStation;
    this.addTimedRecommendations = addTimedRecommendations;
    this.hasTimedRecommendations = hasTimedRecommendations;
    this.addSendEvent = addSendEvent;
    this.addReceiveEvent = addReceiveEvent;
    this.parseIds = parseIds;
    this.getUnSuffixedId = getUnSuffixedId;
    this.getSuffixedMovieIds = getSuffixedMovieIds;
    this.isProduction = isProduction;
    this.getUserId = getUserId;
    this.getCookieId = getCookieId;
    this.getPictureType = getPictureType;
    this.getTeaser = getTeaser;
    this.getMovieTeaser = getMovieTeaser;
    this.getFormatTeaser = getFormatTeaser;
    this.getEnvironment = getEnvironment;
    this.getRecommendationEnabled = getRecommendationEnabled;
    this.getPictureTypeFromObject = getPictureTypeFromObject;
    this.getCurrentTimestamp = getCurrentTimestamp;
    this.getOpt = getOpt;
    this.getReferrer = getReferrer;
    this.getCachedData = getCachedData;
    this.setCachedData = setCachedData;
    this.getRecommendationProvider = getRecommendationProvider;
    this.getRecommendationPrediction = getRecommendationPrediction;
    this.$http = $http;

    function getRecommendationProvider() {
        return $window.recoABC || "yusp"
    }

    function getRecommendationPrediction() {
        return this.recoPrediction;
    }



    function getCachedData(request) {
        var data = false;
        self.cachedRecommendationRequests.some(function (sourceRequest) {
            if (request === sourceRequest.key) {
                data = sourceRequest.value;
                return true;
            }
        });
        return data;
    }

    function setCachedData(request, data) {
        var cachedData = self.getCachedData(request);
        if (false !== cachedData) {
            return;
        }
        self.cachedRecommendationRequests.push(
            {
                key: request,
                value: data
            }
        );

    }

    this.rootScope.$on('$routeChangeStart', function () {
        self.cachedRecommendationRequests = [];
    });

    initWatchers();

    function getCurrentStation() {
        return self.stationMonitor.getStation(false);
    }

    function addTimedRecommendations(recommendationKey, timeout) {
        self.timedRecommendations[recommendationKey] = timeout;
    }

    function hasTimedRecommendations(recommendationKey) {
        return (recommendationKey in self.timedRecommendations);
    }

    function addSendEvent(args) {
        if (false === self.isSendingEnabled()) {
            return;
        }
        _gravity.push(args);
    }

    function addReceiveEvent(args) {
        if (false === self.isReceivingEnabled()) {
            return;
        }

        _gravity.push(args);
    }

    function parseIds(recommendationResponse) {
        var items = recommendationResponse.items;
        var ids = [];
        items.forEach(function (item) {
            var itemId = item.itemId;
            ids.push(itemId);
        });
        return ids;
    }

    function getUnSuffixedId(suffixedId) {
        suffixedId = suffixedId.replace(self.SUFFIX_MOVIE, '');
        suffixedId = suffixedId.replace(self.SUFFIX_SERIE, '');
        return parseInt(suffixedId);
    }

    function getSuffixedMovieIds(movieIds) {
        var newMovieIds = [];
        if (null === movieIds || 0 === movieIds.length) {
            return;
        }
        movieIds.forEach(function (movieId) {
            newMovieIds.push(self.getSuffixedMovieId(movieId));
        });
        return newMovieIds;
    }

    function isProduction() {
        return (self.getEnvironment() === 'production') ? 'PROD' : 'DEVELOP';
    }

    function getUserId() {
        var user = self.sessionStorage.user;
        if (true === angular.isUndefined(user) || !user) {
            return '';
        }
        return String(user.id);
    }

    function getCookieId() {
        var cookieId = $.cookie(self.COOKIE_KEY_GRAVITY);
        if (true === angular.isUndefined(cookieId)) {
            var newCookieId = self.guid.generate();
            $.cookie(self.COOKIE_KEY_GRAVITY, newCookieId, {expires: 365});
            return newCookieId;
        }
        return cookieId;
    }

    function getPictureType(teaser) {
        if (true === angular.isUndefined(teaser)) {
            return 'picture';
        }
        if (teaser.id.indexOf(self.SUFFIX_SERIE) !== -1) {
            return self.getPictureTypeFromObject(teaser.format);
        }
        if (teaser.id.indexOf(self.SUFFIX_MOVIE) !== -1) {
            return self.getPictureTypeFromObject(teaser.movie);
        }
        return 'picture';
    }

    function getTeaser() {
        return {
            'timingOfflineDate': null,
            'timingOnlineDate': null,
            'timingInclusiveDays': null,
            'setting': '{\'dynamicteaserset\':true,\'movie\':true}',
            'movieId': 0,
            'formatId': 0,
            'teaserSetId': null,
            'customTeaserData': [],
            'nowNextType': null,
            'id': '-1',
            'position': 0,
            'priority': null,
            'active': false,
            'highlight': null,
            'type': 'none',
            'customTeaserType': null,
            'movie': null,
            'custom': null,
            'format': null,
            'timingType': null
        };
    }

    function getMovieTeaser(movie) {
        var movieTeaser = self.getTeaser();

        if (!movie) {
            return movieTeaser;
        }

        movieTeaser.movie = movie;
        movieTeaser.movieId = movie.id;
        movieTeaser.format = (movie.format) ? movie.format : null;
        movieTeaser.type = 'movie';
        movieTeaser.formatId = (movie.format && movie.format.id) ? movie.format.id : null;
        movieTeaser.id = self.getSuffixedMovieId(movie.id);

        return movieTeaser;
    }

    function getFormatTeaser(format) {
        var formatTeaser = self.getTeaser();
        formatTeaser.format = format;
        formatTeaser.formatId = format.id;
        formatTeaser.type = 'format';
        formatTeaser.id = self.getSuffixedFormatId(format.id);
        return formatTeaser;
    }

    function getEnvironment() {
        if ($window.document.location.hostname.match(/staging\./i) || $window.document.location.hostname.match(/abnahme\./i)) {
            return 'staging';
        } else if ($window.document.location.hostname.match(/local\./i)) {
            return 'development';
        }
        return 'production';
    }

    function getRecommendationEnabled(key) {
        var station = self.getCurrentStation();
        var environment = self.getEnvironment();
        if (true === angular.isUndefined(self.appConfig.settings[station])) {
            return false;
        }
        var environmentConfig = self.appConfig.settings[station][environment];
        if (true === angular.isUndefined(environmentConfig)) {
            return false;
        }
        var recommendationConfig = environmentConfig['recommendation'];
        if (true === angular.isUndefined(recommendationConfig)) {
            return false;
        }
        var recommendationEnabled = recommendationConfig[key];
        if (true === angular.isUndefined(recommendationEnabled)) {
            return false;
        }
        return ('true' === recommendationEnabled);
    }

    function getPictureTypeFromObject(object) {
        if (true === angular.isUndefined(object)) {
            return 'picture';
        }
        if (true === object.kenburns) {
            return 'kenburns';
        }
        if (true === object.leadTeaserTrailer) {
            return 'trailer';
        }
        return 'picture';
    }

    function getCurrentTimestamp() {
        return Math.floor(Date.now() / 1000);
    }

    function getOpt() {
        if (null === self.opt) {
            self.opt = new Opt(self.COOKIE_KEY_GRAVITY_OPT);
        }
        return self.opt;
    }

    function getReferrer() {
        if ($document[0].referrer && !self.referrer) {
            return $document[0].referrer;
        }
        if ($document[0].referrer && self.referrer) {
            return self.referrer;
        }
        if (!$document[0].referrer && self.referrer) {
            return self.referrer;
        }
        return '';
    }

    function initWatchers() {
        self.rootScope.$on('player::NOWTV_PLAYER_EXIT', function (event, eventName, data, playerService) {
            if(playerService){
                self.fireEventWatched(
                    playerService.getCurrentMovieId(),
                    playerService.getPrice(),
                    playerService.getCurrentTime(),
                    playerService.getTimePercentage()
                );
            }
        });

        self.rootScope.$on('html5::onContentStart', function (event, eventName, data, playerService) {
            if(playerService){
                if (0 !== playerService.getTimePercentage()) {
                    return;
                }
                self.fireEventWatch(
                    playerService.getCurrentMovieId(),
                    playerService.getPrice()
                );
            }
        });

        self.rootScope.$on('$locationChangeSuccess', function (event, newPath, oldPath) {
            if (newPath === oldPath) {
                return;
            }
            self.referrer = oldPath;
        });

        self.rootScope.$on('html5::onContentEnd', function (event, eventName, data, playerService) {
            if(playerService){
                if (100 !== playerService.getTimePercentage()) {
                    return;
                }
                self.fireEventWatched(
                    playerService.getCurrentMovieId(),
                    playerService.getPrice(),
                    playerService.getCurrentTime(),
                    playerService.getTimePercentage()
                );
            }
        });

        self.rootScope.$on('account::login', function () {
            self.login();
        });

        self.rootScope.$on('account::logout', function () {
            self.login();
        });
    }
}

RecommendationService.prototype.SUFFIX_SERIE = '_s';
RecommendationService.prototype.SUFFIX_MOVIE = '_e';
RecommendationService.prototype.COOKIE_KEY_GRAVITY_OPT = 'gr_reco_opt';
RecommendationService.prototype.COOKIE_KEY_GRAVITY = 'gr_reco';

RecommendationService.prototype.isEnabled = function () {
    return (true === this.getOpt().isEnabled());
};

RecommendationService.prototype.getSuffixedMovieId = function (movieId) {
    return movieId + this.SUFFIX_MOVIE;
};

RecommendationService.prototype.getSuffixedFormatId = function (formatId) {
    return formatId + this.SUFFIX_SERIE;
};

RecommendationService.prototype.isSendingEnabled = function () {
    return (this.getRecommendationEnabled('sending') && true === this.isEnabled());
};

RecommendationService.prototype.isReceivingEnabled = function () {
    return (this.getRecommendationEnabled('receiving') && true === this.isEnabled());
};

RecommendationService.prototype.handleOptButton = function () {
    var optEnabled = this.isEnabled();

    if (this.window.isWebview) {
        $('a#recommendationButton').replaceWith('<span>Benutzen Sie in der App bitte den Schalter am unteren Bildschirmrand</span>');
        return;
    }

    if (true === optEnabled) {
        $('a#recommendationButton').text('Abschalten (Es wird ein COOKIE gesetzt)');
    }
    else {
        $('a#recommendationButton').text('Wieder anschalten (Es wird ein COOKIE gesetzt)');
    }
};

RecommendationService.prototype.handleOpt = function () {
    var optEnabled = this.isEnabled();
    if (true === optEnabled) {
        this.disable();
        $('a#recommendationButton').text('Wieder anschalten (Es wird ein COOKIE gesetzt)');
    }
    else {
        this.enable();
        $('a#recommendationButton').text('Abschalten (Es wird ein COOKIE gesetzt)');
    }
};

RecommendationService.prototype.run = function () {
    var self = this;
    this.window.toggleRecommendation = function () {
        self.handleOpt();
    };
    this.login();
};

RecommendationService.prototype.getRecommendationsByTeaserSetId = function (callback, teaserSetId, configuration) {
    configuration = (true === angular.isUndefined(configuration)) ? {} : configuration;
    var self = this;
    this.nowApi.getTeasersets().retrieveTeaserSetById({
        id: teaserSetId,
        fields: 'automaticConfiguration'
    }).then(function (data) {
        var mergedConfiguration = angular.extend({}, data.automaticConfiguration, configuration);
        self.getRecommendations(callback, mergedConfiguration);
    });
};

RecommendationService.prototype.getRecommendations = function (callback, configuration, errorCallback) {
    var self = this;
    this.recoPrediction = "na";
    var reco = this.getRecommendationProvider();
    if(['datarevenue_v1','yusp','random'].indexOf(this.$route.current.params.reco) > -1){
        reco = this.$route.current.params.reco;
        this.window.recoABC = reco;
    }

    var failed = function(){
        if(angular.isFunction(errorCallback)){
            errorCallback();
        }
        self.NowGoogleAnalytics.trackEvent("reco_impression_status", "api-fehler", null, 0, {dimension25:self.getRecommendationProvider()});
    };



    if (reco === "yusp") {
        this.getYspRecommendation(callback, configuration,failed);
    }  else if (reco === "datarevenue_v1") {
        this.getRevRecommendation(callback, configuration, failed);
    }else{
        this.getRandomRecommendation(callback, configuration, failed);
    }
};




RecommendationService.prototype.getRandomRecommendation = function (callback, configuration, failed) {
    var boxId = angular.isUndefined(configuration.scenarioId) ? 'content_box' : String('' + configuration.scenarioId + '_box').toLowerCase(),
        self = this,
        filter = {
            'Id': {
                'containsNotIn': ['1896']
            }
        },
        fields = 'id,title,station,title,titleGroup,seoUrl,icon,hasFreeEpisodes,hasPayEpisodes,categoryId,searchAliasName,genres',
        key = 'azformats';
    this.GlobalFormatService.getFormats(key, fields, filter).then(
        function (data) {
            var formats = data.formats.filter(function (format) {return (format.station !== "watchbox")}).sort( function() { return 0.5 - Math.random() } ).slice(0,20).map(function(format){
                return format.id + "_s";
            });
            if (formats && formats.length > 0) {
                self.getTeasersByMultipleRequests(
                    formats,
                    function (teasers) {
                        teasers.items.forEach(function (element) {
                            element.reco = true;
                            element.boxId = boxId;
                        });
                        self.setCachedData(angular.toJson(configuration), teasers);
                        self.NowGoogleAnalytics.trackEvent("reco_impression_status", "ok", null, 0, {dimension25:self.getRecommendationProvider()});
                        callback(teasers);
                    },
                    failed
                );
            }else{
                failed();
            }
        },
        failed
    );
};


RecommendationService.prototype.getRevRecommendation = function (callback, configuration, failed) {
    var boxId = angular.isUndefined(configuration.scenarioId) ? 'content_box' : String('' + configuration.scenarioId + '_box').toLowerCase();
    var cookieID = null;
    if (angular.isObject(this.$window.thcObj) && this.$window.thcObj.technic) {
        cookieID = this.$window.thcObj.technic;
    }

    var headers = {};
    for (var prop in this.$http.defaults.headers.common){
        if (this.$http.defaults.headers.common.hasOwnProperty(prop)) {
            headers[prop] = undefined;
        }
    }
    headers['Authentication'] = '9edHDABDnAAAWsyURFs6CNesVJeJ6LZmVhkm59rKbfzHkuukC7XucedWhdXz';

    var self = this,
        req = {
            method: 'GET',
            url: "https://reco.tvnow.de/recommendation",
            params: {
                "id": cookieID
            },
            headers: headers
        };


    this.$http(req).then(
        function (response) {
            if (response.data.data && response.data.data.length > 0) {
                self.recoPrediction = response.data.data_availability_status;
                self.getTeasersByMultipleRequests(
                    response.data.data,
                    function (teasers) {
                        teasers.items.forEach(function (element) {
                            element.reco = true;
                            element.boxId = boxId;
                        });
                        self.setCachedData(angular.toJson(configuration), teasers);
                        //var result = self.getCachedData(JSON.stringify(configuration));
                        callback(teasers);
                        self.NowGoogleAnalytics.trackEvent("reco_impression_status", "ok", null, 0, {dimension25:self.getRecommendationProvider(),dimension29:self.getRecommendationPrediction()});
                    },
                    failed
                );
            }else{
                failed();
            }
        },
        failed
    );

};

RecommendationService.prototype.getYspRecommendation = function (callback, configuration, failed) {
    var self = this;
    var boxId = angular.isUndefined(configuration.scenarioId) ? 'content_box' : String('' + configuration.scenarioId + '_box').toLowerCase();
    var baseConfiguration = {
        type: 'recommendation',
        resultNames: ['itemId'],
        currentSite: self.getCurrentStation(),
        callback: (function (results) {
            var loadTest = self.getRecommendationEnabled('loadtest');
            self.log.debug('loadtest', loadTest);
            var ids = self.parseIds(results);
            self.getTeasersByMultipleRequests(
                ids,
                function (teasers) {
                    teasers.items.forEach(function (element) {
                        element.reco = true;
                        element.boxId = boxId;
                    });
                    self.setCachedData(angular.toJson(configuration), teasers);
                    self.NowGoogleAnalytics.trackEvent("reco_impression_status", "ok", null, 0, {dimension25:"yusp"});
                    callback(teasers);
                },
                failed
            );
        })
    };

    var result = self.getCachedData(angular.toJson(configuration));
    if (false !== result) {
        callback(result);
        return result;
    }

    var mergedConfiguration = angular.extend({}, baseConfiguration, configuration);
    self.addReceiveEvent(mergedConfiguration);
}


RecommendationService.prototype.getTeasersBySingleRequest = function (ids, success) {
    var self = this;
    this.nowApi.getTeasers().retrieveRecommendations({
        station: self.getCurrentStation(),
        recommendationItems: angular.toJson(ids),
        fields: '["*","movie",["*","format",["*"],"pictures","packages","paymentPaytypes",["*"]],"format",["*","pictures","paymentPaytypes",["*"]]]'
    }).then(function (data) {
        success(data);
    });
};

RecommendationService.prototype.getTeasersByMultipleRequests = function (ids, success, failed) {
    var self = this;
    var promises = [];
    ids.forEach(function (element) {
        if (element.indexOf(self.SUFFIX_MOVIE) !== -1) {
            promises.push(
                self.nowApi.getMovie().list({
                    'fields': '["*","format",["*"],"pictures","packages","paymentPaytypes",["*"],"format",["*","pictures","paymentPaytypes",["*"]]]',
                    'id': self.getUnSuffixedId(element)
                }).then(function (result) {
                    return self.getMovieTeaser(result);
                }, function () {
                    return false;
                })
            );
        }
        if (element.indexOf(self.SUFFIX_SERIE) !== -1) {
            promises.push(
                self.nowApi.getFormat().retrieveFormatById({
                    'fields': '["*"]',
                    'id': self.getUnSuffixedId(element)
                }).then(function (result) {
                    return self.getFormatTeaser(result);
                }, function () {
                    return false;
                })
            );
        }
    });

    this.q.all(promises).then(
        function (result) {
            var teasers = [];
            result.forEach(function (element) {
                if (false !== element) {
                    teasers.push(element);
                }
            });
            success({'items': teasers, 'total': teasers.length});
        },
        function () {
            if(failed){
                failed();
            }
        });
};


RecommendationService.prototype.getRecommendationsForMyProgramme = function (itemsInPlayList, itemsInFavouriteList, callback) {
    this.getRecommendationsByTeaserSetId(callback, 855, {
        itemInPlaylist: itemsInPlayList,
        itemInFavorits: itemsInFavouriteList
    });
};

RecommendationService.prototype.getRecommendationsForSeries = function (formatId, callback) {
    this.getRecommendationsByTeaserSetId(callback, 996, {currentItemId: this.getSuffixedFormatId(formatId)});
};

RecommendationService.prototype.getRecommendationsForVideoBar = function (currentMovieId, callback) {
    this.getRecommendationsByTeaserSetId(callback, 803, {currentItemId: this.getSuffixedMovieId(currentMovieId)});
};

RecommendationService.prototype.getRecommendationsForLeadTeaser = function (itemOnPage, callback) {
    var configuration = {itemOnPage: itemOnPage, channelName: [this.getCurrentStation()]};
    if (this.getCurrentStation() === 'nowtv') {
        delete configuration.channelName;
    }
    this.getRecommendationsByTeaserSetId(callback, 805, configuration);
};

RecommendationService.prototype.getRecommendationsForSearch = function (callback) {
    this.getRecommendationsByTeaserSetId(callback, 801);
};

RecommendationService.prototype.login = function () {
    _gravity.push({
        type: 'set',
        cookieId: this.getCookieId(),
        cookieName: this.COOKIE_KEY_GRAVITY,
        mode: this.isProduction(),
        userId: this.getUserId()
    });
};

RecommendationService.prototype.fireEventRecClick = function (teaser) {
    if (true === angular.isUndefined(teaser)) {
        return;
    }
    if (!teaser.reco) {
        return;
    }
    this.addSendEvent({
        type: 'event',
        eventType: 'REC_CLICK',
        itemId: teaser.id,
        boxId: teaser.boxId,
        position: teaser.position,
        pictureType: this.getPictureType(teaser),
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.fireEventViewFormat = function (formatId) {
    this.addSendEvent({
        type: 'event',
        eventType: 'VIEW',
        itemId: this.getSuffixedFormatId(formatId),
        referrer: this.getReferrer(),
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.fireEventViewMovie = function (movieId) {
    this.addSendEvent({
        type: 'event',
        eventType: 'VIEW',
        itemId: this.getSuffixedMovieId(movieId),
        referrer: this.getReferrer(),
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.fireEventWatch = function (movieId, price) {
    this.addSendEvent({
        type: 'event',
        eventType: 'WATCH',
        itemId: this.getSuffixedMovieId(movieId),
        referrer: this.getReferrer(),
        price: price,
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.fireEventWatched = function (movieId, price, currentTime, percentage) {
    this.addSendEvent({
        type: 'event',
        eventType: 'WATCHED',
        itemId: this.getSuffixedMovieId(movieId),
        referrer: this.getReferrer(),
        price: price,
        durationSeconds: currentTime,
        percentageWatched: percentage,
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.fireEventAddToFavorites = function (formatId) {
    this.addSendEvent({
        type: 'event',
        eventType: 'ADD_TO_FAVORITES',
        itemId: this.getSuffixedFormatId(formatId),
        referrer: this.window.location.href,
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.fireEventAddToPlayList = function (movieId) {
    this.addSendEvent({
        type: 'event',
        eventType: 'ADD_TO_PLAYLIST',
        itemId: this.getSuffixedMovieId(movieId),
        referrer: this.window.location.href,
        currentSite: this.getCurrentStation()
    });
};

RecommendationService.prototype.enable = function () {
    this.getOpt().enable();
};

RecommendationService.prototype.disable = function () {
    this.getOpt().disable();
};

RecommendationService.prototype.load = function () {
    //this.angularLoad.loadScript(document.location.protocol + '//saas.gravityrd.com/js/rtl_lab/gr_reco4.js').then(function() {
    //    //console.log(_gravity);
    //}).catch(function() {
    //    //console.log('not loaded');
    //});
};

function Opt(newName) {
    this.name = newName;
    this.enabled = true;

    this.createInstance = function () {
        var optCookie = $.cookie(this.name);
        if (true === angular.isUndefined(optCookie)) {
            $.cookie(this.name, this.enabled, {expires: 365});
        }
    };

    this.createInstance();
}

Opt.prototype.isEnabled = function () {
    return ('true' === $.cookie(this.name));
};

Opt.prototype.enable = function () {
    $.cookie(this.name, true, {expires: 365});
};

Opt.prototype.disable = function () {
    $.cookie(this.name, false, {expires: 365});
};

Opt.prototype.toggle = function () {
    this.isEnabled() ? this.disable() : this.enable();
};

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('nowResizeService', nowResizeService);

nowResizeService.$inject = ['$rootScope', '$window'];

function nowResizeService($rootScope, $window) {
    var layout = calcSize();
    var self = this;
    self.calcSize = calcSize;
    self.getSize = getSize;
    initResizeEvent();

    return self;

    function getSize() {
        return layout;
    }

    function initResizeEvent() {
        angular.element($window).on('resize', function () {
            if (calcSize() === 'l' && layout !== 'l') {
                layout = 'l';
                $rootScope.$broadcast('resize::jump', 'l', $window.innerWidth, {'width': 1280, 'height': 720});
                //console.log('changed to L');
            } else if (calcSize() === 'm' && layout !== 'm') {
                layout = 'm';
                $rootScope.$broadcast('resize::jump', 'm', $window.innerWidth, {'width': 960, 'height': 540});
                //console.log('changed to M');
            } else if (calcSize() === 's' && layout !== 's') {
                $rootScope.$broadcast('resize::jump', 's', $window.innerWidth, {'width': 640, 'height': 360});
                layout = 's';
                //console.log('changed to S');
            }

            $rootScope.$broadcast('resize::resize', layout, $window.innerWidth, $window.innerHeight);
        });
    }

    function calcSize() {
        if ($window.innerWidth >= 1560) {
            return 'l';
        } else if ($window.innerWidth >= 1260) {
            return 'm';
        } else if ($window.innerWidth < 1260) {
            return 's';
        }
    }

}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .service('TeaserSetHelper', TeaserSetHelper);


function TeaserSetHelper() {
    this.presets = {
        recommendation: {
            channelName: ['none'],
            genre: ['none'],
            itemType: 'none',
            scenarioId: 'none',
            numberLimit: 1
        },
        mostseenformatsbyfilter: {
            genre: 'Alle Genres',
            category: 'all'
        },
        mostseenmoviesbyfilter: {
            genre: 'Alle Genres',
            category: 'all',
            FreeContent: false
        },
        default: {
            default: true
        }
    };
}

TeaserSetHelper.prototype.getPresetAutomaticConfiguration = getPresetAutomaticConfiguration;
TeaserSetHelper.prototype.getPreset = getPreset;
TeaserSetHelper.prototype.getFilteredAutomaticConfiguration = getFilteredAutomaticConfiguration;

function getPresetAutomaticConfiguration(automaticType, automaticConfiguration) {
    return angular.extend({}, this.getPreset(automaticType), automaticConfiguration);
}

function getPreset(automaticType) {
    if (!(automaticType in this.presets)) {
        return angular.copy(this.presets.default);
    }
    return angular.copy(this.presets[automaticType]);
}

function getFilteredAutomaticConfiguration(automaticType, automaticConfiguration) {
    var newAutomaticConfiguration = angular.copy(automaticConfiguration);
    switch (automaticType) {
        case 'recommendation':
            if ('none' === newAutomaticConfiguration.scenarioId) {
                delete newAutomaticConfiguration.scenarioId;
            }
            newAutomaticConfiguration.numberLimit = parseInt(newAutomaticConfiguration.numberLimit);
            if ('none' === newAutomaticConfiguration.itemType) {
                delete newAutomaticConfiguration.itemType;
            }
            if (newAutomaticConfiguration.channelName && -1 !== newAutomaticConfiguration.channelName.indexOf('none')) {
                delete newAutomaticConfiguration.channelName;
            }
            if (newAutomaticConfiguration.genre && -1 !== newAutomaticConfiguration.genre.indexOf('none')) {
                delete newAutomaticConfiguration.genre;
            }
            break;
        case 'mostseenmoviesbyfilter':
        case 'mostseenformatsbyfilter':
            if (newAutomaticConfiguration.genre === 'Alle Genres') {
                delete newAutomaticConfiguration.genre;
            }
            if (newAutomaticConfiguration.category === 'all') {
                delete newAutomaticConfiguration.category;
            }
            break;
        default:
            break;
    }

    return newAutomaticConfiguration;
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowbreadcrumb', nowbreadcrumb);

nowbreadcrumb.$inject = ['BreadcrumbHelper'];

/**
 *
 * @constructor
 */
function nowbreadcrumb(BreadcrumbHelper) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/shared_breadcrumb.html',
        link: link
    };

    function link(scope) {
        scope.items = BreadcrumbHelper.getBreadcrumbItems();

        scope.$watch(function () {
                return BreadcrumbHelper.items;
            },
            function (newVal) {
                scope.items = newVal;
            }
        );

    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('freebutton', freebutton);

function freebutton() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            checkmodel: '=',
            text: '@text'
        },
        templateUrl: 'templates/shared_button_free.html',
        link: link
    };

    function link(scope, element, attrs) {
        var id = 'now-shared-free-' + Math.floor((Math.random() * 1337) + 1);
        var checkbox = $(element).find('input');
        var label = $(element).find('label');
        label.attr('id', id);
        checkbox.attr('for', id);

        scope.text = (attrs.text) ? attrs.text : 'Nur FREE';

        $(element).on('click', function () {
            scope.$apply(function () {
                scope.checkmodel = !checkbox.prop('checked');
            });
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('orderbutton', orderbutton);

function orderbutton() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/shared_button_order.html',
        link: link
    };

    function link() {
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc directive
 * @name NowShared.directive:nowSharedCircle
 * @element div
 *
 * @description
 * Generates a circle with icon
 *
 * @restrict E
 * @scope
 * @param {string=}  custom   Custom icon name (pay, more, play)
 * @param {object=}  movie   Movie Object
 * @param {object=}  format   Format Object
 */

angular
    .module('NowShared')
    .directive('nowSharedCircle', NowcircleLink);

NowcircleLink.$inject = ['MyProgrammeService', 'Accounting'];

function NowcircleLink(MyProgrammeService, Accounting) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            movie: '=',
            format: '=',
            tslayout: '=',
            isClickable: '=',
            text: '@',
            custom: '@'
        },
        templateUrl: 'templates/shared_circle.html',
        link: link
    };

    function link(scope, element, attrs) {
        var livestream = false;
        var icon = $(element).find('.circleicon');
        var circle = $(element).children('.circle');
        var circlesvg = $(element).children('.circle-svg');
        var spinner = $(element).find('.spinner');
        var chart = $(element).find('.chart');

        var circleClasses = 'icon_circle_play icon_circle_info icon_circle_pay icon_circle_more';
        if (!scope.movie && !scope.format && !scope.custom) {
            circle.hide();
            circlesvg.hide();
            return true;
        }

        if (scope.custom) {
            if (scope.custom.indexOf('more') > -1) {
                scope.custom = 'icon_circle_more';
            }
            if (scope.custom.indexOf('pay') > -1) {
                scope.custom = 'icon_circle_pay';
            }
            if (scope.custom.indexOf('play') > -1) {
                scope.custom = 'icon_circle_play';
            }
            if (scope.custom.indexOf('info') > -1) {
                scope.custom = 'icon_circle_info';
            }

            if (scope.custom.indexOf('spin') > -1) {
                spinner.show();
            } else {
                spinner.hide();
            }

            icon.removeClass(circleClasses).addClass(scope.custom);
        } else if (scope.format) {
            icon.removeClass(circleClasses).addClass('icon_circle_more');
        } else {
            if (!scope.movie.exclusiv && scope.movie.blockadeText === '0' && !scope.movie.geoblocked) {
                if (attrs.showtrailer) {
                    scope.text = 'Vorschau ansehen';
                    icon.removeClass(circleClasses).addClass('icon_circle_play');
                } else if (scope.movie.free || scope.movie.payed) {
                    icon.removeClass(circleClasses).addClass('icon_circle_play');
                    if (scope.movie.livestreamEvent) {
                        livestream = true;
                        scope.text = 'Zum Livestream';
                    } else {
                        if (scope.movie.payed && !scope.movie.free && scope.movie.packages) {
                            scope.text = 'PLUS';
                        } else if (scope.movie.payed && !scope.movie.free && !scope.movie.packages) {
                            icon.removeClass(circleClasses).addClass('icon_circle_info');
                            scope.text = 'Nicht verfügbar';
                        } else {
                            scope.text = 'Jetzt ansehen';
                        }
                    }
                } else {
                    if (scope.movie.paymentPaytypes && scope.movie.paymentPaytypes.items) {
                        scope.text = scope.movie.paymentPaytypes.items[0].price + ' €';
                    }

                    if (!scope.movie.packages) {
                        icon.removeClass(circleClasses).addClass('icon_circle_info');
                        scope.text = 'Nicht verfügbar';
                    } else {
                        scope.text = 'PLUS';
                        icon.removeClass(circleClasses).addClass('icon_circle_pay');
                    }
                }
            } else if (scope.movie.blockadeText !== '0') {
                circle.hide();
                circlesvg.hide();
                scope.text = (scope.movie.blockadeText === '1') ? 'Aus rechtlichen Gründen leider nicht verfügbar!' : scope.movie.blockadeText;
            } else if (scope.movie.geoblocked) {
                circle.hide();
                circlesvg.hide();
                scope.text = 'Von Ihrem Standort aus leider nicht verfügbar!';
            } else {
                circle.hide();
                circlesvg.hide();
                scope.text = 'Diese Folge wurde exklusiv im TV ausgestahlt';
            }
        }

        if (Accounting.isPremiumUser() && scope.movie && !livestream) {
            var percentage = Math.round(MyProgrammeService.getMovieStatistic(scope.movie.id, 'progress') * 100);
            if (percentage >= 99) {
                icon.addClass('viewed');
                chart.addClass('viewed');
                percentage = 100;
            }
            chart.attr('data-percent', percentage);
        } else {
            chart.attr('data-percent', 0);
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('convertToNumber', convertToNumber);

convertToNumber.$inject = [];

function convertToNumber() {
    return {
        require: 'ngModel',
        link: link
    };

    function link(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (val) {
            return parseInt(val, 10);
        });
        ngModel.$formatters.push(function (val) {
            return '' + val;
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('customheader', customheader);

customheader.$inject = ['Metadata', '$log', '$window'];

function customheader(Metadata, $log,$window) {
    var nodes = [];

    return {
        restrict: 'E',
        replace: false,
        template: '<div class="og"></div>',
        link: link
    };

    function buildTags(tags) {
        resetTags();

        if (tags.length > 0) {
            for (var i = 0; i < tags.length; i++) {
                var field = (tags[i].meta) ? 'name' : 'property';
                //remove old field
                $('meta[' + field + '="' + tags[i].type + '"]').remove();
                $log.debug('directive_customheader adding to head:', {tag: tags[i].type, content: tags[i].content});
                nodes.push($('<meta ' + field + '="' + tags[i].type + '" content="' + tags[i].content + '" >').appendTo('head'));
            }
            $log.debug('directive_customheader', {tags: tags, nodes: nodes});
        }
    }

    function buildHreflangTags(tags) {
        //no need to rewrite this after user interaction; SEO-only relevance (one time page call)
        if (tags.length > 0) {
            for (var i = 0; i < tags.length; i++) {
                $('<link rel="alternate" hreflang="' + tags[i].lang + '" href="' + tags[i].url + '" />').appendTo('head');
            }
        }
    }

    function buildDeviceAltTag(url) {

        $('<link rel="alternate" media="only screen and (max-width: 504px)" href="' + url + '" />').appendTo('head');
    }

    function buildCanonicalLink(url) {
        $('<link rel="canonical" href="' + url + '" />').appendTo('head');
    }

    function resetTags() {
        if (nodes.length > 0) {
            for (var i = 0; i < nodes.length; i++) {
                $(nodes[i]).remove();
            }
        }
    }

    function link(scope) {
        scope.opengraphinfos = [];

        scope.$watch(
            function () {
                return Metadata.getHeader();
            },
            function (value) {
                if (value) {
                    buildTags(value);
                }
            }, true
        );

        scope.$watch(function () {
            return Metadata.getMobileAltEnable();
        }, function (currentstate) {
            if (currentstate === true && Metadata.getMobileAlt()) {
                buildDeviceAltTag(Metadata.getMobileAlt());
            }
        });


        Metadata.setHreflang($window.document.location.pathname);
        buildHreflangTags(Metadata.getHreflang());


        if (Metadata.getCanonical()) {
            buildCanonicalLink(Metadata.getCanonical());
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowDockToolbar', nowDockToolbar);

nowDockToolbar.$inject = ['$window'];

function nowDockToolbar($window) {
    return {
        scope: {
            config: '=nowDockToolbar'
        },
        restrict: 'A',
        link: link
    };

    function link($scope, element) {
        var config = $scope.config;
        var navOffset = $(element[0]).offset().top;
        if (!config.fixedClass) {
            config.fixedClass = 'now-toolbar-fixed';
        }


        var scroll = function () {
            var scrollPos = $(window).scrollTop();
            if (scrollPos > navOffset - config.offset) {
                $(element[0]).addClass(config.fixedClass);
            } else {
                $(element[0]).removeClass(config.fixedClass);
            }
        };
        angular.element($window).on('scroll', scroll);
        $scope.$on('$destroy', function () {
            angular.element($window).off('scroll', scroll);
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowimage', NowImage);

NowImage.$inject = ['AutoimgUrlHelper'];

function NowImage(AutoimgUrlHelper) {
    return {
        restrict: 'E', replace: true, scope: {
            movie: '=',
            formatid: '=',
            epgid: '=',
            format: '=',
            id: '@id',
            position: '@position',
            imagesize: '@imagesize',
            formattype: '@formattype',
            imagetype: '@imagetype'

        },
        template: '<img now-on-load="onImgLoad($event);" class="{{::imagetype}}" ng-src="{{::url}}" height="{{height}}" width="{{width}}">',
        link: link
    };

    function link(scope) {
        scope.onImgLoad = function ($event) {
            scope.$emit('image::loaded', $event);
        };
        if (!scope.imagetype) {
            scope.imagetype = 'default';
        }

        if (!scope.id && scope.movie && scope.movie.pictures && scope.movie.pictures[scope.imagetype] && scope.movie.pictures[scope.imagetype].length > 0) {
            scope.id = scope.movie.pictures[scope.imagetype][0].id;
        }
        else if (!scope.id && scope.pictures && scope.pictures[scope.imagetype] && scope.pictures[scope.imagetype].length > 0) {
            scope.id = scope.pictures[scope.imagetype][0].id;
        }

        var movieid = (scope.movie) ? scope.movie.id : 0;
        var epgid = (scope.epgid) ? scope.epgid : 0;
        var hash = scope.id;

        var pictureid = scope.id;
        if (angular.isString(pictureid) && (pictureid.indexOf('http') > -1 || pictureid.indexOf('//') === 0)) {
            pictureid = pictureid.slice(0, -4).split('/');
            for (var i = pictureid.length - 1; i > 0; i--) {
                if (pictureid[i].length === 32) {
                    hash = pictureid[i];
                    break;
                }
            }
        }

        var defaultsize = (scope.imagetype === 'banner') ? '638x169' : (scope.imagetype === 'portrait') ? '300x358' : '638x358';
        var imagesize = (!scope.imagesize) ? defaultsize : scope.imagesize;
        var formatid = (!scope.formatid) ? '0' : scope.formatid;
        var position = (!scope.position) ? null : scope.position;
        var formattype = (!scope.formattype) ? null : scope.formattype;

        if (imagesize === '0x0') {
            scope.height = 'auto';
            scope.width = 'auto';
        } else if (imagesize.indexOf('x0') !== -1) {
            scope.height = 'auto';
            scope.width = imagesize.split('x')[0];
        } else if (imagesize.indexOf('0x') === 0) {
            scope.height = imagesize.split('x')[1];
            scope.width = 'auto';
        } else {
            scope.height = imagesize.split('x')[1];
            scope.width = imagesize.split('x')[0];
        }

        AutoimgUrlHelper.setParams(movieid, formatid, formattype, imagesize, hash, epgid, position);
        scope.url = AutoimgUrlHelper.getAutoimgUrl();
    }
}

})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowShared')
    .directive('nowLandscapeInfo', nowLandscapeInfo);

nowLandscapeInfo.$inject = ['$route'];

function nowLandscapeInfo($route) {

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/landscape_info.html',
        link: link
    };

    function link(scope) {
        var pagetype = ($route.current.$$route.data) ? $route.current.$$route.data.pagetype : false;
        scope.show = (pagetype !== "player") ? true : false;
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowLoadingIndicator', nowLoadingIndicator);

nowLoadingIndicator.$inject = ['$rootScope'];

function nowLoadingIndicator($rootScope) {
    return {
        restrict: 'E',
        template: "<div class='now-loading-identicator' ng-if='isRouteLoading'><now-loading-spinner></now-loading-spinner> </div>",
        link: link
    };

    function link(scope) {
        scope.isRouteLoading = false;

        var changeStart = $rootScope.$on('$routeChangeStart', function () {
            scope.isRouteLoading = true;
        });

        var changeSuccess = $rootScope.$on('$routeChangeSuccess', function () {
            scope.isRouteLoading = false;
        });

        var changeError = $rootScope.$on('$routeChangeError', function () {
            scope.isRouteLoading = false;
        });

        var update = $rootScope.$on('$routeUpdate', function () {
            scope.isRouteLoading = false;
        });

        var loadingShow = $rootScope.$on('nowLoadingIndicator::show', function () {
            scope.isRouteLoading = true;
        });
        var loadingHide = $rootScope.$on('nowLoadingIndicator::hide', function () {
            scope.isRouteLoading = false;
        });

        $rootScope.$on('$destroy', changeStart);
        $rootScope.$on('$destroy', changeSuccess);
        $rootScope.$on('$destroy', changeError);
        $rootScope.$on('$destroy', update);
        $rootScope.$on('$destroy', loadingShow);
        $rootScope.$on('$destroy', loadingHide);
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowLoadingSpinner', nowLoadingSpinner);

nowLoadingSpinner.$inject = [];

function nowLoadingSpinner() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/shared_loadingspinner.html'
    };
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('onFinishRender', onFinishRender);

onFinishRender.$inject = ['$timeout'];

function onFinishRender($timeout) {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope) {
        if (scope.$last === true) {
            $timeout(function () {
                scope.$emit('ngRepeatFinished');
            });
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowOnLoad', nowOnLoad);

nowOnLoad.$inject = ['$parse'];

function nowOnLoad($parse) {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope, element, attrs) {
        var fn = $parse(attrs.nowOnLoad);
        element.on('load', function (event) {
            scope.$apply(function () {
                fn(scope, {$event: event});
            });
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('nowRecommendationButtonOpt', RecommendationButtonOpt);

RecommendationButtonOpt.$inject = ['RecommendationService'];

function RecommendationButtonOpt(RecommendationService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/recommendation_button_opt.html',
        link: link
    };

    function link(scope) {

        function toggleRecommendationOpt() {
            var optEnabled = RecommendationService.isEnabled();
            if (true === optEnabled) {
                RecommendationService.disable();
                scope.buttonText = 'Anschalten (Es wird ein COOKIE gesetzt)';
            }
            else {
                RecommendationService.enable();
                scope.buttonText = 'Abschalten (Es wird ein COOKIE gesetzt)';
            }
        }

        scope.toggle = toggleRecommendationOpt;
        toggleRecommendationOpt();
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc directive
 * @name NowShared.directive:reloadWrapper
 * @element div
 *
 * @description
 * Receive emitted event "forcereload" to reload transcluded content
 *
 * @restrict E
 *
 * @example
 <reload-wrapper>
 <teaserset custom="teaserset"></teaserset>
 </reload-wrapper>

 Use  scope.$emit('forcereload');

 */


angular
    .module('NowShared')
    .directive('reloadWrapper', reloadWrapper);

reloadWrapper.$inject = ['$log'];

function reloadWrapper($log) {
    return {
        restrict: 'E',
        transclude: true,
        link: function (scope) {
            scope.reload = false;
            scope.$on('forcereload', forcereload);

            function forcereload(event) {
                $log.log("forcereload", event);
                if (event && event.stopPropagation) {
                    event.stopPropagation();
                }
                scope.reload = true;
            }

            scope.$watch('reload', function (reload) {
                if (reload) {
                    scope.reload = false;
                }
            });
        },
        template: '<div ng-if="!reload"><ng-transclude></ng-transclude></div>'
    };
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('resize', resize);

resize.$inject = ['nowResizeService'];

function resize(nowResizeService) {

    return {
        link: link
    };

    function link(scope) {
        changeBodyStyle(nowResizeService.getSize());
        scope.$on('resize::jump', function (object, size) {
            changeBodyStyle(size);
        });
    }

    function changeBodyStyle(size) {
        //console.log('changeBodyStyle', size);
        if (size === 'l') {
            $('body').removeClass('size-s size-m').addClass('size-l');
        } else if (size === 'm') {
            $('body').removeClass('size-s size-l').addClass('size-m');
        } else if (size === 's') {
            $('body').removeClass('size-s size-m size-l').addClass('size-s');
        }
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc directive
 * @name NowShared.directive:nowScrollPinBottom
 * @element div
 *
 * @description
 * Scrolls page top within 500 ms
 *
 * @restrict AEC
 */
angular
    .module('NowShared')
    .directive('nowScrollPinBottom', nowScrollPinBottom);

nowScrollPinBottom.$inject = ['$timeout', '$window'];

function nowScrollPinBottom($timeout, $window) {
    return {
        restrict: 'AEC',
        link: link
    };

    function link() {
        $timeout(function () {
            $window.scrollTo(0, 0);
        }, 1000);
    }
}

})();

(function() {

/*!
 Copyright 2014 Vadim Kazakov
 Adapted from source by Maarten Baijs

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 'Software'), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.
 THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

'use strict';

angular
    .module('ngTinyScrollbar', [])
    .directive('scrollbar', scrollbar);

scrollbar.$inject = ['$rootScope', '$window', '$timeout', '$parse', '$animate'];

function scrollbar($rootScope, $window, $timeout, $parse, $animate) {
    controller.$inject = ['$scope', '$element', '$attrs'];
    return {
        restrict: 'A',
        transclude: true,
        template: '<div class="scroll-bar"><div class="scroll-thumb"></div></div><div class="scroll-viewport"><div class="scroll-overview" ng-transclude></div></div>',
        controller: controller,
        link: link
    };

    function link(scope, iElement, iAttrs, controller) {
        var position = $window.getComputedStyle(iElement[0]).getPropertyValue('position');
        if (position !== 'relative' && position !== 'absolute') {
            iElement.css('position', 'relative');
        }

        controller.initialize();

        iElement.on('$destroy', function () {
            controller.cleanup();
        });
    }


    function controller($scope, $element, $attrs) {
        var self = this,
            defaults = {
                axis: 'y', // Vertical or horizontal scrollbar? ( x || y ).
                wheel: true, // Enable or disable the mousewheel;
                wheelSpeed: 40, // How many pixels must the mouswheel scroll at a time.
                wheelLock: true, // Lock default scrolling window when there is no more content.
                scrollInvert: false, // Enable invert style scrolling
                trackSize: false, // Set the size of the scrollbar to auto or a fixed number.
                thumbSize: false, // Set the size of the thumb to auto or a fixed number.
                alwaysVisible: true, // Set to false to hide the scrollbar if not being used,
                appendToScope: false
            },
            localOptions = $attrs.scrollbar;

        self.initialize = initialize;
        self.update = update;
        self.cleanup = cleanup;

        if (localOptions) {
            localOptions = $parse(localOptions)($scope);
        } else {
            localOptions = {};
        }

        self.options = angular.extend({}, defaults, localOptions);
        self._defaults = defaults;

        var $body = angular.element($window.document.querySelectorAll('body')[0]),
            $document = angular.element(document),
            $viewport = angular.element($element[0].querySelectorAll('.scroll-viewport')[0]),
            $overview = angular.element($element[0].querySelectorAll('.scroll-overview')[0]),
            $scrollbar = angular.element($element[0].querySelectorAll('.scroll-bar')[0]),
            $thumb = angular.element($element[0].querySelectorAll('.scroll-thumb')[0]),
            mousePosition = 0,
            isHorizontal = self.options.axis === 'x',
            hasTouchEvents = ('ontouchstart' in $window),
            wheelEvent = ('onwheel' in document ? 'wheel' : // Modern browsers support 'wheel'
                $document[0].onmousewheel !== angular.isUndefined ? 'mousewheel' : // Webkit and IE support at least 'mousewheel'
                    'DOMMouseScroll'), // let's assume that remaining browsers are older Firefox
            sizeLabel = isHorizontal ? 'width' : 'height',
            sizeLabelCap = sizeLabel.charAt(0).toUpperCase() + sizeLabel.slice(1).toLowerCase(),
            posiLabel = isHorizontal ? 'left' : 'top',
            moveEvent = $document[0].createEvent('HTMLEvents'),
            restoreVisibilityAfterWheel;

        moveEvent.initEvent('move', true, true);

        self.contentPosition = 0;
        self.viewportSize = 0;
        self.contentSize = 0;
        self.contentRatio = 0;
        self.trackSize = 0;
        self.trackRatio = 0;
        self.thumbSize = 0;
        self.thumbPosition = 0;

        var refreshScollBar = $rootScope.$on('refreshScrollbar', function () {
            self.update();
        });
        $rootScope.$on('$destroy', refreshScollBar);

        function initialize() {
            if (!self.options.alwaysVisible) {
                $scrollbar.css('opacity', 0);
            }
            self.update();
            setEvents();

            return self;
        }

        function update(scrollTo) {
            self.viewportSize = $viewport.prop('offset' + sizeLabelCap);
            self.contentSize = $overview.prop('scroll' + sizeLabelCap);
            self.contentRatio = self.viewportSize / self.contentSize;
            self.trackSize = self.options.trackSize || self.viewportSize;
            self.thumbSize = Math.min(self.trackSize, Math.max(0, (self.options.thumbSize || (self.trackSize * self.contentRatio))));
            self.trackRatio = self.options.thumbSize ? (self.contentSize - self.viewportSize) / (self.trackSize - self.thumbSize) : (self.contentSize / self.trackSize);
            mousePosition = $scrollbar.prop('offsetTop');

            $scrollbar.toggleClass('disable', self.contentRatio >= 1 || isNaN(self.contentRatio));

            if (!self.options.alwaysVisible && self.contentRatio < 1 && self.viewportSize > 0) {
                //flash the scrollbar when update happens
                $animate.addClass($scrollbar, 'visible').then(function () {
                    $animate.removeClass($scrollbar, 'visible');
                    $scope.$digest();
                });
            }

            if (scrollTo !== null) {
                switch (scrollTo) {
                    case 'bottom':
                        self.contentPosition = self.contentSize - self.viewportSize;
                        break;
                    default:
                        self.contentPosition = parseInt(scrollTo, 10) || 0;
                }
            }

            ensureContentPosition();
            $thumb.css(posiLabel, self.contentPosition / self.trackRatio + 'px');
            $scrollbar.css(sizeLabel, self.trackSize + 'px');
            $thumb.css(sizeLabel, self.thumbSize + 'px');
            $overview.css(posiLabel, -self.contentPosition + 'px');

            return self;
        }

        function ensureContentPosition() {
            if (self.contentRatio <= 1 && self.contentPosition > self.contentSize - self.viewportSize) {
                // if scrollbar is on, ensure the bottom of the content does not go above the bottom of the viewport
                self.contentPosition = self.contentSize - self.viewportSize;
            } else if (self.contentRatio > 1 && self.contentPosition > 0) {
                // if scrollbar is off, ensure the top of the content does not go below the top of the viewport
                self.contentPosition = 0;
            }
        }

        function setEvents() {
            if (hasTouchEvents) {
                $viewport.on('touchstart', touchstart);
            } else {
                $thumb.on('mousedown', start);
                $scrollbar.on('mousedown', drag);
            }

            angular.element($window).on('resize', resize);

            var scope = (self.options.appendToScope) ? self.options.appendToScope : $scope;

            scope.ScrollbarReload = function () {
                self.update(0);
            };

            scope.ScrollbarScrollTo = function (top) {
                self.update(top);

            };

            if (self.options.wheel) {
                $element.on(wheelEvent, wheel);
            }

            /*
             $scope.$watch(function () {
             var contentSize = $overview.prop('scroll'+ sizeLabelCap);
             //console.log('contentSize '+contentSize);
             return contentSize;

             return $viewport.children().children().length;
             },
             function (newVal,oldVal) {
             //console.log('WATCHER SCROLLBAR!',newVal,oldVal);
             self.update();
             }
             );
             */
        }

        function resize() {
            angular.element($element[0].querySelectorAll('.scroll-overview')[0]);
            self.update();
        }

        function touchstart(event) {
            var evntObj = (event && event.originalEvent) || event || $window.event;
            if (1 === evntObj.touches.length) {
                event.stopPropagation();
                start(evntObj.touches[0]);
            }
        }

        function start(event) {
            $body.addClass('scroll-no-select');
            $element.addClass('scroll-no-select');

            if (!self.options.alwaysVisible) {
                $scrollbar.addClass('visible');
            }

            mousePosition = isHorizontal ? event.pageX : event.pageY;
            self.thumbPosition = parseInt($thumb.css(posiLabel), 10) || 0;

            if (hasTouchEvents) {
                $document.on('touchmove', touchdrag);
                $document.on('touchend', end);
            } else {
                $document.on('mousemove', drag);
                $document.on('mouseup', end);
                $thumb.on('mouseup', end);
            }
        }

        function wheel(event) {
            if (self.contentRatio >= 1) {
                return;
            }

            if (!self.options.alwaysVisible) {
                //cancel removing visibility if wheel event is triggered before the timeout
                if (restoreVisibilityAfterWheel) {
                    $timeout.cancel(restoreVisibilityAfterWheel);
                }
                $scrollbar.addClass('visible');

                restoreVisibilityAfterWheel = $timeout(function () {
                    $scrollbar.removeClass('visible');
                }, 100);
            }

            var evntObj = (event && event.originalEvent) || event || $window.event,
                deltaDir = self.options.axis.toUpperCase(),
                delta = {
                    X: evntObj.deltaX,
                    Y: evntObj.deltaY
                },
                wheelSpeed = evntObj.deltaMode === 0 ? self.options.wheelSpeed : 1;

            if (self.options.scrollInvert) {
                wheelSpeed *= -1;
            }

            if (wheelEvent === 'mousewheel') {
                delta.Y = -1 * evntObj.wheelDelta / 40;
                evntObj.wheelDeltaX && ( delta.X = -1 * evntObj.wheelDeltaX / 40 );
            }
            delta.X *= -1 / wheelSpeed;
            delta.Y *= -1 / wheelSpeed;

            var wheelSpeedDelta = delta[deltaDir];

            self.contentPosition -= wheelSpeedDelta * self.options.wheelSpeed;
            self.contentPosition = Math.min((self.contentSize - self.viewportSize), Math.max(0, self.contentPosition));

            $element[0].dispatchEvent(moveEvent);

            ensureContentPosition();

            $thumb.css(posiLabel, self.contentPosition / self.trackRatio + 'px');
            $overview.css(posiLabel, -self.contentPosition + 'px');

            if (self.options.wheelLock || (self.contentPosition !== (self.contentSize - self.viewportSize) && self.contentPosition !== 0)) {
                evntObj.preventDefault();
            }
        }

        function touchdrag(event) {
            var evntObj = (event && event.originalEvent) || event || $window.event;
            if (1 === evntObj.touches.length) {
                event.preventDefault();
                drag(evntObj.touches[0]);
            }
        }

        function drag(event) {
            if (self.contentRatio >= 1) {
                return;
            }

            var mousePositionNew = isHorizontal ? event.pageX : event.pageY,
                thumbPositionDelta = mousePositionNew - mousePosition;

            if ((self.options.scrollInvert && !hasTouchEvents) ||
                (hasTouchEvents && !self.options.scrollInvert)) {
                thumbPositionDelta = mousePosition - mousePositionNew;
            }
            var thumbPositionNew = Math.min((self.trackSize - self.thumbSize), Math.max(0, self.thumbPosition + thumbPositionDelta));
            self.contentPosition = thumbPositionNew * self.trackRatio;

            $element[0].dispatchEvent(moveEvent);

            ensureContentPosition();
            $thumb.css(posiLabel, thumbPositionNew + 'px');
            $overview.css(posiLabel, -self.contentPosition + 'px');
        }

        function end() {
            $body.removeClass('scroll-no-select');
            $element.removeClass('scroll-no-select');
            if (!self.options.alwaysVisible) {
                $scrollbar.removeClass('visible');
            }

            $document.off('mousemove', drag);
            $document.off('mouseup', end);
            $thumb.off('mouseup', end);
            $document.off('touchmove', touchdrag);
            $document.off('ontouchend', end);
        }

        function cleanup() {
            $viewport.off('touchstart', touchstart);
            $thumb.off('mousedown', start);
            $scrollbar.off('mousedown', drag);
            angular.element($window).off('resize', resize);
            $element.off(wheelEvent, wheel);
            //ensure scrollbar isn't activated
            self.options.alwaysVisible = true;
            end();
        }
    }
}


})();

(function() {

'use strict';

/**
 * @ngdoc directive
 * @name NowShared.directive:nowScrollTop
 * @element div
 *
 * @description
 * Scrolls page top within 500 ms
 *
 * @restrict AEC
 */
angular
    .module('NowShared')
    .directive('nowScrollTop', nowScrollTop);

nowScrollTop.$inject = ['$timeout', '$window'];

function nowScrollTop($timeout, $window) {
    return {
        restrict: 'AEC',
        link: link
    };

    function link() {
        $timeout(function () {
            $window.scrollTo(0, 0);
        }, 1000);
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .directive('title', title);

title.$inject = ['Metadata'];

function title(Metadata) {
    return {
        restrict: 'E',
        link: link
    };

    function link(scope, element) {
        scope.$watch(
            function () {
                return Metadata.getTitle();
            },
            function (value) {
                element.html(value);
            }
        );
    }
}

})();

(function() {



})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:capitalize
 * @kind function
 *
 * @description
 * Returns a text uppercase
 *
 * @param {string} input to uppercase
 * @returns {string} uppercase string.
 *
 */

angular
    .module('NowShared')
    .filter('capitalize', capitalize);

function capitalize() {
    return function capitalizeFunction(input, eachword) {
        if (input.toLowerCase) {
            input = input.toLowerCase();
        } else {
            return input;
        }
        if (!eachword) {
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        } else {
            return input.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:truncate
 * @kind function
 *
 * @description
 * Returns a texts with maximum amount of characters and append ...
 *
 * @param {string} input to truncate
 * @param {int=} chars maximum amount of chars
 * @param {bool=} breakOnWord preserve full words while truncate
 * @returns {string} shorten string.
 *
 */

angular
    .module('NowShared')
    .filter('truncate', truncate);

function truncate() {
    return filter;

    function filter(input, chars, breakOnWord) {
        if (isNaN(chars)) {
            return input;
        }

        if (chars <= 0) {
            return '';
        }

        if (input && input.length > chars) {
            input = input.substring(0, chars);

            if (!breakOnWord) {
                var lastspace = input.lastIndexOf(' ');
                //get last space
                if (lastspace !== -1) {
                    input = input.substr(0, lastspace);
                }
            } else {
                while (input.charAt(input.length - 1) === ' ') {
                    input = input.substr(0, input.length - 1);
                }
            }

            return input + '…';
        }

        return input;
    }
}


})();

(function() {

'use strict';

angular
    .module('NowShared')
    .filter('formaturl', formaturl);

formaturl.$inject = ['StationMonitor'];

function formaturl(StationMonitor) {
    return formaturlFunction;

    function formaturlFunction(station) {
        return StationMonitor.getAlias(station);
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:htmlize
 * @kind function
 *
 * @description
 * allow html to render
 *
 * @param {string} html code to trust
 * @returns {string} trusted html code
 *
 */

angular
    .module('NowShared')
    .filter('htmlize', htmlize);

htmlize.$inject = ['$sce'];

function htmlize($sce) {
    return htmlizeFunction;

    function htmlizeFunction(val) {
        return $sce.trustAsHtml(val);
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:newline
 * @kind function
 *
 * @description
 * replaced new lines with <br/> tags
 *
 * @param {string} text Text to analyse
 * @returns {string} returns text with br tag
 *
 */
angular
    .module('NowShared')
    .filter('newline', newline);

newline.$inject = ['$sce'];

function newline($sce) {
    return newlineFunction;

    function newlineFunction(text) {
        if (angular.isString(text)) {
            return $sce.trustAsHtml(text.replace(/\n/g, '<br/>'));
        } else {
            return '';
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowShared')
    .filter('range', range);

function range() {
    return rangeFunction;

    function rangeFunction(input, start, end) {
        start = parseInt(start);
        end = parseInt(end);

        var direction = (start <= end) ? 1 : -1;

        while (start <= end) {
            input.push(start);
            start += direction;
        }

        return input;
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:slice
 * @kind function
 *
 * @description
 * slices a array with
 *
 * @param {string} array to slice
 * @param {number} start start element to slice
 * @param {number} end end element to slice
 * @returns {string} array
 *
 */

angular
    .module('NowShared')
    .filter('slice', slice);

slice.$inject = [];

function slice() {
    return sliceFunction;

    function sliceFunction(arr, start, end) {
        return (arr || []).slice(start, end);
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:statustext
 * @kind function
 *
 * @description
 * returns a status text for movie or format
 *
 * @param {object} item Object like movie or format object
 * @returns {string} statustext for displaying to the user
 *
 */


angular
    .module('NowShared')
    .filter('statustext', statustext);

statustext.$inject = ['moment'];

function statustext(moment) {
    return statustextFunction;

    function statustextFunction(item, mobile) {
        if (!item) {
            return '';
        }

        var parts = [];

        //Check if Format or Movie or EPG
        if (item.startDate && !item.movie) {
            parts.push(moment(item.startDate).format('dd. DD.MM.YYYY HH:mm'));
        } else if (!item.station || item.movie) {
            if (item.movie) {
                item = item.movie;
            }

            if (item.free) {
                parts.push('FREE');
            } else if (item.paymentPaytypes && item.paymentPaytypes.items.length > 0 && item.paymentPaytypes.items[0].price && !mobile) {
                if (item.livestreamEvent && item.livestreamEvent.id > 0) {
                    parts.push('LIVESTREAM ' + item.paymentPaytypes.items[0].price + ' €');
                } else if (moment(item.broadcastStartDate).isAfter(moment())) {
                    parts.push('PRE-TV');
                } else {
                    parts.push('PLUS');
                }
            } else {
                parts.push('PLUS');
            }

            if (item.episode > 0 && item.format && item.format.categoryId !== 'film') {
                parts.push('Folge ' + item.episode);
            }

            if (item.alternateBroadcastDateText) {
                parts.push(item.alternateBroadcastDateText);
            } else {
                parts.push(moment(item.broadcastStartDate).format('dd. DD.MM.YYYY HH:mm'));
            }
        } else {
            if (item.icon === 'free' && !mobile) {
                parts.push('FREE');
            }

            if (item.icon === 'new') {
                parts.push('NEU');
            }
        }

        return parts.join(' | ');
    }
}

})();

(function() {

/**
 * Created by VolkM on 26.05.2017.
 */
angular
    .module('NowShared')
    .filter('timeToSeconds', timeToSeconds);

timeToSeconds.$inject = [];

function timeToSeconds() {
    return timeToSecondsFunction;

    function timeToSecondsFunction(time) {
        return time.split(':')
            .reverse()
            .map(Number)
            .reduce(function (pUnit, cUnit, index) {
                return pUnit + cUnit * Math.pow(60, index);
            });
    }
}

})();

(function() {

'use strict';

/**
 * @ngdoc filter
 * @name NowShared.filter:geturl
 * @kind function
 *
 * @description
 * Returns a link with given format or movie object to the desired type
 *
 * @param {object} item Object like movie or format object
 * @param {string=} type  isformat | page | appendpayment | preview | detail
 * @returns {string} string
 *
 */
angular
    .module('NowShared')
    .filter('geturl', geturl);

geturl.$inject = ['Moviehelper', '$location', 'StationMonitor'];

function geturl(Moviehelper, $location, StationMonitor) {
    return getUrlFunction;

    function getUrlFunction(item, type) {
        if (!item) {
            return '';
        }

        if (type === 'isformat') {
            return '/' + StationMonitor.getAlias(item.station) + '/' + item.seoUrl;
        } else if (type === 'page') {
            return '/' + StationMonitor.getAlias(item.station) + '/cms/' + item.path;
        } else if (type === 'appendpayment' && !item.free && !item.packages) {
            return '';
        } else if (type === 'appendpayment' && !item.payed && !item.free && item.blockadeText === '0' && !item.geoblocked) {
            return $location.path() + '?premium';
            //return $location.path() + '?payment=' + item.containerId;
        } else if (type === 'preview') {
            return Moviehelper.getMoviePlayerURL(item, false, true);
        } else if (type === 'detail') {
            return Moviehelper.getMoviePlayerURL(item, true);
        } else if (item.blockadeText !== '0' || item.geoblocked) {
            return '';
        } else {
            return Moviehelper.getMoviePlayerURL(item, false);
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowShared')
    .factory('Moviehelper', Moviehelper);

Moviehelper.$inject = ['StationMonitor', '$location', '$log'];

/**
 *
 * @constructor
 */
function Moviehelper(StationMonitor, $location, $log) {
    this.getMoviePlayerURL = getMoviePlayerURL;
    this.getMoviePlayerPath = getMoviePlayerPath;
    this.getMoviePlayerSearch = getMoviePlayerSearch;

    return this;

    function getMoviePlayerPath(movie, detail, preview) {
        var url = this.getMoviePlayerURL(movie, detail, preview);
        var pos = url.indexOf('?');
        if (pos === -1) {
            return url;
        } else {
            return url.substring(0, pos);
        }
    }

    function getMoviePlayerSearch(movie, detail, preview) {
        var url = this.getMoviePlayerURL(movie, detail, preview);
        var pos = url.indexOf('?');
        var searchObj = {};

        if (pos === -1) {
            return {};
        }

        var search = url.substring(pos + 1);
        search = search.split('&');

        angular.forEach(search, function (parts) {
            parts = parts.split('=');
            searchObj[parts[0]] = parts[1];
        });

        $log.debug('getMoviePlayerSearch', searchObj);

        return searchObj;
    }

    function getMoviePlayerURL(movie, detail, preview) {
        if (!movie.format || !movie.format.station) {
            return '';
        }

        //$log.debug('getMoviePlayerUrl movie',movie,$rootScope.currentTabSeason);

        if (movie.blockadeText !== '0' || movie.geoblocked) {
            return '/' + StationMonitor.getAlias(movie.format.station) + '/' + movie.format.seoUrl + '?';
        }

        var seoUri = '/' + StationMonitor.getAlias(movie.format.station) + '/' + movie.format.seoUrl + '/' + movie.seoUrl;

        if ((movie.payed || movie.free || preview) && !detail) {
            var suffix = '?return=' + decodeURIComponent($location.path()),
                navTarget = (preview) ? '/preview' : '/player';

            return seoUri + navTarget + suffix;
        }

        return seoUri;
    }
}

})();

(function() {



})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowTemplates', []);

})();

(function() {

angular.module('NowTemplates').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('templates/account_checkbox.html',
    "<div class=\"inputfield checkbox\"><div class=checkbox><input type=checkbox class=regular-checkbox ng-model=\"mymodel\"><label></label></div><div class=label ng-bind-html=label|htmlize></div><div class=\"now-badge success pull-right\"><span class=\"icon icon-nowcheck\"></span></div><div class=\"now-badge error error pull-right\">!</div></div>"
  );


  $templateCache.put('templates/account_input.html',
    "<div class=inputfield><span class=\"icon {{::icon}}\"></span> <input type={{::type}} ng-model=mymodel placeholder=\"{{::placeholder}}\"><div class=\"now-badge success pull-right\"><span class=\"icon icon-nowcheck\"></span></div><div class=\"now-badge error error pull-right\">!</div></div>"
  );


  $templateCache.put('templates/az_toolbar_directive.html',
    "<div class=\"now-toolbar now-toolbar-az\" now-dock-toolbar=\"{offset:'-100'}\"><div class=background><div class=buttons><now-station-switch show-all=true show-genre=true available-genres=$parent.availableGenres genre-selected=$parent.genreSelected allow-multiple=false selection=$parent.selectedStations tracksiteregion=az more-menu-start-position=6 cb=selectStation(arg1) genre-cb=selectGenre(arg1)></now-station-switch></div><div class=buttons><freebutton ng-hide=hideFree checkmodel=$parent.isFree></freebutton><div class=az-buttons><div class=\"button number\" ng-click=\"gotoAnchor($event,'0-9')\">0-9</div><div class=\"button char\" ng-click=gotoAnchor($event,char) data-ng-repeat=\"char in ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y']\">{{char}}</div><div class=\"button char clean-margin\" ng-click=\"gotoAnchor($event,'Z')\">Z</div><div class=clear></div></div><div class=clear></div></div><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/az_view.html',
    "<div class=\"now-az now-scroll-top\" ng-hide=loading><div ng-if=!loading><now-az-toolbar></now-az-toolbar></div><div class=section ng-if=\"titleGroup.length > 0\" ng-repeat=\"(titleGroup, formats) in formatlist\" ng-show=\"filteredItems.length > 0\"><div class=\"now-headline group_{{titleGroup }}\" id=anchor{{titleGroup}}>{{::titleGroup }}</div><div class=\"now-formatlist now-az-columns\"><div data-ng-repeat=\"format in filteredItems = (formats | filter:filterFormats | orderBy : '+title')\"><a ng-href=\"{{::format|geturl: 'isformat'}}\" data-ng-click=trackClick();>{{::format.title}}</a> <span class=\"plus new\" ng-show=\"format.icon=='new'\">NEU</span> <span class=plus ng-class={clickable:!isPremiumUser} ng-show=\"format.hasPayEpisodes && format.icon!='new' && !format.hasFreeEpisodes\" ng-click=openPremium();>PLUS</span><div class=clear></div></div><div ng-show=\"formats.length < 4\" class=show-l>&nbsp;</div><div ng-show=\"formats.length < 3\" class=\"show-l show-m\">&nbsp;</div><div ng-show=\"formats.length < 2\" class=\"show-l show-m show-s\">&nbsp;</div></div></div></div><div data-ng-show=loading><now-loading-spinner></now-loading-spinner></div>"
  );


  $templateCache.put('templates/channel_detailview.html',
    "<div ng-show=\"loading && !error\"><now-loading-spinner></now-loading-spinner></div><div ng-hide=loading><div class=rows><div ng-repeat=\"teaserset in teasersets\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div><div class=\"now-teaserset-headline now-teaserset-topheadline now-scroll-top\">{{channel.title}}</div><div class=\"now-teaserset now-teaserset-missed\"><nowteaser class=now-teaser-m ng-repeat=\"teaser in teasers \"></nowteaser></div></div><div class=rows><div ng-repeat=\"teaserset in teasersets | slice:1:10\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div>"
  );


  $templateCache.put('templates/channel_teaser.html',
    "<div><div class=\"now-teaserset-headline now-teaserset-topheadline\">{{channel.title}}<div class=\"pull-right channelDetailLink\"><a ng-href={{::channel.detailUri}} ng-click=trackChannelDetailClick();>Details <i class=\"icon icon_arrow_right\"></i></a></div></div><div class=channelRow><div class=channelImage><a ng-href={{::channel.detailUri}} ng-click=trackChannelTeaserClick();><nowimage imagetype=default id={{::channel.defaultImage}} imagesize=300x169></nowimage></a></div><div class=channelSlider><div class=\"now-teaserset channel now-channel-{{::channel.id}}\" id=teaserset1><div class=now-teaserset-overflow></div><div class=\"now-teaserset-content now-row-l\"><div class=shownteasers><div class=channelSlideLoader><now-loading-spinner></now-loading-spinner></div><div class=channelSlide><nowteaser class=now-teaser-m teaser=teaser ng-repeat=\"teaser in channel.teasers\" on-finish-render=ngRepeatFinished></nowteaser></div></div></div><div class=\"now-teaser-arrow now-teaser-arrow-right\" ng-hide=teaserset.disableArrows tooltip=\"Weitere Sendungen\"><span class=\"icon icon_arrow_right\"></span></div><div class=\"now-teaser-arrow now-teaser-arrow-left\" ng-hide=teaserset.disableArrows tooltip=\"Weitere Sendungen\"><span class=\"icon icon_arrow_left\"></span></div></div></div><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/channel_view.html',
    "<h1>Channels</h1><div ng-show=loading><now-loading-spinner></now-loading-spinner></div><div ng-show=!loading class=\"channel now-scroll-top\"><channelteaser station=station channel=channel ng-repeat=\"channel in channels.items\"></channelteaser></div>"
  );


  $templateCache.put('templates/customheader.html',
    ""
  );


  $templateCache.put('templates/epg_row.html',
    "<div class=now-filmlist-panel ng-class=\"{hover:(vm.entry.movie || vm.entry.current)}\" ng-click=vm.gotoEntry(vm.entry)><div class=time ng-class={now:vm.entry.current}><span ng-hide=vm.entry.current>{{::vm.entry.startDate | amDateFormat:'HH:mm'}}</span> <a ng-href=\"/{{vm.station | stationalias}}/live-tv?autostart\" ng-show=vm.entry.current ng-click=vm.trackLivePlay();><span>JETZT LIVE</span></a></div><div class=image ng-click=$event.stopPropagation();><div ng-show=vm.entry.movie><nowfavoritebutton item=vm.entry.movie></nowfavoritebutton></div><div class=imagehover ng-show=vm.entry.movie><a ng-href=\"{{::vm.entry.movie|geturl: 'appendpayment'}}\" ng-click=vm.trackMoviePlay(vm.entry.movie);><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a><now-shared-circle movie=vm.entry.movie></now-shared-circle></div><a ng-href=\"{{::vm.entry.movie|geturl: 'appendpayment'}}\" ng-click=vm.trackMoviePlay(vm.entry.movie);><nowimage epgid=::vm.entry.id imagesize=140x79></nowimage></a></div><div class=content><div ng-show=vm.entry.movie></div><a ng-href=\"{{::vm.entry.movie|geturl: 'appendpayment'}}\" class=text-small>{{::vm.entry|statustext}}</a><br><div class=text-title><a ng-show=vm.entry.movie.format ng-href=\"{{::vm.entry.movie|geturl: 'appendpayment'}}\" ng-click=vm.trackMoviePlay(vm.entry.movie);>{{::vm.entry.movie.format.title}}</a> <a ng-hide=vm.entry.movie.format ng-href=\"{{::vm.entry.movie|geturl: 'appendpayment'}}\" ng-click=vm.trackMoviePlay(vm.entry.movie);>{{::vm.entry.title}}</a></div><div class=links ng-show=entry.movie><a ng-href=\"{{::vm.entry.movie|geturl: 'detail'}}\" ng-click=\"vm.trackEvent('mehr_infos');$event.stopPropagation();\">MEHR INFOS</a> <span ng-show=\"!vm.entry.movie.free && vm.entry.movie.trailers && vm.entry.movie.trailers.items.length > 0\">| <a ng-href=\"{{::vm.entry.movie|geturl: 'preview'}}\" ng-click=\"vm.trackEvent('vorschau');$event.stopPropagation();\">VORSCHAU <span class=\"icon icon-nowarrow_play\"></span></a></span></div></div><div class=iconpanel><a ng-href=\"{{::vm.entry.movie|geturl: 'appendpayment'}}\" ng-show=\"vm.entry.movie && !vm.entry.current\" ng-click=vm.trackMoviePlay(vm.entry.movie);><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a> <a ng-show=vm.entry.current ng-href=\"/{{vm.station | stationalias}}/live-tv?autostart\" ng-click=vm.trackLivePlay();><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a><now-shared-circle movie=::vm.entry.movie ng-hide=vm.entry.current></now-shared-circle><now-shared-circle custom=play ng-show=vm.entry.current text=\"Jetzt live\"></now-shared-circle></div></div>"
  );


  $templateCache.put('templates/epg_toolbar.html',
    "<div class=\"now-toolbar now-toolbar-epg\" now-dock-toolbar=\"{offset:'120'}\"><div class=background><now-station-switch selection=selectedStations cb=selectedStation(arg1) more-menu-start-positions=startpositions force-dropdown=1 tracksiteregion=epg></now-station-switch><div class=\"buttons show-s show-m\"><div class=\"daydropdown button\" ng-show=\"dayOptions.length > 0\" dropdown-select=dayOptions dropdown-model=daySelected dropdown-item-label=text tracksiteregion=epg dropdown-onchange=goToDay(selected)></div></div><div class=\"buttons show-l\"><table class=dayttable><tr><td data-ng-repeat=\"day in days\" on-finish-render=ngRepeatFinished><div class=button ng-class=\"{active: $index == selected}\" ng-click=goToDay(day,$index)><span ng-show=\"$index <= 1\">{{day.name}}</span> <span ng-show=\"$index > 1\">{{day.nameshort}}</span></div></td></tr></table></div><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/epg_view.html',
    "<div><epgtoolbar></epgtoolbar><div ng-show=loading class=\"now-filmlist-panel now-filmlist-infopanel\"><now-loading-spinner></now-loading-spinner></div><div ng-show=\"movies.items.length === 0\" class=\"center-box text-center now-filmlist-panel now-filmlist-infopanel\">Es gibt leider kein Programm für den Tag</div><div ng-show=!loading class=\"epg now-scroll-top\"><epgrow entry=entry ng-repeat=\"entry in movies.items\"></epgrow></div><div class=rows><div ng-repeat=\"teaserset in teasersets\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div><now-genre-menu></now-genre-menu></div>"
  );


  $templateCache.put('templates/footer.html',
    "<div class=\"now-footer now-base-background-50\"><div class=\"now-footer-content center-box text-center\" ng-class=\"{'tablet-view-footer':vm.isTabletFooter}\"><div class=now-footer-nav><a href=http://hilfe.tvnow.de class=tour-help-contact ng-click=\"vm.trackEvent('hilfe_kontakt');\">Hilfe & Kontakt</a> | <a href=/impressum ng-click=\"vm.trackEvent('impressum');\">Impressum</a> | <a href=/agb ng-click=\"vm.trackEvent('agb');\">AGB</a> | <a href=/datenschutz ng-click=\"vm.trackEvent('datenschutz');\">Datenschutz</a> | <a ng-click=\"vm.trackEvent('privacy_center');\" onclick=\"tC.privacyCenter.showPrivacyCenter();return false\">Privacy Center</a> | <a href=http://tvnowstatic-a.akamaihd.net/pms/widerrufsformular-now.pdf ng-click=\"vm.trackEvent('widerruf');\" target=_blank>Widerrufsformular</a><br><a href=http://www.ip-deutschland.de/datenschutzinfo_online-werbung target=_blank ng-click=\"vm.trackEvent('nutzungsbasierte_werbung');\">Nutzungsbasierte Online-Werbung</a> | <a href=https://www.ip.de/mediadaten_tvnow ng-click=\"vm.trackEvent('werben_auf_now');\">Werben auf TV NOW</a> | <a href=\"https://www.mediengruppe-rtl.de/jobs/Aktuelle-Stellenangebote/\" target=_blank ng-click=\"vm.trackEvent('karriere');\">Karriere</a> | <a href=/glossar ng-click=\"vm.trackEvent('glossar');\">Glossar</a> | <a href=# ng-click=vm.toggleVideo() ng-hide=vm.disableVideo>Vorschauvideos deaktivieren</a> <a href=# ng-click=vm.toggleVideo() ng-show=vm.disableVideo>Vorschauvideos aktivieren</a><br><table class=\"footer-station-logos center-box text-center\"><tr><td colspan=8>&nbsp;</td></tr></table></div><span data-ng-click=vm.clickVersion()>&copy;</span> 2018 RTL interactive GmbH <span class=version data-ng-show=vm.showVersion><br>{{vm.version}}</span><br><div class=\"browsersupportbar expanded\" ng-show=vm.browserSupportBar><div class=header><div class=text translate=browser.support.infotext ng-click=\"vm.trackBrowserDetection('link')\"></div><div class=button-box><div class=button ng-click=vm.closeBar()><span class=label>OK</span></div></div></div></div><div class=\"privacydetectionbar expanded\" ng-show=vm.privacyDetectionBar><div class=header><div class=text><span translate=privacy.detection.infotext></span>&nbsp;<a href=# ng-click=\"vm.closePrivacyBar();vm.trackPrivacyDetection('klick_privacy_center');\" onclick=\"tC.privacyCenter.showPrivacyCenter();return false\">Privacy Center</a>.</div><div class=button-box><div class=button ng-click=\"vm.trackPrivacyDetection('klick_spaeter');vm.closePrivacyBar();\"><span class=label>Später</span></div></div></div></div><div class=debugbar ng-class={expanded:vm.expand} ng-show=vm.debugMode><div class=header>TVNOW-Debugbar - Version {{vm.version}}<div class=\"button pull-right\" ng-click=\"vm.expand=!vm.expand\"><span class=icon ng-class={icon_arrow_down:!vm.expand,icon_arrow_up:vm.expand}></span></div></div><div class=content><div class=column><div class=header>Optionen</div><div class=button ng-click=vm.logout()>Logout</div><div class=button ng-click=vm.clearStorage()>Local- und Sessionstorage löschen</div></div><div class=column><div class=header>Logs - <a ng-click=\"vm.logs = []\">löschen</a></div><table class=logs><thead><tr><td>#</td><td>Log</td></tr></thead><tbody><tr ng-repeat=\"log in vm.logs\"><td>{{$index}}</td><td>{{log}}</td></tr></tbody></table></div></div></div></div></div>"
  );


  $templateCache.put('templates/genre_menu.html',
    "<div class=now-genre-menu><div class=now-teaserset-headline>Unsere Genres</div><div class=now-genre-menu-content><div ng-repeat=\"genre in genres\" class=now-genre-button><a ng-href=/genres/{{genre.toLowerCase()}}><span class=\"icon icon_arrow_right pull-left\"></span> {{genre|genretext}}</a></div></div></div>"
  );


  $templateCache.put('templates/genre_tabs.html',
    "<div class=\"now-toolbar now-toolbar-tabs now-toolbar-genre\"><div class=background><div class=\"button arrow clean-margin\"><span class=\"icon icon_arrow_right\"></span></div><div class=\"button arrow\"><span class=\"icon icon_arrow_left\"></span></div><div class=buttons><div class=button ng-class=\"{active: genre.toLowerCase() == currentGenre.toLowerCase()}\" ng-repeat=\"genre in genreList\" ng-click=gotoGenre(genre);><a ng-href={{urlBase}}{{genre.toLowerCase()}}>{{genre | genretext}}</a></div></div></div></div>"
  );


  $templateCache.put('templates/genre_view.html',
    "<searchdropdown ng-controller=NowSearchController></searchdropdown><div class=\"rows now-scroll-top\"><div teaserroweditmodecustom ng-repeat=\"teaserset in teasersets | slice:0:1\"><teasersetcustom></teasersetcustom></div></div><div class=now-teaserset-headline><span class=genre-now-teaserset-headline-text>&nbsp;</span><div dropdown-select=orderOptions dropdown-model=orderSelected dropdown-item-label-button=label dropdown-onchange=orderChanged(selected)></div><freebutton checkmodel=isFree></freebutton></div><nowgenretabs></nowgenretabs><div infinite-scroll=nextPage() infinite-scroll-disabled=\"loading || endreadched\" infinite-scroll-distance=2><div class=now-genre-teaserset><nowteaser ng-repeat=\"movie in movielist | filter:isFreeFilter | orderBy:orderSelected.value:false\" layout=genre_movie></nowteaser><nowteaser ng-repeat=\"format in formatlist | filter:isFreeFilter | orderBy:orderSelected.value:false\" layout=genre_format></nowteaser><div class=clear></div></div><div ng-show=loading><now-loading-spinner></now-loading-spinner></div><div ng-show=empty class=\"center-box text-center\">Es wurden keine Filme gefunden!</div><div class=clear></div></div><div class=\"now-genres rows\"><div teaserroweditmodecustom ng-repeat=\"teaserset in teasersets | slice:1:10\"><teasersetcustom></teasersetcustom></div></div>"
  );


  $templateCache.put('templates/header_iconnavi.html',
    "<div class=icon_navigation><div class=\"button button-az\" ng-class=\"{active:isActive('/az')}\" ng-click=\"goPage('/az',false,true)\"><span class=\"icon icon_menu_az\" tooltips tooltip-template=\"Sendungen A-Z\" tooltip-side=top></span></div><div class=\"button button-missed\" ng-class=\"{active:isActive('/sendung-verpasst')}\" ng-click=\"goPage('/sendung-verpasst',false,true)\"><span class=\"icon icon_menu_missed\" tooltips tooltip-template=\"Sendung verpasst?\" tooltip-side=top></span></div><div class=\"button button-livetv\" ng-class=\"{active:isActive('/live-tv')}\" ng-click=\"goPage('/live-tv',false,true)\"><span class=\"icon icon_menu_live\" tooltips tooltip-template=\"Live TV\" tooltip-side=top></span></div><div class=\"button button-tvprogramme\" ng-class=\"{active:isActive('/tv-programm')}\" ng-click=\"goPage('/tv-programm')\"><span class=\"icon icon_menu_epg\" tooltips tooltip-template=\"TV Programm\" tooltip-side=top></span></div><div class=\"button button-channels\" ng-class=\"{active:isActive('/channels')}\" ng-click=\"goPage('/channels',false,true)\"><span class=\"icon icon_menu_channels\" tooltips tooltip-template=Channels tooltip-side=top></span></div><div class=\"button button-myprogramme\" ng-class=\"{active:isActive('/meine-merkliste')}\" ng-click=\"goPage('/meine-merkliste',false,true)\"><span class=\"icon icon_menu_playlist\" tooltips tooltip-template=\" Meine Merkliste\" tooltip-side=top></span></div><div class=\"button navi-search-button\" ng-click=togleSearch()><span class=\"icon icon_menu_search\" tooltips tooltip-template=Suche tooltip-side=top></span></div></div>"
  );


  $templateCache.put('templates/header_search.html',
    "<div class=now-header-search><form><input placeholder=Suchen ng-model=service.query class=search-input ng-model-options=\"{debounce: 500}\"></form><span class=\"icon icon_M_Search pull-right\"></span> <span class=\"icon close icon_IC_Close pull-right\"></span></div>"
  );


  $templateCache.put('templates/header_stations.html',
    "<div></div>"
  );


  $templateCache.put('templates/header.html',
    "<div class=\"now-header now-header-fixed page-{{cls}}\"><nowstationnavigation></nowstationnavigation><div class=now-header-background><div class=\"now-header-inner center-box\" ng-class=\"{'tablet-view-side':isTabletHome}\"><div class=now-header-content ng-class=\"{'tablet-view-side':isTabletHome}\" ng-controller=NowHeaderController><div><div class=now-header-logo ng-click=goHome()></div></div><accountoverlay></accountoverlay><now-search-field></now-search-field><now-header-iconnavigation></now-header-iconnavigation></div></div></div><div class=\"now-navigation now-base-background-50\" ng-controller=NowHeaderController><div class=\"now-navigation-inner center-box\" ng-class=\"{'tablet-view-side':isTabletHome}\"><div class=now-navigation-buttons><div class=\"button now-navigation-button now-navigation-button-az\" ng-class=\"{active:isActive('/az')}\" ng-click=\"goPage('/az',false,true)\"><div class=\"now-navigation-button-inner show-l show-m\"><span class=\"icon icon_menu_az\"></span> Sendungen A-Z</div><div class=\"now-navigation-button-inner show-s\"><span class=\"icon icon_menu_az\"></span> A-Z</div></div><div class=\"button now-navigation-button now-navigation-button-missed\" ng-class=\"{active:isActive('/sendung-verpasst')}\" ng-click=\"goPage('/sendung-verpasst',false,true)\"><div class=now-navigation-button-inner><span class=\"icon icon_menu_missed\"></span> Sendung verpasst?</div></div><div class=\"button now-navigation-button now-navigation-button-live\" ng-class=\"{active:isActive('live-tv')}\" ng-click=\"goPage('/live-tv')\"><div class=now-navigation-button-inner><span class=\"icon icon_menu_live\"></span> Live TV</div></div><div class=\"button now-navigation-button now-navigation-button-epg\" ng-class=\"{active:isActive('tv-programm')}\" ng-click=\"goPage('/tv-programm')\"><div class=now-navigation-button-inner><span class=\"icon icon_menu_epg\"></span> TV Programm</div></div><div class=\"button now-navigation-button now-navigation-button-channel tour-channel\" ng-class=\"{active:isActive('/channels',false,true)}\" ng-click=\"goPage('/channels',false,true)\"><div class=now-navigation-button-inner><span class=\"icon icon_menu_channels\"></span> Channels</div></div><div class=\"button now-navigation-button now-navigation-button-myprogramm tour-myprogramm\" ng-class=\"{active:isActive('/meine-merkliste')}\" ng-click=\"goPage('/meine-merkliste',false,true)\"><div class=\"now-navigation-button-inner show-l show-m\"><span class=\"icon icon_menu_playlist\"></span> Meine Merkliste<nowfavoritecounter></nowfavoritecounter></div><div class=\"now-navigation-button-inner show-s\"><span class=\"icon icon_menu_playlist\"></span> Merkliste<nowfavoritecounter></nowfavoritecounter></div></div></div></div></div></div>"
  );


  $templateCache.put('templates/home_landingpage.html',
    "<div class=landingpage ng-show=landingpage><div class=headline data-translate=web.load.landingpage.headline></div><div class=header>&nbsp;</div><div class=text><div class=large data-translate=web.load.landingpage.headline2></div><div class=small data-translate=web.load.landingpage.description></div></div><div class=buttons><div class=button ng-click=returnToHome()>Zur Startseite</div><div class=\"button no-margin\" ng-click=returnToLivestream()>Direkt zum Livestream</div></div></div>"
  );


  $templateCache.put('templates/home_leadteaser.html',
    "<div class=now-leadteaser><div class=now-leadteaser-video><video id=leadvideo class=video autoplay ng-show=videoShow><source src={{videosrc}} type=video/mp4>Your browser does not support the video tag.</source></video><img ng-src={{imageSrc1}} ng-class=\"{transparent:(imageIndex == '2')}\" ng-show=imageShow> <img ng-src={{imageSrc2}} ng-class=\"{transparent:(imageIndex == '1')}\" ng-show=imageShow></div><div class=now-leadteaser-background><div class=now-leadteaser-overlay><nowfavoritebutton item=statusitem onshow=favButtonOnShow() onhide=favButtonOnHide()></nowfavoritebutton><div class=now-leadteaser-bottom ng-class={show:showBottom}><div class=now-leadteaser-top-inner ng-click=goto()>&nbsp;</div><div class=now-leadteaser-bottom-inner><div class=now-leadteaser-text><div class=now-leadteaser-smalltext ng-show=small ng-class={&quot;now-leadteaser-smalltext-highlight&quot;:(statusitem.livestreamEvent)}><span class=now-base-background-50 ng-click=goto()>{{small}}</span></div><div class=now-leadteaser-smalltext ng-hide=small ng-class={&quot;now-leadteaser-smalltext-highlight&quot;:(statusitem.livestreamEvent)}><span class=now-base-background-50 ng-click=goto()>{{statusitem |statustext}}</span></div><div class=\"now-leadteaser-largetext show-s\" ng-click=goto()><span>{{large|truncate:45}}</span></div><div class=\"now-leadteaser-largetext show-m\" ng-click=goto()><span>{{large|truncate:80}}</span></div><div class=\"now-leadteaser-largetext show-l\" ng-click=goto()><span>{{large|truncate:115}}</span></div><div ng-show=\"description !== null && description.length > 0\" class=\"now-leadteaser-description show-s\" ng-click=goto()><span>{{description|truncate:45}}</span></div><div ng-show=\"description !== null && description.length > 0\" class=\"now-leadteaser-description show-m\" ng-click=goto()><span>{{description|truncate:80}}</span></div><div ng-show=\"description !== null && description.length > 0\" class=\"now-leadteaser-description show-l\" ng-click=goto()><span>{{description|truncate:115}}</span></div></div><div class=now-leadteaser-images><div class=now-leadteaser-nav><span class=\"icon icon_arrow_left\"></span></div><div class=images><div class=now-leadteaser-image data-ng-repeat=\"subteaser in subteasers track by $index\" ng-class=\"{active:($index===3)}\"><div class=border></div><nowimage class=logo attr formatid=subteaser.format.id imagesize=140x79 formattype=formatlogo ng-click=recommendationService.fireEventRecClick(subteaser.teaserItem)></nowimage><nowimage class=format movie=subteaser.movie formatid=subteaser.format.id imagesize=140x79></nowimage></div></div><div class=now-leadteaser-nav><span class=\"icon icon_arrow_right\"></span></div><div class=clear></div></div></div></div></div></div></div>"
  );


  $templateCache.put('templates/home.html',
    "<div ng-hide=landingpage class=\"now-toolbar now-home-toolbar now-docked-toolbar now-scroll-top\" now-dock-toolbar=\"{offset:'100'}\"><now-station-switch show-all=true selection=selectedStations cb=selectedStation(arg1) tracksiteregion=home customstations=stations></now-station-switch></div><ng-include src=\"'templates/static.html'\"></ng-include><div ng-hide=landingpage><now-genre-menu></now-genre-menu></div><div ng-if=landingpage><now-home-landing-page></now-home-landing-page></div>"
  );


  $templateCache.put('templates/intro_button.html',
    "<div class=now-intro><div class=bubble ng-hide=hide><div class=content><b>Alles so neu hier?</b><br><br>Starten Sie jetzt unsere Tour und<br>lernen Sie TV NOW kennen.<div class=links><span class=biglink ng-click=start();>Start</span> <span class=link ng-click=later();>Später</span> <span class=link ng-click=never();>Nicht mehr anzeigen</span></div></div><div class=arrow></div></div><div class=now-intro-button ng-click=start();><span class=\"icon icon_tour\"></span> <span class=divider></span> Tour</div><div class=\"now-intro-button now-intro-button-help\" ng-click=help();><span class=\"icon icon_help\"></span> <span class=divider></span> Hilfe</div><div class=clear></div></div>"
  );


  $templateCache.put('templates/live_epg.html',
    "<div><div class=header><div class=column>JETZT LIVE</div><div class=column>DANACH</div><div class=clear></div></div><div class=stations><div class=\"row row-{{::station}}\" ng-class=\"{active:(activestation === station)}\" ng-repeat=\"station in stations\" ng-click=selectStation(station);><div class=\"column station\"><div class=\"headerstations headerstations-{{station | stationalias}}\"></div></div></div></div><div class=episodes><div class=\"row row-{{::station}}\" ng-class=\"{active:(activestation === station)}\" ng-repeat=\"station in stations\" ng-click=selectStation(station);><div class=\"column now\"><div class=columncontent><span class=time>{{entries[station].now.time}}</span> <span class=episode ng-class=\"{episodecenter:(entries[station].now.subTitle.length==0)}\">{{entries[station].now.title}}<br><span class=episode-subline ng-show=entries[station].now.subTitle>{{entries[station].now.subTitle}}</span></span></div><div class=barbg><div class=bar ng-style=\"{'width':entries[station].now.percentage+'%'}\"></div></div></div><div class=\"column next\"><span class=time>{{entries[station].next.time}}</span> <span class=episode ng-class=\"{episodecenter:(entries[station].next.subTitle.length==0)}\">{{entries[station].next.title}}<br><span class=episode-subline>{{entries[station].next.subTitle}}</span></span></div><div class=clear></div></div></div></div>"
  );


  $templateCache.put('templates/live_player.html',
    "<div><div class=\"now-liveplayer html5\" ng-hide=show>&nbsp;</div><div class=\"now-liveplayer html5\" ng-show=show now-adcontrol=\"\"><div class=\"content center-box\"><div class=player><div id=vaa_underlay></div><div class=player_box><div ng-show=showPreviewPic><div class=player_box_content ng-click=startPlayer()><div class=player_text ng-show=showPreviewPic><span class=large ng-show=largeText ng-click=startPlayer()>{{largeText}}</span><br><span class=small ng-show=smallText ng-click=startPlayer()>{{smallText}}</span></div></div><div class=imagehover ng-click=startPlayer()><now-shared-circle custom=play></now-shared-circle></div><div class=player_img><span class=\"station icon icon_station_{{station|stationalias}}\"></span> <img ng-show=showPreviewPic ng-src={{urlPreviewPic}} id=liveplayer_preview ng-click=\"startPlayer()\"></div></div><div ng-hide=showPreviewPic id=liveplayer_wrapper><div id=liveplayer_container ng-mousemove=showBar()><div class=html5-top ng-show=fullscreen><now-videobar exit=exitPlayer exit-text=\"Vollbild verlassen\"></now-videobar></div><now-player-infobox></now-player-infobox></div></div><nowbreakad></nowbreakad></div><div id=sponsorbanner class=sponsorbanner ng-show=\"showPlayerAd && !isNoFlash()\"></div><div id=vaa_sky_right></div></div></div><div id=vaa_overlay></div></div></div>"
  );


  $templateCache.put('templates/live_view.html',
    "<div class=\"liveepg now-scroll-top\"><nowliveplayer previewpic=urlPreviewPic showpreview=showPreviewPic largetext=largeText smalltext=smallText></nowliveplayer><div ng-show=loading><now-loading-spinner></now-loading-spinner></div><now-live-epg></now-live-epg><div class=rows><div ng-repeat=\"teaserset in teasersets\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div></div>"
  );


  $templateCache.put('templates/missed_toolbar.html',
    "<div class=\"now-toolbar now-toolbar-missed\" now-dock-toolbar=\"{offset:'50'}\"><div class=background><now-station-switch selection=selectedStations allow-multiple=true tracksiteregion=missed genre-selected=$parent.genreSelected more-menu-start-position=6 cb=selectedStation(arg1)></now-station-switch><div class=\"buttons show-s show-m\"><div class=\"daydropdown button\" ng-show=\"dayOptions.length > 0\" dropdown-select=dayOptions dropdown-model=daySelected dropdown-item-label=text dropdown-onchange=goToDay(selected); ng-click=trackDropdownClick();></div></div><div class=\"buttons show-l\"><table class=dayttable><tr><td data-ng-repeat=\"day in days\" on-finish-render=ngRepeatFinished><div class=button ng-class=\"{active: $index == selected}\" ng-click=goToDay(day,$index)><span ng-show=\"$index <= 1\">{{day.name}}</span> <span ng-show=\"$index > 1\">{{day.nameshort}}</span></div></td></tr></table></div><div class=clear></div><div class=\"buttons resetfilter\"><span ng-show=\"selectedStations.indexOf('tvnow') == -1 &&  selectedStations.length > 0\" ng-click=showAllStations();>Filter zurücksetzen</span><div class=daytime-navi><a data-ng-repeat=\"group in groups\" ng-show=\"(group.items | filter:teaserFilter).length > 0\" ng-click=gotoTime(group.title)>{{group.linkText}}</a></div></div><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/missed_view.html',
    "<now-missed-toolbar></now-missed-toolbar><div ng-show=loading><now-loading-spinner></now-loading-spinner></div><div ng-hide=loading class=now-scroll-top><div data-ng-repeat=\"group in groups\" ng-show=\"(group.items | filter:teaserFilter).length > 0\"><div class=\"now-teaserset-headline now-teaserset-headline-missed\" ng-show=\"group.headline != ''\"><a id={{group.title}}></a> <span class=title>{{group.title}}</span> <span class=time>{{group.start | amDateFormat:'HH:mm'}}-{{group.end | amDateFormat:'HH:mm'}}</span></div><div class=\"now-teaserset now-teaserset-missed\"><nowteaser class=now-teaser-m ng-repeat=\"teaser in filteredEntries = (group.items | filter:teaserFilter) \"></nowteaser></div></div></div><div class=rows><div ng-repeat=\"teaserset in teasersets\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div><now-genre-menu></now-genre-menu>"
  );


  $templateCache.put('templates/moviedetail_gallery.html',
    "<div class=now-detail-gallery><div class=largeSlideContainer><div class=\"button icon icon_arrow_left\" ng-show=\"movie.pictures.filtered_pictures.length > 1\"></div><div class=\"button icon icon_arrow_right\" ng-show=\"movie.pictures.filtered_pictures.length > 1\"></div><div class=count ng-show=\"movie.pictures.filtered_pictures.length > 1\">{{movie.pictures.filtered_pictures.length}} Bilder</div><div class=imagehover><a ng-href=\"{{::movie|geturl: 'preview'}}\" ng-show=\"!movie.free && !isPremiumUser && movie.trailers.items && movie.trailers.items.length > 0 && !isTablet\"><now-shared-circle movie=::movie showtrailer=1></now-shared-circle></a> <a ng-href={{url}} ng-show=\"movie.free || isPremiumUser\"><now-shared-circle movie=::movie></now-shared-circle></a></div><div class=largeSlide ng-show=\"movie.pictures.filtered_pictures.length > 1\"><div ng-repeat=\"picture in movie.pictures.filtered_pictures\"><nowimage position={{$index}} movie=movie imagesize=620x349></nowimage></div></div><nowimage ng-show=\"movie.pictures.filtered_pictures.length <=1\" movie=movie imagesize=620x349></nowimage></div><div class=navSlides ng-show=\"movie.pictures.filtered_pictures.length > 1\"><div ng-repeat=\"picture in movie.pictures.filtered_pictures\"><nowimage position={{$index}} movie=movie imagesize=140x79></nowimage></div></div></div>"
  );


  $templateCache.put('templates/moviedetail_texts.html',
    "<div class=now-detail-panel><div class=texts><span class=small>{{movie.broadcastStartDate | amDateFormat:'dd. DD.MM.YYYY HH:mm'}}</span><br><span class=title>{{movie.title}}</span><br><span class=text>{{movie.articleShort}}</span><br></div><div class=iconpanel><a ng-href={{url}}><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a><now-shared-circle movie=movie></now-shared-circle></div></div>"
  );


  $templateCache.put('templates/moviedetail_view.html',
    "<div ng-show=loading><now-loading-spinner></now-loading-spinner></div><div ng-show=!loading><div class=\"now-detail now-scroll-top\"><nowdetailtexts></nowdetailtexts><nowdetailgallery></nowdetailgallery><div><div class=headline>Details</div><div class=text ng-bind-html=movie.articleLong|newline></div></div></div></div><div class=clear></div><now-genre-menu></now-genre-menu>"
  );


  $templateCache.put('templates/movielist_headerimage.html',
    "<div class=now-movielist-headerimage><nowfavoritebutton item=format></nowfavoritebutton><div class=link ng-show=\"format.headerLinkText.length > 0\"><a href={{format.headerLinkSrc}} target=_blank>{{::format.headerLinkText}}</a> <span ng-hide=hideStationText><span>bei&nbsp;</span><a ng-href=http://www.{{::stationDomain}}.de target=_blank>{{::stationText}}.de</a></span></div><nowimage class=show-s formatid=format.id formattype=header imagesize=620x169></nowimage><nowimage class=show-m formatid=format.id formattype=header imagesize=940x169></nowimage><nowimage class=show-l formatid=format.id formattype=header imagesize=1260x169></nowimage></div>"
  );


  $templateCache.put('templates/movielist_row.html',
    "<div class=now-filmlist-panel ng-class=\"{blocked:(movie.blockadeText != '0'), hover:(movie.blockadeText == '0'),'tablet-filmlist-panel':isTablet}\"><div class=image><span class=\"station icon icon_station_{{::movie.format.station}}\"></span><nowfavoritebutton item=movie></nowfavoritebutton><div class=imagehover><now-shared-circle movie=movie></now-shared-circle></div><a ng-href=\"{{::movie|geturl: 'appendpayment'}}\" ng-click=trackMoviePlay(movie);><nowimage movie=::movie formatid=::movie.format.id formattype=formatlogo imagesize=300x169></nowimage></a></div><div class=content><a ng-href=\"{{::movie|geturl: 'appendpayment'}}\" ng-click=trackMoviePlay(movie); class=text-small>{{::movie |statustext}}</a><br><div class=text-title><a ng-href=\"{{::movie|geturl: 'appendpayment'}}\" ng-click=trackMoviePlay(movie);>{{::movie.title}}</a></div><div class=\"text text_l\">{{::movie.articleShort | truncate:270}}</div><div class=\"text text_m\">{{::movie.articleShort | truncate:150}}</div><div class=\"text text_s\">{{::movie.articleShort | truncate:90}}</div><div class=links><a ng-href=\"{{::movie|geturl: 'detail'}}\" ng-click=\"trackEvent('mehr_infos');\">MEHR INFOS</a> <span ng-show=\"!movie.free && movie.trailers && movie.trailers.items.length > 0 && !isTablet\">| <a ng-href=\"{{::movie|geturl: 'preview'}}\" ng-click=\"trackEvent('vorschau');\">VORSCHAU <span class=\"icon icon-nowarrow_play\"></span></a></span></div></div><div class=iconpanel><a class=link ng-href=\"{{::movie|geturl: 'appendpayment'}}\" ng-click=trackMoviePlay(movie);><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a><now-shared-circle movie=movie></now-shared-circle></div></div>"
  );


  $templateCache.put('templates/movielist_seasontabs.html',
    "<div class=\"now-toolbar now-toolbar-movielist now-toolbar-tabs\"><div class=background><div><div class=\"button arrow clean-margin\"><span class=\"icon icon_arrow_right\"></span></div><div class=\"button arrow\"><span class=\"icon icon_arrow_left\"></span></div><div class=\"buttons slickbuttons\"><div class=\"button button-show\" ng-class=\"{active: $index == selected}\" ng-repeat=\"tab in format.formatTabs.items\" ng-click=\"select($index);loadSeasonContent(tab.id, false, tab.seoheadline, $index);\">{{::tab.headline}}<div class=tv ng-show=::tab.tv>TV</div></div></div><div class=clear></div></div><div class=bottom><freebutton ng-hide=hideFree checkmodel=$parent.isFree></freebutton><div dropdown-select=orderOptions dropdown-model=orderSelected dropdown-item-label-button=label ng-class={&quot;now-orderbutton&quot;:true} dropdown-onchange=orderChanged(selected)></div><div class=clear></div></div></div><div ng-hide=1 class=crawlable_links><a ng-show=!$first ng-repeat=\"tab in format.formatTabs.items\" ng-href=\"/{{::format.station | formaturl}}/{{::format.seoUrl}}/list/{{::tab.seoheadline}}\">{{::tab.headline}}</a></div></div>"
  );


  $templateCache.put('templates/movielist_view.html',
    "<div ng-show=\"loadingMovieList && !error\"><now-loading-spinner></now-loading-spinner></div><div ng-hide=loadingMovieList><headerimage></headerimage><div class=\"rows now-scroll-top\"><div ng-repeat=\"teaserset in teasersets | slice:0:1\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div><div ng-if=\"format.tabSeason && !specialTabsActive\"><movietabs seasontab=season></movietabs></div><div ng-if=\"(!format.tabSeason || specialTabsActive)\"><movietabs seasontab=year></movietabs></div><div ng-show=\"tabloading && !error\" class=\"now-filmlist-panel now-filmlist-infopanel\"><now-loading-spinner></now-loading-spinner></div><div ng-show=\"!tabloading && filterActive && (allmovies|filter:isFreeFilter).length == 0\" class=\"center-box text-center now-filmlist-infopanel\">Momentan gibt es keine kostenlosen Folgen</div><div ng-show=\"(!format.tabSeason)  && !tabloading && !orderActive && !filterActive\"><div ng-repeat=\"container in tabmovies\"><div class=now-teaserset-headline ng-bind-html=\"container.title | htmlize\"></div><div class=now-filmlist><movielistrow movie=movie on-finish-render=ngRepeatFinished ng-repeat=\"movie in container.items | filter:isFreeFilter | orderBy:[orderSelected.value, '-orderWeight']\"></movielistrow></div></div></div><div ng-hide=\"(tabloading || orderActive) && format.tabSeason\"><div class=now-teaserset-headline ng-show=\"filterActive && (allmovies|filter:isFreeFilter).length > 0\">FREE | {{(allmovies|filter:isFreeFilter).length}} kostenlose Folgen</div><div ng-hide=\"tabloading || filterActive\"><div ng-repeat=\"tabpage in currentTabs.formatTabPages.items\" ng-hide=\"(!format.tabSeason || !tabpage.container.movies || tabpage.container.movies.items.length == 0)\"><div class=now-teaserset-headline ng-hide=\"filterActive || (selectedPage>1 && !paginationMovies[tabpage.container.id])\" ng-bind-html=\"tabpage.container.headline | htmlize\"></div><div class=now-filmlist><movielistrow movie=movie on-finish-render=ngRepeatFinished ng-repeat=\"movie in tabpage.container.movies.items | filter:isFreeFilter | orderBy:['orderWeight', orderSelected.value, '-broadcastStartDate']\" ng-show=\"selectedPage==1\"></movielistrow><movielistrow movie=movie on-finish-render=ngRepeatFinished ng-repeat=\"movie in paginationMovies[tabpage.container.id] | filter:isFreeFilter | orderBy:['orderWeight', orderSelected.value, '-broadcastStartDate']\" ng-show=\"selectedPage>1\"></movielistrow><div class=\"now-toolbar now-toolbar-pagination\" ng-show=\"tabpage.container.movies.pages.length > 1\"><div class=background><div class=\"buttons pagination\"><div ng-repeat=\"page in tabpage.container.movies.pages.slice().reverse()\" class=button on-finish-render=ngRepeatFinished ng-click=paginatetab(tabpage.container.id,page) ng-class=\"{active: (page == selectedPage) }\">{{::page}}</div><div class=clear></div></div></div></div></div></div></div><div ng-show=\"filterActive && (allmovies|filter:isFreeFilter).length > 0\"><div class=now-filmlist><movielistrow movie=movie on-finish-render=ngRepeatFinished ng-repeat=\"movie in allmovies | filter:isFreeFilter | orderBy:[orderSelected.value, '-orderWeight', '-broadcastStartDate']\"></movielistrow></div></div></div><div ng-hide=\"tabloading || !orderActive || (filterActive && (allmovies|filter:isFreeFilter).length == 0)\"><div class=now-teaserset-headline>Folgen sortiert nach: {{orderby}}</div><div class=now-filmlist><movielistrow movie=movie on-finish-render=ngRepeatFinished ng-repeat=\"movie in allmovies | filter:isFreeFilter | orderBy:[orderSelected.value, '-orderWeight', '-broadcastStartDate']\"></movielistrow></div></div><div class=\"center-box text-center\" ng-show=\"!tabloading && (error || allmovies.length === 0 || (tabmovies.length === 0 && !vm.format.tabSeason))\">Hinweis:<br><div ng-show=\"format.emptyListText.length > 0\" ng-bind-html=\"format.emptyListText | htmlize\"></div><div ng-if=\"format.emptyListText.length === 0\">Aktuell ist leider kein Video zu dieser Sendung / Staffel vorhanden.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.<br>Bis dahin stöbern Sie doch in unserem großen Angebot an kostenlosen Videos.</div><div ng-show=hasRecommendation class=text-left><teaserset></teaserset></div></div></div><div class=rows ng-show=onlyShowTeasersForFirstSeason><div ng-repeat=\"teaserset in teasersets | slice:1:10\" ng-switch=teaserset.automaticConfiguration.static><div ng-switch-when=true><teasersetcustom></teasersetcustom></div><div ng-switch-default><teaserset></teaserset></div></div></div><now-genre-menu></now-genre-menu>"
  );


  $templateCache.put('templates/movielist_yeartabs.html',
    "<div class=\"now-toolbar now-toolbar-movielist now-toolbar-years\"><div class=background><div><div class=\"buttons slickbuttons\"><div ng-show=\"format.tabSpecialTeaserPosition == 'before' && format.formatTabs.items.length > 0\" class=button ng-class=\"{active: ($index == selected && specialTabsActive), 'button-show': (format.tabSpecialTeaserPosition == 'before' && format.formatTabs.items.length > 0)}\" ng-repeat=\"tab in format.formatTabs.items\" ng-click=\"select($index);loadSeasonContent(tab.id,true,tab.seoheadline, $index);\">{{::tab.headline}}</div><div class=\"button month_tab tab_{{::month.month}}\" ng-class=\"{active: ($index == selected)}\" ng-repeat=\"month in months\" ng-click=\"select($index);loadMonthTab(month, $index);\"><div class=tv ng-show={{::month.currentMonth}}>TV</div><span class=long>{{::month.name}}</span> <span class=short>{{::month.nameshort}}</span></div><div ng-show=\"format.tabSpecialTeaserPosition == 'after' && format.formatTabs.items.length > 0\" class=button ng-class=\"{active: ($index == selected && specialTabsActive), 'button-show': (format.tabSpecialTeaserPosition == 'after' && format.formatTabs.items.length > 0)}\" ng-repeat=\"tab in format.formatTabs.items\" ng-click=\"select($index);loadSeasonContent(tab.id,true,tab.seoheadline, $index);\">{{::tab.headline}}</div></div><div ng-show=\"yearOptions.length > 0\" dropdown-select=yearOptions dropdown-model=yearSelected dropdown-item-label=text ng-click=refreshScrollbar(); ng-class={&quot;now-yeardropdown&quot;:true} dropdown-onchange=loadYear(selected)></div><div class=\"button arrow clean-margin\"><span class=\"icon icon_arrow_right\"></span></div><div class=\"button arrow\"><span class=\"icon icon_arrow_left\"></span></div><div class=\"clean-margin clear\"></div></div><div class=bottom><freebutton ng-hide=hideFree checkmodel=$parent.isFree></freebutton><div dropdown-select=orderOptions dropdown-model=orderSelected dropdown-item-label-button=label ng-class={&quot;now-orderbutton&quot;:true} dropdown-onchange=orderChanged(selected)></div></div><div class=clear></div></div><div ng-hide=1 class=crawlable_links><a ng-repeat=\"month in months\" ng-href=\"/{{::format.station | formaturl}}/{{::format.seoUrl}}/jahr/{{::currentYear}}/{{::month.month}}\">{{::month.name}}</a> <a ng-repeat=\"tab in format.formatTabs.items\" ng-href=\"/{{::format.station | formaturl}}/{{::format.seoUrl}}/list/{{::tab.headline}}\">{{::tab.headline}}</a> <a ng-repeat=\"year in yearOptions\" ng-href=\"/{{::format.station | formaturl}}/{{::format.seoUrl}}/jahr/{{::year.value}}\">{{::year.value}}</a></div></div>"
  );


  $templateCache.put('templates/myprogramme_formats.html',
    "<div class=\"now-teaserset now-teaserset-layout-7 clear\"><div ng-hide=\"teaserset.teaserSetInformations.items.length === 0 && !teaserset.loading\"><reload-wrapper><teaserset></teaserset></reload-wrapper></div><div ng-show=\"teaserset[0].teaserSetInformations.items.length === 0 && !teaserset.loading\"><div class=text><span translate=myprogramm.nofavorites></span></div></div></div>"
  );


  $templateCache.put('templates/myprogramme_movies.html',
    "<div class=\"now-teaserset now-teaserset-layout-6 clear\"><div ng-hide=\"teaserset.teaserSetInformations.items.length === 0 && !teaserset.loading\"><reload-wrapper><teaserset custom=teaserset></teaserset></reload-wrapper><div><div class=\"button now-basebutton pull-right\" ng-click=\"showDelete=true;\"><span class=\"icon icon_delete\"></span> Alle entfernen</div></div><div class=\"help clear\" ng-show=showDelete><div class=left><div class=text>Wirklich entfernen?<br><button ng-click=\"showDelete=false;\">Abbrechen</button> <button ng-click=\"showDelete=false;deleteAll();\">Ja</button></div></div><div class=icon ng-click=\"showDelete=false;deleteAll();\"><span class=icon_delete></span></div></div></div><div ng-show=\"teaserset.teaserSetInformations.items.length === 0 && !teaserset.loading\"><div class=text><span translate=myprogramm.nolastseen></span></div></div></div>"
  );


  $templateCache.put('templates/myprogramme_view.html',
    "<div class=\"myprogramme now-scroll-top\" ng-if=\"!loggedin || !isPremiumUser\"><div class=help><div class=left><div class=\"text userinfotext\"><br><span class=translation data-translate={{userInfoText}}></span></div></div><div class=link><a ng-href=# ng-click=showLogin() target={{teaser.custom.data.linktarget}}><span ng-if=!loggedin>Anmelden</span> <span ng-if=\"loggedin && !isPremiumUser\" translate=myprogramm.premium.required.button></span></a></div></div></div><div class=\"myprogramme myprogramme-favorites\" ng-if=\"loggedin && isPremiumUser\"><myprogramme-formats></myprogramme-formats></div><div class=\"myprogramme myprogramme-lastseen\" ng-if=\"loggedin && isPremiumUser\"><myprogramme-movies></myprogramme-movies></div><div ng-if=\"hasRecommendation && teaserset.teaserSetInformations.items.length > 0\"><teaserset></teaserset></div><now-genre-menu></now-genre-menu>"
  );


  $templateCache.put('templates/nowtv_view.html',
    "<searchdropdown ng-controller=NowSearchController></searchdropdown><nowleadteaser></nowleadteaser>"
  );


  $templateCache.put('templates/overlay_account_main.html',
    "<div ng-controller=NowAccountController><div class=\"now-overlay-dark now-overlay-dark-login\" ng-show=showdark ng-click=closeAll(true);></div><div ng-show=!loggedin class=\"button now-header-button now-register-button now-base-background-30\" ng-click=\"showRegistration();trackHeaderButton('registrierung');\" ng-class=\"{'tablet-margin':isTabletRegister}\"><span class=lable>Registrieren</span></div><div class=\"button now-login-button now-header-button now-base-background-30\" ng-click=\"showAccount();trackHeaderButton('login');\" ng-show=isTablet();><span class=\"icon icon_person pull-left\"></span> <span class=lable ng-show=!loggedin>Einloggen</span> <span class=lable ng-show=loggedin>Mein Profil</span></div><div class=\"now-overlay now-overlay-myworld\" ng-show=\"allowedPopupTypes.indexOf(type) > -1\"><div class=arrow></div><div class=top><span class=icon_close ng-click=\"show=closeAll()\"></span></div><div class=forms><div class=alert ng-show=\"type=='alert'\"><div class=\"alertlogin clear\"><div class=icon><span ng-class=alert.icon></span></div><div class=info><div ng-bind-html=alert.message|htmlize></div></div><div class=clear></div></div><div class=textlinks><a ng-show=alert.buttons.regmail ng-click=resendRegmail(); style=float:left>Erneut senden</a> <a ng-show=alert.buttons.regmail ng-click=\"type='account'\" style=float:right>E-Mail Adresse ändern</a><div class=clear></div></div><div class=bottombuttons><button ng-show=alert.buttons.login ng-click=\"type='login'\">ZUM LOGIN</button> <button ng-show=alert.buttons.ok ng-click=closeAll()>OK</button> <button ng-show=alert.buttons.profil ng-click=\"type='account'\">MEIN PROFIL</button> <a ng-show=alert.buttons.cancel ng-click=closeAll(); style=float:left;margin-top:20px>Abbrechen</a> <a ng-show=alert.buttons.agb ng-click=doLogout(); style=float:left;margin-top:20px>Abbrechen</a> <button ng-show=alert.buttons.custom ng-click=alert.buttons.custom.callback()>{{alert.buttons.custom.text}}</button></div><div class=clear></div></div><div class=alert ng-show=\"type=='alertlogin'\"><div class=\"alertlogin clear\"><div class=icon><span class=icon-nowbookmark_add></span></div><div class=info>Jetzt <a ng-click=\"type='login'\">einloggen</a> und kostenlos die Playliste- und Favoritenfunktion nutzen.</div></div><button class=clear ng-click=\"type='login'\">ZUM LOGIN</button></div><div class=alert ng-show=\"type=='emailverify'\"><div class=\"alertlogin clear\"><div class=icon><span class=icon-nowenvelop></span></div><div class=info>Vielen Dank! Ihre E-Mail Adresse ist nun bestätigt und Sie haben Ihr Profil aktiviert.</div></div><button class=clear ng-click=\"type='login'\" ng-show=!loggedin>ZUM LOGIN</button> <button class=clear ng-click=\"type='account'\" ng-show=loggedin>MEIN PROFIL</button></div></div></div><nowfulfillmentiframe></nowfulfillmentiframe></div>"
  );


  $templateCache.put('templates/overlay_search.html',
    "<div class=\"now-overlay now-overlay-search\" ng-show=overlay><div class=arrow></div><div class=top ng-show=\"query.length <3\">Bitte geben Sie mindestens 3 Buchstaben ein</div><div ng-show=initializing><div class=top>Suche wird geladen...<br>{{percent}}%</div></div><div ng-show=\"initialized && query.length > 2\" ng-switch=\"(results | filter:filterAllFormats).length\"><div ng-switch-when=0><div class=top>Leider keine Ergebnisse!</div><div ng-if=\"top20.length > 0\"><div class=headline>Unsere Empfehlung</div><div class=content><div class=search-row ng-click=\"goto(entry);trackEvent('klick_empfehlung', query, entry);\" ng-repeat=\"entry in top20 | slice:0:5 | orderBy:'+title'\"><div class=image><nowimage formatid=entry.id imagesize=80x45 formattype=formatlogo></nowimage></div><div class=text><span class=small ng-show=\"entry.icon == 'free'\">FREE</span> <span class=small ng-show=\"entry.icon == 'new'\">NEU</span><br><span class=large>{{::entry.title}}</span></div><div class=brand><span class=\"icon icon_station_{{::entry.station}}\"></span></div></div></div></div></div><div ng-switch-default><div class=content scrollbar={trackSize:310,thumbSize:50,appendToScope:searchscope}><div class=search-row ng-click=\"goto(entry);trackEvent('klick_format', query, entry);\" ng-repeat=\"entry in results | filter:filterAllFormats | orderBy:'+title'\"><div class=image><nowimage formatid=entry.id imagesize=80x45 formattype=formatlogo></nowimage></div><div class=text><span class=small ng-show=\"entry.icon == 'free'\">FREE</span> <span class=small ng-show=\"entry.icon == 'new'\">NEU</span><br><span class=large ng-bind-html=\"entry.title | searchfilter:query | htmlize\"></span></div><div class=brand><span ng-show=\"entry.icon != 'az'\" class=\"icon icon_station_{{::entry.station}}\"></span> <span ng-show=\"entry.icon == 'az'\" class=\"icon icon_menu_az\"></span></div></div></div></div></div></div>"
  );


  $templateCache.put('templates/player_breakad.html',
    "<div id=breakad class=breakad_wrapper ng-show=showBreakAd><div id=breakad_1 class=\"gujAd breakad now-dom-clean-children\"></div></div>"
  );


  $templateCache.put('templates/player_html5_overlay.html',
    "<div class=no-flash-overlay ng-click=close()><div class=description ng-click=$event.stopPropagation()><div class=title>Gleich geht's los!<div class=closer ng-click=close()>Hinweis schließen <span class=\"icon icon_close\"></span></div></div><div class=sub-title>Um Videos bei TV NOW schauen zu können, musst du den Adobe Flash Player installieren und aktivieren.<br>Weitere Informationen findest du in unserer <a href=https://hilfe.tvnow.de/hc/de/articles/207118449 target=_blank>Hilfe</a>.</div><div ng-if=\"class=='unknown'\" ng-bind-html=listhtml|htmlize></div><div ng-if=\"class!='unknown'\"><div class=\"image {{class}}\">&nbsp;</div><div class=list ng-bind-html=listhtml|htmlize></div></div><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/player_html5.html',
    ""
  );


  $templateCache.put('templates/player_info_box.html',
    "<div class=now-player-infobox ng-if=displayBox><div class=infobox-adbreak ng-show=configuration.breakad><nowbreakad></nowbreakad></div><div ng-class=\"{'infobox-content': configuration.breakad}\"><div class=\"toptext text\" ng-show=\"configuration && configuration.text && configuration.text.length > 0\" ng-style=\"configuration.fullscreen==true &&{'margin-top':'400px'}\"><span ng-bind-html=\"configuration.text | htmlize\"></span><br><br><span ng-show=configuration.textSmall class=infobox-smalltext ng-bind-html=\"configuration.textSmall | htmlize\"></span></div><div ng-show=configuration.drmMobile><ul class=app-list><li><a href=\"https://itunes.apple.com/de/app/tv-now/id1057991212?mt=8\" class=\"apple-store btn-appstores ir\" target=_blank ng-show=\"configuration.ostype==='ios'\"></a></li><li><a href=\"https://play.google.com/store/apps/details?id=de.rtli.tvnow&hl=de\" class=\"google-store btn-appstores ir\" target=_blank ng-show=\"configuration.ostype==='android'\"></a></li><li><a href=https://www.microsoft.com/de-de/store/apps/tv-now/9nblggh4x5wt class=\"microsoft-store btn-appstores ir\" target=_blank ng-show=\"configuration.ostype==='windows'\"></a></li></ul></div><div ng-show=\"configuration && (configuration.movie || configuration.circleCustomIcon)\" ng-class={noFunction:!(configuration.circleFunction)}><span ng-show=configuration.contentEnd>{{configuration.movie.format.title}}<br>{{configuration.movie.title}}</span> <span ng-show=\"countdown && configuration.chapterSwitch\" class=countdown>{{countdown}}&nbsp;{{configuration.countDownText}}</span><now-shared-circle movie=configuration.movie custom={{configuration.circleCustomIcon}} text={{configuration.circleText}} is-clickable=!!(configuration.circleFunction) ng-click=configuration.circleFunction();></now-shared-circle></div><div ng-show=\"configuration && configuration.circleButtons\" class=buttons><div class=wrapper-circle><div ng-repeat=\"circleButton in configuration.circleButtons\" class=circle-buttons><now-shared-circle custom={{circleButton.custom}} is-clickable=!!(circleButton.circleFunction) ng-click=circleButton.circleFunction();></now-shared-circle><div class=object-info-box>{{circleButton.text}}<div class=object-info>{{circleButton.nextFormatTitle}}</div><div class=object-info>{{circleButton.nextEpisodenTitle}}</div></div></div></div></div><div ng-show=\"configuration && configuration.buttons\" class=buttons><div class=wrapper-square><div ng-repeat=\"button in configuration.buttons\" class=button ng-class=button.cls ng-click=button.cb()>{{button.text}}</div></div></div></div></div>"
  );


  $templateCache.put('templates/player_videobar.html',
    "<div class=videobar ng-class={expanded:expand,fadeout:fadeout} ng-hide=hidden ng-mouseenter=killBarLeaveTimeout() ng-mouseleave=onBarLeave()><div class=header><div class=menu-wrapper><div class=menu ng-click=\"(!ad)?expand=!expand:''\" ng-class={ad:ad} ng-show=showMenu>{{title}} <span class=icon ng-class={icon_arrow_down:!expand,icon_arrow_up:expand}></span></div></div><div class=closer ng-class=\"{'tablet-closer':isTablet}\" ng-click=close()>{{::exitText}} <span class=\"icon icon_close\"></span></div></div><div class=teasers-wrapper ng-if=\"!loading && !live\"><div class=\"arrow al\" ng-show=arrows();><span class=\"icon icon_arrow_left\"></span></div><div class=\"arrow ar\" ng-show=arrows();><span class=\"icon icon_arrow_right\"></span></div><div class=teasers><div class=teaser ng-class=\"{'countdown': isCountdown($index)}\" ng-repeat=\"teaser in teasers\"><nowfavoritebutton item=teaser></nowfavoritebutton><div class=teasercontent ng-click=play($index) ng-class=\"{active:($index === 0)}\" style=\"background-image: url({{teaser.image}})\"><span ng-show=\"$index > 1\" class=\"station icon icon_station_{{::teaser.movie.format.station}}\"></span><div class=darkbottom><span class=lable ng-show=\"$index === 0\">JETZT LÄUFT</span> <span class=lable ng-show=\"$index === 1\">DANACH</span><div class=title>{{::teaser.movie.format.title}}</div><div class=statustext>{{::teaser.statustext}}</div></div><div class=hover><span class=lable ng-show=\"$index === 0\">JETZT LÄUFT</span> <span class=lable ng-show=\"$index === 1\">DANACH</span><reload-wrapper><now-shared-circle movie=teaser.movie></now-shared-circle></reload-wrapper><div class=title><span ng-show=\"teaser.title && teaser.title.length > 0\">{{::teaser.movie.title}}</span> <span ng-hide=\"teaser.title && teaser.title.length > 0\">{{::teaser.movie.format.title}}</span></div><div class=statustext>{{::teaser.statustext}}</div></div></div></div></div><div class=clear></div></div><div class=\"teasers loading\" ng-if=\"loading && !live\"><now-loading-spinner></now-loading-spinner></div><div class=live-wrapper ng-if=live><now-live-epg></now-live-epg><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/player_view.html',
    "<h1 ng-show=loading>PLAYER</h1><div ng-show=loading class=\"center-box text-center\"></div>"
  );


  $templateCache.put('templates/player.html',
    "<div class=now-playerlayer now-adcontrol=\"\" ng-show=show><div class=videobar-spacer ng-show=spacer></div><div class=top></div><div class=content ng-class=\"{'content-android':isAndroid}\"><div class=player><div id=vaa_underlay></div><div class=player_box ng-class=\"{'tablet-player':isTablet, 'tablet-player-android':isAndroid}\"><div id=player_wrapper ng-if=playerWrapperShow><div id=player_container ng-mousemove=showBar()><div class=html5-top><now-videobar exit=exitPlayer></now-videobar></div><now-player-infobox></now-player-infobox></div></div><nowbreakad></nowbreakad></div><div id=vaa_sky_right></div></div></div><div id=vaa_overlay></div></div>"
  );


  $templateCache.put('templates/recommendation_button_opt.html',
    "<div ng-click=toggle(); class=\"now-static-tipp center-box\"><a href=# class=ng-binding>{{buttonText}}</a></div>"
  );


  $templateCache.put('templates/shared_breadcrumb.html',
    "<div class=now-breadcrumb><span data-ng-repeat=\"item in items\"><a ng-class=\"{'active': $last, 'inactive': !item.url}\" ng-href={{item.url}} ng-show=\"item.title.length > 0\">{{item.title}}</a> <span ng-show=\"item.title.length > 0 && !$last\" class=\"icon icon_arrow_right\"></span></span></div>"
  );


  $templateCache.put('templates/shared_button_free.html',
    "<div class=\"button now-freebutton\"><input type=checkbox class=regular-checkbox ng-model=\"checkmodel\"><label></label><span>{{text}}</span></div>"
  );


  $templateCache.put('templates/shared_button_order.html',
    "<div class=\"button now-orderbutton\"><span>Sortieren</span><span class=\"icon icon_arrow_down\"></span></div>"
  );


  $templateCache.put('templates/shared_circle.html',
    "<div class=\"now-circle now-circle-pay\" ng-class={isClickable:isClickable}><div class=circle-svg><figure class=chart><svg ng-show=\"tslayout === 10\" width=25 height=25><circle class=inner cx=12 cy=14 r=10></circle><circle class=outer cx=12 cy=14 r=10 transform=\"rotate(-90, 30, 30)\"></circle></svg> <svg ng-show=\"tslayout === 20\" width=40 height=40><circle class=inner cx=18 cy=21 r=15></circle></svg> <svg ng-hide=\"tslayout === 10 || tslayout === 20\" width=60 height=60><circle class=inner cx=30 cy=30 r=28></circle><circle class=outer cx=30 cy=30 r=28 transform=\"rotate(-90, 30, 30)\"></circle></svg></figure></div><div class=circle><div class=spinner></div><span class=\"icon circleicon\"></span></div><div class=text>{{text}}</div></div>"
  );


  $templateCache.put('templates/shared_loadingspinner.html',
    "<div class=loading-spinner><now-shared-circle custom=spin text=\"Lade Daten\"></now-shared-circle></div>"
  );


  $templateCache.put('templates/static.html',
    "<div class=\"rows now-scroll-top\"><div ng-repeat=\"teaserset in teasersets\" class=\"now-teaserset-layout-{{teaserset.layout}} clear\" ng-class={&quot;teaserset-custom-layout&quot;:(teaserset.automaticConfiguration.static)} ng-switch=teaserset.automaticConfiguration.static ng-hide=\"teaserset.hide === true\"><div ng-switch-when=true><div ng-switch on=teaserset.layout><div ng-switch-when=200><teasersetleadteaser></teasersetleadteaser></div><div ng-switch-default><teasersetcustom></teasersetcustom></div></div></div><div ng-switch-default><div ng-switch on=teaserset.layout><div ng-switch-when=200><teasersetleadteaser></teasersetleadteaser></div><div ng-switch-default><reload-wrapper><teaserset></teaserset></reload-wrapper></div></div></div></div></div>"
  );


  $templateCache.put('templates/station_switch.html',
    "<div class=now-station-switch><table><tr><td ng-show=ctrl.showAll><div class=button data-ng-class=\"{active:(ctrl.selection.indexOf('tvnow')>-1 || ctrl.selection.indexOf('nowtv')>-1 ||  ctrl.selection.length === 0)}\" data-ng-click=\"ctrl.change('tvnow')\" class=button>Alle Sender</div></td><td ng-repeat=\"station in ctrl.stations |limitTo:dropdownStationCount \"><div class=\"station button\" data-ng-class=\"{active:ctrl.selection.indexOf(station)>-1}\" data-ng-click=ctrl.change(station)><div class=\"headerstations headerstations-{{station}}\"></div></div></td><td ng-show=showDropdownStation><div class=\"button station-dropdown-button\" ng-class={expanded:(isExpanded())} ng-click=\"ctrl.stationDropdown=!ctrl.stationDropdown\">Mehr</div><div class=station-dropdown ng-class={&quot;genre-active&quot;:ctrl.showGenre} ng-show=ctrl.stationDropdown><div class=\"station button\" ng-repeat=\"station in ctrl.stations | limitTo:10:dropdownStationCount \" data-ng-class=\"{active:ctrl.selection.indexOf(station)>-1}\" data-ng-click=ctrl.change(station)><div class=\"headerstations headerstations-{{station}}\"></div></div></div></td><td ng-show=ctrl.showGenre><div class=\"genre now-genre-dropdown button-ie-fix\" ng-class={selected:ctrl.genreSelected.value} ng-show=\"ctrl.genreOptions.length > 0\" ng-click=ctrl.trackGenreShow();ctrl.refreshScrollbar(); dropdown-select=ctrl.genreOptions dropdown-model=ctrl.genreSelected dropdown-item-label=text dropdown-onchange=ctrl.genreChanged(selected)></div></td></tr></table></div>"
  );


  $templateCache.put('templates/teaser_custom_button.html',
    "<div class=\"now-static-button {{teaser.custom.data.position}}\"><a ng-href={{teaser.custom.data.link}} target={{teaser.custom.data.linktarget}}>{{teaser.custom.data.linktext}}</a></div>"
  );


  $templateCache.put('templates/teaser_custom_channel.html',
    "<div class=now-teaser><div class=image><div><div class=content><a ng-href=\"{{::teaser.custom.movie|geturl: 'appendpayment'}}\"><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\" teaser=teaser></a><div class=inner><div class=large><a ng-href=\"{{::teaser.custom.movie|geturl: 'appendpayment'}}\">{{::teaser.custom.data.title}}</a></div></div></div></div><div class=imagehover><now-shared-circle movie=teaser.custom.movie></now-shared-circle></div><nowimage imagetype=portrait id={{::teaser.custom.data.portraitimage}} size=0x0></nowimage><nowimage imagetype=banner id={{::teaser.custom.data.bannerimage}} size=0x0></nowimage><nowimage imagetype=default id={{::teaser.custom.data.defaultimage}} size=0x0></nowimage></div></div>"
  );


  $templateCache.put('templates/teaser_custom_divider.html',
    "<div class=now-static-divider></div>"
  );


  $templateCache.put('templates/teaser_custom_empty.html',
    "<div class=\"now-teaser {{teaser.style}}\"></div>"
  );


  $templateCache.put('templates/teaser_custom_foobar.html',
    "{{teaser.customData.foo}}"
  );


  $templateCache.put('templates/teaser_custom_html.html',
    "<div class=now-static-column{{teaser.custom.data.columncount}} ng-bind-html=teaser.custom.data.content|htmlize></div>"
  );


  $templateCache.put('templates/teaser_custom_image.html',
    "<a ng-href={{teaser.custom.data.link}} target={{teaser.custom.data.linktarget}} class=cbc-gec-teaser__image gec-track teaser=teaser><nowimage class=show-s id={{teaser.custom.data.imageSmall}} imagesize=0x0></nowimage><nowimage class=show-m id={{teaser.custom.data.imageMiddle}} imagesize=0x0></nowimage><nowimage class=show-l id={{teaser.custom.data.imageLarge}} imagesize=0x0></nowimage></a>"
  );


  $templateCache.put('templates/teaser_custom_linkbox.html',
    "<div class=now-static-tipplist><span class=headline ng-show=\"teaser.custom.data.headline.length > 0\">{{teaser.custom.data.headline}}</span><ul><li data-ng-repeat=\"link in teaser.custom.data.links track by $index\"><a ng-href={{link.src}} target={{link.target}}>{{link.text}}</a></li></ul></div>"
  );


  $templateCache.put('templates/teaser_custom_live.html',
    "<div class=\"now-teaser now-livestream\" ng-if=teaser.custom.data.now ng-class=\"{'teaser-tablet':isTablet}\" gec-track format=teaser.movie.format livestream={true} teaser=teaser><now-teaser-livestream teaser=teaser></now-teaser-livestream></div>"
  );


  $templateCache.put('templates/teaser_custom_manualteaser.html',
    "<div class=\"now-teaser now-teaser-custom {{teaser.style}}\" ng-class=\"{'teaser-tablet':isTablet}\" gec-track teaser=teaser><div class=image><span class=\"station icon icon_station_{{::teaser.custom.data.cornerlogo}}\" ng-show=teaser.custom.data.usecornerlogo></span><div ng-click=recommendation.fireEventRecClick(teaser);><div class=content ng-class={&quot;darkbottom&quot;:!teaser.custom.data.hidedarkbottom}><a ng-href={{teaser.custom.data.url}} target={{::teaser.custom.data.target}} ng-class=\"{&quot;imagegradient&quot;:!teaser.custom.data.hidedarkbottom, &quot;imageshow&quot;:teaser.custom.data.hidedarkbottom}\"><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif></a><div class=inner><div class=\"large hoverhide\"><a ng-href={{teaser.custom.data.url}} target={{::teaser.custom.data.target}}>{{::teaser.custom.data.headline1}}</a></div><div class=\"large hovershow\"><a ng-href={{teaser.custom.data.url}} target={{::teaser.custom.data.target}}>{{::teaser.custom.data.headline2}}</a><div class=small><a ng-href={{teaser.custom.data.url}} target={{::teaser.custom.data.target}}>{{::teaser.custom.data.info}}</a></div></div></div></div></div><div class=imagehover><now-shared-circle custom={{::teaser.custom.data.icon}}></now-shared-circle></div><div ng-if=\"teaser.custom.data.imagedefault && teaser.custom.data.imagebanner && teaser.custom.data.imageportrait\"><nowimage imagetype=portrait id={{::teaser.custom.data.imageportrait}} size=0x0></nowimage><nowimage imagetype=banner id={{::teaser.custom.data.imagebanner}} size=0x0></nowimage><nowimage imagetype=default id={{::teaser.custom.data.imagedefault}} size=0x0></nowimage></div><div ng-if=!teaser.custom.data.imagedefault><img class=portrait ng-src={{::teaser.custom.data.image}}> <img class=banner ng-src={{::teaser.custom.data.image}}> <img class=default ng-src={{::teaser.custom.data.image}}></div></div></div>"
  );


  $templateCache.put('templates/teaser_custom_placeholder.html',
    "<div ng-if=\"teaser.custom.data && teaser.custom.data.height > 0\"><div ng-class=now-spacer ng-style=\"{'height':teaser.custom.data.height+'px'}\"><div ng-show=\"(teaser.custom.data.height > 0)\">&nbsp;</div></div></div>"
  );


  $templateCache.put('templates/teaser_custom_special.html',
    "<div class=\"now-teaser now-teaser-special {{teaser.style}}\"><div class=image><span class=\"station icon icon_station_{{::teaser.custom.data.cornerlogo}}\" ng-show=teaser.custom.data.usecornerlogo></span><div ng-click=recommendation.fireEventRecClick(teaser);><div class=\"content darkbottom\"><a ng-href=\"{{::teaser.custom.page|geturl: 'page'}}\"><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a><div class=inner><div class=\"large hoverhide\"><a ng-href=\"{{::teaser.custom.page|geturl: 'page'}}\">{{::teaser.custom.data.headline1}}</a></div><div class=\"large hovershow\"><a ng-href=\"{{::teaser.custom.page|geturl: 'page'}}\">{{::teaser.custom.data.headline2}}</a></div><div class=small><a ng-href=\"{{::teaser.custom.page|geturl: 'page'}}\">{{::teaser.custom.data.info}}</a></div></div></div></div><div class=imagehover><now-shared-circle custom={{::teaser.custom.data.icon}}></now-shared-circle></div><nowimage imagetype=portrait id={{::teaser.custom.data.imageportrait}} size=0x0></nowimage><nowimage imagetype=banner id={{::teaser.custom.data.imagebanner}} size=0x0></nowimage><nowimage imagetype=default id={{::teaser.custom.data.imagedefault}} size=0x0></nowimage></div></div>"
  );


  $templateCache.put('templates/teaser_custom_stopper.html',
    "<a ng-if=\"teaser.custom.data.internalLinkType === 'format'\" ng-href={{teaser.custom.data.url}} target={{teaser.custom.data.target}} class=cbc-gec-teaser__stopper gec-track format=teaser.custom.format teaser=teaser><nowimage class=show-s id={{teaser.custom.data.imagesmall}} imagesize=620x0></nowimage><nowimage class=show-m id={{teaser.custom.data.imagemiddle}} imagesize=940x0></nowimage><nowimage class=show-l id={{teaser.custom.data.imagelarge}} imagesize=1260x0></nowimage></a> <a ng-if=\"teaser.custom.data.internalLinkType === 'page'\" ng-href=\"{{teaser.custom.page|geturl:'page'}}\" target={{teaser.custom.data.target}} class=cbc-gec-teaser__stopper gec-track teaser=teaser><nowimage class=show-s id={{teaser.custom.data.imagesmall}} imagesize=620x0></nowimage><nowimage class=show-m id={{teaser.custom.data.imagemiddle}} imagesize=940x0></nowimage><nowimage class=show-l id={{teaser.custom.data.imagelarge}} imagesize=1260x0></nowimage></a> <a ng-if=\"teaser.custom.data.internalLinkType === 'deeplink'\" ng-href={{teaser.custom.data.deeplink}} class=cbc-gec-teaser__stopper gec-track teaser=teaser><nowimage class=show-s id={{teaser.custom.data.imagesmall}} imagesize=620x0></nowimage><nowimage class=show-m id={{teaser.custom.data.imagemiddle}} imagesize=940x0></nowimage><nowimage class=show-l id={{teaser.custom.data.imagelarge}} imagesize=1260x0></nowimage></a>"
  );


  $templateCache.put('templates/teaser_custom_teaserset.html',
    "<div class=now-static-teaserset></div>"
  );


  $templateCache.put('templates/teaser_custom_tipps.html',
    "<div class=now-static-tipp><div class=\"content darkbottom\"><div class=headline>{{teaser.custom.data.headline}}</div><div class=text>{{teaser.custom.data.text}}</div></div><div class=link><a ng-href={{teaser.custom.data.link}} target={{teaser.custom.data.linktarget}}>{{teaser.custom.data.linktext}}</a></div></div>"
  );


  $templateCache.put('templates/teaser_custom_trafficteaser.html',
    "<div class=\"now-teaser now-teaser-traffic\"><nowtrafficteaser></nowtrafficteaser></div>"
  );


  $templateCache.put('templates/teaser_custom_welcome.html',
    "<div><h1 class=headline>{{teaser.custom.data.headline}}</h1><h2 class=subheadline>{{teaser.custom.data.subheadline}}</h2></div>"
  );


  $templateCache.put('templates/teaser_genre_format.html',
    "<div class=\"now-teaser now-teaser-m now-teaser-genre-format\" gec-track format=format teaser=teaser><div class=image><span class=\"station icon icon_station_{{::format.station}}\"></span><nowfavoritebutton item=format></nowfavoritebutton><div class=\"content darkbottom\"><a ng-href=\"{{::format|geturl: 'isformat'}}\" class=imagegradient><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif ng-click=goto(format)></a><div class=inner><div class=large><a ng-href=\"{{::format|geturl: 'isformat'}}\">{{::format.title}}</a></div><div class=small><a ng-href=\"{{::format|geturl: 'isformat'}}\">{{::format |statustext}}</a></div></div></div><div class=imagehover><now-shared-circle format=format></now-shared-circle></div><nowimage imagetype=default format=format formatid=format.id></nowimage></div></div>"
  );


  $templateCache.put('templates/teaser_genre_movie.html',
    "<div class=\"now-teaser now-teaser-m now-teaser-genre-movie\" gec-track movie=movie format=movie.format teaser=teaser><div class=click>&nbsp;</div><div class=image><span class=\"station icon icon_station_{{::movie.format.station}}\"></span><nowfavoritebutton item=movie></nowfavoritebutton><div class=imagehover><now-shared-circle movie=movie></now-shared-circle><a ng-href={{::movie|geturl}}></a></div><div class=\"content darkbottom\"><div class=now-leadteaser-top-inner><a ng-href={{::movie|geturl}}><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif style=\"position: absolute\"></a></div><div class=inner><span class=large><a ng-href={{::movie|geturl}}>{{::movie.format.title}}</a></span> <span class=small><a ng-href={{::movie|geturl}}>{{::movie |statustext}}</a></span><br></div></div><nowimage formatid=movie.format.id></nowimage></div></div>"
  );


  $templateCache.put('templates/teaser_hometeaser_format.html',
    "<div class=\"now-teaser now-teaser-home-format {{teaser.style}}\" ng-class=\"{'teaser-tablet':isTablet}\" gec-track format=teaser.format teaser=teaser><div class=image><span class=\"station icon icon_station_{{::teaser.format.station}}\"></span><nowfavoritebutton item=teaser></nowfavoritebutton><div ng-click=recommendation.fireEventRecClick(teaser);><div class=\"content darkbottom\"><a ng-href=\"{{::teaser.format|geturl: 'isformat'}}\" class=imagegradient><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif teaserreco teaser=teaser></a><div class=inner><div class=large><a ng-href=\"{{::teaser.format|geturl: 'isformat'}}\"><span class=counter>{{$index+1}}</span>{{::teaser.format.title}}</a></div><div class=small><a ng-href=\"{{::teaser.format|geturl: 'isformat'}}\">{{::teaser.format |statustext}}</a></div></div></div></div><div class=imagehover><now-shared-circle format=teaser.format tslayout=parentTeaserSet.layout></now-shared-circle></div><div ng-if=\"teaser.style.indexOf('now-teaser-h') > -1\"><nowimage imagetype=portrait imagesize=300x358 format=teaser.format formatid=teaser.format.id></nowimage></div><div ng-if=\"teaser.style.indexOf('now-teaser-w') > -1\"><nowimage imagetype=banner imagesize=620x169 format=teaser.format formatid=teaser.format.id></nowimage></div><div ng-if=\"teaser.style.indexOf('now-teaser-m') > -1 || teaser.style.indexOf('now-teaser-l') > -1\"><nowimage imagetype=default format=teaser.format formatid=teaser.format.id formattype={{formattype}}></nowimage></div></div></div>"
  );


  $templateCache.put('templates/teaser_hometeaser_movie.html',
    "<div class=\"now-teaser now-teaser-home-movie {{teaser.style}}\" ng-class=\"{'teaser-tablet':isTablet}\" gec-track movie=teaser.movie format=teaser.movie.format teaser=teaser><div class=image><span class=\"station icon icon_station_{{::teaser.movie.format.station}}\"></span><nowfavoritebutton item=teaser.movie></nowfavoritebutton><div><div class=\"content darkbottom\" ng-click=customCallback();><a ng-href=\"{{::teaser.movie|geturl: 'appendpayment'}}\" class=imagegradient><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif teaserreco teaser=teaser></a><div class=inner><div class=\"large hoverhide\"><a ng-href=\"{{::teaser.movie|geturl: 'appendpayment'}}\"><span class=counter>{{$index+1}}</span>{{::teaser.movie.format.title}}</a></div><div class=\"large hovershow\"><a ng-href=\"{{::teaser.movie|geturl: 'appendpayment'}}\">{{::teaser.movie.title}}</a></div><div class=small ng-class={highlight:(teaser.movie.livestreamEvent)}><a ng-href=\"{{::teaser.movie|geturl: 'appendpayment'}}\">{{::teaser.movie |statustext}}</a></div></div></div></div><div class=imagehover ng-click=customCallback();recommendation.fireEventRecClick(teaser);><now-shared-circle movie=teaser.movie tslayout=parentTeaserSet.layout></now-shared-circle></div><div ng-if=\"teaser.style.indexOf('now-teaser-h') > -1\"><nowimage imagetype=portrait imagesize=300x358 movie=::teaser.movie format=::teaser.movie.format formatid=::teaser.movie.format.id></nowimage></div><div ng-if=\"teaser.style.indexOf('now-teaser-w') > -1\"><nowimage imagetype=banner imagesize=620x169 movie=::teaser.movie format=::teaser.movie.format formatid=::teaser.movie.format.id></nowimage></div><div ng-if=\"teaser.style.indexOf('now-teaser-m') > -1  || teaser.style.indexOf('now-teaser-l') > -1\"><nowimage imagetype=default movie=::teaser.movie format=::teaser.movie.format formatid=::teaser.movie.format.id></nowimage></div></div></div>"
  );


  $templateCache.put('templates/teaser_livestream.html',
    "<div><div class=image><span class=\"station icon icon_station_{{::station}}\"></span><div class=imagehover><a ng-href=/{{::aliasstation}}/live-tv?autostart><img width=100% height=100% src=//tvnowstatic-a.akamaihd.net/rtlnow/img/blank.gif></a><now-shared-circle custom=\"{{(isTablet)?'pay':'play'}}\"></now-shared-circle></div><img now-on-load=onImgLoad($event); ng-src={{::image}}></div><div class=barbg><div class=bar></div></div><div class=episode><a class=\"time pull-left\" ng-href=/{{::aliasstation}}/live-tv?autostart>{{::teaser.custom.data.now.broadcastStartDate | amDateFormat:'HH:mm'}}</a> <a class=title ng-href=/{{::aliasstation}}/live-tv?autostart>{{::teaser.custom.data.now.title|truncate:60}}</a></div><div class=episode><div class=\"time pull-left\"><span class=text>Danach:</span> {{::teaser.custom.data.next.broadcastStartDate | amDateFormat:'HH:mm'}}</div><div class=title>{{::teaser.custom.data.next.title|truncate:60}}</div></div></div>"
  );


  $templateCache.put('templates/teaser_notfound.html',
    "<h3>PLEASE DEFINE TEASER</h3>"
  );


  $templateCache.put('templates/teaser_teaserset_custom.html',
    "<div class=now-teaserset-custom><div class=now-teaserset-content><nowteaser ng-repeat=\"teaser in teaserset.teaserSetInformations.items\"></nowteaser><div class=clear></div></div></div>"
  );


  $templateCache.put('templates/teaser_teaserset.html',
    "<div class=\"now-teaserset now-teaserset-page-{{page}} now-teaserset-{{teaserset.layout}} {{teaserset.customClass}}\" id=teaserset1 ng-hide=\"teaserset.hide === true\"><div class=now-teaserset-headline ng-show=\"!loading && teaserset.headline != ''\">{{teaserset.headline}}</div><h2 ng-show=teaserset.infotext class=infotext>{{teaserset.infotext}}</h2><div class=now-teaserset-overflow ng-show=!teaserset.infotext></div><div class=\"now-teaserset-content now-row-l\" ng-show=!teaserset.infotext><div class=now-teaserset-loading ng-show=loading><now-loading-spinner></now-loading-spinner></div><div ng-hide=loading class=shownteasers><nowteaser ng-repeat=\"teaser in teasers\" on-finish-render=ngRepeatFinished></nowteaser></div><ul class=slick-dots ng-show=\"!loading && pages.length > 1\"><li ng-click=setPage($index) ng-repeat=\"p in pages\" ng-class=\"{&quot;slick-active&quot;:(page == $index )}\"><button type=button>Teaserseite {{$index}}</button></li></ul></div><div style=\"clear: both\"></div><div class=now-teaser-arrow ng-show=\"pages.length > 1 && !loading && !teaserset.infotext\" ng-class=\"{&quot;disabled&quot;:(page == pages.length -1)}\" ng-click=paginate(1) tooltip=\"Weitere Sendungen\"><span class=\"icon right icon_arrow_right\"></span></div><div class=\"now-teaser-arrow now-teaser-arrow-left\" ng-show=\"pages.length > 1 && !loading && !teaserset.infotext\" ng-class=\"{&quot;disabled&quot;:(page == 0)}\" ng-click=paginate(-1) tooltip=\"Weitere Sendungen\"><span class=\"icon left icon_arrow_left\"></span></div></div>"
  );


  $templateCache.put('templates/teaserset_leadteaser.html',
    "<div class=\"now-leadteaser now-leadteaser-static\" ng-class=\"{'leadteaser-tablet':isTablet}\"><nowfavoritebutton item=statusitem onshow=favButtonOnShow() onhide=favButtonOnHide()></nowfavoritebutton><span class=\"station icon icon_station_{{station}}\"></span><h2 ng-show=infotext class=infotext ng-dblclick=\"infotext=false;\">{{infotext}}</h2><div class=imagehover-outer ng-show=!infotext><a ng-if=gecRerenderHelper class=cbc-gec-teaser__lead ng-href={{getLink().href}} gec-track movie=movie format=format livestream=livestream teaser=teaserItem listname=\"'now-leadteaser-static'\" position=\"currentIndex + 1\"><div class=imagehover><div ng-show=\"teasertype!='format'\"><now-shared-circle custom=icon_circle_play></now-shared-circle></div><div ng-show=\"teasertype=='format'\"><now-shared-circle custom=icon_circle_more></now-shared-circle></div></div></a></div><div class=now-leadteaser-video ng-show=!infotext><video id=leadvideo class=video autoplay ng-show=videoShow><source src={{videosrc}} type=video/mp4>Your browser does not support the video tag.</source></video><img ng-src={{imageSrc1}} class=bild ng-class=\"{transparent:(imageIndex == '2')}\" ng-show=imageShow> <img ng-src={{imageSrc2}} class=bild ng-class=\"{transparent:(imageIndex == '1')}\" ng-show=imageShow></div><div class=now-leadteaser-background ng-show=!infotext><div class=now-leadteaser-overlay><div class=now-leadteaser-bottom ng-class={show:showBottom}><div class=now-leadteaser-top-inner>&nbsp;</div><div class=now-leadteaser-bottom-inner><div class=now-leadteaser-text><div class=\"now-leadteaser-largetext show-s show-m\"><span>{{large|truncate:40}}</span></div><div class=\"now-leadteaser-largetext show-l\"><span>{{large|truncate:115}}</span></div><div ng-show=\"description !== null && description.length > 0\" class=\"now-leadteaser-description show-s\"><span>{{description|truncate:45}}</span></div><div ng-show=\"description !== null && description.length > 0\" class=\"now-leadteaser-description show-m\"><span>{{description|truncate:60}}</span></div><div ng-show=\"description !== null && description.length > 0\" class=\"now-leadteaser-description show-l\"><span>{{description|truncate:115}}</span></div><div class=now-leadteaser-smalltext ng-show=small ng-class={&quot;now-leadteaser-smalltext-highlight&quot;:(statusitem.livestreamEvent)}><span class=now-base-background-50>{{small}}</span></div><div class=now-leadteaser-smalltext ng-hide=small ng-class={&quot;now-leadteaser-smalltext-highlight&quot;:(statusitem.livestreamEvent)}><span class=now-base-background-50>{{statusitem |statustext}}</span></div></div></div></div></div></div><div class=now-leadteaser-navigation ng-show=!infotext style=\"z-index: 498\"><div class=now-leadteaser-dots-wrapper><div class=now-leadteaser-left data-ng-click=prevClick()><span class=\"icon icon_arrow_left\"></span></div><div class=now-leadteaser-dots ng-style=\"{'width':(subteasers.length * 32)+'px'}\"><div class=dot ng-class=\"{active:(currentIndex==$index)}\" data-ng-repeat=\"subteaser in subteasers  track by $index\" data-ng-click=bulletClick($index);>&nbsp;</div></div><div class=now-leadteaser-right data-ng-click=nextClick()><span class=\"icon icon_arrow_right\"></span></div></div></div></div>"
  );

}]);


})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowSearch', ['ngRoute']);

})();

(function() {

'use strict';

/**
 * @ngdoc service
 * @name NowShared.AutoimgUrlHelper
 * @description
 * Service for concatenating autoimg urls
 */

angular
    .module('NowSearch')
    .service('NowSearchService', NowSearchService);

NowSearchService.$inject = ['$rootScope', '$location', 'StationMonitor', 'RecommendationService', 'NowGoogleAnalytics', '$q', 'GlobalFormatService'];

function NowSearchService($rootScope, $location, StationMonitor, RecommendationService, NowGoogleAnalytics, $q, GlobalFormatService) {
    var self = this;
    self.word = false;
    self.overlay = false;
    self.exitbygoto = false;
    self.loadFormats = loadFormats;
    self.trackEvent = trackEvent;
    self.goto = goto;
    self.performSearch = performSearch;


    function performSearch(item) {
        var q = self.word.toLowerCase();

        function match(q) {
            var result = (item && (item.searchAliasName.toLowerCase().indexOf(q) !== -1 || item.title.toLowerCase().indexOf(q) !== -1));
            return result;
        }

        if (item.station && StationMonitor.getStationsOrdered().indexOf(item.station) === -1) {
            return false;
        }

        if (q.indexOf(' ') > -1) {
            var qsplit = q.split(' ');
            for (var i = 0; i < qsplit.length; i++) {
                if (!match(qsplit[i])) {
                    return false;
                }
            }
            return true;
        } else {
            return match(q);
        }
    }

    function goto(format) {
        self.exitbygoto = true;
        if (format.icon === "az") {
            $location.path('/az').search('genre', format.seoUrl);
        } else {
            RecommendationService.fireEventRecClick(format.teaserItem);
            $location.path('/' + StationMonitor.getAlias(format.station) + '/' + format.seoUrl);
        }
        $rootScope.$broadcast('close::togglefulfillment');
    }

    function loadFormats() {
        var result = {};
        var deferred = $q.defer();

        var filter = {
                'Id': {
                    'containsNotIn': ['1896']
                }
            },
            fields = 'id,title,station,seoUrl,searchAliasName,icon,genres',
            key = 'search';

        GlobalFormatService.getFormats(key, fields, filter).then(
            function (data) {
                result.formats = angular.copy(data.formats);
                result.genres = data.genres;

                for (var key in data.genres) {
                    var g = data.genres[key];
                    result.formats.push({
                        icon: 'az',
                        id: result.formats.length + 100000,
                        searchAliasName: '',
                        seoUrl: g.uri,
                        station: 'tvnow',
                        title: g.name
                    });
                }

                deferred.resolve(result);
            },
            function () {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function trackEvent(action, query, entry) {
        var customData = {};
        if (!query) {
            query = self.word;
        }
        if (entry) {
            if (action === 'klick_format' && entry.id > 100000) {
                action = 'klick_genre';
            }
            customData.dimension13 = entry.title;
        }
        NowGoogleAnalytics.trackEvent('suche', action, query, undefined, customData);
    }

    return self;
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowSearch')
    .controller('NowSearchMobileController', NowSearchMobileController);

NowSearchMobileController.$inject = ['NowSearchService', '$rootScope', '$scope', '$location', '$sessionStorage', '$q', 'url', '$window'];

function NowSearchMobileController(NowSearchService, $rootScope, $scope, $location, $sessionStorage, $q, url, $window) {
    var vm = $scope;


    vm.query = '';
    vm.showResults = false;
    vm.initialized = false;
    vm.initializing = false;
    vm.results = [];
    vm.formats = [];
    vm.percent = 0;
    vm.iosstyle = false;

    vm.goto = NowSearchService.goto;
    vm.trackEvent = NowSearchService.trackEvent;

    initWatchers();
    var initPromise = init();

    function init() {
        var deferred = $q.defer();

        if ($location.search()['resetsearch']) {
            $location.search('resetsearch', null);
            delete $sessionStorage.search;
        }

        prepareSearch().finally(function () {
            deferred.resolve();
        });

        return deferred.promise;
    }

    function initWatchers() {
        var reloadFormats = $rootScope.$on('gfs::reloadFormats', function () {
            NowSearchService.loadFormats.then(function (result) {
                vm.formats = result.formats;
                vm.genres = result.genres;
            });
        });

        var field = $window.document.getElementById('search-field');
        field.focus();
        if (bowser.ios) {
            vm.iosstyle = true;
        }
        $rootScope.$on('$destroy', reloadFormats);
        $scope.$watch("query", watchQuery);
    }

    function prepareSearch() {
        if (vm.initializing) {
            //do not prepare twice
            return;
        }

        var deferred = $q.defer();

        //reset formatlist that came from backend
        vm.initializing = true;

        NowSearchService.loadFormats().then(
            function (result) {
                vm.initializing = false;
                vm.initialized = true;
                vm.formats = result.formats;
                vm.genres = result.genres;


                deferred.resolve();
            },
            function () {
                vm.initializing = false;
                vm.initialized = false;


                deferred.reject();
            }
        );

        return deferred.promise;
    }


    function watchQuery(newVal, oldVal) {
        NowSearchService.word = newVal;
        if (!newVal || newVal.length === 0) {
            vm.showResults = false;
            vm.results = [];
            return false;
        }

        if (newVal === oldVal) {
            return;
        }

        if (newVal.length > 2) {
            //search is conducted by user.
            vm.showResults = true;
            if (vm.results.length === 0 && vm.formats.length > 0) {
                //load list from cache, when results array is empty
                vm.results = vm.formats.filter(NowSearchService.performSearch);
                //console.log('result list from cache', vm.results);
                if (!$rootScope.$$phase) $rootScope.$apply();
            } else if (!vm.initialized && !vm.initializing) {
                //load list from backend, when is not initialized or or initializing has not yet begun. should not be happening, as init is always called upon controller load
                //may be extended and/or replaced by (!vm.initializing) || (!$sessionStorage.search && !initPromise) which would lead to ignoring 'initialized' and always getting a new list, when the session.search is empty
                init().finally(function () {
                    vm.results = vm.formats.filter(NowSearchService.performSearch);
                    //if (!$rootScope.$$phase) $rootScope.$apply();
                });
            } else {
                //search is initializing. wait for promise
                $q.when(initPromise).then(function () {
                    vm.results = vm.formats.filter(NowSearchService.performSearch);
                })
            }
        } else {
            vm.results = [];
            vm.showResults = true;
        }

    }
}


})();

(function() {

'use strict';

angular
    .module('NowSearch')
    .controller('NowSearchController', NowSearchController);

NowSearchController.$inject = ['NowSearchService', '$rootScope', '$scope', 'NowApi', '$location', '$timeout', '$sessionStorage', 'StationMonitor', 'RecommendationService', 'NowGoogleAnalytics', '$q'];

function NowSearchController(NowSearchService, $rootScope, $scope, NowApi, $location, $timeout, $sessionStorage, StationMonitor, RecommendationService, NowGoogleAnalytics, $q) {
    var vm = $scope;

    vm.top20 = [];
    vm.query = '';
    vm.overlay = false;
    vm.initialized = false;
    vm.initializing = false;
    vm.results = [];
    vm.formats = [];
    vm.percent = 0;
    vm.searchscope = $scope;

    vm.goto = NowSearchService.goto;
    vm.trackEvent = NowSearchService.trackEvent;
    vm.filterAllFormats = performSearch;

    initWatchers();
    var initPromise = init();

    var contentLoaded = $rootScope.$on('$viewContentLoaded', function(){
        NowSearchService.query='';
    });

    $rootScope.$on('$destroy',contentLoaded);

    function performSearch(item) {
        var q = $scope.query.toLowerCase();

        function match(q) {
            return (item && (item.searchAliasName.toLowerCase().indexOf(q) !== -1 || item.title.toLowerCase().indexOf(q) !== -1));
        }

        if (item.station && StationMonitor.getStationsOrdered().indexOf(item.station) === -1) {
            return false;
        }

        if (q.indexOf(' ') > -1) {
            var qsplit = q.split(' ');
            for (var i = 0; i < qsplit.length; i++) {
                if (!match(qsplit[i])) {
                    return false;
                }
            }
            return true;
        } else {
            return match(q);
        }
    }

    function getTop20() {
        return NowApi.getTeasersets().retrieveTeaserSetById({
            'id': 607,
            'fields': '["*","formats",["id","title","station","seoUrl","icon"]]'
        }).then(function (data) {
            vm.top20 = data.formats.items;
        });
    }

    function getTop20Recommendation() {
        RecommendationService.getRecommendationsForSearch(function (data) {
            var top20 = [];
            angular.forEach(data.items, function (teaser) {
                var format = teaser.format;
                var top20Entry = {
                    id: format.id,
                    title: format.title,
                    station: format.station,
                    seoUrl: format.seoUrl,
                    icon: format.icon,
                    teaserItem: teaser
                };
                top20.push(top20Entry);
            });
            vm.top20 = top20;
        });
    }

    function getRecommendations() {
        if (true === RecommendationService.isReceivingEnabled()) {
            getTop20Recommendation();
        } else {
            getTop20();
        }
    }

    function reloadScrollbar() {
        $timeout(function () {
            if (vm.ScrollbarReload) {
                vm.ScrollbarReload();
            }
        }, 500);
    }

    function init() {
        var deferred = $q.defer();

        if ($location.search()['resetsearch']) {
            $location.search('resetsearch', null);
            delete $sessionStorage.search;
        }

        prepareSearch().finally(function () {
            deferred.resolve();
        });

        return deferred.promise;
    }

    function initWatchers() {
        var accountLogout = $rootScope.$on('account::logout', resetSearch);
        $rootScope.$on('$destroy', accountLogout);
        var reloadFormats = $rootScope.$on('gfs::reloadFormats', function (){
            resetSearch();
            NowSearchService.loadFormats().then(function (result) {
                vm.formats = result.formats;
                vm.genres = result.genres;
            });
        });
        $rootScope.$on('$destroy', reloadFormats);

        $scope.$watch(function () {
            return NowSearchService.query;
        }, watchQuery);
    }

    function resetSearch() {
        delete $sessionStorage.search;

        prepareSearch();
    }

    function prepareSearch() {
        if (vm.initializing) {
            //do not prepare twice
            return;
        }

        var deferred = $q.defer();

        //reset formatlist that came from backend
        vm.initializing = true;

        $timeout(function(){
            NowSearchService.loadFormats().then(
                function (result) {
                    vm.initializing = false;
                    vm.initialized = true;
                    vm.formats = result.formats;
                    vm.genres = result.genres;

                    reloadScrollbar();

                    deferred.resolve();
                },
                function () {
                    vm.initializing = false;
                    vm.initialized = false;

                    reloadScrollbar();

                    deferred.reject();
                }
            );
        },3000);
        return deferred.promise;
    }


    function watchQuery(newVal, oldVal) {
        vm.query = newVal;

        if (!newVal || newVal.length === 0) {
            if (!NowSearchService.exitbygoto && oldVal && oldVal.length > 2) {
                vm.trackEvent('suche_abgebrochen', oldVal);
            }
            vm.overlay = false;
            vm.results = [];
            return false;
        }

        if (newVal === oldVal) {
            return;
        }

        if (newVal.length > 2) {
            //search is conducted by user.
            vm.overlay = true;
            NowSearchService.exitbygoto = false;

            if (vm.results.length === 0 && vm.formats.length > 0) {
                //load list from cache, when results array is empty
                vm.results = vm.formats;
                reloadScrollbar();
            } else if (!vm.initialized && !vm.initializing) {
                //load list from backend, when is not initialized or or initializing has not yet begun. should not be happening, as init is always called upon controller load
                //may be extended and/or replaced by (!vm.initializing) || (!$sessionStorage.search && !initPromise) which would lead to ignoring 'initialized' and always getting a new list, when the session.search is empty
                init().finally(function () {
                    vm.results = vm.formats;
                    reloadScrollbar();
                });
            } else {
                //search is initializing. wait for promise
                $q.when(initPromise).then(function () {
                    vm.results = vm.formats;
                    reloadScrollbar();
                })
            }
        } else {
            vm.results = [];
            vm.overlay = true;
        }

        getRecommendations();
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowSearch')
    .directive('nowSearchField', searchdropdown);

searchdropdown.$inject = ['NowSearchService'];

function searchdropdown(NowSearchService) {
    return {
        restrict: 'E',
        replace: true,
        controller: ['$scope', function ($scope) {
            $scope.query = '';
            $scope.service = NowSearchService;
        }],
        templateUrl: 'templates/header_search.html',
    };
}

})();

(function() {

'use strict';

angular
    .module('NowSearch')
    .directive('nowSearchOverlay', searchdropdown);

searchdropdown.$inject = ['$timeout', '$location', 'NowSearchService'];

function searchdropdown($timeout, $location, NowSearchService) {
    return {
        scope: {},
        restrict: 'E',
        replace: true,
        controller: 'NowSearchController',
        templateUrl: 'templates/overlay_search.html',
        link: link
    };

    function link(scope) {
        var timer = false;

        $('.icon_IC_Close').on('click', function () {
            $('.show-search').removeClass('show-search');
        });
        scope.$watch('overlay', watchOverlay, true);


        function hideSearch() {
            scope.$apply(function () {
                NowSearchService.query = '';
            });
            $('.search-overlay-helper').remove();
            $(window).off('scroll', hideSearch);
        }

        function checktimer() {
            if (timer) {
                $timeout.cancel(timer);
                timer = false;
            }
        }

        function clear() {
            checktimer();
            timer = $timeout(
                hideSearch,
                1000
            );
        }

        function watchOverlay(newValue) {
            scope.overlay = newValue;
            if (newValue) {

                $(window).on('scroll', hideSearch);

                if ($('.search-overlay-helper').length < 1) {
                    var div = $('<div class="search-overlay-helper"></div>');
                    div.on('click', function () {
                        hideSearch();

                    });
                    $('body').append(div);
                }
                rePositonOverlay();
                if ($location.search()['az']) {
                    $location.search('az', null);
                }
                if ($location.search()['account']) {
                    $location.search('account', null);
                }
                if ($location.search()['login']) {
                    $location.search('login', null);
                }
                if ($location.search()['registration']) {
                    $location.search('registration', null);
                }
            }
        }

        function rePositonOverlay() {
            var input = $('.search-input');
            $('.now-overlay-search').css({
                top: input.position().top + 50,
                left: input.offset().left - 67
            }).on('mouseleave', function () {
                clear()
            }).on('mouseenter', function () {
                checktimer();
            });
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowSearch')
    .filter('searchfilter', searchfilter);

searchfilter.$inject = [];

function searchfilter() {
    return function (input, query) {
        var r = new RegExp('(' + query + ')', 'gi');
        return input.replace(r, '<span class="search-bold">$1</span>');
    }
}

})();

(function() {



})();

(function() {

/**
 * Created by VolkM on 30.08.2017.
 */
'use strict';

angular
    .module('NowSearch')
    .config(routing);
routing.$inject = ['$routeProvider'];
function routing($routeProvider) {


    function checkClient(AppConfig, $location) {
        if (AppConfig.webclient !== "mobile") {
            $location.path("/");
            return false;
        }
        return true;
    }

    checkClient.$inject = ['AppConfig', '$location'];

    $routeProvider
        .when('/search', {
                controller: 'NowSearchMobileController',
                controllerAs: 'vm',
                templateUrl: 'templates/search.html',
                reloadOnSearch: false,
                data: {
                    pagetype: 'static',
                    pagesubtype: 'search'
                },
                resolve: {
                    url: checkClient
                }
            }
        );

}

})();

(function() {





})();

(function() {



})();

(function() {

angular.module('NowAz', []);

})();

(function() {

'use strict';

angular
    .module('NowAz')
    .directive('nowAzToolbar', azstations);

azstations.$inject = ['Accounting', '$location', '$anchorScroll', 'NowGoogleAnalytics', '$timeout', 'AppConfig','$window','$log'];

function azstations(Accounting, $location, $anchorScroll, NowGoogleAnalytics, $timeout, AppConfig,$window, $log) {
    return {
        restrict: 'E',
        templateUrl: 'templates/az_toolbar_directive.html',
        link: link
    };

    function link(scope) {
        var vm = scope;

        vm.hideFree = Accounting.isPremiumUser();
        vm.lastAnchor = '';
        vm.selectStation = selectStation;
        vm.selectGenre = selectGenre;
        vm.gotoAnchor = goToAnchor;

        $anchorScroll.yOffset = -100;


        $(".az-buttons .char").hover(function () {
            $(this).animate({fontSize: "32px"}, 300)
        }, function () {
            $(this).animate({fontSize: "20"}, 300)
        });


        function goToAnchor($event, x) {
            $('.az-buttons .active').removeClass('active');
            angular.element($event.currentTarget).addClass('active');
            scrollToAnchor(x);
            vm.lastAnchor = x;

            NowGoogleAnalytics.trackEvent('sendungen_az', 'buchstabenauswahl');
        }

        function selectGenre(genre) {
            var genrepath = "";
            if (genre.value) {
                $log.debug('genreValue',genre);
                genrepath = '/' + genre.value
            }
            if (vm.$parent.selectedStations[0] && vm.$parent.selectedStations[0] !== "tvnow") {
                $location.path('/az/' + vm.$parent.selectedStations[0] + genrepath, true);

            } else {
                $location.path('/az' + genrepath, true);

            }

            $location.search('stations', null);
        }

        function selectStation(stations) {

            if (stations.indexOf('tvnow') > -1) {
                stations = [];
                vm.genreSelected.value = {};
                vm.$parent.setMeta();
                $location.path('/az', true);
                $location.search('stations', null);
                $location.search('genre', null);
            } else {
                vm.$parent.selectedStations = stations;
                if (vm.$parent.selectedStations.length === 1) {
                    vm.$parent.setMeta(vm.$parent.selectedStations[0]);
                    $location.path('/az/' + vm.$parent.selectedStations[0], true);
                    $location.search('stations', null);

                } else if (vm.$parent.selectedStations.length > 1) {
                    vm.$parent.setMeta();
                    $location.path('/az', true);
                    $location.search('stations', vm.$parent.selectedStations.join(','));
                    //debugger;
                } else if (vm.$parent.selectedStations.length === 0 && vm.genreSelected.value) {
                    vm.$parent.setMeta();
                    $location.path('/az/' + vm.genreSelected.value, true);
                    $location.search('stations', null);
                    $location.search('genre', null);
                }
            }

            if (vm.lastAnchor !== '') {
                $window.scrollTo(0, 0);
                $('.az-buttons .active').removeClass('active');
                vm.lastAnchor = '';
            }
        }

        function scrollToAnchor(x) {
            var newHash = 'anchor' + x,
                offset = ($('div.icon_navigation').css('visibility') === 'visible') ? 240 : 370;

            if (AppConfig.webclient === "mobile") {
                offset = 100;
            }
            $('html, body').scrollTop($("#" + newHash).offset().top - offset);
        }

        $timeout(function () {
            $('.az-buttons .char').on("touchstart", function (e) {
                'use strict'; //satisfy code inspectors
                var link = $(this); //preselect the link
                if (link.hasClass('hover')) {
                    return true;
                }
                else {
                    link.addClass('hover');
                    $('.az-buttons .char').not(this).removeClass('hover');
                    e.preventDefault();
                    return false; //extra, and to make sure the function has consistent return points
                }
            }, 2000);
        })
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAz')
    .service('FormatService', Formats);

Formats.$inject = ['NowApi', '$localStorage', 'moment', '$q'];

/**
 *@constructor
 */
function Formats(NowApi, $localStorage, moment, $q) {
    var formats = [];
    var page = 1;
    var self = this;
    var globalDeferred;
    var loading = false;

    self.getAvailableGenres = getAvailableGenres;
    self.extractGenres = extractGenres;
    self.loadFormatsApi = loadFormatsApi;

    return self;

    function getAvailableGenres() {
        if ($localStorage.formats && $localStorage.formats.genres) {
            return $localStorage.formats.genres;
        } else {
            return [];
        }
    }

    function extractGenres() {
        var genres = [];
        var returnGenres = {};

        for (var i = 0; i < formats.length; i++) {
            var format = formats[i];
            for (var j = 0; j < format.genres.length; j++) {
                var genre = format.genres[j];
                if (genres.indexOf(genre) === -1) {
                    genres.push(genre);
                    var uri = genre.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '_');
                    if(uri==='t_gliche_serien'){
                        uri='taegliche_serien';
                    }
                    returnGenres[uri] = {
                        name: genre,
                        uri: uri
                    };
                }
            }
        }

        return returnGenres;
    }

    function loadFormatsApi(deferred) {
        if (loading && !deferred) {
            return globalDeferred.promise;
        }

        if (!deferred) {
            deferred = $q.defer();
        }

        loading = true;
        globalDeferred = deferred;

        if ($localStorage.formats && $localStorage.formats.items && moment($localStorage.formats.date).isAfter(moment())) {
            deferred.resolve($localStorage.formats);
            return deferred.promise;
        }

        NowApi.getFormat().retrieve(
            {
                'maxPerPage': 500,
                'fields': 'id,title,station,seoUrl,searchAliasName,icon,hasFreeEpisodes,hasPayEpisodes,genres,genreUris',
                'page': page
            }
        ).then(function (data) {
                formats = formats.concat(data.items);
                if (formats.length < data.total) {
                    page++;
                    self.loadFormatsApi(deferred);
                } else {
                    var ret = {
                        items: formats,
                        genres: self.extractGenres(),
                        date: moment().add(1, 'h')
                    };
                    $localStorage.formats = ret;
                    loading = false;
                    deferred.resolve(ret);
                    return deferred.promise;
                }
            },
            function () {
                return deferred.reject();
            });

        deferred.notify();
        return deferred.promise;
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAz')
    .controller('NowAzController', NowAzController);

NowAzController.$inject = ['$scope', '$routeParams', 'BreadcrumbHelper', 'StationMonitor', '$location', '$rootScope', '$sessionStorage', 'Accounting', '$filter', 'NowGoogleAnalytics', 'GlobalFormatService', 'Metadata', '$log', 'PageHistory', 'AppConfig','NowTagCommander'];

function NowAzController($scope, $routeParams, BreadcrumbHelper, StationMonitor, $location, $rootScope, $sessionStorage, Accounting, $filter, NowGoogleAnalytics, GlobalFormatService, Metadata, $log, PageHistory, AppConfig,NowTagCommander) {
    var vm = $scope,
        viewInitialized,
        allFormats;

    vm.filterFormats = filterFormats;
    vm.openPremium = openPremium;
    vm.trackClick = trackClick;
    vm.setMeta = setMeta;
    vm.gotoFormat = gotoFormat;

    vm.isFree = false;
    vm.allowedStations = StationMonitor.getStationsWithAlias();
    vm.menuStations = StationMonitor.getStationsWithAlias();
    vm.loading = false;
    vm.init = true;
    vm.selectedStations = [];
    vm.loading = true;
    vm.init = false;
    vm.isPremiumUser = Accounting.isPremiumUser();
    vm.availableGenres = false;
    Metadata.setMobileAltEnable(true);

    if ($routeParams.stations) {
        vm.selectedStations = $routeParams.stations.split(',');
    }
    if ($routeParams.category && vm.allowedStations.indexOf($routeParams.category) > -1) {
        vm.selectedStations.push($routeParams.category);
    }
    checkGenre();
    Breadcrumbs();
    initWatchers();
    init();

    function initWatchers() {
        $scope.$watch('selectedStations', function (stations) {
            var watchboxFormats = [];
            if (allFormats && allFormats.length > 0) {
                angular.forEach(allFormats, function (format) {
                    if (vm.menuStations.indexOf(format.station) > -1 && (format.station === stations[0] || (stations.length === 0 && format.station !== "watchbox"))) {
                        watchboxFormats.push((format));
                    }
                });

                vm.availableGenres = GlobalFormatService.extractGenres(watchboxFormats);
            }
        });
        $scope.$on('$routeUpdate', function () {
            checkGenre();
        });


        $scope.$on('stationswitch:stations', function (event, stations) {
            vm.menuStations = stations;
        });

        $scope.$watch('loading', function (value) {
            if (value === false) {
                $rootScope.$broadcast('nowLoadingIndicator::hide');
            }
        });

        $scope.$watch('isFree', function (newval) {
            if (!viewInitialized) {
                viewInitialized = true;
                return;
            }

            NowGoogleAnalytics.trackEvent('sendungen_az', (newval) ? 'haekchen_an' : 'haekchen_aus', 'nur_free');
        });
        var accountLogin = $rootScope.$on('account::login', function () {
            vm.init = false;
            vm.loading = true;
            delete $sessionStorage.formats;
        });
        var accountLogout = $rootScope.$on('account::logout', function () {
            vm.init = false;
            vm.loading = true;
            delete $sessionStorage.formats;
        });
        var gfsReloadFormats = $rootScope.$on('gfs::reloadFormats', loadFormats);



        $rootScope.$on('$destroy', accountLogin);
        $rootScope.$on('$destroy', accountLogout);
        $rootScope.$on('$destroy', gfsReloadFormats);
    }

    function openPremium() {
        if (!Accounting.isPremiumUser()) {
            if (bowser.tablet === true) {
                $location.search('premium', 'plusflag');
            } else {
                $log.debug('Az/controller openPremium() opening premium');
                $location.search('premium', true);
            }

        }
    }

    function filterFormats(format) {
        if (vm.isFree && !format.hasFreeEpisodes) {
            return false;
        }


        if (vm.menuStations.indexOf(format.station) === -1) {
            return false;
        }

        if ((!vm.genreSelected || !vm.genreSelected.value) && vm.selectedStations.length === 0) {
            if (format.station === "watchbox") {
                return false;
            }
            return true;
        } else if (format.genres && vm.genreSelected && vm.genreSelected.value && vm.selectedStations.length > 0) {
            return (format.genres.indexOf($filter('genretext')(vm.genreSelected.text)) > -1 && vm.selectedStations.indexOf(format.station) > -1);
        } else if (format.genres && vm.genreSelected && vm.genreSelected.value && format.station !== "watchbox") {
            return (format.genres.indexOf($filter('genretext')(vm.genreSelected.text)) > -1 && format.station !== "watchbox");
        } else if ((!format.genres || (vm.selectedStations.length === 0 && format.station === "watchbox")) && vm.genreSelected && vm.genreSelected.value) {
            return false;
        } else if (vm.selectedStations.length === 0) {
            return true;
        } else {
            return (vm.selectedStations.indexOf(format.station) > -1);
        }
    }

    function Breadcrumbs() {
        BreadcrumbHelper.setItems(
            {
                'title': 'Sendungen A-Z',
                'url': 'az'
            }
        );
    }

    function checkGenre() {
        var genre = $location.search()['genre'];
        if ($routeParams.genre) {
            genre = $routeParams.genre;
        }
        if (vm.availableGenres && genre) {
            vm.genreSelected = {
                text: $filter('genretext')(vm.availableGenres[genre].name),
                label: 'Genre',
                value: genre
            };
            $location.search('genre', null);
        }
    }

    function loadFormats() {
        var filter = {
                'Id': {
                    'containsNotIn': ['1896']
                }
            },
            fields = 'id,title,station,title,titleGroup,seoUrl,icon,hasFreeEpisodes,hasPayEpisodes,categoryId,searchAliasName,genres',
            key = 'azformats';

        GlobalFormatService.getFormats(key, fields, filter).then(
            function (data) {
                allFormats = data.formats;
                vm.formatlist = $filter('groupBy')($filter('orderBy')(data.formats, 'titleGroup'), 'titleGroup');
                vm.availableGenres = data.genres;
                vm.loading = false;
                vm.init = true;
                checkGenre();
            },
            function () {
            }
        );
    }

    function init() {
        setMeta($routeParams.category);
        PageHistory.setPage('az');
        if (AppConfig.webclient === 'mobile' && vm.loading === true) {
            $rootScope.$broadcast('nowLoadingIndicator::show');
        }
        NowTagCommander.addToDatalayer("env_template", 'az');
        loadFormats();
    }

    function trackClick() {
        NowGoogleAnalytics.trackEvent('sendungen_az', 'link', 'formatauswahl');
    }

    function setMeta(station) {
        if (!station || station === 'tvnow') {
            Metadata.setTitleAndMeta(
                'Alle Sendungen online schauen als Stream',
                'Alle Sendungen im Überblick - nur bei TV NOW!'
            );
            return;
        }

        var stationUppercase = (station !== 'n-tv') ? station.toUpperCase() : station;
        Metadata.setTitleAndMeta(
            'Alle Sendungen von ' + stationUppercase + ' online schauen als Stream',
            'Alle Sendungen von ' + stationUppercase + ' hier online schauen. Ob Soap oder Actionserie, Show oder Magazin - hier ist für jeden die passende Sendung dabei.'
        );
    }

    function gotoFormat(format) {
        $location.path($filter('geturl')(format, 'isformat'));
    }
}


})();

(function() {

'use strict';

angular
    .module('NowAz')
    .controller('NowAzFlyoutController', NowAzFlyoutController);

NowAzFlyoutController.$inject = ['$scope', 'StationMonitor', 'NowApi', '$timeout', '$location', '$rootScope', '$sessionStorage', 'moment', '$log', 'NowGoogleAnalytics'];

function NowAzFlyoutController($scope, StationMonitor, NowApi, $timeout, $location, $rootScope, $sessionStorage, moment, $log, NowGoogleAnalytics) {

    var currentStation = false,
        trackingInitialIgnoreStatusNews = true,
        trackingInitialIgnoreStatusSerien = true,
        trackingInitialIgnoreStatusFree = true,
        vm = $scope;

    vm.toggleAz = toggleAz;
    vm.trackEvent = trackEvent;
    vm.trackCloseAz = trackCloseAz;
    vm.goToMovies = goToMovies;
    vm.isVisible = isVisible;

    vm.showAz = false;
    vm.isFree = false;
    vm.foobar = 'free';
    vm.loading = true;
    vm.init = false;
    vm.isNews = true;
    vm.isSerie = true;
    vm.trackingInitialWatchStatusOverlay = true;

    initWatchers();

    function checkShowAZ() {
        if (vm.showAz && !$location.search().az) {
            vm.showAz = false;
        } else if (!vm.showAz && $location.search().az) {
            vm.showAz = true;
        }
    }

    function goToMovies() {
        $location.path('/spielfilme');

        NowGoogleAnalytics.trackEvent('sendungen_az', 'link', 'spielfilme');
    }

    function isVisible(entry) {
        var visible = false;
        if (entry.categoryId === 'news' && $scope.isNews) {
            visible = true;
        }
        if (entry.categoryId === 'serie' && $scope.isSerie) {
            visible = true;
        }
        if (!entry.hasFreeEpisodes && $scope.isFree) {
            visible = false;
        }

        return visible;
    }

    function trackCloseAz() {
        NowGoogleAnalytics.trackEvent('navigation', 'zuklappen', 'sendungen_az');
    }

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('sendungen_az', action, label);
    }

    function toggleAz() {
        vm.showAz = !vm.showAz;

        //zur zeit wird toggleAz nur an einer Stelle verwendet, n�mlich am Link, um das AZ-Overlay zu schlie�en, darum kann das Tracking auch hier hin:
        trackEvent('link', 'formatauswahl');
    }

    function init() {
        var station = (StationMonitor.getStation()) ? StationMonitor.getStation() : 'rtl';

        if (station === 'nowtv') {
            vm.loading = true;
            vm.init = false;
            return false;
        }


        if ($sessionStorage.formats && $sessionStorage.formats[station] && moment($sessionStorage.formats[station].date).isAfter(moment()) && $sessionStorage.formats[station].formats.length > 0) {
            //console.log('Formatlist valid until:'+moment($sessionStorage.formats[station].date).format('YYYY-MM-DD HH:mm:ss'));
            vm.formatlist = $sessionStorage.formats[station].formats;
            vm.loading = false;
            vm.init = true;
            $scope.$broadcast('az:contentupdated');
            return true;
        }

        //console.log('INIT');
        var Format = NowApi.getFormat();
        Format.retrieve(
            {
                'filter': {
                    'Station': station,
                    'Disabled': '0',
                    'CategoryId': {
                        'containsIn': ['serie', 'news']
                    }
                },
                'fields': 'title,station,title,titleGroup,seoUrl,categoryId,*',
                'maxPerPage': 1000
            }
        ).then(function (data) {
            if (!$sessionStorage.formats) {
                $sessionStorage.formats = {
                    rtl: null,
                    vox: null,
                    rtl2: null,
                    nitro: null,
                    superrtl: null,
                    ntv: null
                };
            }

            $sessionStorage.formats[station] = {
                formats: data.items,
                date: moment().add(1, 'h')
            };


            vm.formatlist = data.items;
            vm.loading = false;
            vm.init = true;
            $scope.$broadcast('az:contentupdated');
        }, function (err) {
            $log.debug('ERROR updating formatlist az',err);
        });
    }

    function initWatchers() {
        vm.$watch('isFree', function (newValue) {
            if (newValue) {
                vm.foobar = 'free';
            } else {
                vm.foobar = 'check';
            }
            if (!trackingInitialIgnoreStatusFree) {
                trackEvent((newValue) ? 'haeckchen_an' : 'haekchen_aus', 'nur_free');
            }
            trackingInitialIgnoreStatusFree = false;
            $scope.$broadcast('az:contentupdated');
        });

        vm.$watch('isNews', function (newValue) {
            if (!newValue && !vm.isSerie) {
                vm.isNews = true
            }
            $scope.$broadcast('az:contentupdated');

            if (newValue && !trackingInitialIgnoreStatusNews) {
                trackEvent('haeckchen_an', 'news');
            } else if (!trackingInitialIgnoreStatusNews) {
                trackEvent('haeckchen_aus', 'news');
            }
            trackingInitialIgnoreStatusNews = false;
        });

        vm.$watch('isSerie', function (newValue) {
            if (!newValue && !vm.isNews) {
                vm.isSerie = true
            }
            $scope.$broadcast('az:contentupdated');

            if (newValue && !trackingInitialIgnoreStatusSerien) {
                trackEvent('haeckchen_an', 'serien');
            } else if (!trackingInitialIgnoreStatusSerien) {
                trackEvent('haeckchen_aus', 'serien');
            }
            trackingInitialIgnoreStatusSerien = false;
        });

        vm.$watch('showAz', function (newValue) {
            if (newValue && !vm.init || currentStation !== StationMonitor.getStation()) {
                currentStation = StationMonitor.getStation();
                vm.loading = true;
                init();
            }
            if (newValue) {
                if (currentStation === 'rtl') {
                    vm.showCheckboxes = true;
                } else {
                    vm.showCheckboxes = false;
                    vm.isNews = true;
                    vm.isSerie = true;
                }

                $location.search({});
                $location.search('az', true);
                $scope.$broadcast('az:contentupdated');

                NowGoogleAnalytics.trackEvent('navigation', 'aufklappen', 'sendungen_az');
            } else {
                $location.search('az', null);

                /*if (!vm.trackingInitialWatchStatusOverlay) {
                 NowGoogleAnalytics.trackEvent('navigation','zuklappen','sendungen_az');
                 }
                 vm.trackingInitialWatchStatusOverlay = false;*/
            }
        });

        var accountLogin = $rootScope.$on('account::login', function () {
            vm.init = false;
            vm.loading = true;
            delete $sessionStorage.formats;
        });

        var accountLogout = $rootScope.$on('account::logout', function () {
            vm.init = false;
            vm.loading = true;
            delete $sessionStorage.formats;
        });

        vm.$on('az:contentupdated', function () {
            $timeout(function () {
                if (vm.ScrollbarReload) {
                    vm.ScrollbarReload();
                }

            }, 500);
        });

        vm.$on('resize::jump', function () {
            vm.ScrollbarReload();
        });

        var routeUpdate = $rootScope.$on('$routeUpdate', checkShowAZ);
        var routeChangeSuccess = $rootScope.$on('$routeChangeSuccess', checkShowAZ);

        $rootScope.$on('$destroy', accountLogin);
        $rootScope.$on('$destroy', accountLogout);
        $rootScope.$on('$destroy', routeUpdate);
        $rootScope.$on('$destroy', routeChangeSuccess);
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAz')
    .config(routing);
routing.$inject = ['$routeProvider'];
function routing($routeProvider) {

    $routeProvider
        .when('/az', {
                controller: 'NowAzController',
                controllerAs: 'vm',
                templateUrl: 'templates/az_view.html',
                reloadOnSearch: false,
                data: {
                    pagetype: 'static',
                    pagesubtype: 'az'
                },
                resolve: {
                    page: pageResolve
                }
            }
        )
        .when('/az/:category', {
                controller: 'NowAzController',
                controllerAs: 'vm',
                templateUrl: 'templates/az_view.html',
                reloadOnSearch: true,
                data: {
                    pagetype: 'static'
                },
                resolve: {
                    page: pageResolve
                }
            }
        )
        .when('/az/:category/:genre', {
                controller: 'NowAzController',
                controllerAs: 'vm',
                templateUrl: 'templates/az_view.html',
                reloadOnSearch: true,
                data: {
                    pagetype: 'static'
                },
                resolve: {
                    page: pageResolve
                }
            }
        );
    pageResolve.$inject = ['$route', 'NowApi', 'StationMonitor'];
    function pageResolve($route, NowApi, StationMonitor) {
        var station = $route.current.params.station;
        if (StationMonitor.getStationsOrdered().indexOf(station) === -1) {
            station = 'nowtv';
        }
        return NowApi.getPage().retrievePagesByStationAndPath({
            station: station,
            pagepath: 'az',
            fields: '*'
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }
}


})();

(function() {



})();

(function() {

angular.module('NowHome', []);

})();

(function() {

'use strict';

angular.module('NowHome')
    .directive('nowHomeLandingPage', nowHomeLandingPage);

nowHomeLandingPage.$inject = ['$rootScope', '$window', '$sessionStorage', 'NowGoogleAnalytics', 'NowMobileNav', '$timeout', 'AppConfig'];

function nowHomeLandingPage($rootScope, $window, $sessionStorage, NowGoogleAnalytics, NowMobileNav, $timeout, AppConfig) {
    return {
        restrict: 'E',
        link: link,
        replace: true,
        templateUrl: 'templates/home_landingpage.html'
    };

    function link(scope) {
        NowMobileNav.hide();
        scope.returnToHome = returnToHome;
        scope.returnToLivestream = returnToLivestream;

        $("body").addClass('landingpage-active');


        NowGoogleAnalytics.trackEvent('vorschaltseite', 'show');
        var routeCHangeSuccess = $rootScope.$on('$routeChangeSuccess', function () {
            $sessionStorage.noLandingpage = true;
            $("body").removeClass('landingpage-active');
        });
        $rootScope.$on('$destroy',routeCHangeSuccess);


        function returnToHome() {
            NowGoogleAnalytics.trackEvent('vorschaltseite', 'zum_livestream');
            $sessionStorage.noLandingpage = true;
            $("body").removeClass('landingpage-active');
            $timeout(function () {
                $window.location.reload();
            }, 500);
        }

        function returnToLivestream() {
            NowGoogleAnalytics.trackEvent('vorschaltseite', 'zum_livestream');
            $sessionStorage.noLandingpage = true;
            $("body").removeClass('landingpage');
            if (AppConfig.webclient === 'mobile') {
                $window.location.href = AppConfig.ffc + '/?premium=livetv';
            } else {
                $window.location.href = '/rtl/live-tv';
            }
        }
    }

}


})();

(function() {

'use strict';

angular.module('NowHome')
    .directive('nowleadteaser', nowleadteaser);

nowleadteaser.$inject = ['NowApi', '$timeout', 'StationMonitor', 'AutoimgUrlHelper', 'Moviehelper', '$location', '$localStorage', '$log', '$filter', 'RecommendationService', 'NowGoogleAnalytics'];

function nowleadteaser(NowApi, $timeout, StationMonitor, AutoimgUrlHelper, Moviehelper, $location, $localStorage, $log, $filter, RecommendationService, NowGoogleAnalytics) {
    controller.$inject = ['$scope', '$element', '$attrs','$document'];
    return {
        restrict: 'E',
        link: link,
        controller: controller,
        replace: true,
        templateUrl: 'templates/home_leadteaser.html'
    };

    function link(scope) {
        var timeout = false;

        scope.slick = slick;
        scope.favButtonOnShow = favButtonOnShow;
        scope.favButtonOnHide = favButtonOnHide;

        init();

        function init() {
            scope.$on('$destroy', function () {
                if ($('.now-leadteaser-images .slick-initialized').length) {
                    $('.now-leadteaser-images .slick-initialized').slick('unslick');
                }
            });

            scope.$watch('videoSrc', function (videoSrc) {
                $('.video').attr('src', videoSrc);
            });
        }

        function favButtonOnShow() {
            //console.log('favButtonOnShow');
            if (!$('video').is(':visible')) {
                if (timeout) {
                    $timeout.cancel(timeout);
                }
            } else {
                $('video')[0].pause();
            }
        }

        function favButtonOnHide() {
            //console.log('favButtonOnHide');
            if (!$('video').is(':visible')) {
                setNextTimeout();
            } else {
                $('video')[0].play();
            }
        }

        function slick() {
            var slickOptions = {
                centerMode: true,
                centerPadding: '0px',
                slidesToShow: 7,
                draggable: false,
                focusOnSelect: true,
                autoplay: false,
                autoplaySpeed: 6000,
                nextArrow: $('.now-leadteaser-nav .icon-nowarrow_right').parent(),
                prevArrow: $('.now-leadteaser-nav .icon-nowarrow_left').parent(),
                responsive: [
                    {
                        breakpoint: 1560,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 1260,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            };

            $('.now-leadteaser-images .images')
                .on('init', slickInit)
                .slick(slickOptions)
                .on('beforeChange', beforeChange)
                .on('afterChange', afterChange);

            $('#leadvideo').on('ended', function () {
                $('.now-leadteaser-images .images').slick('slickNext');
                //$('.now-leadteaser-images .images').slick('slickSetOption', 'autoplay', true, false);
            });

            function slickInit() {
                scope.showBottom = true;
                setNextTimeout();
                scope.$apply();
            }

            function beforeChange() {
                $('.now-leadteaser-text').fadeOut(500);
            }

            function afterChange(slick, currentSlide, nextSlide) {
                $log.debug('Home::LeadteaserHome::afterChange',slick,currentSlide,nextSlide);
                if (timeout) {
                    $timeout.cancel(timeout);
                }
                scope.showTeaser($('.now-leadteaser-images .images').slick('slickCurrentSlide'), function () {
                    $('.now-leadteaser-text').fadeIn(500);
                });
                setNextTimeout();
            }
        }

        function setNextTimeout() {
            if (timeout) {
                $timeout.cancel(timeout);
            }

            var leadteaserImagesInitialized = $('.now-leadteaser-images .slick-initialized');

            if (!$('video').is(':visible')) {
                timeout = $timeout(function () {
                    if (leadteaserImagesInitialized.length) {
                        leadteaserImagesInitialized.slick('slickNext');
                    }
                }, 5000);
            }
        }
    }


    function controller($scope, $document) {
        var station = StationMonitor.getStation();

        var currentTeaser = false;

        $scope.subteasers = [];
        $scope.showBottom = false;

        $scope.showTeaser = showTeaser;
        $scope.goto = goto;

        var vid = $document[0].createElement('video');
        if (!vid.canPlayType('video/mp4')) {
            $localStorage.disableVideo = true;
        }
        if (angular.isDefined(vid) && angular.isFunction(vid.remove)) {
            vid.remove();
        } else if (vid.parentNode) {
            vid.parentNode.removeChild(vid);
        }

        init();

        function init() {
            $log.debug('directive_leadteaser init();');
            NowApi.getLeadteasers()
                .retrieveCmsLeadteaserByStation({
                    station: (station) ? station : 'nowtv',
                    fields: '["cmsLeadSubteasers",["*","stationId","format",["title","seoUrl","id","station","leadTeaserTrailer","kenburns","icon"],"movie",["id","title","*","pictures","format","livestreamEvent","paymentPaytypes","packages"]]]'
                })
                .then(
                    function (data) {
                        handleRetrieveCmsLeadteaserByStation(data);
                    },
                    function (err) {
                        $log.error(err);
                    }
                );
        }

        function renderSubTeasers(data) {
            $scope.subteasers = data.cmsLeadSubteasers.items;
            $scope.subteasers = $scope.subteasers.concat(data.cmsLeadSubteasers.items);
            showTeaser(0);
            $timeout(function () {
                $scope.slick();
            }, 1000);
        }

        function renderSubTeasersWithRecommendation(data) {
            var itemOnPage = [];
            angular.forEach(data.cmsLeadSubteasers.items, function (cmsLeadSubTeaserItem) {
                var movie = cmsLeadSubTeaserItem.movie;
                if (false === angular.isUndefined(movie) && null !== movie) {
                    itemOnPage.push(RecommendationService.getSuffixedMovieId(movie.id));
                }
            });

            var subTeaserItems = data.cmsLeadSubteasers.items;

            RecommendationService.getRecommendationsForLeadTeaser(itemOnPage, function (data) {
                if (1 < data.items.length) {
                    for (var i = 0; i < 2; i++) {
                        var recommendationItem = data.items[i];
                        var movie = recommendationItem.movie;
                        var format = recommendationItem.format ? recommendationItem.format : recommendationItem.movie.format;
                        var leadSubTeaserItem = {
                            id: '-1',
                            title: '',
                            formatId: format.id,
                            season: 0,
                            headline: '',
                            subHeadline: '',
                            info: '',
                            station: StationMonitor.getStation(),
                            linkSrc: '',
                            linkTarget: '_self',
                            nowNext: 'recommendation',
                            analyticsSource: 'reco',
                            useFormatLink: false,
                            movie: movie,
                            format: format,
                            teaserItem: recommendationItem
                        };
                        subTeaserItems[subTeaserItems.length - 1 - i] = leadSubTeaserItem;
                    }
                }
                $scope.subteasers = subTeaserItems;
                $scope.subteasers = $scope.subteasers.concat(subTeaserItems);

                showTeaser(0);
                $timeout(function () {
                    $scope.slick();
                }, 1000);
            });
        }

        function handleRetrieveCmsLeadteaserByStation(data) {
            $log.debug('directive_teaser handleRetrieveCmsLeadteaserByStation()', {data: data});
            $scope.recommendationService = RecommendationService;
            if (false === RecommendationService.isReceivingEnabled()) {
                renderSubTeasers(data);
                return;
            }
            renderSubTeasersWithRecommendation(data);
        }

        function goto() {
            $log.debug('directive_leadteaser goto()', {currentTeaser: currentTeaser});

            RecommendationService.fireEventRecClick(currentTeaser.teaserItem);

            NowGoogleAnalytics.trackEvent('aufmacher', 'format', (currentTeaser.analyticsSource) ? currentTeaser.analyticsSource : 'redaktionell');

            if (currentTeaser.nowNext === 'none' && currentTeaser.linkSrc && currentTeaser.linkSrc.length > 0) {
                $location.path(currentTeaser.linkSrc);
            } else if (currentTeaser.movie && !currentTeaser.useFormatLink) {
                if ($filter('geturl')(currentTeaser.movie, 'appendpayment').match(/payment=/)) {
                    $location.search('premium');
                } else {
                    $location.search(Moviehelper.getMoviePlayerSearch(currentTeaser.movie)).path(Moviehelper.getMoviePlayerPath(currentTeaser.movie));
                }
            } else if (currentTeaser.format) {
                $location.path(StationMonitor.getAlias(currentTeaser.format.station) + '/' + currentTeaser.format.seoUrl);
            }
        }

        function showTeaser(index, cb) {
            var teaser = $scope.subteasers[index];
            currentTeaser = teaser;

            if (!teaser) {
                return false;
            }

            if (
                teaser.headline && teaser.headline.length > 0 && teaser.subHeadline && teaser.subHeadline.length > 0 && teaser.info && teaser.info.length > 0 && !teaser.movie
            ) {
                $scope.small = teaser.info;
                $scope.large = teaser.headline;
                $scope.description = teaser.subHeadline;
            } else {
                if (teaser.movie) {

                    $scope.description = teaser.movie.teaserText;
                    $scope.date = teaser.movie.broadcastStartDate;
                    if (teaser.movie.free || teaser.movie.payed) {
                        $scope.status = 'FREE';
                    } else {
                        $scope.status = 'PAY';
                    }
                }
                if (teaser.format) {
                    $scope.large = teaser.format.title;
                    if (!teaser.movie) {
                        $scope.status = (teaser.format.icon === 'pay' || teaser.format.icon === 'free') ? teaser.format.icon : '';
                        $scope.description = teaser.subHeadline;
                    }
                }
                $scope.statusitem = teaser.format;
                if (teaser.movie) {
                    $scope.statusitem = teaser.movie;
                }
                $scope.small = null;
            }

            if (bowser.msie && bowser.version === '11.0') {
                $log.debug('Ignore videoteasers on IE11');
                $localStorage.disableVideo = true;
            }

            var effects = ['topright', 'topleft', 'bottomleft', 'bottomright'];
            var effect = effects[Math.floor(Math.random() * effects.length)];

            if (teaser.movie && teaser.movie.leadTeaserTrailer && !$localStorage.disableVideo) {
                $scope.videoSrc = '//bilder.akamai.rtl.de/now/leadteasertrailer/film/' + teaser.movie.id + '/aufmacher.mp4';
                $scope.videoShow = true;
                $scope.imageShow = false;
            } else if (teaser.format && teaser.format.leadTeaserTrailer && !$localStorage.disableVideo) {
                $scope.videoSrc = '//bilder.akamai.rtl.de/now/leadteasertrailer/format/' + teaser.format.id + '/aufmacher.mp4';
                $scope.videoShow = true;
                $scope.imageShow = false;
            } else if (teaser.movie && teaser.movie.kenburns && !$localStorage.disableVideo) {
                $scope.videoSrc = '//bilder.akamai.rtl.de/now/kenburns/film/' + teaser.movie.id + '/' + effect + '.mp4';
                $scope.videoShow = true;
                $scope.imageShow = false;
            } else if (teaser.format && teaser.format.kenburns && !$localStorage.disableVideo) {
                $scope.videoSrc = '//bilder.akamai.rtl.de/now/kenburns/format/' + teaser.format.id + '/' + effect + '.mp4';
                $scope.videoShow = true;
                $scope.imageShow = false;
            }
            else {
                if (teaser.movie && teaser.movie.pictures && teaser.movie.pictures.default.length > 0) {
                    AutoimgUrlHelper.setParams(teaser.movie.id, null, null, '1280x720');
                } else {
                    AutoimgUrlHelper.setParams(null, teaser.format.id, null, '1280x720');
                }

                if ($scope.imageIndex === 1) {
                    $scope.imageSrc2 = AutoimgUrlHelper.getAutoimgUrl();
                    $scope.imageIndex = 2;
                } else {
                    $scope.imageSrc1 = AutoimgUrlHelper.getAutoimgUrl();
                    $scope.imageIndex = 1;
                }

                $scope.videoShow = false;
                $scope.imageShow = true;

            }

            if (!$scope.$digest()) {
                $scope.$apply();
            }

            if (cb) {
                cb();
            }
        }
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowHome')
    .controller('NowHomeController', NowHomeController);

NowHomeController.$inject = ['$scope', 'StationMonitor', '$rootScope', '$timeout', 'BreadcrumbHelper', 'page', 'Metadata', 'RecommendationService', '$location', 'PageHistory', '$filter', 'NowTracking', '$log', '$route', 'NowGoogleAnalytics', 'NowTeaser', 'landingpage', '$window', 'NowTagCommander'];

function NowHomeController($scope, StationMonitor, $rootScope, $timeout, BreadcrumbHelper, page, Metadata, RecommendationService, $location, PageHistory, $filter, NowTracking, $log, $route, NowGoogleAnalytics, NowTeaser, landingpage, $window, NowTagCommander) {
    var vm = $scope;
    vm.landingpage = landingpage;
    vm.page = page;
    vm.station = StationMonitor.getStation();
    vm.selectedStations = [vm.station];
    vm.genreSelected = ''; //Though nowStationSwitch-directive does not display a genre, two-way binding needs this var to be initialized
    vm.newpage = page === false;
    vm.page = (page === false) ? {} : page;
    vm.previewmode = true;
    vm.$rootScope = $rootScope;
    vm.pagePath = ($route.current.params.page) ? $route.current.params.page : $route.current.params.station;
    $rootScope.globalTeasersetCount = 0;

    vm.selectedStation = selectedStation;
    vm.addTeaserSetClass = addTeaserSetClass;
    vm.top = top;
    vm.toggleInfonlineObjectionButton = toggleInfonlineObjectionButton;
    vm.toggleGAObjectionButton = toggleGAObjectionButton;
    init();

    function init() {
        BreadcrumbHelper.resetItems();

        NowTagCommander.addToDatalayer("page_id", page.id);
        NowTagCommander.addToDatalayer("page_path", $location.path());
        NowTagCommander.addToDatalayer("env_template", 'homepage');
        Metadata.setMobileAltEnable(true);
        if (page.teaserSets && page.teaserSets.items) {
            NowTeaser.setCurrentTeasersets(page.teaserSets.items);
        }

        PageHistory.setPage('static');
        if (page && page.path && page.path.indexOf('glossar_') === 0 && angular.isDefined(page.teaserSets.items[0].teaserSetInformations.items[0].custom.data.subheadline)) {
            Metadata.setTitleAndMeta(
                page.teaserSets.items[0].teaserSetInformations.items[0].custom.data.subheadline,
                ''
            );
        } else if (page && page.metaTitle && page.metaTitle.length > 0) {
            Metadata.setTitleAndMeta(
                page.metaTitle,
                page.metaDescription
            );
        }

        if (page.special) {
            PageHistory.setPage('specials', {'specialtag': page.ivw});
        }

        if (page.teaserSets && page.teaserSets.items.length > 0) {
            vm.teasersets = page.teaserSets.items;
        } else {
            vm.teasersets = [];
        }

        $log.debug('NowHomeController init()', {'vm.page': vm.page});

        $timeout(function () {
            RecommendationService.handleOptButton();

            if (vm.page.path === 'datenschutz' && NowTracking.isInfonlineTrackingDisabledByUser()) {
                setInfonlineObjectionButton(true);
            } else {
                setInfonlineObjectionButton(false);
            }

            $('a#infonlineObjectionButton').on('click', function () {
                toggleInfonlineObjectionButton();
            });
        }, 0);

        $timeout(function () {
            //RecommendationService.handleOptButton();

            if (vm.page.path === 'datenschutz' && NowGoogleAnalytics.gaOptoutStatus() === true) {
                setGAObjectionButton(true);
            } else {
                setGAObjectionButton(false);
            }

            $('a#gAObjectionButton').on('click', function () {
                toggleGAObjectionButton();
            });
        }, 0);
    }

    function setInfonlineObjectionButton(val) {
        if ($window.isWebview) {
            $('a#infonlineObjectionButton').replaceWith('<span>Benutzen Sie in der App bitte den Schalter am unteren Bildschirmrand</span>');
            return;
        }

        if (val) {
            //objection === true
            $('a#infonlineObjectionButton').text('Zum Zustimmen hier klicken  (es wird ein Cookie gesetzt)');
        } else {
            $('a#infonlineObjectionButton').text('Zum Widerspruch hier klicken (es wird ein Cookie gesetzt)');
        }
    }



    function toggleGAObjectionButton() {
        if (NowGoogleAnalytics.gaOptoutStatus() === true) {
            NowGoogleAnalytics.gaOptout(false);
        } else {
            NowGoogleAnalytics.gaOptout(true);
        }
        // console.log("status ga",NowGoogleAnalytics.gaOptoutStatus());
        // var newStatus = NowGoogleAnalytics.gaOptoutStatus();
        setGAObjectionButton(NowGoogleAnalytics.gaOptoutStatus());
    }

    function setGAObjectionButton(val) {
        if ($window.isWebview) {
            $('a#gAObjectionButton').replaceWith('<span>Benutzen Sie in der App bitte den Schalter am unteren Bildschirmrand</span>');
            return;
        }

        if (val) {
            //objection === true
            $('a#gAObjectionButton').text('Wieder anschalten(es wird ein Cookie gesetzt)');
        } else {
            $('a#gAObjectionButton').text('Abschalten (es wird ein Cookie gesetzt)');
        }
    }

    function toggleInfonlineObjectionButton() {
        var newStatus = NowTracking.toggleInfonlineTrackingByUser();
        setInfonlineObjectionButton(newStatus);
    }

    function selectedStation(selection) {
        if (selection[0] === 'tvnow') {
            $location.path('/');
        } else if (selection[0] === 'toggoplus') {
            $location.path('/toggoplus/live-tv');
        } else {
            $location.path('/' + $filter('stationalias')(selection[0]));
        }
    }

    function addTeaserSetClass(teaserset) {
        var css = '';
        if (vm.previewmode) {
            css = 'now-teaserset-layout-' + teaserset.layout;
        }
        return css
    }

    function top() {
        //console.log('TOP');
        $window.scrollTo(0, 0);
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowHome')
    .config(routing);

routing.$inject = ['$routeProvider', '$windowProvider', 'AppConfigProvider', '$localStorageProvider', '$sessionStorageProvider'];

function routing($routeProvider, $windowProvider, AppConfigProvider, $localStorageProvider, $sessionStorageProvider) {

    var route = {
        controller: 'NowHomeController',
        templateUrl: templateUrl,
        reloadOnSearch: false,
        data: {
            pagetype: 'static'
        },
        resolve: {
            page: resolvePage,
            landingpage: resolveLandingPage
        }
    };

    $routeProvider
        .when('/', route)
        .when('/:station', route)
        .when('/:station/cms/:page', route)
        .when('/shows/:page', route)
        .when('/serien/:page', route)
        .when('/filme/:page', route)
        //the otherwise is used globally, so routes declared later during the config phase (i.e., in other controllers) will also be using this fallback
        .otherwise({
            redirectTo: function () {
                var $window = $windowProvider.$get();
                if (AppConfigProvider.getConfig().notFoundPage.indexOf('https') === 0) {
                    $window.location.replace(AppConfigProvider.getConfig().notFoundPage);
                    throw new Error("Redirected to FFC");
                }
                return AppConfigProvider.getConfig().notFoundPage;
            }
        });


    function resolveLandingPage() {
        try {
            var config = AppConfigProvider.getConfig();
            if (config.settings.none[config.stage].landingpage == "true" && !$sessionStorageProvider.get('noLandingpage')) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }

    }

    resolvePage.$inject = ['$route', 'NowApi', 'StationMonitor', 'Metadata', '$location', '$window', '$log', '$q', 'Optimizely', 'STAGE', 'Accounting'];
    function resolvePage($route, NowApi, StationMonitor, Metadata, $location, $window, $log, $q, Optimizely, STAGE, Accounting) {

        // GET PAGE
        //console.log($route);
        var deferred = $q.defer();
        var pagepath = ($route.current.params.page) ? $route.current.params.page : $route.current.params.station,
            station,
            testId = (STAGE.isProduction) ? 8659951091 : 8673190352,
            tPromises = [],
            tsPromises = [];
        pagepath = (!pagepath) ? 'tvnow' : pagepath;

        if (StationMonitor.getStationsOrdered().indexOf(pagepath) === -1 && !$route.current.params.page) {
            station = 'nowtv';
        } else {
            station = StationMonitor.getStation();
        }
        //console.log('Optimizely is aktive',Optimizely.isActiveExperiment(8673190352));
        //console.log('pagepath',pagepath);
        if (!Accounting.isPremiumUser()) {
            if (Optimizely.isActiveExperiment(testId)) {
                if (Optimizely.getVariationNames() !== 'Original') {
                    if (Optimizely.getVariationNames() === 'Variante 1') {
                        if (pagepath === 'tvnow') {
                            pagepath = 'home-v1';
                        } else if (pagepath === 'rtl') {
                            pagepath = 'rtlhome-v1';
                        } else if (pagepath === 'rtl2') {
                            pagepath = 'rtl2home-v1';
                        } else if (pagepath === 'vox') {
                            pagepath = 'voxhome-v1';
                        }
                    } else if (Optimizely.getVariationNames() === 'Variante 2') {
                        if (pagepath === 'tvnow') {
                            pagepath = 'home-v2';
                        } else if (pagepath === 'rtl') {
                            pagepath = 'rtlhome-v2';
                        } else if (pagepath === 'rtl2') {
                            pagepath = 'rtl2home-v2';
                        } else if (pagepath === 'vox') {
                            pagepath = 'voxhome-v2';
                        }
                    }
                }
            }
        }
        var fields = [
            '*',
            'teaserSets.id',
            'teaserSets.row',
            'teaserSets.layout',
            'teaserSets.automaticType'
        ].join(',');
        if (resolveLandingPage()) {
            fields = '*';
        }


        if($route.current.originalPath.indexOf('/filme/') > -1){
            pagepath = "filme_"+pagepath;
            station = 'tvnow';
        }else if($route.current.originalPath.indexOf('/serien/') > -1){
            pagepath = "serien_"+pagepath;
            station = 'tvnow';
        }else if($route.current.originalPath.indexOf('/shows/') > -1){
            pagepath = "shows_"+pagepath;
            station = 'tvnow';
        }
        NowApi.getPage().retrievePagesByStationAndPath({
            station: station,
            pagepath: pagepath,
            fields: fields
        }).then(success, error);

        function success(data) {
            if (data.redirectFrontend) {
                Metadata.setSeoRedirect(Metadata.getFullUrl(data.redirectFrontend));

                if (Metadata.getFullUrl(data.redirectFrontend) === data.redirectFrontend) {
                    $log.debug('home/route setting url to ', data.redirectFrontend);
                    $window.location.href = data.redirectFrontend;
                } else {
                    $log.debug('home/route setting path ', {
                        'metadata.getFullUrl': Metadata.getFullUrl(data.redirectFrontend),
                        'data.redirectFrontend': data.redirectFrontend
                    });
                    $location.path(data.redirectFrontend);
                    $location.replace();
                }

                deferred.resolve(false);
            }

            //$log.debug('resolvePage() pagedata', data, data.teaserSets, angular.isObject(data.teaserSets));
            if (angular.isObject(data.teaserSets) && angular.isArray(data.teaserSets.items)) {
                angular.forEach(data.teaserSets.items, function (teaserset, keyts) {
                    //$log.debug('resolvePage() getTeaserSet', teaserset.id);
                    tsPromises.push(getSingleTeaserSet(teaserset.id, teaserset.automaticType).then(function (teasersetdata) {
                        //$log.debug('resolvePage() teasersetdata', teaserset.id, teasersetdata);
                        data.teaserSets.items[keyts] = teasersetdata;
                        if (angular.isObject(teasersetdata.teaserSetInformations)) {
                            angular.forEach(teasersetdata.teaserSetInformations.items, function (teaser, keyt) {
                                //$log.debug('resolvePage() getTeaser', teaserset.id, teaser.id);
                                if (teaser.id > 1) {
                                    tPromises.push(getSingleTeaser(teaser.id).then(function (teaserdata) {
                                        //$log.debug('resolvePage() teaserdata', teaser.id, teaserdata);
                                        data.teaserSets.items[keyts].teaserSetInformations.items[keyt] = teaserdata;
                                    }, function () {
                                    }));
                                }
                            });
                        }
                    }, function () {
                    }));
                });
                //$log.debug('resolvePage() tsPromises', angular.copy(tsPromises));
                $q.all(tsPromises).then(function () {
                    //$log.debug('resolvePage() all teasersets called');
                    //$log.debug('resolvePage() tPromises', angular.copy(tPromises));
                    $q.all(tPromises).then(function () {
                        //$log.debug('resolvePage() all teasers called');
                        Metadata.setOgPage(data);
                        $log.debug('resolvePage() complete', data);
                        deferred.resolve(data);
                    });

                });
            }
            else {
                deferred.resolve(data);
            }
        }

        function error() {

            if (AppConfigProvider.getConfig().mode !== 'edit') {
                Metadata.tryGlobalRedirect($location.path()).then(function () {
                    return true;
                }, function(){
                    Metadata.setSeoStatuscode(404);
                    $location.path(AppConfigProvider.getConfig().notFoundPage);
                });
            }

            deferred.resolve(false);
        }

        var teaserSetInformationsFields = '["*","custom",["*","page",["id","station","path","name"],"format",["id","title","station","seoUrl"],"movie",["id","title","station","seoUrl","episode","path","payed","free","packages","blockadeText","geoblocked","startDate","broadcastStartDate","alternateBroadcastDateText","teaserText","exclusive","exclusive","paymentPaytypes",["*"],"format",["id","station","seoUrl","title","movieCount","categoryId"]]],"movie",["id","title","station","seoUrl","episode","path","payed","free","packages","blockadeText","geoblocked","startDate","broadcastStartDate","alternateBroadcastDateText","teaserText","exclusive","exclusive","pictures","packages","leadTeaserTrailer","kenburns","paymentPaytypes",["*"],"format",["id","station","seoUrl","title","categoryId"]],"format",["id","station","seoUrl","title","movieCount","categoryId","icon","leadTeaserTrailer","kenburns","paymentPaytypes",["*"]]]';

        function getSingleTeaserSet(id, automaticType) {
            var deferredTeasers = ['none', 'recommendation', 'recommendation-series', 'allseencontent', 'lastseencontent', 'favoriteformats'];
            var fields = [
                '*',
                'teaserSetInformations.id',
                'teaserSetInformations.type'
            ].join(',');

            if (deferredTeasers.indexOf(automaticType) === -1) {
                fields = '["*","teaserSetInformations",' + teaserSetInformationsFields + ']';
            }


            return NowApi.getTeasersets().retrieveTeaserSetById({
                id: id,
                fields: fields
            });
        }

        function getSingleTeaser(id) {
            return NowApi.getTeasers().retrieveTeaserById({
                id: id,
                fields: teaserSetInformationsFields
            });
        }

        return deferred.promise;
    }

    function templateUrl(params) {
        if (!params.station) {
            params.station = 'nowtv';
        }
        var template = 'templates/home.html';
        if (['nowtv'].concat(AppConfigProvider.getConfig().stationsOrdered).indexOf(params.station) > -1 && !params.page) {
            if (AppConfigProvider.getConfig().mode === 'edit') {
                template = 'templates/static_edit.html';
            } else {
                template = 'templates/home.html';
            }
        } else {
            if (AppConfigProvider.getConfig().mode === 'edit') {
                template = 'templates/static_edit.html';
            } else {
                template = 'templates/static.html';
            }

        }

        //console.log('template', template);
        return template;
    }
}


})();

(function() {



})();

(function() {

angular.module('NowMovielist', ['ngRoute', 'NowAppBase', 'NowStation']);

})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .directive('headerimage', NowHeaderImage);

NowHeaderImage.$inject = ['$window'];

function NowHeaderImage($window) {
    return {
        restrict: 'E',
        templateUrl: 'templates/movielist_headerimage.html',
        link: link,
        replace: true
    };

    function link(scope) {
        scope.stationDomain = '';
        scope.stationText = '';
        scope.hideStationText = false;

        $window.scrollTo(0, 0);
        if (scope.format) {
            scope.url = ($window.innerWidth >= 1560) ? scope.format.defaultHeaderLargeImage : (($window.innerWidth >= 1260) ? scope.format.defaultHeaderMediumImage : scope.format.defaultHeaderSmallImage);
        }

        if (angular.isUndefined(scope) || !scope.format || !scope.format.headerLinkStation) {
            scope.hideStationText = true;
        } else {
            switch (scope.format.headerLinkStation) {
                case 'rtl':
                    scope.stationText = 'RTL';
                    break;
                case 'vox':
                    scope.stationText = 'VOX';
                    break;

                case 'ntv':
                    scope.stationText = 'n-tv';
                    break;
                case 'nitro':
                    scope.stationText = 'NITRO-TV';
                    break;
                case 'superrtl':
                    scope.stationText = 'SUPERRTL';
                    break;
                case 'rtl2':
                    scope.stationText = 'RTL2';
                    break;
                case 'rtlplus':
                    scope.stationText = 'RTLplus';
                    break;
                case 'nowus':
                    scope.stationText = 'NOW-US';
                    break;
                case 'toggoplus':
                    scope.stationText = 'TOGGO plus';
                    break;
                default:
                    scope.hideStationText = true;
            }
            scope.stationDomain = scope.stationText.toLowerCase();
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .directive('nowMovielistAccordionTab', nowMovielistAccordionTab);

nowMovielistAccordionTab.$inject = ['NowApi', 'moment', '$q', 'AppConfig', '$window', '$anchorScroll', 'NowGoogleAnalytics', 'STAGE', '$log', 'Optimizely'];

function nowMovielistAccordionTab(NowApi, moment, $q, AppConfig, $window, $anchorScroll, NowGoogleAnalytics, STAGE, $log, Optimizely) {
    var now = moment();
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/movielist_accordion_tab.html',
        link: link,
        scope: {
            year: '=',
            month: '=',
            currentmonth: '=',
            format: '=',
            title: '=',
            expand: '=',
            seasontab: '=',
            tabindex: '=',
            tabtype: '@'
        }
    };

    function link(scope) {
        scope.loading = true;
        scope.init = false;
        scope.accordions = [{
            title: scope.title,
            movies: []
        }];
        scope.limitMovies = 5;
        scope.less = false;
        scope.ffc = AppConfig.ffc + '/?premium=';
        var testId = (STAGE.isProduction) ? 8845710674 : 8842620166,
            imageCount = 0,
            allImagesLoaded = false,
            maxImages,
            acIndex = 0;
        scope.$watch('expand', function (expand) {
            if (scope.tabtype === "month" && expand && scope.month && scope.year && scope.init === false) {
                loadMonthContent();
            } else if (scope.tabtype === "season" && expand && scope.seasontab && scope.init === false) {
                loadSeasonContent()
            }
        });
        scope.scrollButton = false;
        scope.scrollEvent = false;

        scope.$on('image::loaded', onImageLoaded);

        function onImageLoaded(event, imageEvent) {
            event.stopPropagation();
            imageCount++;
            $log.debug('image::loaded in acordeon movie', imageCount + ' of ' + maxImages, imageEvent);
            if (imageCount === scope.limitMovies || imageCount === scope.accordions[acIndex].movies.length) {
                var buttonOffset = false;
                if (scope.scrollButton) {
                    buttonOffset = scope.scrollButton.offset();
                    $window.scrollTo(0, parseInt(buttonOffset.top) - $(window).height() + 55);

                }
                if (scope.scrollEvent) {
                    buttonOffset = scope.scrollEvent;
                    $window.scrollTo(0, parseInt(buttonOffset.top) - 60);

                }
                if (scope.limitMovies >= scope.accordions[acIndex].movies.length) {
                    scope.less = true;

                }
                $log.debug('button offset', buttonOffset);
                scope.scrollButton = false;
                scope.scrollEvent = false;
            }
        }


        scope.moreMovies = moreMovies;
        scope.lessMovies = lessMovies;
        scope.openTab = openTab;


        function openTab($event, index) {
            acIndex = index;
            scope.scrollEvent = $($event.currentTarget).offset();
            if (scope.scrollEvent && allImagesLoaded && scope.accordions[index].expand) {
                var buttonOffset = scope.scrollEvent;
                $window.scrollTo(0, parseInt(buttonOffset.top) - 60);
                allImagesLoaded = false;
            }
            scope.scrollButton = false;
        }


        function moreMovies($event) {
            var button;
            if (abTest() === false || abTest() === 'Original') {
                if (scope.tabtype === "month") {
                    scope.limitMovies += 5;
                    button = $($event.currentTarget);
                    scope.scrollButton = button;
                    scope.scrollEvent = false;
                } else {
                    scope.limitMovies += 5;
                    button = $($event.currentTarget);
                    scope.scrollButton = button;
                    scope.scrollEvent = false;
                }
            } else if (abTest() === 'Variante 1') {
                $window.open(AppConfig.ffc + '/?premium=plusfolge', '_blank');
            }
            NowGoogleAnalytics.trackEvent('formatseite', 'mehr_episoden');
        }

        function lessMovies(id) {
            scope.limitMovies = 5;
            scope.less = false;
            $anchorScroll(id);
            $window.scrollBy(0, -60);
            imageCount = 5;
            allImagesLoaded = true;
            NowGoogleAnalytics.trackEvent('formatseite', 'weniger_episoden');
        }

        function abTest() {
            if (Optimizely.isActiveExperiment(testId)) {
                return Optimizely.getVariationNames();
            } else {
                return false;
            }
        }


        function loadSeasonContent() {
            var allPromises = [];

            angular.forEach(scope.seasontab.formatTabPages.items, function (tab) {
                if (tab.container && tab.container.id) {
                    allPromises.push(
                        $q(function (resolve) {
                            NowApi.getContainer().retrieveMoviesByContainerId({
                                id: tab.container.id,
                                fields: ['*',
                                    'format.*',
                                    'paymentPaytypes.*',
                                    'livestreamEvent.*',
                                    'pictures',
                                    'trailers',
                                    'packages',
                                    'annualNavigation'
                                ].join(','),
                                'maxPerPage': 100,
                                'page': 0,
                                'order': 'OrderWeight asc, BroadcastStartDate desc'
                            }).then(
                                function (movies) {
                                    if (movies && movies.items && movies.items.length > 0) {
                                        resolve(movies.items);

                                    }
                                }, function () {
                                    resolve();
                                }
                            );
                        })
                    );
                }
            });

            $q.all(allPromises).then(function (movies) {
                    var allMovies = [];
                    if (movies) {
                        angular.forEach(movies, function (movielist) {
                            if (movielist && movielist.length > 0) {
                                allMovies = allMovies.concat(movielist);
                            }
                        });
                        scope.loading = false;
                        maxImages += allMovies.length;
                        scope.accordions[0].movies = allMovies;
                        scope.accordions[0].expand = true;
                        scope.accordions[0].more = (scope.accordions[0].movies.length > 5) ? true : false;
                        scope.accordions[0].tabtype = scope.tabtype;

                        scope.$emit("accordion::loaded", allMovies);
                    }
                },
                function () {
                });
        }

        function loadMonthContent() {
            scope.init = true;
            var filter = '{"BroadcastStartDate":{"between":{"start":"' + scope.year + '-' + scope.month + '-01 00:00:00","end": "' + scope.year + '-' + scope.month + '-31 23:59:59"}},"FormatId" : ' + scope.format.id + '}';

            NowApi
                .getMovie()
                .retrieve({
                    'fields': '*,format,paymentPaytypes,pictures,trailers,packages',
                    'filter': filter,
                    'order': 'BroadcastStartDate desc',
                    'maxPerPage': 35
                })
                .then(function (data) {
                        scope.loading = false;
                        scope.movies = data.items;
                        scope.accordions[0].movies = data.items;
                        maxImages = data.items.length;
                        var archiv = {
                                title: scope.title,
                                movies: data.items,
                                expand: true,
                                more: true,
                                month: scope.month
                            },
                            pretv = {
                                title: "Aktuelle Preview",
                                movies: [],
                                expand: false,
                                more: false,
                                month: 'pretv'
                            },
                            catchup = {
                                title: "Aktuell",
                                movies: [],
                                expand: true,
                                more: false,
                                month: 'catchup'
                            };


                        scope.accordions = [];
                        if (scope.tabindex === 0) {
                            if (scope.currentmonth === now.format('M') && scope.year === now.format('YYYY')) {
                                while (archiv.movies.length > 0 && moment(archiv.movies[0].broadcastStartDate, 'YYYY-MM-DD HH:mm:ss') > now) {
                                    pretv.movies.push(archiv.movies.shift());
                                }

                                if (pretv.movies.length > 0) {
                                    scope.accordions.push(pretv);
                                }

                                var i = 0;
                                while (i < 5) {
                                    if (archiv.movies.length > 0) {
                                        if (archiv.movies[0].free === true) {
                                            catchup.movies.push(archiv.movies.shift());
                                        }
                                    }
                                    i++;
                                }


                                if (catchup.movies.length > 0) {
                                    scope.accordions.push(catchup);
                                    archiv.expand = false;
                                }
                            }
                        }


                        if (archiv.movies.length > 0) {
                            archiv.more = (archiv.movies.length > 5) ? true : false;
                            scope.accordions.push(archiv);

                        }
                        if (catchup.movies.length > 0) {
                            scope.$emit("accordion::loaded", catchup.movies);
                        } else {
                            scope.$emit("accordion::loaded", data.items);
                        }
                    },
                    function () {
                        scope.error = "Leider gibt es keine Folgen";
                        scope.loading = false;
                    });
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .directive('nowMovielistAccordionHeader', nowMovielistAccordionHeader);

nowMovielistAccordionHeader.$inject = ['AppConfig'];

function nowMovielistAccordionHeader(AppConfig) {

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/movielist_accordion_header.html',
        scope: {
            movie: '='
        },
        link: link
    };

    function link(scope) {
        scope.ffc = AppConfig.ffc + '/?premium=';
    }
}

})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .directive('nowMovielistAccordionMovie', nowMovielistAccordionMovie);

nowMovielistAccordionMovie.$inject = ['$location', 'AppConfig', '$window'];

function nowMovielistAccordionMovie($location, AppConfig, $window) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/movielist_accordion_movie.html',
        scope: {
            movie: '='
        },
        link: link
    };

    function link(scope) {
        scope.goToMovie = function (movieUrl) {
            //debugger;
            if (scope.movie.free === true) {
                $location.path(movieUrl.split('?')[0]);
            } else {
                $window.open(AppConfig.ffc + '/?premium=plusfolge', '_blank');
            }
        };

        scope.seasonInfo = function seasonInfo() {
            if (scope.movie.season === 0 || scope.movie.episode === 0 || scope.movie.season === null || scope.movie.episode === null) {
                return false;
            } else {
                return true;
            }
        };


    }


}

})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .directive('movielistrow', NowNovielistrow);

NowNovielistrow.$inject = ['$location', 'Moviehelper', '$filter', '$log', 'Metadata'];

function NowNovielistrow($location, Moviehelper, $filter, $log, Metadata) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/movielist_row.html',
        link: link
    };

    function link(scope, element) {
        scope.trackEvent = trackEvent;
        scope.trackMoviePlay = trackMoviePlay;
        scope.isTablet = (bowser.tablet && !bowser.msie) ? true : false;
        Metadata.setMobileAltEnable(true);
        $(element).find('.imagehover').on('click', onClick);

        function trackEvent(action, value) {
            scope.$parent.trackEvent(action, value);
        }

        function onClick() {
            if ((!scope.movie.free && !scope.movie.packages) || scope.movie.blockadeText !== '0' || scope.movie.geoblocked) {
                return false;
            }

            if (!scope.movie.free && !scope.movie.payed) {
                if (bowser.tablet === true) {
                    $location.search('premium', 'plusfolge');

                } else {
                    $location.search('premium');
                }

                scope.$apply();
                scope.trackEvent('premium_overlay');
            } else {
                $location.search(Moviehelper.getMoviePlayerSearch(scope.movie)).path(Moviehelper.getMoviePlayerPath(scope.movie));
                scope.$apply();
                scope.trackEvent('play');
            }
        }

        function trackMoviePlay(movie) {
            $log.debug('scope.trackMoviePlay is called', movie);
            if ($filter('geturl')(movie, 'appendpayment').match(/payment=/)) {
                scope.trackEvent('premium_overlay');
            } else {
                scope.trackEvent('play');
            }
        }
    }
}

})();

(function() {

'use strict';

angular.module('NowMovielist').directive('movietabs', NowMovieTabs);

NowMovieTabs.$inject = ['$rootScope', '$route', 'Accounting', '$timeout', '$window', '$log','moment'];

function NowMovieTabs($rootScope, $route, Accounting, $timeout, $window, $log,moment) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: function (elem, attr) {
            if (attr.seasontab === 'season') {
                return 'templates/movielist_seasontabs.html';
            } else {
                return 'templates/movielist_yeartabs.html';
            }
        },
        link: link
    };

    function link(scope) {
        scope.hideFree = Accounting.isPremiumUser();
        var mlscope = scope.$parent,
            fixed = false,
            routemonth = (angular.isUndefined($route.current.params.monat)) ? false : parseInt($route.current.params.monat),
            routeyear = (angular.isUndefined($route.current.params.jahr)) ? false : parseInt($route.current.params.jahr),
            firstMonthInActiveYear,
            navOffset = 500,
            now = moment(),
            yearOptions = [];


        mlscope.refreshScrollbar = refreshScrollbar;


        function refreshScrollbar() {
            //console.log('refreshScrollbar');
            $rootScope.$broadcast('refreshScrollbar');
        }

        if (!mlscope.format) {
            $log.error('movie.formats undefined in movielist');
            return;
        }

        mlscope.loadYear = loadYear;
        mlscope.loadMonthTab = loadMonthTab;
        mlscope.definedYears = {};

        //$log.debug('mlscope.format',mlscope.format);
        if (mlscope.format.tabVariant === 'seasonTabs') {
            $timeout(function () {
                slickTabs();
            }, 1000);
        } else {
            //$log.debug('LINK: NowYearTabs', scope, mlscope.format.tabVariant);

            //mlscope.$watch('format', function () {
            var startDate = moment(mlscope.format.tabSeasonStartDate).year(),
                endDate = mlscope.format.tabSeasonEndDate ? moment(mlscope.format.tabSeasonEndDate).year() : now.year();

            setupYears(mlscope.format.annualNavigation.items);
            setupMonths((routeyear) ? routeyear : false);
            //});
        }

        initWatchers();

        function loadYear(selected) {
            redoMonths(selected.value);
            showhideMonthTabs(selected.value);
            mlscope.$broadcast('monthtab::click', mlscope.months[12 - firstMonthInActiveYear]);
            mlscope.$broadcast('monthtab::select', 12 - firstMonthInActiveYear);
            slickTabs();
        }

        function loadMonthTab(tab, clickedTabIndex) {
            mlscope.$broadcast('monthtab::click', tab, clickedTabIndex);
        }

        function setupYears(years) {
            for (var key in years) {
                if (years.hasOwnProperty(key)) {
                    var months = [];
                    for (var key2 in years[key].months) {
                        if (years[key].months.hasOwnProperty(key2)) {
                            months.push(parseInt(key2));
                        }
                    }
                    mlscope.definedYears[years[key].year] = months;
                }
            }

            if (routeyear && !mlscope.yearSelected) {
                //wenn in der route ein jahr steht, wird das zum ausgewählten eintrag
                mlscope.yearSelected = {
                    'text': routeyear, 'label': routeyear, 'value': routeyear
                };
            }

            /*var duration = moment.duration(now.diff(startDate));
             var years = Math.ceil(duration.asYears());*/

            for (var i = endDate; i >= startDate; i--) {
                if (!mlscope.definedYears[i]) {
                    continue;
                }

                if (!mlscope.yearSelected) {
                    //wenn noch kein jahr ausgewählt, dann nimm das erste jahr
                    mlscope.yearSelected = {
                        'text': i, 'label': i, 'value': i
                    };
                }

                yearOptions.push({
                    'text': i, 'label': i, 'value': i
                });
            }

            mlscope.yearOptions = yearOptions;

            if (!mlscope.yearSelected) {
                //wenn noch kein jahr ausgewählt, nimm halt dieses jahr her
                i = moment().year();
                mlscope.yearSelected = {
                    'text': i, 'label': i, 'value': i
                };
            }
            $rootScope.$broadcast('refreshScrollbar');
        }

        function showhideMonthTabs(year) {
            var m,
                selectedYear = (year) ? year : mlscope.yearSelected.value;

            $('.month_tab').removeClass('button-show');
            $('.month_tab .tv').hide();

            for (var i = 12; i > 0; i--) {
                //$log.debug('showhideMonthTabs mlscope.definedYears[selectedYear],mlscope.definedYears[selectedYear].indexOf(i)',mlscope.definedYears[selectedYear],mlscope.definedYears[selectedYear].indexOf(i));
                if (mlscope.definedYears[selectedYear].indexOf(i) !== -1) {
                    m = (i < 10) ? '0' + i : i;

                    if (!firstMonthInActiveYear) {
                        firstMonthInActiveYear = i;
                    }

                    $('.tab_' + m).addClass('button-show');

                    if (mlscope.months[12 - i].currentMonth) {
                        $('.tab_' + m + ' .tv').show();
                    }
                }
            }
        }

        function setupMonths(year) {
            mlscope.months = [];
            var selectedYear = (year) ? year : mlscope.yearSelected.value,
                months = [];

            //$log.debug('setupMonths mit selectedYear '+selectedYear)
            for (var i = 12; i > 0; i--) {
                var m = (i < 10) ? '0' + i : i,
                    date = moment(selectedYear + '-' + m + '-01'),
                    today = moment();

                months.push({
                        currentMonth: (selectedYear === today.year() && date.month() === today.month()),
                        year: selectedYear,
                        name: date.format('MMMM'),
                        monthIndex: date.month(),
                        nameshort: date.format('MMM').substring(0, 3),
                        month: date.format('MM'),
                        from: date.format('MM-DD') + ' 00:00:00',
                        till: date.endOf('month').format('MM-DD') + ' 23:59:59'
                    }
                );
            }
            mlscope.months = months;

            $timeout(function () {
                showhideMonthTabs(year);
                slickTabs();
                if (mlscope.startWithSpecialTab) {
                    return;
                }
                if (routemonth) {
                    mlscope.$broadcast('monthtab::click', mlscope.months[12 - routemonth]);
                    mlscope.$broadcast('monthtab::select', 12 - routemonth);
                    routemonth = false;
                } else {
                    mlscope.$broadcast('monthtab::click', mlscope.months[12 - firstMonthInActiveYear]);
                    mlscope.$broadcast('monthtab::select', 12 - firstMonthInActiveYear);
                }
            }, 1000);
        }

        function redoMonths(year) {
            if ($('.now-toolbar .slick-active').length) {
                $('.now-toolbar .background .slick-slider').slick('slickGoTo', 0, false);
            }
            firstMonthInActiveYear = 0;
            var today = moment();
            for (var i = 0; i < mlscope.months.length; i++) {
                mlscope.months[i].year = year;
                mlscope.months[i].currentMonth = (year === today.year() && mlscope.months[i].monthIndex === today.month());
            }
        }

        function slickInactivateArrows(slidesToShow, slick, nextSlide) {
            //$log.debug('slickInactiveArrows',slidesToShow,slick,nextSlide);
            $('.now-toolbar .background .arrow span').removeClass('inactive');

            var realslicklength =
                ($('.now-toolbar .now-yeardropdown').length || !slick || !slick.$slides) ?
                    //slick for months; may have different length. slick && slick.slides necessary because at one point slick is not provided
                    $('.now-toolbar .buttons .slick-slide:visible').length :
                    slick.$slides.length;

            //console.log(slick,nextSlide,'slicklength',realslicklength);
            if (nextSlide === 0) {
                $('.now-toolbar .icon-nowarrow_left').addClass('inactive');
            } else if (nextSlide >= realslicklength - slidesToShow) {
                $('.now-toolbar .icon-nowarrow_right').addClass('inactive');
            }
        }

        function slickTabs() {
            //$log.debug('slickTabs');
            var slidesToShow = ($window.innerWidth >= 1560) ? 6 : (($window.innerWidth >= 1260) ? 5 : 4),
                buttons = $('.now-toolbar .background .slickbuttons .button-show'),
                toolbar = $('.now-toolbar');

            if (angular.isDefined(mlscope.definedYears) && Object.keys(mlscope.definedYears).length <= 1) {
                toolbar.addClass('no-yearbutton');
            }

            if (buttons.length <= slidesToShow) {
                $('.now-toolbar .background .arrow').hide();
                toolbar.addClass('no-arrows');
            } else if ($('.now-toolbar .slick-active').length) {
                //slick is initialized. re-init.
                $log.debug('slickTabs: slick re-inizializing', slidesToShow);
                $('.now-toolbar .background .arrow').show();
                toolbar.removeClass('no-arrows');
                $('.now-toolbar .background .slick-slider')
                    .off('beforeChange')
                    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        slickInactivateArrows(slidesToShow, slick, nextSlide);
                    })
                    .slick('slickSetOption', 'slidesToShow', slidesToShow, false)
                    .slick('slickSetOption', 'slide', '.button.button-show', true);
            } else {
                //$log.debug('slickTabs: slick inizializing');
                $('.now-toolbar .background .arrow').show();
                toolbar.removeClass('no-arrows');

                $('.now-toolbar .background .slickbuttons').on('init', function (event, slick) {
                    var buttonFirstChild = $('.now-toolbar .slick-active:first');
                    //var nextSlide = ( === 0) ? 0 : 1;
                    slickInactivateArrows(slidesToShow, slick, buttonFirstChild.data('slickIndex'));
                }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    slickInactivateArrows(slidesToShow, slick, nextSlide);
                }).slick({
                    touchMovie: false,
                    slidesToShow: slidesToShow,
                    slidesToScroll: 1,
                    initialSlide: (parseInt(mlscope.selected) > 3) ? parseInt(mlscope.selected) - 2 : 0,
                    //slide not working here. dunno why
                    infinite: false,
                    nextArrow: $('.now-toolbar .icon_arrow_right').parent(),
                    prevArrow: $('.now-toolbar .icon_arrow_left').parent(),
                    variableWidth: true
                }).slick('slickSetOption', 'slide', '.button.button-show', true);
            }

            $timeout(function () {
                //initialize slick arrows
                slickInactivateArrows(slidesToShow, null, 0);
            }, 1000);
        }

        function scroll() {
            var scrollPos = $(window).scrollTop();
            if (!fixed) {
                var adHeight = $('#wallpaper').height() + $('.billboard-wrapper').height(),
                    nowcontentdiv = $('.now-content'),
                    contentmargin = nowcontentdiv.outerHeight(true) - nowcontentdiv.innerHeight();

                if (adHeight > 0 || contentmargin > 40) {
                    navOffset = $('.now-toolbar-movielist').offset().top - adHeight - contentmargin;
                } else {
                    navOffset = $('.now-toolbar-movielist').offset().top + contentmargin + adHeight - 160;
                }
                if (navOffset < 0) navOffset = 0;
                //console.log(scrollPos, navOffset, $('.now-toolbar-movielist').offset().top, adHeight, contentmargin);
            }
            if (scrollPos > navOffset && !fixed) {
                //console.log('FIXED');
                $('.now-toolbar-movielist').addClass('now-toolbar-epg-fixed');
                $('.now-teaserset-topheadline').css({
                    'marginBottom': 60
                });
                fixed = true;
            } else if (scrollPos < navOffset && fixed) {
                removeFix()
            }
        }

        function removeFix() {
            $log.log("REMOVEFIXED");
            $('.now-toolbar-movielist').removeClass('now-toolbar-epg-fixed');
            $('.now-teaserset-topheadline').css({
                "marginBottom": ""
            });
            fixed = false;
        }

        function initWatchers() {
            scope.$on('movielist::rearrow', function () {
                //$log.debug('on moviellist::rearrow');
                slickTabs();
            });

            scope.$on('resize::jump', function () {
                //$log.debug('catching jump and issueing the slickTabs');
                slickTabs();
            });

            var loadWatcher = $rootScope.$on('movielist::loaded', function () {
                $window.scrollTo(0, 0);
                navOffset = 500;
                removeFix();
            })

            mlscope.$on('$destroy', function () {
                //console.log('destroy scrollwatch');
                loadWatcher();
                angular.element($window).off('scroll', scroll);
            });

            angular.element($window).on('scroll', scroll);
        }
    }
}



})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .service('MovielistService', MovielistService);

MovielistService.$inject = [
    'NowApi',
    '$q',
    '$log',
    'StationMonitor',
    '$route',
    'Metadata',
    '$location',
    'AppConfig',
    '$window'
];

/**
 *@constructor
 */
function MovielistService(NowApi, $q, $log, StationMonitor, $route, Metadata, $location, AppConfig, $window) {
    var self = this;

    self.seoRouteLookup = seoRouteLookup;
    self.retrieveFormat = retrieveFormat;
    self.switchToMonth = switchToMonth;

    return self;

    function seoRouteLookup(getpageFunction) {
        //redirect only for users from :station/:format to :station/:format/{jahr|list}/:staffel[/:monat]
        return $q(function (resolve) {
            $log.debug('movielist_Service',resolve);
            return NowApi.getFormat().retrieveFormatBySeoLink(
                {
                    'name': $route.current.params.format + '.php',
                    'station': StationMonitor.getStation(),
                    'fields': '*,.*,formatTabs.*,formatTabs.formatTabPages.*,annualNavigation.*'
                }
            ).then(
                function (format) {
                    if (format.annualNavigation && format.annualNavigation.items.length > 0 && !format.tabSeason) {
                        //jahresnavigation
                        var nav = format.annualNavigation.items[format.annualNavigation.items.length - 1];
                        var year = nav.year;
                        var month = 1;
                        for (month in nav.months) {
                        }


                        switchToMonth(format, year, month, true);
                    } else if (format.formatTabs && format.formatTabs.items) {
                        //staffelnavigation
                        var seolink = format.formatTabs.items[0].seoheadline;
                        var path = '/' + StationMonitor.getStation(true) + '/' + format.seoUrl + '/list/' + seolink;
                        $log.debug('service_movielist seoRouteLookup() switch to list ', path);
                        //$rootScope.trackingIgnoreNextRoutechangeEvent = true;
                        $location.path(path);
                        $location.replace();
                    } else {
                        //format deaktiviert, aber page aktiviert?
                        getpageFunction($route, NowApi, StationMonitor).then(function () {
                            //show page, because it seems to have content
                            $log.debug('service_movielist seoRouteLookup() okayish: format.annualNavigation + format.formatTabs not present, page found!');
                        }, function () {
                            $log.debug('service_movielist seoRouteLookup() failed: format.annualNavigation + format.formatTabs not present, no page found!');
                            Metadata.tryGlobalRedirect($location.path()).then(function () {
                                return true;
                            }, function(){
                                Metadata.setSeoStatuscode(404);
                                $location.path(AppConfig.notFoundPage);
                            });
                        });
                    }
                }, function () {
                    Metadata.tryGlobalRedirect($location.path()).then(function () {
                        return true;
                    }, function(){
                        Metadata.setSeoStatuscode(404);
                        $location.path(AppConfig.notFoundPage);
                    });
                }
            )
        });
    }

    function retrieveFormat() {
        $log.debug('service_movielist retrieveFormat()');
        return NowApi.getFormat().retrieveFormatBySeoLink({
            'name': $route.current.params.format + '.php',
            'station': StationMonitor.getStation(),
            'fields': '*,.*,formatTabs.*,formatTabs.formatTabPages.*,formatTabs.formatTabPages.container.*,annualNavigation.*'
        }).then(
            function (foundFormat) {
                if (foundFormat.station && StationMonitor.getAlias(foundFormat.station) !== StationMonitor.getStation(true)) {
                    //format mit falscher station aufgerufen
                    Metadata.tryGlobalRedirect($location.path()).then(function () {
                        return true;
                    }, function(){
                        Metadata.setSeoStatuscode(404);
                        $location.path(AppConfig.notFoundPage);
                    });
                } else {
                    $log.debug('service_movielist retrieveFormat()', foundFormat);
                    Metadata.setOgFormat(foundFormat);
                    foundFormat.latestMovie = false;
                    return NowApi.getMovie().retrieve({
                        'fields': 'broadcastStartDate',
                        'filter': '{"FormatId":' + foundFormat.id + '}',
                        'order': 'BroadcastStartDate desc',
                        'page': 1,
                        'maxPerPage': 1
                    }).then(
                        function (movie) {
                            if (movie.items.length > 0) {
                                foundFormat.latestMovie = movie.items[0];
                            }
                            return foundFormat;
                        }, function () {
                            return foundFormat;
                        }
                    );
                }
            }, function () {
                Metadata.tryGlobalRedirect($location.path()).then(function () {
                    return true;
                }, function(){
                    Metadata.setSeoStatuscode(404);
                    $location.path(AppConfig.notFoundPage);
                });
            }
        );
    }

    function switchToMonth(format, year, month, overwriteHistoryPushstate) {
        var path = '/' + StationMonitor.getStation(true) + '/' + format.seoUrl + '/jahr/' + year + '/' + month;
        $log.debug('service_movielist switchToMonth()', {year: year, month: month, path: path, format: format , historyPushstate:overwriteHistoryPushstate});
        //$rootScope.trackingIgnoreNextRoutechangeEvent = true
        $window.location.href = path;
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .controller('NowMovielistController', NowMovielistController);

NowMovielistController.$inject = ['$rootScope', '$scope', '$location', '$route', 'StationMonitor', 'format', 'NowApi', 'MovielistService', '$filter', 'BreadcrumbHelper', 'Metadata', '$log', 'page', 'RecommendationService', 'NowGoogleAnalytics', '$q', 'Optimizely', 'moment', 'PageHistory', 'Accounting', 'AppConfig', 'NowTeaser', '$window', 'NowTagCommander'];

function NowMovielistController($rootScope, $scope, $location, $route, StationMonitor, format, NowApi, MovielistService, $filter, BreadcrumbHelper, Metadata, $log, page, RecommendationService, NowGoogleAnalytics, $q, Optimizely, moment, PageHistory, Accounting, AppConfig, NowTeaser, $window, NowTagCommander) {
    if (!format) {
        return false;
    }

    format.tabVariant = (format.tabSeason) ? 'seasonTabs' : 'yearMonthTabs';

    var vm = $scope,
        presetCurrentTab,
        trackingInitialIgnoreStatusFree = true,
        trackingInitialIgnoreStatusListchange = true,
        maxItemsPerPage = 30,
        redirectUri = '/' + StationMonitor.getRouteStation(format.station) + '/' + format.seoUrl,
        formatPath = '/' + StationMonitor.getStation(true) + '/' + format.seoUrl,
        firstYearToDisplay,
        firstMonthInFirstYear,
        watchers = [],
        firstCall = true;

    vm.isFreeFilter = isFreeFilter;
    vm.loadSeasonContent = loadSeasonContent;
    vm.orderChanged = orderChanged;
    vm.select = selectTab;
    vm.trackEvent = trackEvent;
    vm.paginatetab = paginatetab;


    vm.loadingMovieList = false;

    vm.tabloading = true;
    vm.isFree = false;
    vm.filterActive = false;
    vm.orderActive = false;
    vm.selected = 0;
    vm.selectedPage = 1;
    vm.currentYear = moment().year();
    vm.format = format;
    vm.paginationMovies = [];
    vm.newpage = page === false;
    vm.params = $route.current.params;
    vm.page = (page === false) ? {} : page;
    vm.teasersets = (page.teaserSets && page.teaserSets.items.length > 0) ? page.teaserSets.items : [];
    vm.hasRecommendation = RecommendationService.isReceivingEnabled();
    vm.onlyShowTeasersForFirstSeason = false;
    vm.teaserset = {
        headline: 'Empfehlungen',
        layout: 6,
        row: 1,
        automaticType: 'recommendation-series',
        movies: {
            items: []
        },
        formats: {
            items: []
        },
        teaserSetInformations: {
            items: []

        }
    };
    vm.ffc = AppConfig.ffc + '/?premium=extscreen';
    NowTeaser.setCurrentTeasersets(vm.teasersets);
    $log.debug('current Format',vm.format);
    NowTagCommander.addToDatalayer("content_format",vm.format.title,true);
    NowTagCommander.addToDatalayer("env_template", 'format');


    vm.goBack = goBack;

    setOrderOptions();
    resetOrder();
    initWatchers();
    init();

    Optimizely.trackEvent('pageview_format');

    function setOrderOptions(withEpisodes) {
        var orderOptions = [
            {
                text: 'Standardsortierung',
                label: 'Sortierung',
                value: false
            }
        ];
        if (withEpisodes) {
            orderOptions.push({
                    text: 'Folgennummer: Aufsteigend',
                    label: 'Sortierung',
                    value: 'episode'
                },
                {
                    text: 'Folgennummer: Absteigend',
                    label: 'Sortierung',
                    value: '-episode'
                });
        }

        orderOptions.push(
            {
                text: 'Ausstrahlung: Aufsteigend',
                label: 'Sortierung',
                value: 'broadcastStartDate'
            },
            {
                text: 'Ausstrahlung: Absteigend',
                label: 'Sortierung',
                value: '-broadcastStartDate'
            });

        vm.orderOptions = orderOptions;
    }

    function init() {
        RecommendationService.fireEventViewFormat(format.id);

        /*if (format && format.metaTitle && format.metaTitle.length > 0) {
         Metadata.setTitle(format.metaTitle);
         }*/

        BreadcrumbHelper.setItems({
            'title': format.title,
            'url': format.seoUrl
        });

        /*
         $log.debug('movielist/controller init()', {
         format: format,
         'format.tabSeason': format.tabSeason,
         'format.formatTabs.items[0].id': format.formatTabs.items[0].id,
         '$route.current.params.staffelname': $route.current.params.staffelname
         });
         */

        if (format.tabVariant === 'seasonTabs') {
            //staffelnavigation!

            if (!format.formatTabs || !format.formatTabs.items) {
                //tabVariant === seasonTabs, aber keine tabs vorhanden -> redirect.
                $location.path('/' + StationMonitor.getStation(true));
            } else if ($location.path().indexOf('/list/') > -1) {
                //zeige entsprechende liste, wenn vorhanden
                presetCurrentTab = checkSeasonExists(format, redirectUri);
                vm.currentTab = presetCurrentTab.seasonid;
                vm.currentTabSeoheadline = presetCurrentTab.seoheadline;
                $log.debug('movielist/controller init() called with a specific page', {presetCurrentTab: presetCurrentTab});
                selectTab(presetCurrentTab.tabid);

                //overwrite title and Description
                var metaTitleName = format.title + ', ' + format.formatTabs.items[presetCurrentTab.tabid].headline;
                Metadata.setOgFormatTitleAndDescription(
                    metaTitleName + ' online schauen als Stream bei TV NOW',
                    metaTitleName + ' im Stream auf TV NOW schauen. Keine Sendung von ' + metaTitleName + ' mehr verpassen!'
                );
            } else {
                //wir sind auf der ersten liste und zeigen die auch - zum beispiel für crawler!
                $log.debug('movielist/controller init() this is the first page');
                vm.currentTab = format.formatTabs.items[0].id;
                vm.currentTabSeoheadline = format.formatTabs.items[0].seoheadline;
                vm.onlyShowTeasersForFirstSeason = true;
            }

            $log.debug('movielist/controller init() getting current Tab', vm.currentTab);
            if (vm.currentTab > 0) {
                loadSeasonContent(vm.currentTab, false, vm.currentTabSeoheadline, (!presetCurrentTab || presetCurrentTab.seasonid !== format.formatTabs.items[0].id) || 0);
            }
        } else {
            //$log.debug('!!! NOT format.tabSeason', format.tabSeason);
            if ($location.path().indexOf('/list/') > -1) {
                //ein jahresnavigations-format mit einer sonderstaffel
                vm.startWithSpecialTab = true;
                presetCurrentTab = checkSeasonExists(format, redirectUri, true);
                vm.currentTab = presetCurrentTab.seasonid;
                vm.currentTabSeoheadline = presetCurrentTab.seoheadline;
                selectTab(presetCurrentTab.tabid);
                loadSeasonContent(vm.currentTab, true, vm.currentTabSeoheadline);

                Metadata.setOgFormatTitleAndDescription(
                    format.title + ', ' + vm.currentTabSeoheadline + ' online schauen als Stream bei TV NOW',
                    format.title + ', ' + vm.currentTabSeoheadline + ' im Stream auf TV NOW schauen. Keine Sendung von ' + format.title + ', ' + vm.currentTabSeoheadline + ' mehr verpassen!'
                );
            } else if ($location.path().indexOf('/jahr/') > -1) {
                //ein jahresnavigations-format mit einer jahres/monatsstaffel
                checkYearMonthExists(format, redirectUri);

                var momentDe = moment().locale('de'),
                    getMonthName = momentDe.localeData().months(moment([$route.current.params.jahr, $route.current.params.monat - 1]));
                    metaTitleName = (angular.isDefined($route.current.params.jahr) && angular.isDefined($route.current.params.monat)) ? ', ' + getMonthName + ' ' + $route.current.params.jahr : '';

                Metadata.setOgFormatTitleAndDescription(
                    format.title + metaTitleName + ' online schauen als Stream bei TV NOW',
                    format.title + metaTitleName + ' im Stream auf TV NOW schauen. Keine Sendung von ' + format.title + metaTitleName + ' mehr verpassen!'
                );

                vm.currentMonthTabs = getCurrentMonthTabs($route.current.params.jahr);
            }
        }
    }


    function getCurrentMonthTabs(year) {
        year = parseInt(year);
        var list = [];
        for (var key in format.annualNavigation.items) {
            var item = format.annualNavigation.items[key];
            if (item.year === year) {
                for (var month in item.months) {
                    if (item.months.hasOwnProperty(month)) {
                        list.push({
                            month: parseInt(month),
                            title: $filter('amDateFormat')($filter('amParse')(month, 'M'), 'MMMM') + " " + year,
                            count: parseInt(item.months[month])
                        });
                    }
                }
            }
        }
        return list;
    }

    function orderChanged(val, reload) {
        if (val.value === false && reload !== true) {
            resetOrder();
        } else {
            vm.orderActive = true;
            vm.orderby = val.text;
        }
    }

    function initWatchers() {
        watchers.push(vm.$watch('isFree', function (newValue) {
            vm.foobar = (newValue) ? 'free' : 'check';

            if (!trackingInitialIgnoreStatusFree) {
                trackEvent((newValue) ? 'haeckchen_an' : 'haekchen_aus', 'nur_free');
            }
            trackingInitialIgnoreStatusFree = false;
        }));

        watchers.push(vm.$on('monthtab::select', function (event, which) {
            vm.selected = which;
            $window.scrollTo(0, 0);
        }));

        watchers.push(vm.$on('monthtab::click', onMonthtabClick));

        watchers.push(vm.$on('accordion::loaded', function (event, movies) {
            if (!vm.accordionDetailMovie && movies.length > 0) {
                vm.accordionDetailMovie = movies[0];
            }
        }));

        watchers.push(vm.$on('ngRepeatFinished', function () {
            $rootScope.$broadcast('movielist::loaded');
        }));

        watchers.push($scope.$on('$destroy', function () {
            angular.forEach(watchers, function (event) {
                event();
            });
        }));

        function onMonthtabClick(event, tab) {
            vm.onlyShowTeasersForFirstSeason = (tab.year === firstYearToDisplay && tab.monthIndex === firstMonthInFirstYear - 1);
            $log.debug('movielist/controller onMonthtabClick() tab', {
                tab: tab,
                'vm.onlyShowTeasersForFirstSeason': vm.onlyShowTeasersForFirstSeason
            });

            if ($location.path() === formatPath && Metadata.isSearchEngine()) {
                //don't do a route update, when this is a search engine - search engines are supposed to crawl the root url
                /*} else if ($location.path() === formatPath || $location.path() === yearPath) {
                 switchToMonth($scope.yearSelected.value, tab.month);
                 } else if ($location.path() !== seoFullPath) {*/
                vm.onlyShowTeasersForFirstSeason = true;
            } else if ($location.path() === formatPath && !firstCall) {
                //do a location.replace to overwrite history pushState
                MovielistService.switchToMonth(format, $scope.yearSelected.value, tab.month, true);
            } else if (!firstCall) {
                MovielistService.switchToMonth(format, $scope.yearSelected.value, tab.month);
            } else if (firstCall) {
                firstCall = false;
            }

            loadMonthContent(tab);
        }
    }

    function selectTab(index) {
        vm.selected = index;
        $window.scrollTo(0, 0);
    }

    function isFreeFilter(movie) {
        if (Accounting.isPremiumUser()) {
            vm.filterActive = false;
            return true;
        } else {
            if (vm.isFree === true && movie.free === true) {
                vm.filterActive = true;
                return true;
            } else if (vm.isFree === true && movie.free === false) {
                vm.filterActive = true;
                return false;
            }
            vm.filterActive = false;
            return true;
        }
    }

    function loadMonthContent(tab) {
        vm.tabloading = true;
        vm.format.tabSeason = false;
        vm.specialTabsActive = false;
        $rootScope.currentTabYear = $scope.yearSelected.value;
        $rootScope.currentTabMonth = tab.month;

        NowApi
            .getMovie()
            .retrieve({
                'fields': '*,format,paymentPaytypes,pictures,trailers,packages',
                'filter': '{"BroadcastStartDate":{"between":{"start":"' + $scope.yearSelected.value + '-' + tab.from + '","end": "' + $scope.yearSelected.value + '-' + tab.till + '"}}, "FormatId" : ' + vm.format.id + '}',
                'order': 'BroadcastStartDate desc',
                'maxPerPage': 70
            })
            .then(function (data) {
                    //console.log(data);
                    vm.allmovies = data.items;
                    $log.debug('vm.tabloading = false in loadMonthContent NowApi.getMovie.retrieve.then');
                    vm.tabloading = false;
                    vm.tabmovies = [];
                    var now = moment();
                    var oldlist = angular.copy(data.items);
                    var list = [],
                        prelist = [];

                    if (oldlist.length > 0 && oldlist[0].episode > 0) {
                        setOrderOptions(true);
                    }

                    if (data.items.length > 0 && tab.currentMonth) {
                        while (oldlist.length > 0 && moment(oldlist[0].broadcastStartDate, 'YYYY-MM-DD HH:mm:ss') > now) {
                            prelist.push(oldlist.shift());
                        }
                        if (prelist.length > 0) {
                            list.push({
                                'title': 'Aktuelle Preview',
                                'items': prelist
                            });
                        }
                    }
                    if (oldlist.length > 0 && tab.currentMonth) {
                        list.push({
                            'title': 'Aktuelle Woche',
                            'items': oldlist.slice(0, 5)
                        });
                        if (oldlist.slice(5, 100).length > 0) {
                            list.push({
                                'title': 'Archiv ' + moment(data.items[0].BroadcastStartDate).format('MMMM YYYY'),
                                'items': oldlist.slice(5, 100)
                            });
                        }
                    } else if (oldlist.length > 0) {
                        list.push({
                            'title': 'Archiv ' + tab.name + ' ' + tab.year,
                            'items': oldlist
                        });
                    }
                    vm.tabmovies = list;
                    vm.error = false;
                },
                function (e) {
                    $log.debug('vm.tabloading = false in loadMonthContent NowApi.getMovie.retrieve.then error',e);
                    vm.tabloading = false;
                    vm.error = true;
                }
            ).catch(function (error) {
                $log.error('error movielist controller',error);
        });

        if (!trackingInitialIgnoreStatusListchange) {
            trackEvent('staffelwechsel');
        }
        trackingInitialIgnoreStatusListchange = false;
    }

    function loadSeasonContent(id, special, seolink, clickedTabIndex) {
        vm.curentTab = id;
        vm.tabloading = true;
        vm.isFree = false;
        vm.allmovies = [];
        vm.selectedPage = 1;
        vm.specialTabsActive = special;
        vm.format.tabSeason = true;
        var seoFullPath = '/' + StationMonitor.getStation(true) + '/' + format.seoUrl + '/list/' + seolink,
            allPromises = [],
            successfullContainerLoads;

        vm.onlyShowTeasersForFirstSeason = (clickedTabIndex === 0);
        $log.debug('movielist/controller loadSeasonContent() setting onlyShowTeasersForFirstSeason to', vm.onlyShowTeasersForFirstSeason);

        if (special !== true) {
            $rootScope.currentTabSeason = seolink;
        } else {
            $rootScope.currentTabSpecial = seolink;
        }
        //resetOrder();
        //$log.debug('loadContent seoFullPath', seoFullPath, 'with reload = false, and the url was previously',$location.path());
        if ($location.path() === formatPath && Metadata.isSearchEngine()) {
            vm.onlyShowTeasersForFirstSeason = true;
        } else if ($location.path() === formatPath) {
            $location.path(seoFullPath);
            $location.replace();
        } else if ($location.path() !== seoFullPath) {
            //don't set anew when initially loading page and the location is already properly set
            $location.path(seoFullPath);
        }

        NowApi.getFormatlists().retrieveFormatTabById({
            id: id,
            fields: ['*',
                'formatTabPages.*',
                'formatTabPages.container.*'
            ].join(','),
            'maxPerPage': 20,
            'page': vm.selectedPage
        }).then(function (tab) {
            $log.debug('movielist/controller loadSeasonContent(): got content', tab);

            vm.currentTabs = tab;
            vm.error = false;

            if (!vm.currentTabs.formatTabPages.items) {
                vm.error = true;
                return;
            }

            successfullContainerLoads = 0;
            angular.forEach(vm.currentTabs.formatTabPages.items, function (tab, key) {
                if (tab.container && tab.container.id) {
                    allPromises.push(getContainerPageMovies(tab.container.id, key, 1).then(function () {
                        // $log.debug('movielist/controller loadSeasonContent() vm.tabloading = false in loadSeasonContent NowApi.getFormatlists.retrieveFormatTabById.then');
                        successfullContainerLoads++;
                    }, function () {
                        // $log.debug('movielist/controller getContainerpages() returned error');
                    }).catch(function (error) {
                        $log.error('error',error);
                    }));
                }
            });

            // $log.debug('movielist/controller allPromises.length', allPromises.length);
            $q.all(allPromises).then(function () {
                vm.tabloading = false;
                if (!successfullContainerLoads) {
                    // vm.error = true;
                }
            }).catch(function (error) {
                $log.error('error::MOvielist',error);
            });

            //$scope.$broadcast('movielist::rearrow');
        }, function (err) {
            $log.debug('movielist/controller loadSeasonContent() err when loading NowApi.getFormatlists().retrieveFormatTabById with id ', id, err);
            vm.error = true;
        }).catch(function (error) {
            $log.error('error',error);
        });

        if (!trackingInitialIgnoreStatusListchange) {
            trackEvent('staffelwechsel');
        }
        trackingInitialIgnoreStatusListchange = false;
    }

    function getContainerPageMovies(containerId, arrayKey, page) {
        return $q(function (resolve, reject) {
            NowApi.getContainer().retrieveMoviesByContainerId({
                id: containerId,
                fields: [
                    '*',
                    'format.*',
                    'paymentPaytypes.*',
                    'livestreamEvent.*',
                    'pictures',
                    'trailers',
                    'packages',
                    'annualNavigation'
                ].join(','),
                'maxPerPage': maxItemsPerPage,
                'page': page,
                'order': 'OrderWeight asc, BroadcastStartDate desc'
            }).then(
                function (result) {
                    if (result && result.items && result.items.length > 0) {
                        if (result.items.length > 0 && result.items[0].episode > 0) {
                            setOrderOptions(true);
                        }
                        //movies = movies.concat(tab.container.movies.items);
                        vm.allmovies = vm.allmovies.concat(result.items);


                        if (page === 1) {
                            var pages = [],
                                pageCount = Math.ceil(result.total / maxItemsPerPage),
                                promises = [];

                            for (var i = 1; i <= pageCount; i++) {
                                pages.push(i);
                                //fill rest of allmovies
                                if (i > 1) {
                                    //promises[i] = getContainerPageMovies(containerId, arrayKey, i);
                                }
                            }

                            $q.all(promises).then(function () {
                                resolve();
                            }).catch(function (error) {
                                $log.error('error',error);
                            });

                            vm.currentTabs.formatTabPages.items[arrayKey].container.movies = result;
                            vm.currentTabs.formatTabPages.items[arrayKey].container.movies.pages = pages;
                            //vm.tabloading = false;
                        } else {
                            resolve();
                        }
                    }
                },
                function (err) {
                    $log.debug('vm.tabloading = false in getContainerPageMovies NowApi.getContainer().retrieveMoviesByContainerId.then error', err);
                    reject();
                }
            );
        });
    }

    function resetOrder() {
        vm.orderSelected = {
            text: 'Standardsortierung',
            label: 'Sortierung',
            value: 'orderWeight' //orderWeight / -broadcastStartDate
        };
        vm.orderActive = false;
    }

    /**
     *
     * @param id
     * @param page
     * @returns {*}
     */
    function getContainerContent(id, page) {
        return $q(function (resolve, reject) {
            NowApi.getContainer().retrieveMoviesByContainerId({
                id: id,
                fields: ['*',
                    'format.*',
                    'paymentPaytypes.*',
                    'livestreamEvent.*',
                    'pictures',
                    'trailers',
                    'packages',
                    'annualNavigation'
                ].join(','),
                'maxPerPage': maxItemsPerPage,
                'page': page,
                'order': 'OrderWeight asc, BroadcastStartDate desc'
            }).then(
                function (movies) {
                    if (movies && movies.items && movies.items.length > 0) {
                        vm.paginationMovies = [];
                        vm.paginationMovies[id] = movies.items;
                        vm.error = false;

                        resolve();
                    }
                }, function () {
                    vm.error = true;

                    reject();
                }
            );
        });
    }

    function paginatetab(containerId, page) {
        if (page !== vm.selectedPage) {
            $window.scrollTo(0, 0);
            vm.selectedPage = page;
            if (page > 1) {
                vm.tabloading = true;
                getContainerContent(containerId, page).then(function () {
                    vm.tabloading = false;
                }).catch(function (error) {
                    $log.error('error',error);
                });
            }
        }
    }

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('formatseite', action, label);
    }

    function checkSeasonExists(foundFormat, redirectUri) {
        var routestaffel = (angular.isUndefined($route.current.params.staffelname)) ? false : $route.current.params.staffelname,
            found = false,
            seasonid,
            seoheadline;

        if (!routestaffel) {
            $log.debug('cheackSeasonExists - !routestaffel, redirecting to', redirectUri);
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
            $location.path(redirectUri);
            return false;
        }

        for (var key in foundFormat.formatTabs.items) {
            if (foundFormat.formatTabs.items.hasOwnProperty(key)) {
                if (routestaffel === foundFormat.formatTabs.items[key].seoheadline) {
                    found = key;
                    seasonid = foundFormat.formatTabs.items[key].id;
                    seoheadline = foundFormat.formatTabs.items[key].seoheadline;
                }
            }
        }

        if (routestaffel === foundFormat.formatTabs.items[0].seoheadline) {
            $log.debug('checkSeasonExists', routestaffel + ' is first season; users may stay, redirecting crawlers to ' + redirectUri);
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
            seasonid = foundFormat.formatTabs.items[0].id;
            found = 0;
            vm.onlyShowTeasersForFirstSeason = true;
        }

        if (found === false) {
            $log.debug('checkSeasonExists ', routestaffel + ' not found, redirecting to ' + redirectUri);
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
            $location.path(redirectUri);
        }

        return {tabid: found, seasonid: seasonid, seoheadline: seoheadline};
    }

    function checkYearMonthExists(foundFormat, redirectUri) {
        var routeyear = (angular.isUndefined($route.current.params.jahr)) ? false : parseInt($route.current.params.jahr),
            thisyear = moment().year(),
            routemonth = (angular.isUndefined($route.current.params.monat)) ? false : parseInt($route.current.params.monat),
            routespecialid = (angular.isUndefined($route.current.params.specialid)) ? false : parseInt($route.current.params.specialid),
            found = false,
            firstYearToDisplayId,
            firstMonthInRouteYear,
            key;

        //jahr umdrehen, aus der api kommt die 'falsche' reihenfolge!
        firstYearToDisplayId = foundFormat.annualNavigation.items.length - 1;
        firstYearToDisplay = foundFormat.annualNavigation.items[firstYearToDisplayId].year;

        //determine first month in this very first year:
        firstMonthInFirstYear = getHighestMonthFromMonthlist(foundFormat.annualNavigation.items[firstYearToDisplayId].months);

        $log.debug('checkYearMonthExists(foundFormat,redirectUri)', {
            foundFormat: foundFormat,
            redirectUri: redirectUri,
            foundFormatAnnualNavigation: foundFormat.annualNavigation,
            routeyear: routeyear,
            routemonth: routemonth,
            routespecialid: routespecialid,
            vmYearOptions: vm.yearOptions,
            firstYearToDisplay: firstYearToDisplay,
            firstMonthInFirstYear: firstMonthInFirstYear
        });

        if (!routeyear || (routeyear < 1990 || routeyear > thisyear + 1)) {
            $log.debug('redirecte zu ' + redirectUri + ' wegen jahr falsch');
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
            $location.path(redirectUri);
            return false;
        }

        if (routespecialid && routespecialid < 1) {
            $log.debug('redirecte zu ' + redirectUri + '/jahr/' + routeyear + ' weil kein specialid');
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri + '/jahr/' + routeyear);
            $location.path(redirectUri + '/jahr/' + routeyear);
            return false;
        }

        for (key in foundFormat.annualNavigation.items) {
            if (foundFormat.annualNavigation.items.hasOwnProperty(key)) {
                if (routeyear === foundFormat.annualNavigation.items[key].year && (!routemonth || foundFormat.annualNavigation.items[key].months[routemonth] > 0)) {
                    found = true;
                    $.each(foundFormat.annualNavigation.items[key].months, function (key) {
                        firstMonthInRouteYear = key;
                    });
                }
            }
        }

        if (routeyear !== firstYearToDisplay && !routemonth) {
            $log.debug('redirecte zu ' + redirectUri + '/jahr/' + routeyear + '/' + firstMonthInRouteYear + ' weil !firstyear und !routemonth');
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri + '/jahr/' + routeyear + '/' + firstMonthInRouteYear);
            $location.path(redirectUri + '/jahr/' + routeyear + '/' + firstMonthInRouteYear);
            $location.replace();
            return false;
        }

        if (routeyear === firstYearToDisplay && routemonth === firstMonthInRouteYear) {
            $log.debug('seo-redirect auf FORMAT LANDING page zu ' + redirectUri + ' wegen routeyear===firstyear und monat===firstMonthInFirstYear; kein Redirect fuer User');
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
            found = true;
            vm.onlyShowTeasersForFirstSeason = true;
        }

        if (!found) {
            $log.debug('redirecte zu ' + redirectUri + ' wegen nicht gefunden (beinhaltet: keinen monat ans jahr angehaengt');
            Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
            $location.path(redirectUri);
            return false;
        }

        return true;
    }

    function getHighestMonthFromMonthlist(monthlist) {
        var returnMonth = false;

        $.each(monthlist, function (key) {
            //highest value is the last one
            returnMonth = key;
        });

        return returnMonth;
    }

    function goBack() {
        var page = PageHistory.getLastPage();
        if (page && page.page) {
            $location.path('/' + page.page.path);
        } else {
            $location.path('/' + format.station);
        }

    }
}



})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMovielist')
    .config(routing);

routing.$inject = ['$routeProvider', '$windowProvider', 'AppConfigProvider'];

function routing($routeProvider, $windowProvider, AppConfigProvider) {
    var movielistFormatRoute = {
        templateUrl: templateUrl,
        controller: 'NowMovielistController',
        reloadOnSearch: false,
        data: {
            pagetype: 'format'
        },
        resolve: {
            page: resolvePage,
            resolveSeoRoute: resolveSeoRoute
        }
    };

    var movielistroute = {
        templateUrl: templateUrl,
        controller: 'NowMovielistController',
        reloadOnSearch: false,
        data: {
            pagetype: 'format'
        },
        resolve: {
            page: resolvePage,
            format: resolveFormat
        }
    };

    $routeProvider.when('/:station/:format/jahr/:jahr/:monat', movielistroute);
    $routeProvider.when('/:station/:format/jahr/:jahr', movielistroute);
    $routeProvider.when('/:station/:format/list/:staffelname', movielistroute);
    //$routeProvider.when('/:station/:format/special/:staffelname', movielistroute);

    var $window = $windowProvider.$get();
    if ($window.nowSEDetected) {
        $routeProvider.when('/:station/:format', movielistroute);
    } else {
        $routeProvider.when('/:station/:format', movielistFormatRoute);
    }

    function templateUrl() {
        //$log.debug('movielist::route::templateUrl',params);
        var template = 'templates/movielist_view.html';

        if (AppConfigProvider.getConfig().mode === 'edit') {
            template = 'templates/movielist_view_edit.html';
        }

        return template;
    }

    resolvePage.$inject = ['$route', 'NowApi', 'StationMonitor'];
    function resolvePage($route, NowApi, StationMonitor) {
        return NowApi.getPage().retrievePagesByStationAndPath({
            station: StationMonitor.getStation(),
            pagepath: $route.current.params.format,
            fields: ['*',
                'teaserSets.*',
                'teaserSets.teaserSetInformations.*',
                'teaserSets.teaserSetInformations.custom.*',
                'teaserSets.teaserSetInformations.custom.page.*,',
                'teaserSets.teaserSetInformations.custom.format.*,',
                'teaserSets.teaserSetInformations.custom.movie.*,',
                'teaserSets.teaserSetInformations.movie.*',
                'teaserSets.teaserSetInformations.movie.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.format.*',
                'teaserSets.teaserSetInformations.format.*',
                'teaserSets.teaserSetInformations.format.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.pictures',
                'teaserSets.teaserSetInformations.movie.packages'
            ].join(',')
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }

    resolveFormat.$inject = ['MovielistService'];
    function resolveFormat(MovielistService) {
        return MovielistService.retrieveFormat();
    }

    resolveSeoRoute.$inject = ['MovielistService'];
    function resolveSeoRoute(MovielistService) {
        return MovielistService.seoRouteLookup(resolvePage);
    }

}

})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowMoviedetail', []);

})();

(function() {

'use strict';

angular
    .module('NowMoviedetail')
    .directive('nowdetailgallery', nowdetailgallery);

nowdetailgallery.$inject = ['$timeout'];

function nowdetailgallery($timeout) {
    return {
        restrict: 'E',
        link: link,
        replace: true,
        templateUrl: 'templates/moviedetail_gallery.html'
    };

    function link(scope) {
        $timeout(init, 1000);
        scope.isTablet = (bowser.tablet && !bowser.msie) ? true : false;

        function init() {
            $('.now-detail-gallery .largeSlide')
                .on('init', onInitLargeSlide)
                .on('beforeChange', beforeChange)
                .slick({
                    arrows: true,
                    touchMovie: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: $('.now-detail-gallery .icon_arrow_right'),
                    prevArrow: $('.now-detail-gallery .icon_arrow_left'),
                    asNavFor: '.now-detail-gallery .navSlides'
                });

            $('.now-detail-gallery .navSlides')
                .on('init', onInitSlides)
                .slick({
                    arrows: false,
                    touchMovie: false,
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    asNavFor: '.now-detail-gallery .largeSlide'
                });

            function onInitLargeSlide() {
                $('.now-detail-gallery .largeSlide').css('visibility', 'visible');
            }

            function onInitSlides() {
                $('.now-detail-gallery .navSlides').css('visibility', 'visible');
                $('.now-detail-gallery .navSlides .slick-active:first').addClass('slick-manual-active');
            }

            function beforeChange(event, slick, current, next) {
                $('.now-detail-gallery .navSlides .slick-slide').removeClass('slick-manual-active');
                if (slick.$slides.length <= 4) {
                    var slideIndex = next + 1;
                    $('.now-detail-gallery .navSlides .slick-slide:nth-child(' + slideIndex + ')').addClass('slick-manual-active');
                } else {
                    $timeout(function () {
                        $('.now-detail-gallery .navSlides .slick-active:first').addClass('slick-manual-active');
                    }, 100);
                }
            }
        }
    }
}





})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMoviedetail')
    .directive('nowdetailtexts', nowdetailtexts);

nowdetailtexts.$inject = ['$log'];

function nowdetailtexts($log) {
    return {
        restrict: 'E',
        link: link,
        replace: true,
        templateUrl: 'templates/moviedetail_texts.html'
    };

    function link(scope) {
        $log.debug('Moviedetail::detailtext',scope);
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMoviedetail')
    .controller('NowMoviedetailController', NowMoviedetailController);

NowMoviedetailController.$inject = ['$scope', '$filter', 'BreadcrumbHelper', 'movie', '$location', '$log', 'RecommendationService', 'Accounting', 'Optimizely','NowTagCommander'];

function NowMoviedetailController($scope, $filter, BreadcrumbHelper, movie, $location, $log, RecommendationService, Accounting, Optimizely,NowTagCommander) {
    if (!movie) {
        return false;
    }

    var vm = $scope;
    var filtered_pictures = [];

    vm.movie = movie;
    vm.loading = true;

    vm.showPayment = showPayment;
    vm.isPremiumUser = !!Accounting.isPremiumUser();

    $log.debug('current Movie detail',vm.movie);

    NowTagCommander.addToDatalayer("content_format", vm.movie.format.title);
    NowTagCommander.addToDatalayer("content_video_id", vm.movie.id, true);
    NowTagCommander.addToDatalayer("content_video_title", vm.movie.title, true);
    NowTagCommander.addToDatalayer("content_season", vm.movie.season, true);
    NowTagCommander.addToDatalayer("content_type", (vm.movie.free)? "free" : "plus",true);
    NowTagCommander.addToDatalayer("env_template", 'episode_detail');


    RecommendationService.fireEventViewMovie(movie.id);

    vm.loading = false;

    vm.url = $filter('geturl')(movie, 'appendpayment');

    if (vm.movie.pictures && vm.movie.pictures.default) {
        $.each(
            vm.movie.pictures.default, function (i, picture) {
                if (picture.width === 768) {
                    filtered_pictures.push({id: picture.id});
                }
            }
        );
    }
    $.extend(vm.movie.pictures, {filtered_pictures: filtered_pictures});
    $log.debug('new picturelist', vm.movie.pictures);

    /*
     wird das nicht schon ausreichend im Service von setOg gemacht? kann man sich wohl sparen.
     if (movie && movie.format && movie.format.metaTitle && movie.format.metaTitle.length > 0) {
     Metadata.setTitle(''' + movie.title + '' aus ' +movie.format.metaTitle);
     }*/

    BreadcrumbHelper.setItems([{
        'title': movie.format.title,
        'url': movie.format.seoUrl
    }, {
        'title': movie.title,
        'url': movie.seoUrl
    }]);

    Optimizely.trackEvent('pageview_detail');

    function showPayment() {
        //console.log(movie);
        $location.search('premium');
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMoviedetail')
    .config(routing);

routing.$inject = ['$routeProvider', 'AppConfigProvider'];

function routing($routeProvider, AppConfigProvider) {
    var moviedetailroute = {
            templateUrl: 'templates/moviedetail_view.html',
            controller: 'NowMoviedetailController',
            reloadOnSearch: false,
            data: {
                pagetype: 'detail'
            },
            resolve: {
                movie: resolveMovie
            }
        },
        movieRedirectSeoRoute = {
            template: '<div></div>',
            controller: redirectSeoController,
            reloadOnSearch: false
        };

    $routeProvider.when('/:station/:format/:episode', moviedetailroute);

    $routeProvider.when('/:station/:format/list/:staffelname/:episode', movieRedirectSeoRoute);
    $routeProvider.when('/:station/:format/jahr/:jahr/:monat/:episode', movieRedirectSeoRoute);
    //$routeProvider.when('/:station/:format/special/:staffelname/:episode', moviedetailroute);

    resolveMovie.$inject = ['$route', 'NowApi', '$location', 'StationMonitor', 'Metadata'];
    function resolveMovie($route, NowApi, $location, StationMonitor, Metadata) {
        return NowApi.getMovie().retrieveMovieBySeoLink(
            {
                formatSeoLink: $route.current.params.format,
                movieSeoLink: $route.current.params.episode,
                station: StationMonitor.getStation(),
                fields: '*,format,pictures,paymentPaytypes,trailers,packages'
            }
        ).then(
            function (movie) {
                if (movie.format.station && StationMonitor.getAlias(movie.format.station) !== StationMonitor.getStation(true)) {
                    Metadata.tryGlobalRedirect($location.path()).then(function () {
                        return true;
                    }, function(){
                        Metadata.setSeoStatuscode(404);
                        $location.path(AppConfigProvider.getConfig().notFoundPage);
                    });
                    return;
                }

                Metadata.setOgMovie(movie);
                return movie;
            }, function () {
                Metadata.tryGlobalRedirect($location.path()).then(function () {
                    return true;
                }, function(){
                    Metadata.setSeoRedirect('http://' + $location.host() + '/' + StationMonitor.getStation() + '/' + $route.current.params.format);
                    $location.path('/' + StationMonitor.getStation(true) + '/' + $route.current.params.format);
                });
            }
        );
    }

    redirectSeoController.$inject = ['$route', '$location', 'Metadata', 'StationMonitor'];
    function redirectSeoController($route, $location, Metadata, StationMonitor) {
        Metadata.setSeoRedirect('http://' + $location.host() + '/' + StationMonitor.getStation() + '/' + $route.current.params.format + '/' + $route.current.params.episode);
        $location.path('/' + StationMonitor.getStation(true) + '/' + $route.current.params.format + '/' + $route.current.params.episode);
        $location.replace();
    }
}

})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowGenre', []);

})();

(function() {

'use strict';

angular
    .module('NowGenre')
    .service('Genres', Genres);

Genres.$inject = [];

/**
 *@constructor
 */
function Genres() {
    this.getGenreList = getGenreList;
    return this;

    function getGenreList() {
        return [
            'Tägliche Serien',
            'Action',
            'Crime',
            'Ratgeber',
            'Comedy',
            'Show',
            'Docutainment',
            'Drama',
            'Tiere',
            'News',
            'Mags',
            'Romantik',
            'Horror',
            'Familie',
            'Kochen',
            'Auto',
            'Sport',
            'Reportage und Dokumentationen',
            'Sitcom',
            'Mystery',
            'Lifestyle',
            'Musik',
            'Spielfilm',
            'Anime'
        ];
    }
}


})();

(function() {



})();

(function() {

'use strict';

})();

(function() {



angular
    .module('NowGenre')
    .directive('nowGenreMenu', nowGenreMenu);

nowGenreMenu.$inject = [];

function nowGenreMenu() {
    return {
        restrict: 'E',
        replace: true,
        controller: 'NowGenreListController',
        templateUrl: 'templates/genre_menu.html'
    };
}

})();

(function() {

'use strict';

angular
    .module('NowGenre')
    .directive('nowgenretabs', nowgenretabs);

nowgenretabs.$inject = ['$timeout', '$window', '$log'];

function nowgenretabs($timeout, $window,$log) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/genre_tabs.html',
        link: link
    };

    function link(scope) {
        var fixed = false;
        var navOffset = 500;

        angular.element($window).on('scroll', scroll);
        $('.now-toolbar-genre').css('visibility', 'hidden');

        initWatchers();
        $timeout(init, 1000);

        function initWatchers() {
            scope.$on('$destroy', function () {
                //console.log('destroy scrollwatch');
                angular.element($window).off('scroll', scroll);
            });

            scope.$on('resize::jump', function (event, size, innerWidth, playersize) {
                $log.debug('resize::jump',event, playersize)
                $('.now-toolbar-genre .buttons').slick('slickSetOption', 'slidesToShow', getSlideCount(innerWidth), true)
            });
        }

        function init() {
            var currentSlide = 1,
                toolbarGenreButtons = $('.now-toolbar-genre .buttons');

            if (scope.currentGenre) {
                for (var i = 1; i < scope.genreList.length; i++) {
                    if (scope.currentGenre.toLowerCase() === scope.genreList[i].toLowerCase()) {
                        currentSlide = i;
                    }
                }
            }

            toolbarGenreButtons
                .on('init', function () {
                    $('.now-toolbar-genre').css('visibility', 'visible');
                })
                .slick({
                    touchMovie: false,
                    slidesToShow: 5,
                    centerMode: true,
                    focusOnSelect: true,
                    infinite: true,
                    initialSlide: currentSlide,
                    nextArrow: $('.now-toolbar-tabs .icon_arrow_right').parent(),
                    prevArrow: $('.now-toolbar-tabs .icon_arrow_left').parent()
                });
        }

        function getSlideCount(w) {
            if (w >= 1560) {
                return 7;
            } else if ((w < 1560 && w >= 1260)) {
                return 5;
            } else if (w < 1260) {
                return 5;
            }
        }

        function scroll() {
            var scrollPos = $(window).scrollTop();
            if (!fixed) {
                var adHeight = $('#wallpaper').height() + $('.billboard-wrapper').height(),
                    contentSelector = $('.now-content'),
                    contentmargin = contentSelector.outerHeight(true) - contentSelector.innerHeight();

                if (adHeight > 0 || contentmargin > 40) {
                    navOffset = $('.now-toolbar-genre').offset().top - adHeight - contentmargin;
                } else {
                    navOffset = $('.now-toolbar-genre').offset().top + contentmargin + adHeight - 100;

                }
                //console.log(scrollPos, navOffset, $('.now-toolbar-genre').offset().top, adHeight, contentmargin);
            }

            if (scrollPos > navOffset && !fixed) {
                //console.log('FIXED');
                $('.now-toolbar-genre').addClass('now-toolbar-genre-fixed');
                $('.now-teaserset-topheadline').css({
                    'marginBottom': 60
                });
                fixed = true;
            } else if (scrollPos < navOffset && fixed) {
                //console.log('REMOVEFIXED');
                $('.now-toolbar-genre').removeClass('now-toolbar-genre-fixed');
                $('.now-teaserset-topheadline').css({
                    'marginBottom': ''
                });
                fixed = false;
            }
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowGenre')
    .controller('NowGenreListController', NowGenreListController);

NowGenreListController.$inject = ['$scope', 'Genres'];

function NowGenreListController($scope, Genres) {
    var vm = $scope;

    vm.genres = Genres.getGenreList();
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowGenre')
    .filter('genretext', genretext);
function genretext() {
    return function (input) {
        var aliases = {
            'Reportage und Dokumentationen': 'Reportage & Doku',
            'reportage und dokumentationen': 'Reportage & Doku',
            'Reportage & Doku': 'Reportage und Dokumentationen'

        };

        if (aliases[input]) {
            return aliases[input]
        } else {
            return input;
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowGenre')
    .controller('NowGenreController', NowGenreController);

NowGenreController.$inject = ['$scope', '$location', '$routeParams', 'NowApi', 'Moviehelper', 'PlayerService', 'BreadcrumbHelper', '$filter', '$route', 'page', 'Metadata', '$log', 'NowTeaser', '$rootScope', '$timeout'];

function NowGenreController($scope, $location, $routeParams, NowApi, Moviehelper, PlayerService, BreadcrumbHelper, $filter, $route, page, Metadata, $log, NowTeaser, $rootScope, $timeout) {
    var routeData = $route.current.$$route.data;
    var vm = $scope;
    var total = 0;
    var itemcount = 0;

    vm.loading = true;
    vm.tabloading = true;
    vm.isFree = false;
    vm.filterActive = false;
    vm.orderActive = false;
    vm.selected = 0;
    vm.currentGenre = false;
    vm.genres = false;
    vm.movies = false;
    vm.movielist = [];
    vm.formatlist = [];
    vm.params = $routeParams;
    vm.endreadched = false;
    vm.pagecount = 1;
    vm.teaserset = {
        headline: '',
        layout: 1,
        row: 2,
        automaticType: 'none',
        movies: {
            items: []
        },
        formats: {
            items: []
        },
        teaserSetInformations: {
            items: []

        }
    };

    // NowTeaser.setCurrentTeasersets(vm);

    vm.isFreeFilter = isFreeFilter;
    vm.orderChanged = orderChanged;
    vm.gotoGenre = gotoGenre;
    vm.nextPage = nextPage;
    vm.goto = goto;

    run();

    function run() {
        vm.page = (page === false) ? {} : page;
        if (page.teaserSets && page.teaserSets.items.length > 0) {
            vm.teasersets = page.teaserSets.items;
            NowTeaser.setCurrentTeasersets(vm.teasersets);
            vm.teaserset.teaserSetInformations.items = vm.teasersets[1].teaserSetInformations.items;
        } else {
            vm.teasersets = [];
        }

        if (vm.params.genre) {
            vm.currentGenre = $routeParams.genre;
        }

        $log.debug('genre scope', vm.teasersets);

        var orderOptionsMovies = [
            {
                text: 'Titel: Aufsteigend',
                label: 'Sortierung',
                value: 'title'
            },
            {
                text: 'Titel: Absteigend',
                label: 'Sortierung',
                value: '-title'
            },
            {
                text: 'Ausstrahlung: Aufsteigend',
                label: 'Sortierung',
                value: 'broadcastStartDate'
            },
            {
                text: 'Ausstrahlung: Absteigend',
                label: 'Sortierung',
                value: '-broadcastStartDate'
            }
        ];

        var orderOptionsGenres = [
            {
                text: 'Titel: Aufsteigend',
                label: 'Sortierung',
                value: 'title'
            },
            {
                text: 'Titel: Absteigend',
                label: 'Sortierung',
                value: '-title'
            }
        ];

        vm.orderOptions = orderOptionsMovies;

        if (routeData.movies) {
            if (!vm.currentGenre) {
                vm.currentGenre = 'Alle Spielfilme';
            }
            vm.orderOptions = orderOptionsMovies;
            vm.genreList = ['Alle Spielfilme', 'Action', 'Crime', 'Comedy', 'Drama', 'Tiere', 'Romantik', 'Horror', 'Familie', 'Mystery'];
            vm.headline = ((vm.currentGenre !== 'Alle Spielfilme') ? 'Spielfilme ' + $filter('capitalize')(vm.currentGenre) : 'Alle Spielfilme');

            Metadata.setTitle((vm.currentGenre !== 'Alle Spielfilme') ? 'Spielfilme ' + vm.currentGenre + ' online schauen als Stream auf TV NOW' : 'Spielfilme online schauen als Stream auf TV NOW');

            BreadcrumbHelper.setItems({
                'title': vm.headline,
                'url': 'spielfilme/' + vm.currentGenre
            });

            vm.movies = true;
            vm.urlBase = '/spielfilme/';
        } else {
            vm.orderOptions = orderOptionsGenres;
            vm.genreList = ['Tägliche Serien', 'Action', 'Crime', 'Ratgeber', 'Comedy', 'Show', 'Docutainment', 'Drama', 'Tiere', 'News', 'Mags', 'Romantik', 'Horror', 'Familie', 'Kochen', 'Auto', 'Sport', 'Reportage und Dokumentationen', 'Sitcom', 'Mystery', 'Lifestyle', 'Musik', 'Spielfilm', 'Anime'];
            vm.headline = ((vm.currentGenre) ? ' Alle „' + $filter('capitalize')($filter('genretext')(vm.currentGenre), true) + '“-Sendungen im Überblick ' : 'Alle Genres');
            Metadata.setTitle((vm.currentGenre) ? $filter('genretext')($filter('capitalize')(vm.currentGenre), true) + ' online schauen als Stream auf TV NOW' : 'Alle Genres online schauen als Stream auf TV NOW');

            if (vm.currentGenre && vm.currentGenre.toLowerCase() === 'tägliche serien') {
                vm.headline = 'Alle täglichen Serien im Überblick';
            }

            if (vm.currentGenre && vm.currentGenre.toLowerCase().indexOf('reportage') > -1) {
                vm.headline = 'Alle „Reportagen & Dokumentationen“ im Überblick ';
            }

            BreadcrumbHelper.setItems({
                'title': 'Genre: ' + $filter('genretext')($filter('capitalize')(vm.currentGenre)),
                'url': 'genres/' + vm.currentGenre
            });
            vm.genres = true;
            vm.urlBase = '/genres/';
        }

        resetOrder();
        loadData();
        initWatchers();
    }

    function loadData() {
        $log.debug('controller_genre loadData()', {'vm.pagecount': vm.pagecount});

        vm.loading = true;
        if (routeData.movies) {
            fetchMovieGenre(vm.currentGenre, vm.pagecount);
        } else {
            fetchFormatGenre(vm.currentGenre, vm.pagecount);
        }
        vm.pagecount = vm.pagecount + 1;
    }

    function orderChanged(val, reload) {
        if (val.value === false && reload !== true) {
            resetOrder();
        } else {
            vm.orderActive = true;
            vm.orderby = vm.orderChanged.text;
        }
    }

    function initWatchers() {
        vm.$watch('orderSelected', function (val) {
            //console.log('orderSelected');
        });
    }

    function isFreeFilter(movie) {

        if (movie.format && !movie.format.id) {
            return false;
        }
        if (movie.format && movie.format.station && StationMonitor.getStationsWithAlias().indexOf(movie.format.station) === -1) {
            return false;
        }
        if (vm.isFree === true && (movie.free === true || movie.icon === 'free')) {
            vm.filterActive = true;
            return true;
        } else if (vm.isFree === true && (movie.free === false || movie.icon !== 'free')) {
            vm.filterActive = true;
            return false;
        }
        vm.filterActive = false;
        return true;
    }

    function gotoGenre(genre) {
        if (vm.movies) {
            $location.path(vm.urlBase + genre);
        } else {
            $location.path(vm.urlBase + genre);
        }
    }

    function goto(format) {
        var teaser = {
            format: format,
            type: "format",
            layout: 'now-teaser-m',
            position: vm.formatlist.indexOf(format),
            genreTeaser: true
        };
    }

    function nextPage() {
        if (!vm.loading && total > itemcount) {
            $log.debug('controller_genre nextPage()', {total: total, itemcount: itemcount});
            loadData();
        } else if (total > 0 && total <= itemcount) {
            //not really an error, just end reached
            errorNotFound();
        }
    }

    function errorNotFound(err) {
        $log.debug('controller_genre errorNotFound()', {err: err});

        vm.empty = (total === 0);
        vm.loading = 0;
        vm.endreadched = true;
    }

    function fetchFormatGenre(genre, page) {
        NowApi.getFormat().genre({
            'genre': genre,
            'filter': {
                'station': 'none'
            },
            'fields': '*',
            'order': 'NameLong asc',
            'maxPerPage': 50,
            'page': page
        }).then(function (data) {
            $log.debug('controller_genre fetchFormatGenre() found: ' + data.items.length + ', total: ' + data.total);
            total = data.total;

            if (data.items.length > 0) {
                vm.formatlist = vm.formatlist.concat(data.items);
                itemcount = vm.formatlist.length;

            }
            //NowTeaser.setCurrentTeasersets(vm.formatlist);
            vm.teaserset.headline = genre;
            vm.teaserset.formats.items = vm.formatlist;

            //$log.debug('format genre', vm.t);

            vm.loading = false;

            $timeout(function () {
                $rootScope.$broadcast("contentUpdated", vm.teaserset, 'now-genre-teaserset');
            }, 0);
        }, errorNotFound);
    }

    function fetchMovieGenre(genre, page) {
        if (genre.toLowerCase() === 'alle spielfilme') {
            genre = 'all';
        }

        NowApi.getMovie().genre({
            'genre': genre,
            'station': 'none',
            'categories': '["film"]',
            'fields': '*,format,paymentPaytypes,pictures,packages',
            'order': 'HeadlineLong asc',
            'maxPerPage': 50,
            'page': page
        }).then(function (data) {
                $log.debug('controller_genre fetchMovieGenre() found: ' + data.items.length + ', total: ' + data.total);
                total = data.total;
                if (data.items.length > 0) {
                    vm.movielist = vm.movielist.concat(data.items);
                    itemcount = vm.movielist.length;
                }

                $timeout(function () {
                    $rootScope.$broadcast("contentUpdated", vm.teaserset, 'now-genre-teaserset');
                }, 0);
                vm.loading = false;
            },
            errorNotFound
        );
    }

    function resetOrder() {
        vm.orderSelected = {
            text: 'Titel: Aufsteigend',
            label: 'Sortierung',
            value: 'title'
        };
        vm.orderActive = false;
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowGenre')
    .config(routing);

routing.$inject = ['$routeProvider', 'AppConfigProvider'];

function routing($routeProvider, AppConfigProvider) {
    var resolvePage = {
        page: resolvePageFunction
    };

    $routeProvider
        .when('/genres', {
            controller: 'NowGenreController',
            controllerAs: 'vm',
            templateUrl: templateUrl,
            data: {
                genres: true,
                pagetype: 'static'
            },
            reloadOnSearch: false,
            resolve: resolvePage
        }).when('/genres/spielfilme', {
        redirectTo: function () {
            return '/genres/spielfilm';
        }
    })
        .when('/genres/:genre', {
            templateUrl: templateUrl,
            controller: 'NowGenreController',
            controllerAs: 'vm',
            data: {
                genres: true,
                pagetype: 'static'
            },
            reloadOnSearch: false,
            resolve: resolvePage
        })
        .when('/spielfilme', {
            redirectTo: function () {
                return '/genres/spielfilm';
            }
        })
        .when('/spielfilme/:genre', {
            redirectTo: function () {
                return '/genres/spielfilm';
            }
        });

    function templateUrl() {
        //$log.debug("Genre::route:templateUrl",params);
        var template = 'templates/genre_view.html';
        if (AppConfigProvider.getConfig().mode === 'edit') {
            template = 'templates/static_genre_edit.html';
        }
        return template;
    }

    resolvePageFunction.$inject = ['$route', 'NowApi', 'StationMonitor'];
    function resolvePageFunction($route, NowApi, StationMonitor) {
        // GET PAGE
        var path = 'spielfilme',
            station = 'nowtv';

        if ($route.current.$$route.data.genres) {
            path = 'genres';
        }

        if ($route.current.params.genre) {
            path += '_' + $route.current.params.genre;
        }

        if (StationMonitor.getStationsOrdered().indexOf(path) > -1) {
            station = StationMonitor.getStation();
        }

        return NowApi.getPage().retrievePagesByStationAndPath({
            station: station,
            pagepath: path,
            fields: '*,teaserSets.*,teaserSets.movies.*,teaserSets.movies.pictures,teaserSets.movies.packages,teaserSets.movies.format,teaserSets.movies.paymentPaytypes,teaserSets.formats.*,teaserSets.teaserSetInformations.*,teaserSets.teaserSetInformations.custom.*,teaserSets.teaserSetInformations.custom.format.*,teaserSets.teaserSetInformations.custom.movie.*,teaserSets.teaserSetInformations.custom.page.*,teaserSets.teaserSetInformations.custom.format.*,teaserSets.teaserSetInformations.custom.movie.*,teaserSets.teaserSetInformations.custom.page.*,teaserSets.teaserSetInformations.movie.*,teaserSets.teaserSetInformations.movie.paymentPaytypes.*,teaserSets.teaserSetInformations.movie.format.*,teaserSets.teaserSetInformations.format.*,teaserSets.teaserSetInformations.format.paymentPaytypes.*,teaserSets.teaserSetInformations.movie.pictures'
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }
}


})();

(function() {



})();

(function() {

angular.module('NowTeaser', ['NowMyProgramme']);

})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowTeaser')
    .directive('teasersetleadteaser', teasersetleadteaser);

teasersetleadteaser.$inject = ['$timeout', 'StationMonitor', 'AutoimgUrlHelper', 'Moviehelper', '$window', '$log', '$filter', 'RecommendationService', 'NowGoogleAnalytics', 'STAGE', '$window', '$httpParamSerializer', '$rootScope'];

function teasersetleadteaser($timeout, StationMonitor, AutoimgUrlHelper, Moviehelper, $localStorage, $log, $filter, RecommendationService, NowGoogleAnalytics, STAGE, $window, $httpParamSerializer, $rootScope) {
    var timeout = false;
    var setNextTimeout;
    controller.$inject = ['$scope','$document'];
    return {
        restrict: 'E',
        link: link,
        controller: controller,
        replace: true,
        templateUrl: 'templates/teaserset_leadteaser.html'
    };

    function link(scope) {
        scope.infotext = false;
        scope.isTablet = $rootScope.isTablet;

        if (STAGE.editMode) {
            scope.infotext = "Leadteaser Videos";
        }

        var videoSelector = $('video');
        var bildSelector = $('bild');

        scope.favButtonOnShow = favButtonOnShow;
        scope.favButtonOnHide = favButtonOnHide;

        $('#leadvideo').on('ended', function () {
            scope.next();
        });

        scope.$watch('videoSrc', function (videoSrc) {
            $('.video').attr('src', videoSrc);
        });



        function favButtonOnShow() {
            if (!videoSelector.is(':visible') || !bildSelector.is(':visible')) {
                if (timeout) {
                    $timeout.cancel(timeout);
                }
            } else {
                $('video')[0].pause();
            }
        }

        setNextTimeout = function () {
            if (timeout) {
                $timeout.cancel(timeout);
            }

            if (!videoSelector.is(':visible') || !bildSelector.is(':visible')) {
                timeout = $timeout(function () {
                    if (scope.subteasers.length > 0) {
                        scope.next();
                    }
                }, 5000);
            }
        };

        function favButtonOnHide() {
            if (!videoSelector.is(':visible') || !bildSelector.is(':visible')) {
                setNextTimeout();
            } else {
                $('video')[0].play();
            }
        }
    }


    function controller($scope,$document) {
        var currentTeaser = false,
            vid = $document[0].createElement('video');

        $scope.currentIndex = 0;
        $scope.subteasers = [];
        $scope.showBottom = true;

        $scope.showTeaser = showTeaser;
        $scope.clickLink = clickLink;
        $scope.getLink = getLink;
        $scope.prev = prev;
        $scope.next = next;
        $scope.prevClick = prevClick;
        $scope.nextClick = nextClick;
        $scope.bulletClick = bulletClick;
        $scope.gecRerenderHelper = false;

        $scope.$watch('gecRerenderHelper', function(gecRerenderHelper){
            if(gecRerenderHelper){
                $timeout(function(){
                    $rootScope.$broadcast("contentUpdated", false, "now-leadteaser");
                },0);
            }
        });

        if (!vid.canPlayType('video/mp4')) {
            $localStorage.disableVideo = true;
        }
        if (angular.isDefined(vid) && angular.isFunction(vid.remove)) {
            vid.remove();
        } else if (vid.parentNode) {
            vid.parentNode.removeChild(vid);
        }

        setupLeadteaser();

        function convertTeasersetToSubteaser(teaserset) {
            var subTeaserItems = [];
            $log.debug('aufmacher teaserset', teaserset);
            for (var i = 0; i < teaserset.teaserSetInformations.items.length; i++) {
                var teaser = teaserset.teaserSetInformations.items[i];
                if (teaser.customTeaserType === 'live') {
                    var now = teaser.custom.data.now;
                    if (now && now.format) {
                        leadSubTeaserItem = {
                            id: '-1',
                            title: '',
                            livestream: true,
                            formatId: now.format.id,
                            season: 0,
                            headline: now.title,
                            subHeadline: now.broadcastStartDate,
                            image: now.image,
                            info: 'LIVESTREAM',
                            station: now.station,
                            linkSrc: StationMonitor.getStation() + '/live',
                            linkTarget: '_self',
                            nowNext: 'none',
                            useFormatLink: false,
                            movie: null,
                            format: now.format,
                            teaserItem: teaser,
                            position: i,
                            type: teaser.type
                        };
                        subTeaserItems.push(leadSubTeaserItem);
                    }
                }
                else if (teaser.customTeaserType === 'special' || teaser.customTeaserType === 'manualteaser') {
                    var link;
                    switch (teaser.custom.data.internalLinkType) {
                        case 'format':
                            link = $filter('geturl')(teaser.custom.format, 'isformat');
                            break;
                        case 'page':
                            link = $filter('geturl')(teaser.custom.page, 'page');
                            break;
                        case 'external':
                            link = teaser.custom.data.url;
                    }
                    var leadSubTeaserItem = {
                        id: '-1',
                        title: '',
                        formatId: 0,
                        season: 0,
                        headline: teaser.custom.data.headline1 ? teaser.custom.data.headline1 : ' ',
                        subHeadline: teaser.custom.data.headline2 ? teaser.custom.data.headline2 : ' ',
                        info: teaser.custom.data.info ? teaser.custom.data.info : ' ',
                        icontype: teaser.custom.data.icon.replace(/icon-nowcircle_/, ''),
                        station: teaser.custom.data.usecornerlogo ? teaser.custom.data.cornerlogo : '',
                        imageId: teaser.custom.data.imagedefault,
                        linkSrc: link,
                        linkTarget: teaser.custom.data.target,
                        nowNext: 'none',
                        useFormatLink: false,
                        movie: false,
                        format: false,
                        teaserItem: teaser,
                        position: i,
                        type: teaser.type
                    };
                    subTeaserItems.push(leadSubTeaserItem);
                }
                else if (teaser) {
                    try {
                        var movie = teaser.movie,
                            format = teaser.format;
                        leadSubTeaserItem = {
                            id: '-1',
                            title: '',
                            formatId: format.id,
                            season: 0,
                            headline: '',
                            subHeadline: '',
                            info: '',
                            station: StationMonitor.getStation(),
                            linkSrc: '',
                            linkTarget: '_self',
                            nowNext: teaser.nowNextType,
                            useFormatLink: false,
                            movie: movie,
                            format: format,
                            teaserItem: teaser,
                            position: i,
                            type: teaser.type
                        };
                        subTeaserItems.push(leadSubTeaserItem);
                    } catch (e) {
                        $log.debug(e);
                    }
                }

            }
            $log.debug('TEASERSET::subTeaserItems Leadteaser', subTeaserItems);
            return subTeaserItems;
        }

        function renderSubTeasersWithRecommendation(subteasers) {
            var itemOnPage = [];
            angular.forEach(subteasers, function (cmsLeadSubTeaserItem) {
                var movie = cmsLeadSubTeaserItem.movie;
                if (false === angular.isUndefined(movie) && null !== movie) {
                    itemOnPage.push(RecommendationService.getSuffixedMovieId(movie.id));
                }
            });

            var subTeaserItems = subteasers;

            RecommendationService.getRecommendationsForLeadTeaser(itemOnPage, function (data) {
                if (1 < data.items.length) {
                    for (var i = 0; i < 2; i++) {
                        var recommendationItem = data.items[i];
                        var movie = recommendationItem.movie;
                        var format = recommendationItem.format ? recommendationItem.format : recommendationItem.movie.format;
                        var leadSubTeaserItem = {
                            id: '-1',
                            title: '',
                            formatId: format.id,
                            season: 0,
                            headline: '',
                            subHeadline: '',
                            info: '',
                            station: StationMonitor.getStation(),
                            linkSrc: '',
                            linkTarget: '_self',
                            nowNext: 'recommendation',
                            useFormatLink: false,
                            movie: movie,
                            format: format,
                            teaserItem: recommendationItem,
                            position: subTeaserItems[subTeaserItems.length - 1 - i].position,
                            type: recommendationItem.type
                        };
                        $log.debug('Aufmacher::Reco Teaser',recommendationItem);
                        subTeaserItems[subTeaserItems.length - 1 - i] = leadSubTeaserItem;
                    }
                }

                $scope.subteasers = subTeaserItems;
                showTeaser(0);
            });
        }

        function setupLeadteaser() {
            $scope.subteasers = convertTeasersetToSubteaser($scope.teaserset);
            if (
                STAGE.stage === 'local' ||
                false === RecommendationService.isReceivingEnabled() ||
                $scope.teaserset.automaticType === 'clienthomesfirstteaser' ||
                $window.nowSEDetected
            ) {
                showTeaser(0);
            } else {
                renderSubTeasersWithRecommendation($scope.subteasers);
            }
        }

        function clickLink(teaserSet) {
            RecommendationService.fireEventRecClick(currentTeaser.teaserItem);
        }

        function getLink() {
            var href = '#';
            $log.debug('directive_leadteaser getLink()', {currentTeaser: currentTeaser});
            if (currentTeaser.nowNext === 'none' && currentTeaser.linkSrc && currentTeaser.linkSrc.length > 0) {
                href = currentTeaser.linkSrc;
            } else if (currentTeaser.movie && !currentTeaser.useFormatLink) {
                var params = $httpParamSerializer(Moviehelper.getMoviePlayerSearch(currentTeaser.movie));
                $log.debug('getLink() params', params);
                href = Moviehelper.getMoviePlayerPath(currentTeaser.movie) + '?' + params;
            } else if (currentTeaser.format) {
                href = StationMonitor.getAlias(currentTeaser.format.station) + '/' + currentTeaser.format.seoUrl;
            }

            return {href: href, target: currentTeaser.linkTarget};
        }

        function nextClick() {
            trackEvent('klick', 'pfeile_bullets');
            next();
        }

        function next() {
            if ($scope.currentIndex + 1 < $scope.subteasers.length) {
                $scope.currentIndex++;
            } else {
                $scope.currentIndex = 0;
            }
            showTeaser($scope.currentIndex);
        }

        function prevClick() {
            trackEvent('klick', 'pfeile_bullets');
            prev();
        }

        function prev() {
            if ($scope.currentIndex > 0) {
                $scope.currentIndex--;
            } else {
                $scope.currentIndex = $scope.subteasers.length - 1;
            }
            showTeaser($scope.currentIndex);
        }

        function bulletClick(index) {
            trackEvent('klick', 'pfeile_bullets');
            return showTeaser(index);
        }

        function showTeaser(index, cb) {
            $scope.gecRerenderHelper = false;
            $('.now-leadteaser-text').fadeOut(500, fadeOutFunction);

            function fadeOutFunction() {
                var teaser = $scope.subteasers[index];
                $scope.currentIndex = index;
                $log.debug(teaser);
                currentTeaser = teaser;

                if (!teaser) {
                    return false;
                }

                if (
                    teaser.headline && teaser.headline.length > 0 && teaser.subHeadline && teaser.subHeadline.length > 0 && teaser.info && teaser.info.length > 0 && !teaser.movie
                ) {
                    $scope.small = teaser.info;
                    $scope.large = teaser.headline;
                    $scope.description = teaser.subHeadline;
                    $scope.teasertype = 'movie';
                    if (teaser.icontype === 'more') {
                        $scope.teasertype = 'format';
                    }
                } else {
                    if (teaser.movie) {

                        $scope.description = teaser.movie.teaserText;
                        $scope.date = teaser.movie.broadcastStartDate;

                        if (teaser.movie.free || teaser.movie.payed) {
                            $scope.status = 'FREE';
                        } else {
                            $scope.status = 'PAY';
                        }
                    }

                    if (teaser.format) {
                        $scope.large = teaser.format.title;
                        if (!teaser.movie) {
                            $scope.status = (teaser.format.icon === 'pay' || teaser.format.icon === 'free') ? teaser.format.icon : '';
                            $scope.description = teaser.subHeadline;
                        }
                        $scope.station = teaser.format.station;
                    }

                    $scope.statusitem = teaser.format;
                    $scope.format = teaser.format;
                    $scope.movie = teaser.movie;
                    $scope.icontype = '';
                    $scope.teasertype = 'format';
                    $scope.livestream = false;


                    if (teaser.movie) {
                        $scope.teasertype = 'movie';
                        $scope.statusitem = teaser.movie;
                    }

                    if (teaser.livestream) {
                        $scope.teasertype = 'movie';
                        $scope.livestream = true;
                    }

                    $scope.small = null;
                }
                $scope.teaserItem = teaser.teaserItem;

                if (bowser.msie && bowser.version === '11.0') {
                    $log.debug('Ignore videoteasers on IE11');
                    $localStorage.disableVideo = true;
                }

                var effects = ['topright', 'topleft', 'bottomleft', 'bottomright'];
                var effect = effects[Math.floor(Math.random() * effects.length)];

                if (!bowser.tablet) {
                    $scope.imageShow = true;
                    if (teaser.movie && teaser.movie.leadTeaserTrailer && !$localStorage.disableVideo) {
                        $scope.videoSrc = '//tvnowstatic-a.akamaihd.net/now/leadteasertrailer/film/' + teaser.movie.id + '/aufmacher.mp4';
                        $scope.videoShow = true;
                        $scope.imageShow = false;
                    } else if (teaser.format && teaser.format.leadTeaserTrailer && !$localStorage.disableVideo) {
                        $scope.videoSrc = '//tvnowstatic-a.akamaihd.net/now/leadteasertrailer/format/' + teaser.format.id + '/aufmacher.mp4';
                        $scope.videoShow = true;
                        $scope.imageShow = false;
                    } else if (teaser.movie && teaser.movie.kenburns && !$localStorage.disableVideo) {
                        $scope.videoSrc = '//tvnowstatic-a.akamaihd.net/now/kenburns/film/' + teaser.movie.id + '/' + effect + '.mp4';
                        $scope.videoShow = true;
                        $scope.imageShow = false;
                    } else if (teaser.format && teaser.format.kenburns && !$localStorage.disableVideo) {
                        $scope.videoSrc = '//tvnowstatic-a.akamaihd.net/now/kenburns/format/' + teaser.format.id + '/' + effect + '.mp4';
                        $scope.videoShow = true;
                        $scope.imageShow = false;
                    }
                }
                if (bowser.tablet || $scope.imageShow) {
                    if (teaser.movie && teaser.movie.pictures && teaser.movie.pictures.default.length > 0) {
                        AutoimgUrlHelper.setParams(teaser.movie.id, null, null, '1280x720');
                    } else if (teaser.imageId) {
                        AutoimgUrlHelper.setParams(null, null, null, '1280x720', teaser.imageId);
                    } else {
                        AutoimgUrlHelper.setParams(null, teaser.format.id, null, '1280x720');
                    }
                    if ($scope.imageIndex === 1) {
                        $scope.imageSrc2 = AutoimgUrlHelper.getAutoimgUrl();
                        $scope.imageIndex = 2;
                    } else {
                        $scope.imageSrc1 = AutoimgUrlHelper.getAutoimgUrl();
                        $scope.imageIndex = 1;
                    }

                    $scope.station = (teaser.station !== 'nowtv') ? teaser.station : false;
                    if (!$scope.station && teaser.format.station) {
                        $scope.station = teaser.format.station;
                    }

                    $scope.videoShow = false;
                    $scope.imageShow = true;
                }

                if (!$scope.$$phase) {
                    $scope.$apply();
                }

                $('.now-leadteaser-text').fadeIn(500, function(){
                    $scope.gecRerenderHelper = true;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });

                setNextTimeout();

                if (cb) {
                    cb();
                }
            }
        }

        function trackEvent(cat, lab) {
            NowGoogleAnalytics.trackEvent('aufmacher', cat, lab);
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('nowteaser', NowTeaserDirective);

NowTeaserDirective.$inject = ['NowGoogleAnalytics', '$log', 'NowApi', '$q', '$rootScope'];

function NowTeaserDirective(NowGoogleAnalytics, $log, NowApi, $q, $rootScope) {
    controller.$inject = ['$scope', '$element', '$attrs'];
    function controller($scope, $element, $attrs) {
        var teaser = $scope.teaser,
            urlCache = {};

        $scope.parentTeaserSet = $scope.$parent.teaserset;

        if (!$scope.teaser) {
            //happened for genre_format-teaser as set in controller_genre which led to empty genre lists
            $log.error('directive_teaser controller() $scope.teaser empty!', {
                '$scope': $scope,
                '$element': $element,
                '$attrs': $attrs
            });
            $scope.teaser = {};
        } else if (teaser.custom && teaser.custom.data && teaser.custom.data.formatid) {
            generateUrl(teaser.custom.data).then(function (url) {
                    $scope.teaser.custom.data.url = url;
                }, function () {
                    $scope.teaser.custom.data.url = '/';
                }
            );
        }

        if (!$scope.teaser.style) {
            $scope.teaser.style = 'now-teaser-m';
        }

        $scope.trackEvent = trackEvent;
        $scope.getTemplateUrl = getTemplateUrl;
        $scope.getStatus = getStatus;
        $scope.generateUrl = generateUrl;
        $scope.formattype = null;
        $scope.customCallback = function () {
            if (teaser.customClickCB) {
                teaser.customClickCB();
            }
        };
        if ($scope.parentTeaserSet && $scope.parentTeaserSet.automaticType === 'favoriteformats') {
            $scope.formattype = 'formatlogo';
        }
        $scope.isTablet = $rootScope.isTablet;

        function generateUrl(data) {
            var deferred = $q.defer(),
                cacheKey;

            if (data.url) {
                deferred.resolve(data.url);
            } else if (data.annualNavigation) {
                cacheKey = 'annual_' + data.formatid + '_' + data.annualNavigation.year + data.annualNavigation.month;
                if (urlCache[cacheKey]) {
                    deferred.resolve(urlCache[cacheKey]);
                } else {
                    NowApi.getFormat().retrieveFormatById({
                        id: data.formatid,
                        fields: '["seoUrl","station"]'
                    }).then(function (format) {
                            urlCache[cacheKey] = format.station + '/' + format.seoUrl + '/jahr/' + data.annualNavigation.year + '/' + data.annualNavigation.month;
                            deferred.resolve(urlCache[cacheKey]);
                        },
                        function () {
                            $log.log("Format not found");
                            deferred.reject();
                        }
                    );
                }
            } else if (data.formatTabId) {
                cacheKey = 'tab_' + data.formatid + '_' + data.formatTabId;
                if (urlCache[cacheKey]) {
                    deferred.resolve(urlCache[cacheKey]);
                } else {
                    NowApi.getFormat().retrieveFormatById({
                        id: data.formatid,
                        fields: '["seoUrl","station","formatTabs",["id","seoheadline"]]'
                    }).then(function (format) {
                            var seoheadline = '';
                            angular.forEach(format.formatTabs.items, function (tab) {
                                if (tab.id === data.formatTabId) {
                                    seoheadline = tab.seoheadline;
                                }
                            });
                            urlCache[cacheKey] = format.station + '/' + format.seoUrl + '/list/' + seoheadline;
                            deferred.resolve(urlCache[cacheKey]);
                        },
                        function () {
                            $log.log("Format not found");
                            deferred.reject();
                        }
                    );
                }
            } else if (data.formatid) {
                cacheKey = 'format_' + data.formatid;
                if (urlCache[cacheKey]) {
                    deferred.resolve(urlCache[cacheKey]);
                } else {
                    NowApi.getFormat().retrieveFormatById({
                        id: data.formatid,
                        fields: '["seoUrl","station"]'
                    }).then(function (format) {
                            urlCache[cacheKey] = format.station + '/' + format.seoUrl + '/list';
                            deferred.resolve(urlCache[cacheKey]);
                        },
                        function () {
                            $log.log("Format not found");
                            deferred.reject();
                        }
                    );
                }
            } else {
                deferred.resolve('/');
            }
            return deferred.promise;
        }

        function getStatus(movie) {
            if (movie.free) {
                return 'FREE';
            } else {
                return 'PAY';
            }
        }

        function getTemplateUrl() {
            if ($attrs.layout) {
                return 'templates/teaser_' + $attrs.layout + '.html';
            } else if (teaser.type === 'movie') {
                return 'templates/teaser_hometeaser_movie.html';
            } else if (teaser.type === 'format') {
                return 'templates/teaser_hometeaser_format.html';
            } else if (teaser.type === 'custom' && teaser.custom && teaser.custom.data && teaser.custom.data.type) {
                return 'templates/teaser_custom_' + teaser.custom.data.type + '.html';
            } else {
                $log.error('WRONG TEASER', teaser.id, teaser.type, teaser);
                return 'templates/teaser_notfound.html'
            }
        }

        function trackEvent(act, cat, lab) {
            NowGoogleAnalytics.trackEvent(act, cat, lab);
        }
    }

    return {
        restrict: 'E',
        replace: true,
        controller: controller,
        template: '<div ng-include src="getTemplateUrl()"/></div>'
    };

}




})();

(function() {

'use strict';

angular.module('NowTeaser')
    .directive('nowTeaserLivestream', nowTeaserLivestream);

nowTeaserLivestream.$inject = ['$interval', 'AutoimgUrlHelper', 'StationMonitor', 'moment', '$rootScope'];

function nowTeaserLivestream($interval, AutoimgUrlHelper, StationMonitor, moment, $rootScope) {
    return {
        restrict: 'E',
        link: link,
        replace: true,
        scope: {
            teaser: '='
        },
        templateUrl: 'templates/teaser_livestream.html'
    };

    function link(scope, element) {
        var headline = $(element).parents('.now-teaserset').children('.now-teaserset-headline');
        var bar = $(element).find('.bar');

        if ($('.now-teaserset-headline-livestream').length === 0) {
            headline.append('<div class="now-teaserset-headline-livestream">Jetzt live</div>');
        }

        scope.onImgLoad = function ($event) {
            scope.$emit('image::loaded', $event);
        };
        scope.isTablet = $rootScope.isTablet;
        scope.station = StationMonitor.getStation();
        scope.aliasstation = StationMonitor.getStation(true);
        scope.percentage = calcPercentage();
        var stopTime = $interval(function () {
            scope.percentage = calcPercentage();
        }, 10000);

        element.on('$destroy', function () {
            $interval.cancel(stopTime);
        });

        if (!scope.teaser.custom.data.now.image || scope.teaser.custom.data.now.image === '') {
            AutoimgUrlHelper.setParams(0, 0, 'formatlogo', '300x169');
            scope.image = AutoimgUrlHelper.getAutoimgUrl();
        } else {
            scope.image = scope.teaser.custom.data.now.image.replace('http:', 'https:');
        }

        function calcPercentage() {
            if (!scope.teaser.custom.data.now) {
                return 0;
            }
            var startDate = moment(scope.teaser.custom.data.now.broadcastStartDate),
                endDate = moment(scope.teaser.custom.data.next.broadcastStartDate),
                percentage_complete = (moment() - startDate) / (endDate - startDate) * 100,
                percentage_rounded = parseInt((Math.round(percentage_complete * 100) / 100));
            if (percentage_rounded > 100) {
                percentage_rounded = 100;
            }
            bar.css({'width': percentage_rounded + '%'});
            return percentage_rounded;
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('teaserreco', RecommendationTeaserDirective);

RecommendationTeaserDirective.$inject = ['RecommendationService'];

function RecommendationTeaserDirective(RecommendationService) {
    return {
        restrict: 'A',
        scope: {
            teaser: '='
        },
        link: link
    };

    function link(scope, el) {
        var teaser = scope.teaser;
        var element = $(el);
        element.bind('click', function () {
            RecommendationService.fireEventRecClick(teaser);
        });
    }

}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('teaserset', TeaserSetDirective);

TeaserSetDirective.$inject = ['$timeout', 'nowResizeService', 'RecommendationService', 'TeaserSetHelper', '$log', '$rootScope', 'STAGE', 'MyProgrammeService', '$filter', 'StationMonitor', '$window'];

function TeaserSetDirective($timeout, nowResizeService, RecommendationService, TeaserSetHelper, $log, $rootScope, STAGE, MyProgrammeService, $filter, StationMonitor, $window) {
    var items = [];
    var size = 'l';
    var initDone = false;
    var latestPageCountEvent = null;

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/teaser_teaserset.html',
        link: link
    };

    function link(scope, element) {

        scope.setPage = setPage;
        scope.paginate = paginate;

        scope.$on('resize::jump', onResizeJump);
        scope.$on('image::loaded', onImageLoaded);
        scope.$on('forcereload', forcereload);
        scope.filterStations = filterStations;
        var allowedStations = StationMonitor.getStationsWithAlias();


        init();

        function filterStations(teaser) {
            var station = "";
            if (teaser.movie && teaser.movie.format && teaser.movie.format.station) {
                station = teaser.movie.format.station;
            } else if (teaser.format && teaser.format.station) {
                station = teaser.format.station;
            } else if (teaser.type === "custom") {
                return true;
            } else {
                return false;
            }

            if (allowedStations.indexOf(station) > -1) {
                return true;
            }
            return false;
        }

        function forcereload(event, data) {
            if (data && data.page) {
                latestPageCountEvent = data.page;
                scope.page = data.page;
            }
        }

        function init(newSize) {
            initDone = false;
            scope.teaserset.hide = false;
            scope.loading = true;
            scope.pages = [];
            scope.teasers = [];
            scope.imageCount = 0;
            if (!scope.page || angular.isObject(scope.page)) {
                scope.page = 0;
            }
            if (latestPageCountEvent) {
                scope.page = latestPageCountEvent;
            }

            $rootScope.globalTeasersetCount += 1;
            scope.teaserset.analyticsTeasersetNo = $rootScope.globalTeasersetCount;

            $log.debug('TEASERSET', scope.teaserset);


            items = [];
            size = (!newSize) ? nowResizeService.getSize() : newSize;
            setupTeaserset();
            initDone = true;
        }

        function onImageLoaded(event, imageEvent) {
            //Stop ImageEvents here
            event.stopPropagation();

            scope.imageCount++;

            $log.debug('image::loaded', scope.imageCount + ' of ' + scope.teasers.length, imageEvent);
            if (scope.imageCount >= scope.teaserCount) {
                //console.log('Image loaded completly');
                scope.loading = false;
                $timeout(function () {
                    $rootScope.$broadcast("contentUpdated", scope.teaserset, element[0]);
                },500);
                $timeout.cancel(scope.timeout);
            }
        }

        function setLoadingTimeout() {
            $timeout.cancel(scope.timeout);
            scope.timeout = $timeout(function () {
                if (scope.loading) {
                    scope.loading = false;
                    $timeout(function () {
                        $rootScope.$broadcast("contentUpdated", scope.teaserset, element[0]);
                    },500);
                }
            }, 5000);
        }

        function setPage(page) {
            scope.page = page;

            showPage(page);
        }

        function onResizeJump(object, newSize) {
            scope.loading = true;
            if (initDone) {
                init(newSize);
            }
        }

        function paginate(count) {
            if (scope.page + count < 0) {
                scope.page = 0;
            } else if (scope.page + count >= scope.pages.length) {
                scope.page = scope.pages.length - 1;
            } else {
                scope.page = scope.page + count;
                showPage(scope.page);
            }
        }

        function setupTeaserset() {
            scope.teaserset.infotext = false;

            if (scope.teaserset.automaticType === 'recommendation') {
                if (!$window.yasp) {
                    scope.teaserset.hide = true;
                } else {
                    if (STAGE.editMode) {
                        scope.teaserset.loading = false;
                        scope.teaserset.infotext = 'Teaserset wird mit Reco-Content befüllt';
                    } else {
                        getRecommendations(function () {
                            setupPages(scope.teaserset.teaserSetInformations.items.slice());
                        });
                    }
                }

            }
            else if (scope.teaserset.automaticType === 'recommendation-series') {
                if (STAGE.editMode) {
                    scope.teaserset.loading = false;
                    scope.teaserset.infotext = 'Teaserset wird mit Reco-Content befüllt';
                } else {
                    getRecommendationsSeries(function () {
                        setupPages(scope.teaserset.teaserSetInformations.items.slice());
                    });
                }
                getRecommendationsSeries(function () {
                    setupPages(scope.teaserset.teaserSetInformations.items.slice());
                });
            }
            else if (scope.teaserset.automaticType === 'lastseencontent') {
                if (STAGE.editMode) {
                    scope.teaserset.loading = false;
                    scope.teaserset.infotext = 'Teaserset wird mit User-Content befüllt';
                } else {
                    scope.teaserset.teaserSetInformations = {items: []};
                    MyProgrammeService.getUserLastSeenContent().then(function (movies) {
                        $log.debug('getUserLastSeenContent items', movies, movies.length);
                        if (movies.length > 0) {
                            var items = [];
                            angular.forEach(movies, function (movie) {
                                items.push({type: 'movie', timingType: 'none', active: true, movie: movie, style: 'now-teaser-m'});
                            });
                            scope.teaserset.teaserSetInformations.items = items;
                            $log.debug(scope.teaserset);
                            setupPages(scope.teaserset.teaserSetInformations.items.slice());
                        } else {
                            scope.teaserset.hide = true;
                        }
                    }, function () {
                        scope.teaserset.hide = true;
                    });
                }
            }
            else if (scope.teaserset.automaticType === 'allseencontent') {
                if (STAGE.editMode) {
                    scope.teaserset.loading = false;
                    scope.teaserset.infotext = 'Teaserset wird mit User-Content befüllt';
                } else {
                    scope.teaserset.teaserSetInformations = {items: []};
                    scope.teaserset.loading = true;
                    MyProgrammeService.getUserLastSeenContent(true).then(function (movies) {
                        $log.debug('getUserLastSeenContent items', movies, movies.length);
                        if (movies.length > 0) {
                            var items = [];
                            angular.forEach(movies, function (movie) {
                                items.push({type: 'movie', timingType: 'none', active: true, movie: movie, style: 'now-teaser-m'});
                            });
                            scope.teaserset.teaserSetInformations.items = items;
                            $log.debug(scope.teaserset);
                            scope.teaserset.loading = false;
                            setupPages(scope.teaserset.teaserSetInformations.items.slice());
                        } else {
                            $log.debug('allseencontent hide');
                            scope.teaserset.hide = true;
                            scope.teaserset.loading = false;
                        }
                    }, function () {
                        $log.debug('allseencontent hide');
                        scope.teaserset.hide = true;
                        scope.teaserset.loading = false;
                    });
                }
            }
            else if (scope.teaserset.automaticType === 'favoriteformats') {
                if (STAGE.editMode) {
                    scope.teaserset.loading = false;
                    scope.teaserset.infotext = 'Teaserset wird mit User-Content befüllt';
                } else {
                    var generateTeaser = function () {
                        scope.loading = true;
                        scope.teaserset.teaserSetInformations = {items: []};
                        var items = [];
                        MyProgrammeService.getUserFormats().then(function (favorites) {
                            $log.debug('getUserFormats items', favorites, favorites.items.length);
                            if (favorites.items.length > 0) {
                                angular.forEach(favorites.items, function (favorite) {
                                    items.push({type: 'format', timingType: 'none', active: true, format: favorite.format, style: 'now-teaser-m'});
                                });
                                scope.teaserset.teaserSetInformations.items = $filter('orderBy')(items, '+format.title');
                                $log.debug(scope.teaserset);
                                scope.loading = false;
                                setupPages(scope.teaserset.teaserSetInformations.items.slice());
                            } else {
                                scope.loading = false;
                                scope.teaserset.hide = true;
                            }
                        }, function () {
                            scope.loading = false;
                            scope.teaserset.hide = true;
                        });
                    };

                    scope.$watch(function () {
                        return MyProgrammeService.getFormatids();
                    }, function (formatIdsNew, formatIdsOld) {
                        if (!MyProgrammeService.isLoading() && !angular.equals(formatIdsNew, formatIdsOld)) {
                            scope.$emit('forcereload');
                        }
                    }, true);
                    generateTeaser();
                }
            } else if (scope.teaserset.automaticType !== 'none') {
                if (STAGE.editMode) {
                    scope.teaserset.loading = false;
                    scope.teaserset.infotext = 'Teaserset wird automatisch befüllt ' + scope.teaserset.automaticType;
                } else {
                    if (scope.teaserset.teaserSetInformations.items) {
                        setupPages(scope.teaserset.teaserSetInformations.items.slice());
                    } else {
                        scope.teaserset.hide = true;
                    }
                }

            } else {
                var layout = getAllLayouts()[scope.teaserset.layout];
                //Immer vom größten Layout ausgehen.
                setupPages(scope.teaserset.teaserSetInformations.items.slice().splice(0, layout['l'].styles.length).slice());
            }
        }

        function setupPages(teaser) {
            //Filter all stations;
            teaser = $filter('filter')(teaser, filterStations);

            scope.disableArrows = true;
            var layout = getAllLayouts()[scope.teaserset.layout];
            if (scope.teaserset.layout < 7 && layout.l.styles.length > teaser.length) {
                var layoutId = getFallbackLayout(teaser.length);
                layout = getAllLayouts()[layoutId];
            }


            items = teaser;
            var first = true;
            var secureCounter = 20;
            while (items.length > 0 && secureCounter-- > 0) {
                if (first) {
                    scope.pages.push(generatePage(layout));
                    first = false;
                } else {
                    var page;
                    if (scope.teaserset.layout === 6 || scope.teaserset.layout === 7 || scope.teaserset.layout === 9) {
                        page = generatePage(layout);
                    } else {
                        page = generatePage();
                    }
                    if (page !== false) {
                        scope.pages.push(page);
                    }
                }
            }
            if (scope.page > 0 && scope.page >= scope.pages.length) {
                scope.page = scope.pages.length - 1;
            }
            showPage(scope.page);
        }

        function getEmptyTeaser() {
            return {type: 'custom', custom: {data: {type: 'empty', height: 169, width: 300}}, timingType: 'none', active: true, style: 'now-teaser-m'};
        }

        function showPage(page) {
            setLoadingTimeout();
            scope.loading = true;
            scope.imageCount = 0;
            scope.teasers = scope.pages[page];
            scope.teaserCount = getTeaserCountWithoutEmptyTeaser(scope.teasers);
            console.log("showPage",scope.teaserCount);
        }

        function getTeaserCountWithoutEmptyTeaser(teasers) {
            return teasers.filter(function (teaser) {
                return (teaser.type !== "custom" || (teaser.type === "custom" && teaser.custom.data.type && teaser.custom.data.type !== "empty"));
            }).length;
        }

        function generatePage(layout) {
            var layouts = getRandomLayouts(),
                sizeLayout,
                noMatchingLayoutFound,
                i, j;
            if (!layout) {
                noMatchingLayoutFound = true;
                for (i = 0; i < layouts.length; i++) {
                    sizeLayout = layouts[i][size];
                    if (sizeLayout.styles.length <= items.length) {
                        noMatchingLayoutFound = false;
                        break;
                    }
                }
                if (noMatchingLayoutFound) {
                    // new fallback dvd covers
                    var allLayouts = getAllLayouts();
                    sizeLayout = allLayouts[9][size];
                }
            } else {
                sizeLayout = layout[size];
            }

            var tmpItems = items.splice(0, sizeLayout.styles.length);
            var teasers = [];

            for (i = 0; i < sizeLayout.teaserOrder.length; i++) {
                if (angular.isDefined(tmpItems[sizeLayout.teaserOrder[i] - 1])) {
                    teasers[i] = tmpItems[sizeLayout.teaserOrder[i] - 1];
                    teasers[i].style = sizeLayout.styles[i];
                }
            }

            if (tmpItems.length < sizeLayout.styles.length) {
                for (j = 0; j < sizeLayout.styles.length; j++) {
                    if (angular.isUndefined(teasers[j])) {
                        teasers[j] = getEmptyTeaser();
                    }
                }
            }

            return teasers;
        }

        function getRecommendations(callback) {

            scope.teaserset.hide = !RecommendationService.isReceivingEnabled();
            scope.recommendationService = RecommendationService;
            var teaserset = scope.teaserset;
            var recommendationCallback = function (data) {
                teaserset.teaserSetInformations = {
                    items: data.items
                };
                callback();
            };
            var newAutomaticConfiguration = TeaserSetHelper.getFilteredAutomaticConfiguration(teaserset.automaticType, teaserset.automaticConfiguration);
            var errorCallback = function () {
                scope.teaserset.hide = true;
            };

            RecommendationService.getRecommendations(recommendationCallback, newAutomaticConfiguration, errorCallback);
        }

        function getRecommendationsSeries(callback) {
            var teaserset = scope.teaserset;
            var recommendationCallback = function (data) {
                teaserset.teaserSetInformations = {
                    items: data.items
                };
                callback();
            };
            RecommendationService.getRecommendationsForSeries(scope.format.id, recommendationCallback);
        }
    }

    function getFallbackLayout(neededLength) {
        var fallbackLayout = 6;
        var layoutCount = 0;
        angular.forEach(getRandomLayouts(), function (layout) {
            if (layout.l.styles.length === neededLength) {
                fallbackLayout = layoutCount;
            }
            layoutCount++;
        });
        return fallbackLayout;
    }

    function getRandomLayouts() {
        return [
            { //1 [.layout0]
                random: true,
                l: {
                    styles: ['now-teaser-h',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 4, 6, 3, 5]
                },
                m: {
                    styles: ['now-teaser-h',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 4, 3, 5]
                },
                s: {
                    styles: ['now-teaser-h',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3]
                }
            },
            { //2 [.layout1]
                random: true,
                l: {
                    styles: ['now-teaser-m',
                        'now-teaser-m now-teaser-right',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-m now-teaser-right',
                        'now-teaser-m now-teaser-right now-teaser-right-fix-large'
                    ],
                    teaserOrder: [1, 5, 4, 3, 2, 6]
                },
                m: {
                    styles: ['now-teaser-h now-teaser-right',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [4, 3, 1, 2]
                },
                s: {
                    styles: ['now-teaser-h  now-teaser-right',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [3, 1, 2]
                }
            },
            { //3 [.layout2]
                random: true,
                l: {
                    styles: ['now-teaser-h',
                        'now-teaser-h',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3, 5, 4, 6]
                },
                m: {
                    styles: ['now-teaser-h',
                        'now-teaser-h',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3, 4]
                },
                s: {
                    styles: ['now-teaser-h',
                        'now-teaser-h'
                    ],
                    teaserOrder: [1, 2]
                }
            },
            { //4 [.layout3]
                random: true,
                l: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-w'
                    ],
                    teaserOrder: [1, 2, 5, 4, 3]
                },
                m: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-w'
                    ],
                    teaserOrder: [1, 2, 4, 3]
                },
                s: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-w'
                    ],
                    teaserOrder: [1, 3, 2]
                }
            },
            { //5 [.layout4]
                random: true,
                l: {
                    styles: ['now-teaser-w',
                        'now-teaser-m',
                        'now-teaser-h now-teaser-right',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 4, 6, 2, 3, 5]
                },
                m: {
                    styles: ['now-teaser-w',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 4, 2, 3, 5]
                },
                s: {
                    styles: ['now-teaser-w',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3]
                }
            },
            { //6 [.layout5]
                random: true,
                l: {
                    styles: ['now-teaser-l',
                        'now-teaser-h',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3, 4]
                },
                m: {
                    styles: ['now-teaser-l',
                        'now-teaser-h'
                    ],
                    teaserOrder: [1, 2]
                },
                s: {
                    styles: ['now-teaser-l'
                    ],
                    teaserOrder: [1]
                }
            },
            { //7 [.layout6]
                random: true,
                l: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 3, 5, 7, 2, 4, 6, 8]
                },
                m: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 3, 5, 2, 4, 6]
                },
                s: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 3, 2, 4]
                }
            }
        ];
    }

    function getAllLayouts() {
        return getRandomLayouts().concat([
            { //8 [.layout7]
                l: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3, 4]
                },
                m: {
                    styles: ['now-teaser-m',
                        'now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2, 3]
                },
                s: {
                    styles: ['now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2]
                }
            },
            { //9 [.layout8]
                l: {
                    styles: ['now-teaser-h',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2]
                },
                m: {
                    styles: ['now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2]
                },
                s: {
                    styles: ['now-teaser-m',
                        'now-teaser-m'
                    ],
                    teaserOrder: [1, 2]
                }
            },
            { //10 [.layout9]
                random: true,
                l: {
                    styles: ['now-teaser-h',
                        'now-teaser-h',
                        'now-teaser-h',
                        'now-teaser-h'
                    ],
                    teaserOrder: [1, 2, 3, 4]
                },
                m: {
                    styles: ['now-teaser-h',
                        'now-teaser-h',
                        'now-teaser-h'
                    ],
                    teaserOrder: [1, 2, 3]
                },
                s: {
                    styles: ['now-teaser-h',
                        'now-teaser-h'
                    ],
                    teaserOrder: [1, 2]
                }
            },
            { //11 [.layout10]
                l: {
                    styles: [
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10'
                    ],
                    teaserOrder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                },
                m: {
                    styles: [
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10'
                    ],
                    teaserOrder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                },
                s: {
                    styles: [
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10',
                        'now-teaser-t10'
                    ],
                    teaserOrder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                }
            }
        ]);
    }
}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('teasersetcustom', teasersetcustom);

teasersetcustom.$inject = [];

function teasersetcustom() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/teaser_teaserset_custom.html'
    };
}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('teasersetMobile', TeaserSetDirective);

TeaserSetDirective.$inject = ['$timeout', 'nowResizeService', 'RecommendationService', 'TeaserSetHelper', '$log', '$rootScope', 'STAGE', 'StationMonitor', '$filter', 'AppConfig'];

function TeaserSetDirective($timeout, nowResizeService, RecommendationService, TeaserSetHelper, $log, $rootScope, STAGE, StationMonitor, $filter, AppConfig) {


    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/teaser_teaserset.html',
        link: link
    };

    function link(scope, element) {

        scope.setPage = setPage;
        scope.paginate = paginate;

        scope.$on('image::loaded', onImageLoaded);

        scope.filterStations = filterStations;

        var allowedStations = StationMonitor.getStationsWithAlias();

        scope.ffc = AppConfig.ffc + '/?premium=home';


        init();

        function init() {

            scope.teaserset.hide = false;
            scope.loading = true;
            scope.page = 0;
            scope.pages = [];
            scope.teasers = [];
            scope.imageCount = 0;

            $rootScope.globalTeasersetCount += 1;
            scope.teaserset.analyticsTeasersetNo = $rootScope.globalTeasersetCount;

            $log.debug('TEASERSET', scope.teaserset);

            if (scope.teaserset.headline === 'Unsere Channels') {
                scope.teaserset.hide = true;
            }


            setupTeaserset();

        }


        function filterStations(teaser) {

            if (teaser.customTeaserType === "manualteaser" || teaser.customTeaserType === "special"  ) {
                return true;
            }

            var station = "";
            if (teaser.movie && teaser.movie.format && teaser.movie.format.station) {
                station = teaser.movie.format.station;
            } else if (teaser.format && teaser.format.station) {
                station = teaser.format.station;
            } else {
                return false;
            }

            if (allowedStations.indexOf(station) > -1) {
                return true;
            }
            return false;
        }

        function onImageLoaded(event, imageEvent) {
            //Stop ImageEvents here
            event.stopPropagation();

            scope.imageCount++;

            $log.debug('image::loaded', scope.imageCount + ' of ' + scope.teasers.length, imageEvent);
            if (scope.imageCount >= scope.teasers.length) {
                //console.log('Image loaded completly');
                scope.loading = false;
                $timeout(function () {
                    $rootScope.$broadcast("contentUpdated", scope.teaserset, element[0]);
                },500);
                $timeout.cancel(scope.timeout);

                var shownTeasers = $(element).find('.shownteasers')

                shownTeasers.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    centerMode: false,
                    variableWidth: true,
                    arrows: false,
                    swipeToSlide: true
                });
            }
        }

        function setLoadingTimeout() {
            $timeout.cancel(scope.timeout);
            scope.timeout = $timeout(function () {
                if (scope.loading) {
                    scope.loading = false;
                }
            }, 5000);
        }

        function setPage(page) {
            scope.page = page;
            showPage(page);
        }


        function paginate(count) {

            if (scope.page + count < 0) {
                scope.page = 0;
            } else if (scope.page + count >= scope.pages.length) {
                scope.page = scope.pages.length - 1;
            } else {
                scope.page = scope.page + count;
                showPage(scope.page);
            }
        }

        function setupTeaserset() {
            scope.teaserset.infotext = false;

            if (scope.teaserset.automaticType === 'recommendation') {
                scope.teaserset.hide = true;
            } else if (scope.teaserset.automaticType === 'recommendation-series') {
                scope.teaserset.hide = true;
            } else if (scope.teaserset.automaticType === 'lastseencontent') {
                scope.teaserset.hide = true;
            } else if (scope.teaserset.automaticType === 'favoriteformats') {
                scope.teaserset.hide = true;
            } else {
                scope.teasers = $filter('filter')(scope.teaserset.teaserSetInformations.items.slice(), filterStations);
            }

        }


        function showPage(page) {
            setLoadingTimeout();
            scope.loading = true;
            scope.imageCount = 0;
            scope.teasers = scope.pages[page];
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('teasersetTopTenMobile', TeaserSetTopTenDirective);

TeaserSetTopTenDirective.$inject = ['$log', '$rootScope', 'StationMonitor', '$filter', '$location', 'Optimizely', 'STAGE', '$timeout'];

function TeaserSetTopTenDirective($log, $rootScope, StationMonitor, $filter, $location, Optimizely, STAGE, $timeout) {


    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/teaser_teaserset_top10_mobile.html',
        link: link
    };

    function link(scope, element) {

        scope.setPage = setPage;
        scope.paginate = paginate;
        scope.gotoFormat = gotoFormat;
        scope.slickSlider = false;
        scope.gecRerenderHelper = false;

        scope.filterStations = filterStations;
        scope.abTest = abTest;

        var allowedStations = StationMonitor.getStationsWithAlias();
        var testId = (STAGE.isProduction) ? 9828424932 : 9833722894;

        scope.$on('ngRepeatFinished', function () {
            scope.slickSlider = $(element).find('.t10-mobile-row');

            scope.slickSlider.on('init', function () {
                scope.gecRerenderHelper = true;
                scope.$apply();

                $timeout(function () {
                    $rootScope.$broadcast("contentUpdated", scope.teaserset, element[0]);
                }, 0);
            });

            scope.slickSlider.slick({
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                swipeToSlide: true
            });
        });


        init();

        function init() {
            scope.teaserset.hide = false;
            scope.page = 0;
            scope.pages = [];
            scope.teasers = [];
            scope.imageCount = 0;
            scope.left = false;
            scope.tableTest = (abTest() === false || abTest() === 'Original') ? false : true;


            $rootScope.globalTeasersetCount += 1;
            scope.teaserset.analyticsTeasersetNo = $rootScope.globalTeasersetCount;

            $log.debug('TEASERSET', scope.teaserset);
            $log.debug('AB Test Top 10', abTest());
            scope.teaserset.infotext = false;

            scope.teaserset.teaserSetInformations.items = $filter('limitTo')(scope.teaserset.teaserSetInformations.items, 10);
            scope.teasers = $filter('filter')(scope.teaserset.teaserSetInformations.items.slice(), filterStations);
        }


        function filterStations(teaser) {
            if (teaser.customTeaserType === "manualteaser") {
                return true;
            }

            var station = "";
            if (teaser.movie && teaser.movie.format && teaser.movie.format.station) {
                station = teaser.movie.format.station;
            } else if (teaser.format && teaser.format.station) {
                station = teaser.format.station;
            } else {
                return false;
            }

            if (allowedStations.indexOf(station) > -1) {
                return true;
            }
            return false;
        }

        function setPage(page) {
            scope.page = page;
            showPage(page);
        }

        function gotoFormat(format) {
            $location.path($filter('geturl')(format, 'isformat'));
        }

        function abTest() {
            if (Optimizely.isActiveExperiment(testId)) {
                return Optimizely.getVariationNames();
            } else {
                return false;
            }
        }

        function paginate(count) {

            if (scope.page + count < 0) {
                scope.page = 0;
            } else if (scope.page + count >= scope.pages.length) {
                scope.page = scope.pages.length - 1;
            } else {
                scope.page = scope.page + count;
                showPage(scope.page);
            }
        }

        function showPage(page) {
            scope.loading = true;
            scope.imageCount = 0;
            scope.teasers = scope.pages[page];
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowTeaser')
    .directive('nowtrafficteaser', nowtrafficteaser);

nowtrafficteaser.$inject = ['$timeout', '$log', '$window'];

function nowtrafficteaser($timeout, $log, $window) {
    var randId = Math.floor((Math.random() * 999999) + 1);
    var promise;

    return {
        restrict: 'E',
        replace: true,
        link: link,
        template: ' <div id="nowOctopus' + randId + '" data-adformat="octopus_mr" data-adextensions="pos=1;nw_pos=1"></div>'
    };

    function link($scope) {
        renderTeaser();

        $scope.$on('resize::jump', function () {
            renderTeaser();
        });

        function renderTeaser() {
            if (promise) {
                $timeout.cancel(promise)
            }

            promise = $timeout(function () {
                $log.debug('Render Trafficteaser ' + 'nowOctopus' + randId);
                if (angular.isDefined($window.$AC)) {
                    $AC.loadUnfilledSlots();
                }
            }, 1500);
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular.module('NowTeaser')
    .service('NowTeaser', NowTeaser);

NowTeaser.$inject = ['NowTracking'];

/**
 *@constructor
 */
function NowTeaser(NowTracking) {
    var teasersets;

    this.setCurrentTeasersets = setCurrentTeasersets;
    this.getCurrentTeasersets = getCurrentTeasersets;
    this.getTeasersetPosition = getTeasersetPosition;
    this.appendToCurrentTeasersets = appendToCurrentTeasersets;

    function setCurrentTeasersets(set) {
        teasersets = set;
        NowTracking.setCurrentTeasersets(set);
    }

    function appendToCurrentTeasersets(teaserset) {
        teasersets.push(teaserset);
        NowTracking.appendToCurrentTeasersets(teaserset);
    }

    function getCurrentTeasersets() {
        return teasersets;
    }

    function getTeasersetPosition(teaserset) {
        if (angular.isArray(teasersets) && teasersets.length > 0) {
            return teasersets.indexOf(teaserset) + 1;
        } else {
            return 0;
        }
    }
}

})();

(function() {



})();

(function() {

angular.module('NowStation', []);

})();

(function() {

'use strict';

angular
    .module('NowStation')
    .directive('nowStationSwitch', nowStationSwitch);


switchController.$inject = ['$scope', 'StationMonitor', '$filter', '$rootScope', 'NowGoogleAnalytics', '$route'];

function switchController($scope, StationMonitor, $filter, $rootScope, NowGoogleAnalytics, $route) {
    var vm = this,
        trackCategory,
        genreShown;

    $scope.$watch('ctrl.availableGenres', function (n, o) {
        if (!angular.equals(n, o)) {
            resetGenre();
        }
        setupGenres();

    });

    var stations = angular.copy(StationMonitor.getStationsWithAlias());
    //Dont show tvnow as station in filter
    if (stations.indexOf('tvnow') > -1) {
        stations.splice(stations.indexOf('tvnow'), 1);
    }


    switch (vm.tracksiteregion) {
        case 'az':
            stations.splice(stations.indexOf('toggoplus'), 1);
            trackCategory = 'sendungen_az';
            break;
        case 'epg':
            stations.splice(stations.indexOf('watchbox'), 1);
            break;
        case 'missed':
            stations.splice(stations.indexOf('watchbox'), 1);
            stations.splice(stations.indexOf('toggoplus'), 1);
            trackCategory = 'sendung_verpasst';
            break;
        default:
            trackCategory = vm.tracksiteregion;
    }

    $scope.$emit('stationswitch:stations', stations);

    vm.refreshScrollbar = refreshScrollbar;
    vm.change = change;
    vm.genreChanged = genreChanged;
    vm.trackGenreShow = trackGenreShow;
    vm.isExpanded = isExpanded;
    vm.stations = stations;
    vm.toggleFree = toggleFree;
    vm.isFree = isFree;

    function toggleFree() {
        $scope.$parent.$parent.isFree = !$scope.$parent.$parent.isFree;
        $scope.$parent.$parent.$apply();
    }

    function isFree() {
        return $scope.$parent.$parent.isFree;
    }


    setupGenres();

    function isExpanded() {

        return vm.stationDropdown;
    }

    function refreshScrollbar() {
        $rootScope.$broadcast('refreshScrollbar');
    }

    function resetGenre() {
        vm.genreSelected = {
            text: 'Alle Genres',
            label: 'Genre',
            value: false
        };
    }

    function setupGenres() {
        if (!vm.genreSelected) {
            resetGenre();
        }

        vm.genreOptions = [{
            text: 'Alle Genres',
            label: 'Genre',
            value: false
        }];

        var genres = [];
        //$filter('orderBy')(vm.availableGenres, '-name')
        for (var key in vm.availableGenres) {
            var genre = vm.availableGenres[key];
            if(genre.uri)
            if ($route.current.params.category && $route.current.params.category === genre.uri) {
                vm.genreSelected = {
                    text: $filter('genretext')(genre.name),
                    label: 'Genre',
                    value: genre.uri
                };
            }
            genres.push({
                text: $filter('genretext')(genre.name),
                label: 'Genre',
                value: genre.uri
            });

        }
        vm.genreOptions = vm.genreOptions.concat($filter('orderBy')(genres, '+text'));
    }

    function change(station) {
        vm.stationDropdown = false;
        //Single Selection
        if (!vm.allowMultiple || station === 'tvnow') {
            vm.selection = [];
        }

        //tvnow cannot be in multiple selection
        if (station !== 'tvnow' && vm.selection.indexOf('tvnow') > -1) {
            vm.selection.splice(vm.selection.indexOf('tvnow'), 1);
        }

        //add station to selection
        if (vm.selection.indexOf(station) === -1) {
            vm.selection.push(station);
            trackStationChange(trackCategory, StationMonitor.getAlias(station), 'on'); //in case of tvnow, the third parameter will be overwritten on purpose
        } else {
            vm.selection.splice(vm.selection.indexOf(station), 1);
            trackStationChange(trackCategory, StationMonitor.getAlias(station), 'off');
        }

        if (vm.cb) {
            vm.cb({
                arg1: vm.selection
            });
        }
    }

    function genreChanged(newGenre) {
        NowGoogleAnalytics.trackEvent(trackCategory, 'genreauswahl', 'genrefilter');
        if (vm.genreCb) {
            vm.genreCb({
                arg1: newGenre
            });
        }
    }

    function trackGenreShow() {
        genreShown = (genreShown) ? false : true;
        if (genreShown) {
            NowGoogleAnalytics.trackEvent(trackCategory, 'aufklappen', 'genrefilter');
        }
    }

    function trackStationChange(category, station, onOff) {
        var action, label;

        if (station === 'tvnow') {
            action = 'tv_now';
            label = 'alle_sender';
        } else {
            action = station + '_' + onOff;
            label = 'sender';
        }

        NowGoogleAnalytics.trackEvent(category, action, label);
    }
}

nowStationSwitch.$inject = ['StationMonitor', '$filter', 'nowResizeService'];
function nowStationSwitch(StationMonitor, $filter, nowResizeService) {
    return {
        scope: {},
        bindToController: {
            showAll: '=',
            allowMultiple: '=',
            selection: '=',
            showGenre: '=',
            genre: '=?',
            availableGenres: '=?',
            genreSelected: '=?',
            cb: '&',
            genreCb: '&',
            tracksiteregion: '@',
            trackGenreShow: '&',
            moreMenuStartPosition: '@',
            moreMenuStartPositions: '=',
            forceDropdown: '@'
        },
        restrict: 'E',
        link: link,
        controller: switchController,
        replace: true,
        controllerAs: 'ctrl',
        templateUrl: 'templates/station_switch.html'
    };




    function link(scope) {

        function isDropdownStation(){
            if(!!(nowResizeService.getSize() == "s") || scope.ctrl.forceDropdown){
                return true;
            }
            return false;
        }

        var startPosition = 6;
        if (scope.ctrl && scope.ctrl.moreMenuStartPosition) {
            startPosition = scope.ctrl.moreMenuStartPosition;
        }
        if (scope.ctrl && scope.ctrl.moreMenuStartPositions) {
            if(angular.isObject(scope.ctrl.moreMenuStartPositions)){
                startPosition = scope.ctrl.moreMenuStartPositions[nowResizeService.getSize()];
            }
        }


        scope.showDropdownStation = isDropdownStation();
        scope.dropdownStationCount = (isDropdownStation()) ? startPosition : 20;

        scope.isExpanded = function () {

            var dropdownStations = $filter('limitTo')(StationMonitor.getStationsWithAlias(), 10, startPosition);
            if (scope.ctrl.stationDropdown || dropdownStations.indexOf(scope.ctrl.selection[0]) > -1) {
                return true;
            } else {
                return false;
            }
        };

        scope.$on('resize::jump', function (obj, size) {

            if (scope.ctrl && scope.ctrl.moreMenuStartPositions) {
                if(angular.isObject(scope.ctrl.moreMenuStartPositions)){
                    startPosition = scope.ctrl.moreMenuStartPositions[size];
                }
            }

            if (scope.ctrl && scope.ctrl.moreMenuStartPosition) {
                startPosition = scope.ctrl.moreMenuStartPosition;
            }


            if (isDropdownStation() || size === "s") {
                scope.showDropdownStation = true;
                scope.dropdownStationCount = startPosition;
            } else {
                scope.showDropdownStation = false;
                scope.ctrl.stationDropdown = false;
                scope.dropdownStationCount = 20;
            }
            scope.$apply();
        });
    }


}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowStation')
    .filter('stationalias', stationalias);

stationalias.$inject = ['StationMonitor'];

function stationalias(StationMonitor) {
    return function (input) {
        return (StationMonitor.getAlias(input));
    };
}

})();

(function() {

'use strict';

angular
    .module('NowStation')
    .filter('nowStationBrand', nowStationBrand);

nowStationBrand.$inject = ['StationMonitor'];

function nowStationBrand(StationMonitor) {
    return function (input) {
        return (StationMonitor.getStationName(input));
    };
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowStation')
    .factory('StationMonitor', StationMonitor);

StationMonitor.$inject = ['$route', 'AppConfig', 'STAGE'];

function StationMonitor($route, AppConfig, STAGE) {
    var stations = AppConfig.stationsOrdered,
        aliases = {
            //rtlnitro: 'nitro',
            //nitro: 'rtlnitro'
        },
        translateRoute = {
            //nitro: 'rtlnitro',
            srtl: 'superrtl'
        },
        aliasesEpg = {
            superrtl: 'srtl'
        },
        stationNames = {
            'rtl': 'RTL',
            'vox': 'VOX',
            'rtl2': 'RTL II',
            'superrtl': 'SUPER RTL',
            'nitro': 'NITRO',
            'ntv': 'n-tv',
            'rtlplus': 'RTLplus',
            'toggoplus': 'TOGGO plus',
            'nowus': 'NOW US',
            'tvnow': 'TV NOW'
        };

    if (AppConfig.settings.nowtv[STAGE.stage].stations) {
        stationNames = AppConfig.settings.nowtv[STAGE.stage].stations.aliases;
    }

    return {
        'getStation': getStation,
        'getEpgStation': getEpgStation,
        'getAlias': getAlias,
        'getRouteStation': getRouteStation,
        'getStationName': getStationName,
        'getStationsOrdered': getStationsOrdered,
        'getStationsWithAlias': getStationsWithAlias
    };

    function getAlias(station) {
        if (aliases[station]) {
            return aliases[station];
        } else {
            return station;
        }
    }

    function getRouteStation(station) {
        if (translateRoute[station]) {
            return translateRoute[station];
        } else {
            return station;
        }
    }

    function getStation(dontusealias) {
        //console.log('getStation', $route.current);

        if ($route.current && $route.current.params.station && (stations.indexOf($route.current.params.station) >= 0 || aliases[$route.current.params.station])) {
            if (!dontusealias && aliases[$route.current.params.station]) {
                return aliases[$route.current.params.station];
            } else {
                return $route.current.params.station;
            }
        } else {
            return 'nowtv';
        }
    }

    function getEpgStation(dontusealias) {
        var epgstation = getStation(dontusealias);
        if (epgstation === 'superrtl') epgstation = aliasesEpg[epgstation];

        return epgstation;
    }

    function getStationName(station) {
        return stationNames[station];
    }

    function getStationsOrdered() {
        return stations;
    }

    function getStationsWithAlias() {
        return stations.map(function (station) {
            return getAlias(station);
        });
    }
}

})();

(function() {



})();

(function() {

angular.module('NowHeader', ['NowTracking']);

})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .directive('nowBurgerIcon', nowBurgerIcon);

nowBurgerIcon.$inject = ['BurgerMenu'];

function nowBurgerIcon(BurgerMenu) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/burger_icon.html',
        link: link
    };

    function link(scope) {
        scope.expanded = false;

        scope.$watch(function () {
            return BurgerMenu.isExpanded();
        }, function () {
            scope.expanded = BurgerMenu.isExpanded();
        });

        scope.$watch('expanded', function (expanded) {
            BurgerMenu.setExpanded(expanded);
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .directive('nowBurgerMenu', nowBurgerMenu);

nowBurgerMenu.$inject = ['BurgerMenu', '$location', 'AppConfig', 'NowGoogleAnalytics', '$window','$log','$timeout'];

function nowBurgerMenu(BurgerMenu, $location, AppConfig, NowGoogleAnalytics, $window,$log,$timeout) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/burger_menu.html',
        link: link
    };

    function link(scope) {

        scope.ffc = AppConfig.ffc;
        scope.isActive = isActive;
        scope.trackClick = trackClick;

        scope.$watch(function () {
            return BurgerMenu.isExpanded();
        }, function () {
            scope.expanded = BurgerMenu.isExpanded();
        });

        scope.$watch('expanded', function (expanded) {
            BurgerMenu.setExpanded(expanded);
        });

        function trackClick(label) {
            NowGoogleAnalytics.trackEvent('navigation', 'link', label);
        }
        $window.addEventListener('message', tagCommanderEvent, false);

        function isActive(url, param) {

            if (url === '/' && $location.path() === '/') {
                return true;
            } else if (url && url !== '/' && $location.path().indexOf(url) > -1) {
                return true;
            }

            return (param && $location.search()[param]);
        }

        function tagCommanderEvent(event) {
            if(event.origin.indexOf('tagcommander')>-1){
                if(event.data.indexOf('setCat')>-1){
                    $log.debug('TagCommander Event', event);
                    $timeout(function () {
                        $window.location.reload();
                    },500);
                }
            }
        }

    }
}

})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .directive('nowHeader', header);

header.$inject = ['$rootScope', 'NowTagCommander'];

function header($rootScope, NowTagCommander) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            movie: '='
        },
        templateUrl: 'templates/header.html',
        link: link
    };

    function link(scope) {
        NowTagCommander.initCommander();
        scope.isTabletHome = (bowser.tablet && !bowser.msie) ? true : false;

        var routeCHangeSuccess = $rootScope.$on('$routeChangeSuccess', onRouteChangeSuccess);
        function onRouteChangeSuccess(event, current) {
            if (current.$$route.data && current.$$route.data.pagetype) {
                if (current.$$route.data.headerCls) {
                    scope.cls = current.$$route.data.headerCls;
                } else {
                    scope.cls = current.$$route.data.pagetype;
                }

            }
        }
        $rootScope.$on('$destroy',routeCHangeSuccess);
    }
}


})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .directive('nowHeaderIconnavigation', nowHeaderIconnavigation);

nowHeaderIconnavigation.$inject = ['$window'];

function nowHeaderIconnavigation($window) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/header_iconnavi.html',
        link: link
    };

    function link($scope) {
        $('.navi-search-button').on('click', function () {
            $('.now-header').addClass('show-search');
        });

        angular.element($window).on('scroll', scroll);

        $scope.$on('$destroy', function () {
            angular.element($window).off('scroll', scroll);
        });

        function scroll() {
            var scrollPos = $(window).scrollTop();
            if (scrollPos > 80) {
                $('.now-header').addClass('now-header-small');
            } else {
                $('.now-header').removeClass('now-header-small');
                $('.show-search').removeClass('show-search');
            }
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .directive('nowstationnavigation', nowstationnavigation);

nowstationnavigation.$inject = ['$rootScope', '$translate', 'LastRoute', 'NowGoogleAnalytics'];

function nowstationnavigation($rootScope, $translate, LastRoute, NowGoogleAnalytics) {
    var currentLayout = 'nowtv';


    function changeToCSS(station) {
        if (currentLayout !== station) {
            $('body').removeClass(currentLayout).addClass(station);
            currentLayout = station;
        }
        $rootScope.$broadcast('site::changedstation', station);
        $translate.use(station);
        return station;
    }

    function checkCSSRoute() {
        return changeToCSS('tvnow');
    }

    function link($scope) {
        $scope.trackEvent = function (action, label) {
            NowGoogleAnalytics.trackEvent('senderleiste', action, label);
        };
    }

    controller.$inject = [];
    function controller() {
        var routeCHangeSuccess = $rootScope.$on('$routeChangeStart', function () {
            if (LastRoute.getLastRoute() && LastRoute.getLastRoute().data && LastRoute.getLastRoute().data.pagetype === 'player') {
                checkCSSRoute();
            }
        });

        $rootScope.$on('$destroy',routeCHangeSuccess);
    }

    return {
        restrict: 'E',
        link: link,
        controller: controller,
        replace: true,
        templateUrl: 'templates/header_stations.html'
    };

}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .service('BurgerMenu', BurgerMenu);

BurgerMenu.$inject = [

];

/**
 *@constructor
 */
function BurgerMenu() {
    var self = this,
        expanded = false;
    self.setExpanded = function (newState) {
        expanded = newState;
    }
    self.isExpanded = function () {
        return expanded;
    }
}

})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .service('NowMobileNav', NowMobileNav);

/**
 *@constructor
 */
function NowMobileNav() {
    var show = true;
    self.isVisible = function () {
        return show;
    }
    self.show = function () {
        show = true;
    }
    self.hide = function () {
        show = false;
    }
    return self;
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowHeader')
    .controller('NowHeaderController', NowHeaderController);

NowHeaderController.$inject = ['$scope', '$location', 'StationMonitor', '$rootScope', '$window', 'NowTracking', 'NowMobileNav', 'NowGoogleAnalytics', 'Accounting', 'AppConfig', '$log'];

function NowHeaderController($scope, $location, StationMonitor, $rootScope, $window, NowTracking, NowMobileNav, NowGoogleAnalytics, Accounting, AppConfig, $log) {
    // NOW TRACKING HAS TO BE INJECTED AND PROVIDED AS A PARAMETER.
    // Otherwise, tracking would be disabled

    var vm = $scope;
    vm.station = StationMonitor.getStation();

    var stations = StationMonitor.getStationsWithAlias();
    stations.splice(stations.indexOf('tvnow'), 1);
    //stations.splice(stations.indexOf('toggoplus'), 1);

    vm.stations = stations;
    vm.shownav = true;
    vm.showMoreMobile = false;

    vm.goHome = goHome;
    vm.goPage = goPage;
    vm.showRegistration = showRegistration;
    vm.isActive = isActive;
    vm.showMoreMobileStations = showMoreMobileStations;

    $scope.$watch(function () {
        return NowMobileNav.isVisible();
    }, function (visible) {
        vm.shownav = visible;
    });

    $log.debug('windowservice',$window);

    $scope.$watch(function () {
        return $location.path();
    }, function (path) {
        if (path.indexOf('az') > 0 || path.indexOf('/jahr/') > 0 || path.indexOf('/list/') > 0 || path.indexOf('search') > 0) {
            NowMobileNav.hide();
        } else {
            NowMobileNav.show();
        }
    });

    var routeCHangeSuccess = $rootScope.$on('$routeChangeSuccess', function () {

        vm.station = StationMonitor.getStation();
        vm.showMoreMobile = false;
    });

    $rootScope.$on('$destroy',routeCHangeSuccess);

    function goHome() {
        $location.search({}, null);
        $location.path('/');
    }

    function showMoreMobileStations() {
        vm.showMoreMobile = !vm.showMoreMobile;
    }

    function showRegistration() {
        if (AppConfig.webclient === 'mobile') {
            NowGoogleAnalytics.trackEvent('header_button','registrierung','registrieren');
            $window.open(AppConfig.ffc + '/', '_blank');
        } else {
            $window.location.href = AppConfig.ffc + '/';
        }

    }

    function goPage(path, blank, nostation) {
        $location.search('az', null);
        $location.search('account', null);
        $location.search('newsletter', null);
        $location.search('emailverify', null);
        $location.search('contactsettings', null);
        $location.search('login', null);
        $location.search('registration', null);
        $location.search('stations', null);
        if (path.indexOf('hilfe.tvnow.de') > -1) {
            NowGoogleAnalytics.trackEvent('navigation', 'link', 'hilfe_kontakt');
        } else {
            NowGoogleAnalytics.trackEvent('navigation', 'link', path.substr(1));
        }
        if (blank) {
            $log.debug('path blank');
            $window.open(path, '_blank');
        } else {

            if (nostation) {
                if (Accounting.isLoggedIn() === false && bowser.tablet === true && path === '/meine-merkliste') {
                    $location.search('premium', 'merkliste');
                }else if(AppConfig.webclient === 'mobile' && path === 'toggoplus'){
                    $window.open(AppConfig.ffc+'?premium=livetv', '_blank');
                }
                else {
                    $location.path(path);
                }

            } else {
                if (Accounting.isLoggedIn() === false && bowser.tablet === true && path === '/live-tv') {
                    $location.search('premium', 'livetv');
                } else {

                    $location.path('/' + StationMonitor.getStation(true) + path);
                }

            }

        }
    }

    function isActive(url, param) {
        if (url && $location.path().indexOf(url) > -1) {
            return true;
        }

        return (param && $location.search()[param]);
    }
}


})();

(function() {






})();

(function() {



})();

(function() {

angular.module('NowFooter', ['ngCookies']);

})();

(function() {

'use strict';

angular
    .module('NowFooter')
    .component('nowfooter', {
        bindings:{},
        controllerAs: 'vm',
        controller: footerController,
        templateUrl: 'templates/footer.html'

    });

footerController.$inject = ['$scope','$localStorage', 'AppConfig', 'NowGoogleAnalytics', '$rootScope', '$sessionStorage', '$location', 'nowlog', 'STAGE', '$window', '$log', 'PlayerHelperService', '$cookies'];

function footerController($scope, $localStorage, AppConfig, NowGoogleAnalytics, $rootScope, $sessionStorage, $location, nowlog, STAGE, $window, $log, PlayerHelperService, $cookies) {
    var vm = this;
    vm.disableVideo = $localStorage.disableVideo;
    vm.version = (STAGE.stage !== 'production') ? 'testing' : AppConfig.clientversion;
    vm.showVersion = false;
    vm.debugMode = false;
    vm.isTabletFooter = (bowser.tablet && !bowser.msie) ? true : false;
    vm.logs = [];
    vm.showFooter = true;
    var logs = [];
    vm.browserSupport = {
        desktop: {
            chrome: {
                minVersion: 30,
                minVersionDRM: 35
            },
            firefox: {
                minVersion: 42,
                minVersionDRM: 53
            },
            msie: {
                minVersion: 11,
                minVersionDRM: 11,
                minPlatforms: [
                    {name: "Windows", minVersion: '8'}
                ],
                minPlatformsDRM: [
                    {name: "Windows", minVersion: '8.1'}
                ]
            },
            msedge: {
                minVersion: 14,
                minVersionDRM: 14
            },
            safari: {
                minVersion: 8,
                minVersionDRM: 9,
                minPlatforms: [
                    {name: "OS X", minVersion: '10.9'},
                    {name: "macOS", minVersion: '10.9'}
                ],
                minPlatformsDRM: [
                    {name: "OS X", minVersion: '10.11'},
                    {name: "macOS", minVersion: '10.11'}
                ]
            }
        },
        mobile: {
            chrome: {
                minVersion: 30,
                minVersionDRM: 35,
                minPlatforms: [
                    {name: "Android", minVersion: '4.3'}
                ],
                minPlatformsDRM: [
                    {name: "Android", minVersion: '4.4'}
                ],
            },
            firefox: {
                minVersion: 42,
                minVersionDRM: 99,
            },
            msie: {
                minVersion: 11,
                minVersionDRM: 11,
                minPlatforms: [
                    {name: "Windows", minVersion: '8',}
                ],
                minPlatformsDRM: [
                    {name: "Windows", minVersion: '8.1',}
                ],
            },
            msedge: {
                minVersion: 14,
                minVersionDRM: 14,
            },
            safari: {
                minVersion: 9,
                minVersionDRM: 11,
                minPlatforms: [
                    {name: "ios", minVersion: '11.2'}
                ],
            },
            samsungBrowser: {
                minVersion: 5,
                minVersionDRM: 99,
                minPlatforms: [
                    {name: "Android", minVersion: '5.0'}
                ],
            },
            android: {
                minVersion: 5,
                minVersionDRM: 99,
                minPlatforms: [
                    {name: "Android", minVersion: '5.0'}
                ]
            }
        }
    };

    vm.browserSupportBar = false;
    vm.barClosed = false;

    vm.privacyDetectionBar = false;
    vm.privacyBarClosed = false;

    $rootScope.isTablet = (bowser.tablet && !bowser.msie) ? true : false;

    $scope.$watch(function () {
            return $location.path();
        }, function (path) {
            if (path.indexOf('search') > 0) {

                vm.showFooter = false;
            } else {
                vm.showFooter = true;
            }
            $log.debug("path", path);
        });

    $scope.$watch(function () {
        return vm.browserSupportBar;
    }, function (oldValue, newValue) {
        if (vm.browserSupportBar === false && vm.barClosed === false){
            vm.checkBrowserSupport();
        }
    });

    $scope.$watch(function () {
        return vm.privacyDetectionBar;
    }, function (oldValue, newValue) {
        if (vm.privacyDetectionBar === false && vm.privacyBarClosed === false){
            vm.checkPrivacyDetection();
        }
    });

    $scope.$watch(function () {
            return nowlog.getLastLog();
        }, function (log) {
            if (log) {
                logs.unshift(log);
                logs = logs.splice(0, 15);
                vm.logs = logs;
            }
        });

        var clickCount = 0;

        if ($localStorage.debugMode) {
            vm.debugMode = true;
        }

        if ($localStorage.debugModeExpanded) {
            vm.expand = true;
        }

    $scope.$watch('vm.expand', function (expand) {
            $localStorage.debugModeExpanded = expand;
        });


    vm.logout = function() {
        $rootScope.$broadcast('account::doLogout', function () {
        });
    };

    vm.trackEvent = function(linktext) {
        NowGoogleAnalytics.trackEvent('footer', 'link', linktext);
        tc_events_21(this,"event_footer_link",{
            linktext: linktext
        });
    };

    vm.clearStorage = function() {
        $localStorage.$reset();
        $sessionStorage.$reset();
        $rootScope.$broadcast('account::doLogout', function () {
        });
        $location.path('/');

    };

    vm.toggleVideo = function() {
        $localStorage.disableVideo = !$localStorage.disableVideo;
        vm.disableVideo = $localStorage.disableVideo;

        vm.trackEvent(vm.disableVideo ? 'vorschau_deaktivieren' : 'vorschau_aktivieren');
    };


    vm.clickVersion = function() {
        if (++clickCount > 3) {
            vm.showVersion = true;
        }
        if (++clickCount > 5) {
            $localStorage.debugMode = true;
            vm.debugMode = true;
            clickCount = 0;
        }
    };

    vm.trackBrowserDetection = function(action ) {
        NowGoogleAnalytics.trackEvent('browser_hinweis', action);
    };

    vm.trackPrivacyDetection = function(action ) {
        NowGoogleAnalytics.trackEvent('do_not_track', action);
    };

    vm.closeBar = function () {
        if(vm.browserSupportBar === true && vm.barClosed === false){
            vm.barClosed = true;
            vm.browserSupportBar = false;
            vm.trackBrowserDetection('schliessen');
        }
    };

    vm.closePrivacyBar = function () {
        if (vm.privacyDetectionBar === true && vm.privacyBarClosed === false){
            vm.privacyBarClosed = true;
            vm.privacyDetectionBar = false;
            vm.setPrivacyDetectionCookie(true);
        }
    };

    vm.checkBrowserSupport = function() {
        if(!bowser.tablet && AppConfig.webclient !== 'mobile'){
            if(bowser.chrome && bowser.version < vm.browserSupport.desktop.chrome.minVersionDRM){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.safari && bowser.version < vm.browserSupport.desktop.safari.minVersionDRM){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.firefox && bowser.version < vm.browserSupport.desktop.firefox.minVersionDRM){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.msie && bowser.version < vm.browserSupport.desktop.msie.minVersionDRM) {
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.msedge && bowser.version < vm.browserSupport.desktop.msedge.minVersionDRM){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            }
        } else {
            if(bowser.chrome && bowser.version < vm.browserSupport.mobile.chrome.minVersion){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.safari && bowser.version < vm.browserSupport.mobile.safari.minVersion){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.firefox && bowser.version < vm.browserSupport.mobile.firefox.minVersion){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.msie && bowser.version < vm.browserSupport.mobile.msie.minVersion) {
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.msedge && bowser.version < vm.browserSupport.mobile.msedge.minVersion){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.samsungBrowser && bowser.version < vm.browserSupport.mobile.samsungBrowser.minVersion){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            } else if(bowser.android && bowser.version < vm.browserSupport.mobile.android.minVersion){
                vm.browserSupportBar = true;
                vm.trackBrowserDetection('anzeigen');
            }
        }
    };

    vm.checkPrivacyDetection = function() {
        var privacyDetectionOptout = $cookies.get('privacy-detection-optout');
        var doNoTrack = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;

        if ((doNoTrack === '1' || doNoTrack === 'yes' ) && (angular.isUndefined(privacyDetectionOptout) === true || privacyDetectionOptout === 'false')) {
            vm.privacyDetectionBar = true;
            vm.trackPrivacyDetection('hinweis_angezeigt');
        }
    };

    vm.setPrivacyDetectionCookie = function (val) {
        var cookieLifetime = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
        return $cookies.put('privacy-detection-optout', val, {domain:".tvnow.de", expires: cookieLifetime, secure: false, path: '/'});
    };
}


})();

(function() {



})();

(function() {

angular.module('NowEpg', []);

})();

(function() {

'use strict';

angular
    .module('NowEpg')
    .directive('epgtoolbar', epgtoolbar);

epgtoolbar.$inject = ['moment', '$filter', '$location', '$route', '$log'];

function epgtoolbar(moment, $filter, $location, $route, $log) {
    controller.$inject = ['$scope'];

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/epg_toolbar.html',
        link: link,
        controller: controller
    };

    function link($scope) {
        var vm = $scope,
            slickInit = false,
            days = [],
            trackingInitialIgnoreStatus = true,
            name,
            dayOptions = [];
        vm.dayOptions = [];
        vm.startpositions = {s:6,m:7,l:7};

        $scope.selected = 0;
        $scope.station = $route.current.params.station;

        $scope.goToDay = goToDay;

        initWatchers();
        setupMonths();

        function goToDay(day, $index) {
            $log.debug('goToDay', day, $index, day.name.indexOf('.'));

            $scope.selected = $index;
            if (slickInit) {
                $('.now-toolbar-epg .buttons').slick('slickGoTo', $index);
            }
            $scope.$broadcast('epg::dayChanged', day);

            if (day.name.indexOf('.') < 0) {
                //gestern, heute, morgen - ignore first event, because it's always 'today'
                if (!trackingInitialIgnoreStatus) {
                    $scope.trackEvent(day.name.toLowerCase(), 'datum');
                }
            } else {
                $scope.trackEvent((day.pastOrFuture === 'past') ? 'datum_vergangenheit' : 'datum_zukunft', 'datum');
            }

            trackingInitialIgnoreStatus = false;
        }

        function setupMonths() {
            for (var i = -7; i < 1; i++) {
                var date = moment().subtract(i, 'days');
                if (i === -1) {
                     name = 'Morgen';
                } else if (i === 0) {
                     name = 'Heute';
                } else if (i === 1) {
                    name = 'Gestern';
                } else {
                    name = date.format('dd. DD.MM.');
                }

                days.unshift({
                        name: name,
                        pastOrFuture: (i > 0) ? 'past' : ((i < 0) ? 'future' : undefined),
                        nameshort: date.format('DD.MM.'),
                        date: date.format('YYYY-MM-DD')
                    }
                );

                dayOptions.push({
                    text: name,
                    label: name,
                    pastOrFuture: (i > 0) ? 'past' : ((i < 0) ? 'future' : undefined),
                    name: date.format('DD.MM.'),
                    value: date.format('YYYY-MM-DD'),
                    date: date.format('YYYY-MM-DD')
                });
            }

            if (!vm.daySelected) {
                vm.daySelected = {
                    text: name,
                    label: name,
                    pastOrFuture: (i > 0) ? 'past' : ((i < 0) ? 'future' : undefined),
                    name: date.format('DD.MM.'),
                    value: date.format('YYYY-MM-DD'),
                    date: date.format('YYYY-MM-DD')
                };
            }

            $scope.days = days;
            $scope.dayOptions = dayOptions.reverse();
        }

        function initWatchers() {
            $scope.$on('resize::jump', function (object, size) {
                var slidesToShow = (size === 'l') ? 7 : ((size === 'm') ? 5 : 4);
                $('.now-toolbar-epg .buttons').slick('slickSetOption', 'slidesToShow', slidesToShow, true);
            });

            $scope.$on('ngRepeatFinished', function () {
                $scope.selected = 0;
                $scope.goToDay(days[$scope.selected], $scope.selected);
            });
        }
    }

    function controller($scope) {
        $scope.selectedStation = function (station) {
            $location.path('/' + $filter('stationalias')(station) + '/tv-programm');
        };
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowEpg')
    .component('epgrow', {
        bindings:{
            entry: '='
        },
        controllerAs: 'vm',
        controller: epgrowController,
        templateUrl: 'templates/epg_row.html'

    });



epgrowController.$inject = ['$location', 'StationMonitor', '$log', '$filter','NowGoogleAnalytics'];

function epgrowController($location, StationMonitor, $log, $filter, NowGoogleAnalytics) {
    var vm = this;
    vm.station = StationMonitor.getStation();
    vm.stationEpgAlias = StationMonitor.getEpgStation(1);

    vm.trackEvent = trackEvent;
    vm.trackMoviePlay = trackMoviePlay;
    vm.trackLivePlay = trackLivePlay;
    vm.gotoEntry = gotoEntry;

    //init() function removed, see rev. 4876 in branch everest

    function trackEvent(action, value) {
        NowGoogleAnalytics.trackEvent('epg',action, value);
    }

    function trackMoviePlay(movie) {
        $log.debug('vm.trackMoviePlay is called', movie);
        if ($filter('geturl')(movie, 'appendpayment').match(/\?premium/)) {
            vm.trackEvent('premium_overlay', 'format');
        } else {
            vm.trackEvent('play', 'format');
        }
    }

    function trackLivePlay() {
        vm.trackEvent('play', 'live_tv');
    }

    function gotoEntry(entry) {
        if (entry.current) {
            var url = '/' + $filter('stationalias')(StationMonitor.getStation()) + '/live-tv?autostart';
            $location.url(url);
        } else if (entry.movie) {
            trackMoviePlay(entry.movie);
            url = $filter('geturl')(entry.movie, 'appendpayment');
            $location.url(url);
        }
    }

}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowEpg')
    .controller('NowEpgController', NowEpgController);

NowEpgController.$inject = ['$scope', 'StationMonitor', 'NowApi', 'BreadcrumbHelper', 'moment', '$rootScope', '$location', 'NowGoogleAnalytics', '$route', 'page', '$filter', 'Metadata','$log','NowTagCommander'];

function NowEpgController($scope, StationMonitor, NowApi, BreadcrumbHelper, moment, $rootScope, $location, NowGoogleAnalytics, $route, page, $filter, Metadata, $log,NowTagCommander) {
    var vm = $scope,
        currentDay = false;

    vm.newpage = page === false;
    vm.page = (page === false) ? {} : page;
    vm.teasersets = (page.teaserSets && page.teaserSets.items.length > 0) ? page.teaserSets.items : [];

    vm.loading = true;
    vm.station = $route.current.params.station;
    vm.selectedStations = [StationMonitor.getStation()];
    vm.genreSelected = ''; //Though nowStationSwitch-directive does not display a genre, two-way binding needs this var to be initialized

    vm.trackEvent = trackEvent;
    vm.setMeta = setMeta;

    BreadcrumbHelper.setItems(
        {
            'title': 'TV Programm',
            'url': 'tv-programm'
        }
    );

    initWatchers();
    init();

    function init() {
        setMeta(StationMonitor.getStationName(StationMonitor.getStation()));
        NowTagCommander.addToDatalayer("env_template", 'epg');
    }

    function initWatchers() {
        var routeChangeSuccess = $rootScope.$on('$routeChangeSuccess', function () {
            if ($location.path().indexOf('/tv-programm') > 0 && currentDay) {
                $scope.$broadcast('epg::dayChanged', currentDay);
                //console.log('RELOAD EPG:');
                //console.log(StationMonitor.getStation());
            }
        });

        $rootScope.$on('$destroy',routeChangeSuccess)

        $scope.$on('epg::dayChanged', function (event, day) {
            currentDay = day;
            vm.loading = true;
            NowApi.getEpgs().retrieveMoviesByDate({
                'fields': '*,movie.*,movie.format,movie.paymentPaytypes,movie.pictures,movie.packages,movie.trailers,epgImages,epgImages.*,epgFormat,epgFormat.format',
                'station': StationMonitor.getStation(),
                'date': day.date
            }).then(function (data) {
                for (var i = 0; i < data.items.length; i++) {
                    if (i + 1 < data.items.length && moment().isBetween(data.items[i].startDate, data.items[i + 1].startDate)) {
                        data.items[i].current = true;
                    } else if (i === data.items.length && moment().isAfter(data.items[i].startDate)) {
                        data.items[i].current = true;
                    }
                }
                vm.movies = data;
                vm.loading = false;
            }, function (data) {
                vm.loading = false;
                vm.movies = {
                    items: []
                }
                $log.debug('data',data);
            });
        });
    }

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('epg', action, label);
    }

    function setMeta(stationName) {
        if (!stationName || stationName === 'tvnow') {
            Metadata.setTitleAndMeta(
                'Das Fernsehprogramm von RTL, VOX, RTL2, RTL-Nitro, Super-RTL, n-tv, RTLplus und TOGGO plus online als Stream abrufen',
                'Was läuft heute im Fernsehprogramm? Hier findest du übersichtlich, was heute auf RTL, VOX, RTL2, RTL-Nitro, Super-RTL, n-tv, RTLplus und TOGGO plus läuft'
            );

            return;
        }

        Metadata.setTitleAndMeta(
            'Das Fernsehprogramm von ' + stationName + ' online als Stream abrufen',
            'Was läuft heute im Fernsehprogramm? Hier findest du übersichtlich, was heute auf ' + stationName + ' läuft.'
        );
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowEpg')
    .config(routing);
routing.$inject = ['$routeProvider'];
function routing($routeProvider) {
    $routeProvider
        .when('/:station/tv-programm', {
                controller: 'NowEpgController',
                controllerAs: 'vm',
                templateUrl: 'templates/epg_view.html',
                reloadOnSearch: false,
                data: {
                    pagetype: 'static'
                },
                resolve: {
                    page: resolvePage
                }
            }
        );
    resolvePage.$inject = ['$route', 'NowApi', 'StationMonitor', '$location'];
    function resolvePage($route, NowApi, StationMonitor, $location) {
        // GET PAGE
        var path = $route.current.params.station,
            station;
        if (StationMonitor.getStationsOrdered().indexOf(path) === -1 || path === "tvnow") {
            station = 'nowtv';
            $location.path('/rtl/tv-programm');
            $location.replace();
            return true;
        } else {
            station = StationMonitor.getStation();
        }
        path = 'tv-programm';

        return NowApi.getPage().retrievePagesByStationAndPath({
            station: station,
            pagepath: path,
            fields: ['*',
                'teaserSets.*',
                'teaserSets.teaserSetInformations.*',
                'teaserSets.teaserSetInformations.custom.*',
                'teaserSets.teaserSetInformations.custom.page.*,',
                'teaserSets.teaserSetInformations.custom.format.*,',
                'teaserSets.teaserSetInformations.custom.movie.*,',
                'teaserSets.teaserSetInformations.movie.*',
                'teaserSets.teaserSetInformations.movie.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.format.*',
                'teaserSets.teaserSetInformations.format.*',
                'teaserSets.teaserSetInformations.format.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.pictures',
                'teaserSets.teaserSetInformations.movie.packages'
            ].join(',')
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }
}


})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowMissed', []);

})();

(function() {

'use strict';

angular
    .module('NowMissed')
    .directive('nowMissedToolbar', nowMissedToolbar);

nowMissedToolbar.$inject = ['moment', '$route', '$log', '$location', '$window'];

function nowMissedToolbar(moment, $route, $log, $location, $window) {
    controller.$inject = ['$scope'];
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/missed_toolbar.html',
        link: link,
        controller: controller
    };

    function link($scope) {
        var vm = $scope;

        var days = [],
            dayOptions = [];

        $scope.selected = 0;
        $scope.station = $route.current.params.station;

        vm.dayOptions = [];

        vm.gotoTime = gotoTime;
        $scope.goToDay = goToDay;

        setupMonths();

        function gotoTime(elementId) {
            $scope.trackTimeClick();

            var element = $('#' + elementId);

            if (!element) {
                return;
            }

            var pos = element.offset(),
                top = pos.top;

            if ($('.now-header-small').length > 0) {
                top = top - 200;
            } else {
                top = top - 315;
            }

            if (top < 100) {
                top = 0;
            }
            $window.scrollTo(0, top);
        }

        function setupMonths() {
            for (var i = -7; i < 1; i++) {
                var date = moment().add(i, 'days'),
                    trackDatename,
                    name;

                if (i === -1) {
                    name = 'Gestern';
                    trackDatename = 'vergangenheit';
                } else if (i === 0) {
                    name = 'Heute';
                    trackDatename = 'heute';
                } else {
                    name = date.format('dd. DD.MM.');
                    trackDatename = (i > 0) ? 'zukunft' : 'vergangenheit';
                }

                days.unshift({
                        name: name,
                        pastOrFuture: (i < 0) ? 'past' : ((i > 0) ? 'future' : undefined),
                        nameshort: date.format('DD.MM.'),
                        date: date.format('YYYY-MM-DD'),
                        trackDatename: trackDatename
                    }
                );

                dayOptions.push({
                    text: name,
                    label: name,
                    pastOrFuture: (i < 0) ? 'past' : ((i > 0) ? 'future' : undefined),
                    name: date.format('DD.MM.'),
                    value: date.format('YYYY-MM-DD'),
                    date: date.format('YYYY-MM-DD'),
                    trackDatename: trackDatename
                });
            }

            if (!vm.daySelected) {
                vm.daySelected = {
                    text: name,
                    label: name,
                    pastOrFuture: (i < 0) ? 'past' : ((i > 0) ? 'future' : undefined),
                    name: date.format('DD.MM.'),
                    value: date.format('YYYY-MM-DD'),
                    date: date.format('YYYY-MM-DD'),
                    trackDatename: trackDatename
                };
            }

            $scope.days = days;
            $scope.dayOptions = dayOptions.reverse();
        }

        function goToDay(day, $index) {
            //console.log(day);
            $scope.selected = $index;
            $scope.$broadcast('missed::missedDayChanged', day);

            if (day.name.indexOf('.') < 0) {
                //gestern, heute, morgen - ignore first event, because it's always 'today'
                $scope.trackEvent(day.name.toLowerCase(), 'datum');
            } else {
                $scope.trackEvent('datum_' + day.trackDatename, 'datum');
            }
        }
    }


    function controller($scope) {
        $scope.selectedStation = selectedStation;

        function selectedStation(stations) {
            $log.debug('directive_toolbar selectedStation()', stations, $scope);

            if (stations.length === 1) {
                $scope.setMeta(stations[0]);
                $location.path('/sendung-verpasst/' + stations[0], true);
                $location.search('stations', null);
            } else {
                $scope.setMeta();
                $location.path('/sendung-verpasst', true);
                if (stations.length > 1) {
                    $location.search('stations', stations.join(','));
                } else {
                    $location.search('stations', null);
                }
            }
        }
    }
}

})();

(function() {



})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMissed')
    .controller('NowMissedController', NowMissedController);

NowMissedController.$inject = ['$scope', 'NowApi', 'BreadcrumbHelper', 'moment', '$rootScope', '$location', 'NowGoogleAnalytics', 'page', 'Metadata', '$routeParams', 'StationMonitor','NowTagCommander'];

function NowMissedController($scope, NowApi, BreadcrumbHelper, moment, $rootScope, $location, NowGoogleAnalytics, page, Metadata, $routeParams, StationMonitor,NowTagCommander) {
    var date = new moment();
    var vm = $scope,
        trackDropdownOpen,
        currentDay = {
            name: 'Heute',
            pastOrFuture: undefined,
            nameshort: date.format('DD.MM.'),
            date: date.format('YYYY-MM-DD')
        };

    vm.newpage = page === false;
    vm.page = (page === false) ? {} : page;
    vm.teasersets = (page.teaserSets && page.teaserSets.items.length > 0) ? page.teaserSets.items : [];
    vm.genreSelected = ''; //Though nowStationSwitch-directive does not display a genre, two-way binding needs this var to be initialized
    vm.stations = StationMonitor.getStationsOrdered();

    vm.loading = true;

    vm.trackTimeClick = trackTimeClick;
    vm.trackDropdownClick = trackDropdownClick;
    vm.trackEvent = trackEvent;

    vm.teaserFilter = teaserFilter;
    vm.fetchMovies = fetchMovies;
    vm.showAllStations = showAllStations;
    vm.setMeta = setMeta;


    init();
    initWatchers();

    function init() {
        if ($routeParams.station) {
            vm.selectedStations = [$routeParams.station];
        } else {
            if ($location.search()['stations']) {
                vm.selectedStations = $location.search()['stations'].split(',');
            } else {
                vm.selectedStations = ['tvnow'];
            }
        }


        vm.fetchMovies(moment().format('YYYY-MM-DD'));

        BreadcrumbHelper.setItems(
            {
                'title': 'Sendung verpasst?',
                'url': 'sendung-verpasst'
            },
            true
        );
        NowTagCommander.addToDatalayer("env_template", 'missed');

        setMeta($routeParams.station);
    }

    function teaserFilter(teaser) {

        if (vm.stations && vm.stations.indexOf(teaser.station) === -1) {
            return false;
        }

        return (vm.selectedStations.length === 0 || (vm.selectedStations.indexOf(teaser.station) > -1 || vm.selectedStations.indexOf('tvnow') > -1 ));
    }

    function fetchMovies(day) {
        vm.loading = true;
        if (day.value) {
            day = day.value;
        }
        var moviegroups = [
            {
                title: 'Nachts',
                start: moment(day + ' 00:00'),
                end: moment(day + ' 06:00'),
                items: [],
                linkText: 'Ab 00 Uhr'
            },
            {
                title: 'Morgens',
                start: moment(day + ' 06:00'),
                end: moment(day + ' 11:00'),
                items: [],
                linkText: 'Ab 06 Uhr'
            },
            {
                title: 'Mittags',
                start: moment(day + ' 11:00'),
                end: moment(day + ' 15:00'),
                items: [],
                linkText: 'Ab 11 Uhr'
            },
            {
                title: 'Nachmittags',
                start: moment(day + ' 15:00'),
                end: moment(day + ' 20:00'),
                items: [],
                linkText: 'Ab 15 Uhr'
            },
            {
                title: 'Abends',
                start: moment(day + ' 20:00'),
                end: moment(day + ' 00:00').add(1, 'd'),
                items: [],
                linkText: 'Ab 20 Uhr'
            }
        ];

        NowApi.getMovie().retrieve({
            'fields': '*,format,paymentPaytypes,pictures,trailers,packages',
            'filter': '{"BroadcastStartDate":{"between":{"start":"' + day + ' 00:00:00","end":"' + day + ' 23:59:59"}}}',
            'order': 'BroadcastStartDate asc',
            'maxPerPage': 200
        })
            .then(function (data) {
                for (var m = 0; m < data.items.length; m++) {
                    var movie = data.items[m];
                    for (var i = 0; i < moviegroups.length; i++) {
                        var g = moviegroups[i];
                        if (moment(movie.broadcastStartDate).isBetween(g.start, g.end) || moment(movie.broadcastStartDate).isSame(g.start)) {
                            if (movie.format) {
                                if (movie.format.station && vm.stations.indexOf(movie.format.station) > -1) {
                                    g.items.push({
                                        type: 'movie',
                                        movie: movie,
                                        station: movie.format.station,
                                        movieId: movie.id
                                    });
                                }
                            }
                            break;
                        }
                    }
                }
                vm.groups = moviegroups;
                vm.loading = false;
            });
    }

    function showAllStations() {
        vm.selectedStations = ['tvnow'];

        $location.path('/sendung-verpasst', false);
        $location.search('stations', null);
    }

    function initWatchers() {

        var routChangesucces = $rootScope.$on('$routeChangeSuccess', function () {
            if ($location.path().indexOf('/sendung-verpasst') > 0 && currentDay) {
                vm.$broadcast('missed::missedDayChanged', currentDay);
            }
        });
        $rootScope.$on('$destroy', routChangesucces);

        $scope.$on('missed::missedDayChanged', function (event, day) {
            vm.fetchMovies(day.date);
            currentDay = day.date;
            vm.loading = true;
        });

        $scope.$on('stationswitch:stations', function (event, stations) {
            vm.stations = stations;
        });


    }

    function trackTimeClick() {
        NowGoogleAnalytics.trackEvent('sendung_verpasst', 'klick', 'uhrzeit');
    }

    function trackDropdownClick() {
        trackDropdownOpen = (trackDropdownOpen) ? false : true;
        if (trackDropdownOpen) {
            NowGoogleAnalytics.trackEvent('sendung_verpasst', 'aufklappen', 'datumsfilter');
        }
    }

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('sendung_verpasst', action, label);
    }

    function setMeta(station) {
        if (!station || station === 'tvnow') {
            Metadata.setTitleAndMeta(
                'Sendung verpasst? Das TV Programm der letzten Tage als Stream',
                'Sendung verpasst? Deine Lieblingssendung hier bequem online schauen.'
            );
            return;
        }

        var stationUppercase = (station !== 'n-tv') ? station.toUpperCase() : station;
        Metadata.setTitleAndMeta(
            'Sendung verpasst bei ' + stationUppercase + '? Die Mediathek von ' + stationUppercase + ' hier online nutzen',
            'Sendung verpasst bei ' + stationUppercase + '? Deine Lieblingssendung von ' + stationUppercase + ' hier online schauen.'
        );
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMissed')
    .config(routing);
routing.$inject = ['$routeProvider'];
function routing($routeProvider) {
    var route = {
        controller: 'NowMissedController',
        templateUrl: 'templates/missed_view.html',
        reloadOnSearch: true,
        data: {
            pagetype: 'static'
        },
        resolve: {
            page: resolvePage
        }
    };

    $routeProvider
        .when('/:station/sendung-verpasst', {redirectTo: '/sendung-verpasst'})
        .when('/sendung-verpasst/:station', route)
        .when('/sendung-verpasst', route);


    /**
     * Get Page
     * @param $route
     * @param NowApi
     * @param StationMonitor
     * @returns {*}
     */
    resolvePage.$inject = ['NowApi', '$route'];
    function resolvePage(NowApi, $route) {
        return NowApi.getPage().retrievePagesByStationAndPath({
            station: ($route.current.params.station) ? $route.current.params.station : 'nowtv',
            pagepath: 'sendung-verpasst',
            fields: ['*',
                'teaserSets.*',
                'teaserSets.teaserSetInformations.*',
                'teaserSets.teaserSetInformations.custom.*',
                'teaserSets.teaserSetInformations.custom.page.*,',
                'teaserSets.teaserSetInformations.custom.format.*,',
                'teaserSets.teaserSetInformations.custom.movie.*,',
                'teaserSets.teaserSetInformations.movie.*',
                'teaserSets.teaserSetInformations.movie.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.format.*',
                'teaserSets.teaserSetInformations.format.*',
                'teaserSets.teaserSetInformations.format.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.pictures',
                'teaserSets.teaserSetInformations.movie.packages'
            ].join(',')
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }
}

})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowAd', ['NowPlayer']);

})();

(function() {

'use strict';

angular
    .module('NowAd')
    .service('AdControlService', AdControlService);

AdControlService.$inject = ['$rootScope', '$log', '$window', '$route', 'AppConfig', 'Accounting', '$timeout', 'StationMonitor'];

/**
 *@constructor
 */
function AdControlService($rootScope, $log, $window, $route, AppConfig, Accounting, $timeout, StationMonitor) {
    var self = this;

    self.init = init;
    self.reconfigure = reconfigure;
    self.disablePlayerAd = disablePlayerAd;
    self.enablePlayerAd = enablePlayerAd;
    self.getVPTags = getVPTags;
    self.getSXPKeys = getSXPKeys;
    self.disableInPageAd = disableInPageAd;
    self.getActiveAd = getActiveAd;
    self.setAdEnvironment = setAdEnvironment;
    self.enableInPageAd = enableInPageAd;

    self.init();
    initWatchers();

    return self;

    function init() {
        self.showInPageAd = (AppConfig.settings.nowtv.ad.page === 'true');
        self.showPlayerAd = (AppConfig.settings.nowtv.ad.player === 'true');

        self.adConfig = {
            rtl: {
                site: 'rtl-now.de',
                subsite: 'rtl_now',
                nuggsid: '1441718982'
            },
            vox: {
                site: 'voxnow.de',
                subsite: 'voxnow',
                nuggsid: '679815629'
            },
            superrtl: {
                site: 'superrtlnow',
                subsite: 'superrtlnow',
                nuggsid: '1576228103'
            },
            rtl2: {
                site: 'RTL2NOW.de',
                subsite: 'rtl2_now',
                nuggsid: '677304004'
            },
            nitro: {
                site: 'rtlnitronow',
                subsite: 'rtlnitro_now',
                nuggsid: '1362307170'
            },
            ntv: {
                site: 'ntvnow',
                subsite: 'ntv_now',
                nuggsid: '1945505236'
            },
            nowtv: {
                site: 'nowtv.de',
                subsite: 'home',
                nuggsid: ''
            },
            rtlplus: {
                site: 'now_rtlplusnow',
                subsite: 'rtlplus_now',
                nuggsid: '900605834'
            },
            toggoplus: {
                site: 'nowtv.de',
                subsite: 'home',
                nuggsid: ''
            },
            nowus: {
                site: 'nowtv.de',
                subsite: 'home',
                nuggsid: ''
            }
        };

        self.adControlConfig = {
            autoDetection: true,
            site: self.adConfig.nowtv.site,
            subsite: self.adConfig.nowtv.subsite,
            nuggadID: self.adConfig.nowtv.nuggsid,
            keys: {
                pack: ''
            }
        };
    }

    function initWatchers() {
        //when removing dependencies in mobile.js, adcontrol.reconfigure() can be easily replaced by the following broadcast/listener.
        //$rootScope.$on('adcontrolservice::reconfigure', onAdcontrolserviceReconfigure);
        var accountLogin = $rootScope.$on('account::login', function () {
            if (Accounting.isPremiumUser()) {
                self.disableInPageAd();
            }
        });
        $rootScope.$on('$destroy',accountLogin);
    }

    /*function onAdcontrolserviceReconfigure(event, data) {
     $log.debug('onAdcontrolserviceReconfigure()', {event:event, data:data});
     self.reconfigure(data.szm, data.format, data.channel);
     }*/

    function reconfigure(szm, format, channel) {

        var pagetype = ($route.current.$$route.data) ? $route.current.$$route.data.pagetype : false;

        if (Accounting.isPremiumUser() && pagetype !== "player") {
            $log.debug('Werbung für Premiumuser deaktiviert! ');
            return false;
        }
        if ($window.nowSEDetected || window.na || AppConfig.mode === 'edit') {
            return false;
        }
        if (angular.isDefined($route.current.locals) && angular.isDefined($route.current.locals.page) &&
            $route.current.locals.page.disableDisplayAds === '1') {
            $log.debug('Werbung auf dieser Seite deaktiviert! ');
            return false;
        }

        $log.debug('AdControlService.reconfigure', szm, format, channel, $route.current);
        var conf = self.adConfig['nowtv'];
        if (StationMonitor.getStation() in self.adConfig) {
            conf = self.adConfig[StationMonitor.getStation()];
        }

        if (!conf) {
            $log.debug('No AD-Config of Route!');
            return false;
        }

        if (format && StationMonitor.getStation() === 'nowtv') {
            $log.debug('Must be wrong, there are no TVNOW-Formats available!');
            return false;
        }

        self.adControlConfig.site = conf.site;
        self.adControlConfig.subsite = conf.subsite;
        self.adControlConfig.nuggadID = conf.nuggsid;
        self.adControlConfig.keys.pack = '';

        if (format && format.taggingSubSite) {
            self.adControlConfig.subsite = format.taggingSubSite;
            self.adControlConfig.keys.pack = format.taggingPack;
        } else if ($route.current.locals.page && $route.current.locals.page.taggingSubSite) {
            self.adControlConfig.subsite = $route.current.locals.page.taggingSubSite;
            self.adControlConfig.keys.pack = $route.current.locals.page.taggingPack;
        }

        self.adControlConfig.keys.nowchannel = channel;

        if ($window.document.location.host.match(/staging\./i) || $window.document.location.host.match(/local\./i) || $window.document.location.host.match(/abnahme\./i)) {
            self.adControlConfig.keys.dev = true;
            self.adControlConfig.debug = true;
        }

        if (angular.isDefined($window.$AC)) {
            $window.$AC.loadConfig(self.adControlConfig);
            $log.debug('AdControlService.reconfigure done', $window.$AC.config.site, $window.$AC.config.subsite, $window.$AC.config.keys.pack, $window.$AC.config.keys.nowchannel);
        } else {
            $timeout(function () {
                if (angular.isDefined($window.$AC)) {
                    $window.$AC.loadConfig(self.adControlConfig);
                    $log.debug('AdControlService.reconfigure done after timeout', $window.$AC.config.site, $window.$AC.config.subsite, $window.$AC.config.keys.pack, $window.$AC.config.keys.nowchannel);
                } else {
                    $log.error('AdControlService.reconfigure: IP AdControl not loaded');
                }
            }, 500);
        }
    }

    function getVPTags(movieDuration, isLivestream, station) {
        var tags,
            acTags;

        if (isLivestream) {
            //livestream: probleme mit vaa
            tags = ['vpaid'];
            if (station === 'superrtl' || station === 'toggoplus') {
                tags.push('len=long');
            }
        } else {
            tags = ['vaa', 'vpaid'];
        }

        // movieDuration Format HH:MM:SS:FF
        var timeArray = movieDuration.split(':');
        var durationSeconds = (+timeArray[0]) * 60 * 60 + (+timeArray[1]) * 60 + (+timeArray[2]);

        if ($window.document.location.hostname.match(/dev\./i)) {
            tags.push('evo_test');
        }

        if ($window.document.location.hostname.match(/abnahme\./i)) {
            tags.push('dev%3Dtrue');
        }

        if (angular.isDefined($window.$AC)) {
            $AC.setTargeting('vcd', durationSeconds);
            acTags = decodeURIComponent($window.$AC.getVPTags()).split(',');
        } else {
            // fallback
            acTags = ['j4=1', 'j4=2', 'j5=0', 'j5=1', 'j5=2', 'j5=3', 'j5=4', 'j5=5', 'j5=6'];
        }
        if (Accounting.isPremiumUser()) {
            acTags.push('tvnow_premium');
        } else {
            acTags.push('tvnow_basic');
        }

        return tags.concat(acTags);
    }

    function getSXPKeys(isLivestream, station) {
        var tags = [];

        if (isLivestream) {

            if (station === 'superrtl' || station === 'toggoplus') {
                tags.push('len=long');
            }
        }

        if ($window.document.location.hostname.match(/abnahme\./i)) {
            tags.push('fwd_dev=1');
        }

        if (Accounting.isPremiumUser()) {
            tags.push('fwd_tvnow=plus');
        } else {
            tags.push('fwd_tvnow=standard');
        }

        return tags;
    }

    function getActiveAd() {
        return $window.RTLi_Adcontrol.getActiveAd();
    }

    function setAdEnvironment(env) {
        if (angular.isUndefined(env)) env = null;
        switch (env) {
            case 'player':
                this.disableInPageAd(true);
                this.enablePlayerAd(true);
                break;
            case 'page':
            default:
                this.enableInPageAd(true);
                //this.disablePlayerAd(true);
                break;
        }
    }

    function enableInPageAd(dontApply) {
        if (Accounting.isPremiumUser()) {
            return false;
        }
        if (AppConfig.settings.nowtv.ad.page !== 'true') return;
        self.showInPageAd = true;
        if (!dontApply) {
            if (!$rootScope.$$phase) $rootScope.$apply();
        }
    }

    function disableInPageAd(dontApply) {
        if (AppConfig.settings.nowtv.ad.page !== 'true') return;
        self.showInPageAd = false;
        if (!dontApply) {
            if (!$rootScope.$$phase) $rootScope.$apply();
        }
    }

    function enablePlayerAd(dontApply) {
        if (AppConfig.settings.nowtv.ad.player !== 'true') return;
        self.showPlayerAd = true;
        if (!dontApply) {
            if (!$rootScope.$$phase) $rootScope.$apply();
        }
    }

    function disablePlayerAd(dontApply) {
        if (AppConfig.settings.nowtv.ad.player !== 'true') return;
        self.showPlayerAd = false;
        if (!dontApply) {
            if (!$rootScope.$$phase) $rootScope.$apply();
        }
    }
}


})();

(function() {

'use strict';

angular
    .module('NowAd')
    .service('BreakAdSservice', BreakAdSservice);

BreakAdSservice.$inject = ['$rootScope', '$log', '$window', 'AdControlService','PlayerHelperService'];

/**
 *@constructor
 */
function BreakAdSservice($rootScope, $log, $window, AdControlService,PlayerHelperService) {
    var self = this;
    this.showBreakAd = false;
    this.breakadOptions = 'bad=1;';
    this.isBreakAdVisible =isBreakAdVisible;
    this.setBreakadVisibility =setBreakadVisibility;

    init();

    return this;

    function init() {
        var htmlBreakAd = $rootScope.$on('html5::showBreakad', function () {
            if (AdControlService.getActiveAd() !== false) return;

            var playerSize = PlayerHelperService.getSize();


            switch (playerSize) {
                case 's':
                    self.breakadOptions = 'bad=1;';
                    break;
                case 'm':
                    self.breakadOptions = 'bad=1;badxxl=1;';
                    break;
                case 'l':
                    self.breakadOptions = 'bad=1;badxxl=1;';
                    break;
                default:
                    break;
            }
            if ($window.document.location.hostname.match(/dev\./i)) {
                self.breakadOptions = self.breakadOptions + 'evo=1;'
            }
            $log.debug('BREAKAD: START ( LayoutSize: ' + playerSize + ')');
            $log.debug('breakAdStatus', self.showBreakAd);
                self.showBreakAd = true;
                if (!$rootScope.$$phase) $rootScope.$apply();


            if (angular.isDefined($window.$AC)) {
                $window.$AC.loadUnfilledSlots();
            }


        });
        function hideBreakAd() {
            $log.debug('BREAKAD: STOP');
            self.showBreakAd = false;
            if (!$rootScope.$$phase) $rootScope.$apply();
        }

        var htmlonPlay = $rootScope.$on('html5::onPlay', hideBreakAd);

        $rootScope.$on('$destroy', htmlonPlay);

        $rootScope.$on('$destroy', htmlBreakAd);
    }

    function isBreakAdVisible(){
        return self.showBreakAd;
    }

    function setBreakadVisibility(visibility){
        self.showBreakAd = visibility;
    }
}


})();

(function() {

'use strict';

angular
    .module('NowAd')
    .service('EmsService', EmsService);

EmsService.$inject = ['$rootScope', '$log', '$window', 'StationMonitor','$timeout','AppConfig'];

/**
 *@constructor
 */
function EmsService($rootScope, $log,$window, StationMonitor,$timeout,AppConfig) {
    var self = this,
        initialized = false,
        loadCounter = 0;

    self.client = "tvnow";
    self.setClient = setClient;
    self.reloadAds = reloadAds;
    self.finishInit = finishInit;
    self.pushAd = pushAd;
    self.setZone = setZone;
    self.setKeywords = setKeywords;
    self.init = init;
    self.detectAndSetZone = detectAndSetZone;
    self.getGujAd = getGujAd;
    self.reloadSpecificAds = reloadSpecificAds;




    function init(){

    }
    if(AppConfig.webclient!=='mobile') {
        initWatchers();
    }
    function initWatchers() {

        var locationChangeStart = $rootScope.$on('$routeChangeStart', function () {
            setKeywords(false);
        });

        $rootScope.$on('$destroy',locationChangeStart);


        $log.info("EmsService: initWatchers");
        var routeChange = $rootScope.$on('$routeChangeSuccess', function (event, currentRoute) {

            function callback(){
                var pagetype = (currentRoute.$$route.data) ? currentRoute.$$route.data.pagetype : false;

                if(self.client !== StationMonitor.getStation() ){
                    self.setClient(StationMonitor.getStation());
                }
                if(!$window.allowEMS){
                    _pushToQueue(function () {
                        GujAd.Privacy.isOptedOut();
                    });
                }

                self.detectAndSetZone(pagetype);
                $log.info("EmsService: pageType: "+ pagetype);
                if(pagetype === "format"){
                    self.setKeywords(currentRoute.locals.format.szm.format.name);

                }
                if(pagetype === "player"){
                    self.setKeywords(currentRoute.locals.movie.format.szm.format.name);
                }
                $log.debug('ems::currentRoute',currentRoute);


                if(initialized){
                    if(pagetype!=='player'){
                       self.reloadSpecificAds(['superbanner_1','wallpaper_1','skyscraper_1'])
                    }
                }else{
                    initialized = true;
                    self.pushAd("superbanner_1");
                    self.pushAd("wallpaper_1");
                    self.pushAd("skyscraper_1");
                    self.finishInit();
                }
            }


            function checkLoading(){
                if(getGujAd()){
                    callback();
                }else{
                    loadCounter++;
                    if(loadCounter < 50){
                        $timeout(checkLoading,100);
                    }
                }
            }

            checkLoading();



        });
        $rootScope.$on('$destroy', routeChange);
    }

    function detectAndSetZone(pagetype){
        var zone = "homepage";
        if(pagetype === "format" || pagetype === "player"){
            zone = "sendung";
        }
        self.setZone(zone);
    }

    function setClient(client) {
        if(client === "nowtv"){
            client = "tvnow";
        }
        if(client !== 'tvnow' && client !=='watchbox'){
            client = client+'now';
        }
        $log.info("EmsService -  setClient: "+client);
        self.client = client;
        //$window.GujAd.getClient().setSiteType(client);
        _getGujClient().setSiteType(client);
    }

    function reloadAds(){
        $log.info("EmsService -  reloadAds: ");
        _pushToQueue(function(){
            _getGujClient().reloadAds();
        });
    }

    function reloadSpecificAds(ads){
        $log.info("EmsService -  reloadSpecificAds: ",ads);
        _pushToQueue(function(){
            _getGujClient().reloadSpecificAds(ads);
        });
    }

    function setZone(zone){
        $log.info("EmsService -  setZone: " + zone);
        _pushToQueue(function(){
            _getGujClient().setZone(zone);
        });
    }
    function setKeywords(keyword){
        if(!keyword){
            keyword = [];
        }else{
            keyword = [keyword];
        }
        $log.info("EmsService - setKeywords: " + keyword);
        _pushToQueue(function(){
            _getGujClient().setKeywords(keyword);
        });
    }

    function finishInit(){
        $log.info("EmsService -  finishInit");
        _pushToQueue(function(){
            getGujAd().finalizeInlineLoading();
        });
    }

    function _getGujClient(){
        if($window.GujAd){
            return getGujAd().getClient();
        }else{
            $log.debug("EmsService: could not load ems script - GujAd not available in window");
            return false;
        }
    }

    function getGujAd(){
        if($window.GujAd){
            return $window.GujAd;
        }else{
            $log.debug("EmsService: could not load ems script - GujAd not available in window");
            return false;
        }
    }

    function pushAd(ad){
        $log.info("EmsService -  pushAd:"+ad);
        _pushToQueue(function(){
            getGujAd().push(ad);
        });
    }

    function _pushToQueue(fnc){
        if($window.GujAd){
            return GujAd.cmd.push(fnc);
        }else{
            return  $log.debug("EmsService: could not load ems script - GujAd not available in window");
        }

    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAd')
    .directive('nowAdcontrol', nowAdcontrol);

nowAdcontrol.$inject = ['$log', '$rootScope', '$window', 'PlayerService', 'AdControlService', 'EmsService'];

function nowAdcontrol($log, $rootScope, $window, PlayerService, AdControlService, EmsService) {
    var RTLi_Adcontrol = {
        isActivePrerolltakeoverxxl: false,
        isActivePrerolltakeover: false,
        isActiveBrandedplayerxxl: false,
        isActiveSky: false,
        isActiveBreakadtakeover: false,

        _isPlayerSite: _isPlayerSite,

        _clearUnderlay: _clearUnderlay,
        _clearOverlay: _clearOverlay,
        _clearSkyright: _clearSkyright,

        _nowplayerSet: _nowplayerSet,
        _nowplayerReset: _nowplayerReset,

        startPrerolltakeoverxxl: startPrerolltakeoverxxl,
        startPrerolltakeover: startPrerolltakeover,
        _stopPrerolltakeoverxxl: _stopPrerolltakeoverxxl,
        _stopPrerolltakeover: _stopPrerolltakeover,
        startBrandedplayerxxl: startBrandedplayerxxl,
        _stopBrandedplayerxxl: _stopBrandedplayerxxl,
        startSky: startSky,
        _stopSky: _stopSky,

        repositionBreakad: repositionBreakad,

        startBreakadtakeover: startBreakadtakeover,
        _stopBreakadtakeover: _stopBreakadtakeover,

        getActiveAd: getActiveAd,

        init: init
    };

    var RTLi_Pagecontrol = {
        setDebugBackground: setDebugBackground,
        getPlaceholdImageUrl: getPlaceholdImageUrl
    };

    return {
        restrict: 'AC',
        link: link
    };

    function link(scope) {
        $window['RTLi_Adcontrol'] = RTLi_Adcontrol;
        $window['RTLi_Pagecontrol'] = RTLi_Pagecontrol;

        RTLi_Adcontrol.init();
        EmsService.init();

        scope.$on('html5::onLoadNewContentSource', function (){
            RTLi_Adcontrol.init();
        });

        scope.$on('html5::onAdSlotComplete',function(){
            if(getActiveAd()==='ptoxxl') {
                RTLi_Adcontrol._clearOverlay();
            }
        });

        scope.$on('html5::onAdSlotStart', function (){
            RTLi_Adcontrol.init();
        });

       scope.$on('html5::onAdFinished', function (event, data) {
            $log.debug('AdControll::html5::onAdFinished', event, data);
            if(data.info &&
                data.info.variant === 'COMMERCIAL' &&
                data.info.currentCommercial === data.info.totalCommercials &&
                RTLi_Adcontrol.isActivePrerolltakeover &&
                !RTLi_Adcontrol.isActivePrerolltakeoverxxl &&
                !RTLi_Adcontrol.isActiveBrandedplayerxxl){
                RTLi_Adcontrol.init();
            }
        });


        scope.showInPageAd = AdControlService.showInPageAd;
        scope.$watch(function () {
                return AdControlService.showInPageAd;
            },
            function (newVal) {
                scope.showInPageAd = newVal;
            }
        );

        scope.showPlayerAd = AdControlService.showPlayerAd;
        scope.$watch(function () {
                return AdControlService.showPlayerAd;
            },
            function (newVal) {
                scope.showPlayerAd = newVal;
            }
        );
    }

    /**
     * set debug background
     *
     * @param selector
     * @param debug
     */
    function setDebugBackground(selector, debug) {
        var width = $(selector).width();
        var height = $(selector).height();
        var image = this.getPlaceholdImageUrl(width, height);

        if (debug) {
            $(selector).css('background-color', '#cccccc');
            $(selector).css('background-image', 'url(' + image + ')');
        } else {
            $(selector).css('background', 0);
        }
    }

    /**
     * returns placehold image url
     *
     * @return string
     */
    function getPlaceholdImageUrl(width, height) {
        return 'http://placehold.it/' + width + 'x' + height;
    }

    /**
     * check if playersite is enabled
     * @returns {boolean}
     * @private
     */
    function _isPlayerSite() {
        $log.debug('RTLi_Adcontrol check playerservice state', PlayerService.show);
        return (PlayerService.show);
    }

    /**
     * clear and hide underlay
     * @private
     */
    function _clearUnderlay() {
        var _vaa_underlay = $('#vaa_underlay');
        if (_vaa_underlay.length === 1) {
            _vaa_underlay.empty().removeClass().removeAttr('style').hide();
            return true;
        }
        return false;
    }

    /**
     * clear and hide overlay
     * @private
     */
    function _clearOverlay() {
        var _vaa_overlay = $('#vaa_overlay');
        if (_vaa_overlay.length === 1) {
            _vaa_overlay.empty().removeClass().removeAttr('style').hide();
            return true;
        }
        return false;
    }

    /**
     * clear and hide right sky
     * @private
     */
    function _clearSkyright() {
        var _vaa_sky_right = $('#vaa_sky_right');
        if (_vaa_sky_right.length === 1) {
            _vaa_sky_right.empty().removeClass().removeAttr('style').hide();
            return true;
        }
        return false;
    }

    /**
     * set nowplayer size and position
     * @param type
     * @private
     */
    function _nowplayerSet(type) {
        var _player = $('.player');
        var _width, _height;
        var spacer = $('.videobar-spacer');
        switch (type) {
            case 'branded-player':
                _player.addClass('branded-player');
                spacer.addClass('branded-spacer');
                _width = 608;
                _height = 342;
                break;
            case 'preroll-takeover-medium':
                _player.addClass('preroll-takeover');
                spacer.addClass('branded-spacer');
                _width = 960;
                _height = 540;
                break;
            case 'preroll-takeover-small':
                _player.addClass('preroll-takeover');
                spacer.addClass('branded-spacer');
                _width = 640;
                _height = 360;
                break;
            default:
                break;
        }

        PlayerService.resize(_width, _height);
    }

    /**
     * reset nowplayer size and position
     * @private
     */
    function _nowplayerReset() {
        var _player = $('.player');
        var spacer = $('.videobar-spacer');
        _player.removeClass('branded-player preroll-takeover');
        spacer.removeClass('branded-spacer');
        PlayerService.resizeReset();
    }

    /**
     * do all the stuff for preroll takeover xxl
     * i.e. preroll takeover with 3 minute branding
     */
    function startPrerolltakeoverxxl(size, debug) {
        if (!this._isPlayerSite()) return;
        this.isActivePrerolltakeoverxxl = true;
        this.startPrerolltakeover(size, debug);
    }

    /**
     * do all the stuff for preroll takeover
     */
    function startPrerolltakeover(size, debug) {
        if (!this._isPlayerSite()) return;

        $rootScope.showpoweredby = false;
        if (!$rootScope.$$phase) {
            $rootScope.$apply();
        }

        if (angular.isUndefined(size)) {
            // the default
            size = 'S';
        }

        AdControlService.disableInPageAd();
        AdControlService.disablePlayerAd();

        this.isActivePrerolltakeover = true;

        var _vaa_underlay = $('#vaa_underlay');
        if (_vaa_underlay.length === 1) {
            RTLi_Pagecontrol.setDebugBackground('#vaa_underlay', debug);
        }

        var _vaa_overlay = $('#vaa_overlay');
        if (_vaa_overlay.length === 1) {
            RTLi_Pagecontrol.setDebugBackground('#vaa_overlay', debug);
        }

        switch (size.toUpperCase()) {
            case 'M':
                this._nowplayerSet('preroll-takeover-medium');
                break;
            case 'S':
            default:
                this._nowplayerSet('preroll-takeover-small');
                break;
        }

        var _vaa_both = $('#vaa_underlay, #vaa_overlay');
        _vaa_both.addClass('vaa_pto').hide();
        _vaa_both.height($(window).height() - $('.now-playerlayer>.top').height());
        _vaa_both.find('iframe').css({'width': '100%', 'height': '100%'});

        if (debug !== true) {
            _vaa_both.not(':empty').show();
        }
        else {
            _vaa_both.show();
        }
    }

    /**
     * hide preroll take over specific stuff
     * @private
     */
    function _stopPrerolltakeoverxxl() {
        this._stopPrerolltakeover(true);
    }

    /**
     * hide preroll take over specific stuff
     * @private
     */
    function _stopPrerolltakeover(force) {
        force = angular.isDefined(force) ? force : false;
        this._clearOverlay();
        if (force || (this.isActivePrerolltakeover && !this.isActivePrerolltakeoverxxl)) {
            this._nowplayerReset();
            this._clearUnderlay();
            AdControlService.enablePlayerAd();

            this.isActivePrerolltakeover = false;
            this.isActivePrerolltakeoverxxl = false;
        }
    }

    /**
     * do all the stuff for branded player xxl
     */
    function startBrandedplayerxxl(debug) {
        if (!this._isPlayerSite()) return;

        AdControlService.disableInPageAd();
        AdControlService.disablePlayerAd();

        this.isActiveBrandedplayerxxl = true;
        var _vaa_underlay = $('#vaa_underlay');

        if (_vaa_underlay.length === 1) {
            this._nowplayerSet('branded-player');
            _vaa_underlay.removeClass().removeAttr('style').addClass('vaa_bpxxl');
            RTLi_Pagecontrol.setDebugBackground('#vaa_underlay', debug);
            _vaa_underlay.show();
        }
    }

    /**
     * hide branded player xxl specific stuff
     * @private
     */
    function _stopBrandedplayerxxl() {
        this.isActiveBrandedplayerxxl = false;

        this._nowplayerReset();
        this._clearUnderlay();
        AdControlService.enablePlayerAd();
    }

    /**
     * do all the stuff for sky
     */
    function startSky(debug) {
        if (!this._isPlayerSite()) return;

        AdControlService.disableInPageAd();

        this.isActiveSky = true;
        var _vaa_sky_right = $('#vaa_sky_right');
        _vaa_sky_right.removeClass().removeAttr('style').addClass('vaa_sky');
        RTLi_Pagecontrol.setDebugBackground('#vaa_sky_right', debug);
        _vaa_sky_right.show();
    }

    /**
     * hide sky take over specific stuff
     * @private
     */
    function _stopSky() {
        this.isActiveSky = false;
        this._clearSkyright();
        AdControlService.enablePlayerAd();
    }

    /**
     *
     * @param width
     * @param height
     */
    function repositionBreakad(width, height) {
        var breakadSelector = $('#breakad');
        var classes = breakadSelector.attr('class').split(' ');
        var newclasses = [];
        for (var i = 0; i < classes.length; i++) {
            var r = classes[i].search(/now-breakad-size-.+/);
            if (r) newclasses[newclasses.length] = classes[i];
        }

        if (width && height) {
            newclasses[newclasses.length] = 'now-breakad-size-' + width + 'x' + height;
        }

        breakadSelector.removeClass().addClass(newclasses.join(' '));
    }

    /**
     * do all the stuff for Breakad TakeOver
     */
    function startBreakadtakeover(debug) {
        if (!this._isPlayerSite()) return;

        $rootScope.showpoweredby = false;
        if (!$rootScope.$$phase) {
            $rootScope.$apply();
        }

        AdControlService.disablePlayerAd();

        this.isActiveBreakadtakeover = true;

        var _vaa_overlay = $('#vaa_overlay');
        if (_vaa_overlay.length === 1) {
            RTLi_Pagecontrol.setDebugBackground('#vaa_overlay', debug);
        }

        _vaa_overlay.addClass('vaa_pto').hide();
        _vaa_overlay.height($(window).height() - $('.now-playerlayer>.top').height());
        _vaa_overlay.find('iframe').css({'width': '100%', 'height': '100%'});

        _vaa_overlay.show();
    }

    /**
     * hide Breakad TakeOver specific stuff
     * @private
     */
    function _stopBreakadtakeover() {
        this.isActiveBreakadtakeover = false;
        this._clearOverlay();
        AdControlService.enablePlayerAd();
    }

    /**
     * get active ad type         *
     * @returns {string}
     */
    function getActiveAd() {
        var ret = false;
        if (RTLi_Adcontrol.isActivePrerolltakeoverxxl) {
            ret = 'ptoxxl';
        } else if (RTLi_Adcontrol.isActivePrerolltakeover) {
            ret = 'pto';
        } else if (RTLi_Adcontrol.isActiveBrandedplayerxxl) {
            ret = 'bpxxl';
        } else if (RTLi_Adcontrol.isActiveSky) {
            ret = 'sky';
        } else if (RTLi_Adcontrol.isActiveBreakadtakeover) {
            ret = 'bato';
        }
        return ret;
    }

    /**
     * reset all to default
     */
    function init() {
        if (!this._isPlayerSite()) return;

        $rootScope.showpoweredby = true;
        if (!$rootScope.$$phase) {
            $rootScope.$apply();
        }

        //var _console = angular.isObject(console);
        //var _consoleLog = (_console && angular.isFunction(console.log));

        this.isActivePrerolltakeoverxxl = false;
        this.isActivePrerolltakeover = false;
        this.isActiveBrandedplayerxxl = false;

        this._nowplayerReset();
        this._clearOverlay();
        this._clearUnderlay();
        this._clearSkyright();

        AdControlService.enablePlayerAd();

        //if (_consoleLog) {
            //console.log('RTLi_Adcontrol init completed.')
        //}
    }
}


})();

(function() {

'use strict';

angular
    .module('NowAd')
    .directive('nowbreakad', nowbreakad);

nowbreakad.$inject = ['$window', 'BreakAdSservice', 'EmsService'];

function nowbreakad($window, BreakAdSservice, EmsService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/player_breakad.html',
        link: link
    };

    var showBreakAd = false;
    var firstTimeShown = false;

    function link(scope) {
        scope.showBreakAd = BreakAdSservice.isBreakAdVisible();
        scope.breakadOptions = BreakAdSservice.breakadOptions;

        scope.$watch(function () {
                return BreakAdSservice.isBreakAdVisible();
            },
            function (newVal,oldval) {
                if(newVal === oldval) return;

                if (newVal === false) {
                    $('#breakad').empty().html('<div id="breakad_1" class="gujAd breakad now-dom-clean-children"></div>');
                    $window.RTLi_Adcontrol.repositionBreakad();
                }
                if(newVal && !oldval && !showBreakAd){

                    if(!firstTimeShown) {
                        EmsService.pushAd('breakad_1',[300,250]);
                        firstTimeShown = true;
                    }else{
                        EmsService.reloadSpecificAds(['breakad_1']);
                    }
                }

                scope.showBreakAd = newVal;
                showBreakAd = newVal;

            }
        );
        scope.$watch(function () {
                return BreakAdSservice.breakadOptions;
            },
            function (newVal) {
                scope.breakadOptions = newVal;
            }
        );
    }
}


})();

(function() {



})();

(function() {

angular.module('NowPlayerHTML5', []);
angular.module('NowPlayer', ['ngRoute', 'ngCookies', 'oc.lazyLoad', 'angularMoment', 'NowPlayerHTML5']);

})();

(function() {

/* eslint angular/no-private-call: 0 */
/* eslint angular/on-watch: 0 */
'use strict';

angular
    .module('NowPlayer')
    .service('PlayerService', PlayerService);

PlayerService.$inject = [
    'NowApi',
    '$q',
    '$filter',
    '$rootScope',
    '$routeParams',
    '$route',
    '$window',
    '$log',
    '$location',
    '$sessionStorage',
    '$interval',
    'AppConfig',
    'StationMonitor',
    'moment',
    'PageHistory',
    'Accounting',
    'Optimizely',
    'STAGE',
    '$ocLazyLoad',
    'MyProgrammeService',
    'InfoBoxService',
    'VideobarService',
    '$timeout',
    '$http',
    'PlayerConfigService',
    'PlayerHelperService',
    '$httpParamSerializer'
];

/**
 *@constructor
 */
function PlayerService(NowApi, $q, $filter, $rootScope, $routeParams, $route, $window, $log, $location, $sessionStorage, $interval, AppConfig, StationMonitor, moment, PageHistory, Accounting, Optimizely, STAGE, $ocLazyLoad, MyProgrammeService, InfoBoxService, VideobarService, $timeout, $http, PlayerConfigService, PlayerHelperService, $httpParamSerializer) {
    var self = this,
        broadcastSubscriptions = [],
        autoMovieCount = 0,
        movieCount = 0,
        countdownInterval = [],
        currentCountdown,
        myconfig,
        streamCheckTimeout = false;


    self.convertParamsToUrl = convertParamsToUrl;
    self.displayShare = displayShare;
    self.displayUnsupportedPlatform = displayUnsupportedPlatform;
    self.playCurrentRoute = playCurrentRoute;
    self.saveSourcePage = saveSourcePage;
    self.getSourcePage = getSourcePage;
    self.getDefaultUserdata = getDefaultUserdata;
    self.setPlayer = setPlayer;
    self.getPlayer = getPlayer;
    self.setDOMElement = setDOMElement;
    self.loadJSON2 = loadJSON2;
    self.handleEvents = handleEvents;
    self.saveTimeCodeInterval = saveTimeCodeInterval;
    self.showPlayer = showPlayer;
    self.showLivePlayer = showLivePlayer;
    self.hidePlayer = hidePlayer;
    self.resize = resize;
    self.resizeReset = resizeReset;
    self.pause = pause;
    self.resume = resume;
    self.stop = stop;
    self.exitFullscreen = exitFullscreen;
    self.enterFullscreen = enterFullscreen;
    self._reset = _reset;
    self.play = play;
    self.getTimeCode = getTimeCode;
    self.loadMovieToPlayer = loadMovieToPlayer;
    self._buildAndCallMovieJson = _buildAndCallMovieJson;
    self.bindPlayerEventHandler = bindPlayerEventHandler;
    self.bindGlobalPlayerFunctions = bindGlobalPlayerFunctions;
    self.setStation = setStation;
    self.decodeData = decodeData;
    self.getCurrentMovieId = getCurrentMovieId;
    self.getPrice = getPrice;
    self.clamp = clamp;
    self.getCompleteTime = getCompleteTime;
    self.getCurrentTime = getCurrentTime;
    self.getTimePercentage = getTimePercentage;
    self.getSpecialTag = getSpecialTag;
    self.initEvents = initEvents;
    self.unregisterEvents = unregisterEvents;
    self.setPlayerCovered = setPlayerCovered;
    self.activateHTML5Mode = activateHTML5Mode;
    self.logExternalError = logExternalError;
    self.addProgressToMovie = addProgressToMovie;
    self.circlePlayInfoBox = circlePlayInfoBox;
    self.resumeMyMovie = resumeMyMovie;
    self.queryStreamcheck = queryStreamcheck;
    self.cancelStreamcheck = cancelStreamcheck;
    self.helpOverlay = helpOverlay;
    self.playerLogData = playerLogData;
    self.isAd = isAd;


    self.adslot = true;
    self.show = false;
    self.showLive = false;
    self.currentVideoplayer = false;
    self.currentDOMElement = false;
    self.lastStation = false;
    self.lastPathParams = false;
    self.stopSaveTimeCode = false;
    self.sourcePage = false;
    self.specialTag = '';
    self.showShareAuto = true;
    self.showShare = true;
    self.setStationCmd = false;
    self.firstContentStarted = false;
    self.firstLivestreamStarted = false;
    self.visibilityListener = false;
    self.firstPlay = false;
    self.ffc = AppConfig.ffc + '/?premium=extscreen';

    self.html5PlayerLoaded = false;
    self.lastCode = false;


    self.playerColors = {
        'link': '#ffffff',
        'cta-bg': '#002748', // $tvnow-primary-darkblue
        'cta-text': '#ffffff',
        'watched': '#00b2cf', // $tvnow-primary-signalblue
        'link-hover': '#002748', // $tvnow-primary-darkblue
        'cta-bg-hover': '#468fb3', // $tvnow-primary-greyblue
        'cta-text-hover': '#002748', // $tvnow-primary-darkblue
        'plus': '#002748' // $tvnow-primary-darkblue
    };

    VideobarService.setPlayerService(this);


    var routeChangeSuccess = $rootScope.$on('$routeChangeSuccess', onRouteChangeSuccess);
    $rootScope.$on('$destroy', routeChangeSuccess);

    return self;


    function onRouteChangeSuccess(event, current) {
        InfoBoxService.hide();
        PlayerHelperService.setCurrentState("stopped");

        $log.debug('PlayerService::current route', current, PageHistory.getLastPage());

        if (current.$$route.data && current.$$route.data.pagetype !== 'player' && self.show) {
            self.hidePlayer();
        }
        if (current.$$route.data && current.$$route.data.pagetype !== 'player' && !PlayerHelperService.getLiveStreamPreroll()) {
            PlayerHelperService.setLiveStreamPreroll(true);
            self.firstLivestreamStarted = false;
            $log.debug('liveStreamPreroll:: preroll set on route change', PlayerHelperService.getLiveStreamPreroll());
            PageHistory.getLastPage();

        }


        if (current.$$route.data && current.$$route.data.pagetype === 'player' && self.show) {
            $log.debug('service_player player::onrouteChangeSuccess pathParams, lastPathParams', current.pathParams, self.lastPathParams);
            if (current.pathParams.hasOwnProperty('format') && current.pathParams.hasOwnProperty('movie')) {
                if (self.convertParamsToUrl(current.pathParams) !== self.convertParamsToUrl(self.lastPathParams)) {
                    self.lastPathParams = current.pathParams;
                    self.playCurrentRoute();
                }
            }
        }
    }

    function circlePlayInfoBox() {
        resume();
        InfoBoxService.hide();
    }

    function onCountdown(countdown, cb, type) {
        if (countdown === 0) {
            killCountdown();
            cb();
        }
        $rootScope.$broadcast('html5::countdown', countdown, type);
    }

    function killCountdown() {
        $rootScope.$broadcast('html5::countdown', false);
        if (countdownInterval) {
            $interval.cancel(countdownInterval);
            $log.info('chapter interval killed');
        }
    }

    function convertParamsToUrl(pathParams) {
        return '/' + pathParams.station + '/' + pathParams.format + '/' + pathParams.episode;
    }

    function displayShare(show, auto) {
        if (angular.isDefined(auto)) self.showShareAuto = auto;
        self.showShare = show;
        if (!$rootScope.$$phase) $rootScope.$apply();
    }

    function displayUnsupportedPlatform(callback) {
        InfoBoxService.show({
            text: $filter('translate')('browser.support.infotext'),
            buttons: [
                {
                    text: $filter('translate')('browser.support.trybutton'),
                    cls: 'center',
                    cb: function () {
                        callback();
                    }
                }
            ]
        });
    }

    function addProgressToMovie(movie) {
        var lastPage = PageHistory.getLastPage();
        movie.watched = MyProgrammeService.getMovieStatistic(movie.id, 'progress');
        movie.timecode = MyProgrammeService.getMovieStatistic(movie.id, 'timecode');
        if (lastPage.pagetype !== 'player' && movie.watched && movie.watched >= 0.99 && Accounting.isLoggedIn()) {
            if (movie.id > 0) {
                MyProgrammeService.updateMovieStatistic(movie.id, 0, 0);
                movie.watched = 0;
                movie.timecode = 0;
                $log.debug('service_player player::playCurrentRoute delete');
            }
        }

        return movie;
    }

    /**
     * Checks the current Playerroute and loads movie for playing!
     */
    function playCurrentRoute(movie) {
        MyProgrammeService.refreshSingleMovie(movie.id).then(
            function () {
                try {
                    self.addProgressToMovie(movie);
                    PlayerHelperService.setAutostartCountdown(0);
                    var cb = function () {
                        self.play(0, false);
                    };
                    $log.debug('service_player player::playCurrentRoute > loadMovieToPlayer');
                    self.loadMovieToPlayer($routeParams.format, $routeParams.episode, movie, cb);
                }
                catch (e) {
                    $log.debug(e);
                }
            }
        );
    }


    function saveSourcePage() {
        var sourcePageData = PageHistory.getLastPage();
        $log.debug('service_player player::saveSourcePage', sourcePageData, $location.search()['return']);
        if (sourcePageData) {
            self.sourcePage = sourcePageData.pagetype;
            if (sourcePageData.pagetype === 'specials' && sourcePageData.additionalData) {
                self.specialTag = sourcePageData.additionalData.specialtag;
            }
        }
        if ($location.search()['return']) {
            PlayerHelperService.setReturnPage($location.search()['return']);
            $location.search('return', null).replace();
        }
    }

    function getSourcePage() {
        return self.sourcePage;
    }

    function getDefaultUserdata() {
        return {
            email: 'alluser@rtl.de',
            password: 'password',
            token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE0ODY0Njc1MzUsImlzcyI6Imh0dHBzOlwvXC9hcGkudHZub3cuZGVcL3R2bm93XC93ZWIiLCJhdWQiOiJvM2kydWhyb3doaWVmaXNlZmh1c2xpZWpmaGxrc2RoZmtqc2RmIiwidWlkIjozMTMzNjQzMSwicm9sZXMiOlsidXNlciJdLCJwYWNrYWdlcyI6W10sImhhc0FjcXVpcmVkUGFja2FnZXMiOmZhbHNlLCJyaCI6ImE2NTc1NzZiYmRkZDA0OTNiNGQ5MjBmYzE3ZTIwZjQ5IiwiY2siOiIwNzkxNzgzZTZlYjhlNjhhYjllNzAzMDY5MmU5NDMzNiIsInN1YnNjcmlwdGlvbiI6bnVsbH0.RBcfycowqO55UBacbIAbFIgGSrcaXOFFp4YS2qlcR8I'
        }
    }

    function getPlayer() {
        return self.currentVideoplayer;
    }

    function setPlayer(player) {
        self.currentVideoplayer = player;
    }

    function setDOMElement(element) {
        self.currentDOMElement = element;
    }

    function loadJSON2(str) {
        $.getJSON(str, function (json) {
            var result = self.currentVideoplayer.exec(json);
            $log.debug('service_player loadJSON2()', result);
        });
    }

    function handleEvents(event, data) {
        $log.debug('service_player handleEvents()', event, data);
        $rootScope.$broadcast('player::' + event, event, data, self);
        return true;
    }

    function saveTimeCodeInterval(save) {
        if (save) {
            if (!self.stopSaveTimeCode) {
                self.stopSaveTimeCode = $interval(function () {
                    $rootScope.$broadcast('player::playingRefresh');
                }, AppConfig.settings.nowtv.player.statistic.delay);
            }
        }
        else {
            if (self.stopSaveTimeCode) {
                $interval.cancel(self.stopSaveTimeCode);
                self.stopSaveTimeCode = false;
            }
        }
    }

    function showPlayer(media) {
        PlayerHelperService.setMovieObject(media);
        self.show = true;
        self.showLive = false;
    }

    function showLivePlayer() {
        PlayerHelperService.setMovieObject({});
        self.show = false;
        self.showLive = true;
    }


    function hidePlayer() {
        $log.debug('service_player hidePlayer()');
        try {
            self.stop();
            if (!$rootScope.$$phase) $rootScope.$apply();
        }
        catch (e) {
            $log.debug('service_player caught e', e);
        }
    }

    function resizeReset() {
        self.showShare = self.showShareAuto;
        $rootScope.$broadcast('resize::forceReset');
    }

    function resize(width, height) {
        if ((width / 16 * 9) === height || (width === 608 && height === 368) /*bpxxl*/) {
            $rootScope.$broadcast('resize::force', width, height);
        }
        else {
            //$log.log('Error please define width and height with aspectratio of 16:9');
        }
    }

    /**
     * Pauses the Player
     */
    function pause() {
        self.currentVideoplayer.pause();
    }

    /**
     * Resumes the Player
     */
    function resume() {
        self.currentVideoplayer.play();
    }

    /**
     * Stops the Player
     */
    function stop(dontReset) {
        if (angular.isObject(self.currentVideoplayer) && angular.isFunction(self.currentVideoplayer.destroy)) {
            $log.debug('html5 player destroy');
            self.currentVideoplayer.destroy();
        }
        if (!dontReset) {
            self._reset();
        }

    }

    function enterFullscreen() {
        self.currentVideoplayer.player.enterFullscreen();
        PlayerHelperService.setFullscreenStatus(true);
    }

    function exitFullscreen() {
        self.currentVideoplayer.player.exitFullscreen();
        PlayerHelperService.setFullscreenStatus(false);
    }

    function _reset() {
        $rootScope.$broadcast('player::reset');
        killCountdown();
        self.saveTimeCodeInterval(false);
        self.show = false;
        self.showLive = false;
        PlayerHelperService.setCurrentState("stopped");
        self.lastStation = false;
        self.firstContentStarted = false;
        self.firstLivestreamStarted = false;
        PlayerHelperService.setFullscreenStatus(false);
        PlayerHelperService.setRecoInfo(false);
        self.firstPlay = false;

        self.cancelStreamcheck();
        VideobarService.reset();

        if (PlayerHelperService.getReturnPage()) {
            $location.path(PlayerHelperService.getReturnPage());
        } else if (PlayerHelperService.getCurrentMovie().format) {
            if (!PlayerHelperService.getCurrentMovie().isLivestream) {
                var url = '/' + StationMonitor.getAlias(PlayerHelperService.getCurrentMovie().format.station) + '/' + PlayerHelperService.getCurrentMovie().format.seoUrl;
                $location.path(url);
            } else {
                $location.path('/' + StationMonitor.getAlias(PlayerHelperService.getCurrentMovie().format.station));
            }
        } else if ($route.current.$$route.data.embedded) {
            $route.reload();
        } else {
            $location.path('/');
        }
        PlayerHelperService.setCurrentMovie(false);
        if (!$rootScope.$$phase) $rootScope.$apply();
    }

    function showResumeInfobox(restartCB, resumeCB) {
        if (Accounting.isLoggedIn() && PlayerHelperService.getCurrentMovie().timecode > 0 && !PlayerHelperService.getCurrentMovie().isLiveStream) {
            var resume = function () {
                InfoBoxService.hide();
                resumeCB();
            };
            var configuration = {
                text: $filter('translate')('player.resume.text'),
                movie: PlayerHelperService.getMovieObject(),
                buttons: [
                    {
                        text: $filter('translate')('player.resume.skip'),
                        cls: 'left',
                        cb: resume
                    },
                    {
                        text: $filter('translate')('player.resume.restart'),
                        cls: 'right',
                        cb: function () {
                            restartCB();
                            InfoBoxService.hide();
                        }
                    }
                ]
            };

            startCountdownInterval(10, function () {
                restartCB();
                InfoBoxService.hide();
            }, 0);

            InfoBoxService.show(configuration);
            $rootScope.$broadcast('html5::onResumeOverlay');
        } else {
            restartCB();
        }
    }

    function startCountdownInterval(seconds, cb, type) {
        currentCountdown = seconds;
        if (countdownInterval) {
            $interval.cancel(countdownInterval);
        }
        countdownInterval = $interval(function () {
            onCountdown(currentCountdown, function () {
                cb();
            }, type);
            currentCountdown--;
        }, 1000);
    }

    /**
     * Start the Player
     * @param payid
     * @param isCountdown
     */
    function play(payid, isCountdown) {
        var promises = [];
        var paymovie = false;
        //$log.debug('isCountdown', isCountdown);
        if (isCountdown) {
            Optimizely.trackEvent('player__videostart_auto_' + (++autoMovieCount));
        }
        Optimizely.trackEvent('player__videostart_' + (++movieCount));
        if (payid > 0) {
            promises.push(NowApi.getMovie().list({
                'fields': '*,format,paymentPaytypes',
                'id': payid
            }).then(function (movie) {
                paymovie = movie;
            }));
        }
        $q.all(promises).then(function () {
            var countdown = PlayerHelperService.getAutostartCountdown();
            var startTimeCode = '00:00:00:00';
            var resumeTimeCode = '00:00:00:00';
            if (Accounting.isLoggedIn()) {
                var userTimeCode = moment('2014-01-01 00:00:00');
                userTimeCode.set('second', PlayerHelperService.getCurrentMovie().timecode);
                resumeTimeCode = $filter('amDateFormat')(userTimeCode, 'HH:mm:ss:00');
            }
            if ($location.search()['position']) {
                var shareTimeCode = moment('2014-01-01 00:00:00');
                shareTimeCode.set('second', $location.search()['position']);
                startTimeCode = $filter('amDateFormat')(shareTimeCode, 'HH:mm:ss:00');
                $location.search('position', null);
            }
            if (PlayerHelperService.getCurrentMovie().livestreamEvent && PlayerHelperService.getCurrentMovie().livestreamEvent.videochat) {
                resumeTimeCode = '00:00:00:00';
            }

            if (!isCountdown) countdown = 0;
            if (!PlayerHelperService.getCurrentMovie().isLivestream) {
                NowApi.getMovie().updateMovieViews({
                    REQUEST_BODY: {
                        'id': PlayerHelperService.getCurrentMovie().id
                    }
                });
            }
        });
    }

    /**
     * Returns current timecode
     * @returns {*}
     */
    function getTimeCode() {
        try {
            var seconds = 0;
            var percent = 0;
            if (self.currentVideoplayer && self.currentVideoplayer.player) {
                var movie = PlayerHelperService.getMovieObject();
                seconds = self.currentVideoplayer.player.getCurrentTime();
                percent = self.currentVideoplayer.player.getCurrentTime() / moment.duration(movie.duration, 'HH:mm:ss').asSeconds();
            }
            return [{time: seconds, percent: percent}];
        } catch (e) {
            return [{time: 0, percent: 0}];
        }
    }


    /**
     * Loads Movie to Player
     * @param formatSeoLink
     * @param movieSeoLink
     * @param movie
     * @param callback
     */
    function loadMovieToPlayer(formatSeoLink, movieSeoLink, movie, callback) {
        $log.debug('service_player player::loadMovieToPlayer', formatSeoLink, movieSeoLink, movie, Accounting.isPremiumUser(), self.firstLivestreamStarted);


        if (movie && movie.isLivestream && !Accounting.isPremiumUser()) {
            $log.debug('service_player player::loadMovieToPlayer livestream');
            Accounting.showPremiumOverlay();
            return;
        }

        if (movie && movie.id > 0) {
            self.setStation(movie.format.station, movie.isLivestream);
            self._buildAndCallMovieJson(movie, callback);
        }
        else {
            //$log.debug(formatSeoLink, movieSeoLink);
            NowApi.getMovie().retrieveMovieBySeoLink({
                formatSeoLink: formatSeoLink,
                movieSeoLink: movieSeoLink,
                station: StationMonitor.getStation(),
                fields: '*,format,files,manifest,breakpoints,paymentPaytypes'
            }).then(function (movie) {
                self.setStation(movie.format.station);
                self._buildAndCallMovieJson(movie, callback);
            }, function () {
                $log.debug('service_player Error movie not found');
            });
        }
    }

    function _buildAndCallMovieJson(movie, callback) {
        $log.debug('service_player _buildAndCallMovieJson FOUND MOVIE', movie);
        PlayerHelperService.setCurrentMovie(movie);
        PageHistory.setMovie(movie);
        $log.log('HTML5 CALL MOVIE', movie);
        if ((bowser.mobile || (bowser.tablet && !bowser.msie)) && movie.isDrm === true) {
            var osType;
            if (bowser.ios) {
                osType = 'ios';
            } else if (bowser.android) {
                osType = 'android';
            } else if (bowser.windowsphone || bowser.windows) {
                osType = 'windows';
            }

            var configuration = {
                text: $filter('translate')('player.drm.mobileinfo'),
                drmMobile: true,
                ostype: osType

            };

            InfoBoxService.show(configuration);
        } else {

            myconfig = PlayerConfigService.createConfig(movie);
            myconfig.style.button.help = helpOverlay;

            var eventManager = {
                playerEvents: function (event, data) {
                    $rootScope.$broadcast('html5::' + event.type, event, data, self);
                }
            };
            self.currentVideoplayer.registerPlugin(eventManager);
            var resumeCB = resumeMyMovie;

            var restartCB = function () {
                myconfig.source.options.startTime = 0;
                resumeCB();
            };
            showResumeInfobox(restartCB, resumeCB);
        }
    }


    function queryStreamcheckInSeconds(seconds) {
        streamCheckTimeout = $timeout(queryStreamcheck, seconds * 1000);
    }

    function cancelStreamcheck() {
        if (streamCheckTimeout) {
            $timeout.cancel(streamCheckTimeout);
            streamCheckTimeout = false;
        }
    }

    function queryStreamcheck() {

        if (PlayerHelperService.getCurrentMovie().isLivestream) {
            try {
                var url = AppConfig.settings.nowtv.player.streamcheck + "?station=" + StationMonitor.getStation();
                var headers = {};
                for (var prop in $http.defaults.headers.common) {
                    if ($http.defaults.headers.common.hasOwnProperty(prop)) {
                        headers[prop] = undefined;
                    }
                }
                var req = {
                    method: 'GET',
                    url: url,
                    headers: headers
                };


                $http(req).then(function (response) {
                        if (!response.data.success) {
                            var configuration = {text: $filter('translate')('player.geoblockingtext')};
                            InfoBoxService.show(configuration);
                        } else if (response.data.nextPoll) {
                            queryStreamcheckInSeconds(response.data.nextPoll)
                        } else {
                            queryStreamcheckInSeconds(60);
                        }
                    }
                    , function (response) {
                        if (response.status === 403) {
                            self.stop(true);
                            var errorMessage = response.data.errorMessage || 'player.geoblockingtext';
                            var configuration = {text: $filter('translate')(errorMessage)};
                            InfoBoxService.show(configuration);
                        } else {
                            queryStreamcheckInSeconds(60);
                        }
                    });
            } catch (e) {
                $log.log(e);
            }
        }
    }

    function resumeMyMovie() {
        try {
            $log.log('HTML5 CONF', myconfig);
            self.currentVideoplayer.startContent(myconfig).then(function () {
                $log.log('Success');

            }, function (reason) {
                $log.log(reason);
            });
        } catch (e) {
            $log.error(e);
            InfoBoxService.show({
                text: 'Fehler im Player... Bitte Seite neu laden'
            })
        }

    }

    function bindPlayerEventHandler() {
        $window['playerEvent'] = function (event, data) {
            return self.handleEvents(event, data);
        }
    }

    function bindGlobalPlayerFunctions() {
        self = this;
        $window['NowPlayerResize'] = function (width, height) {
            return self.resize(width, height);
        };

        $window['NowPlayerResizeReset'] = function () {
            self.resizeReset();
        };

        $window['NowPlayerResume'] = function () {
            self.resume();
        };

        $window['NowPlayerHideShare'] = function () {
            //SharePanel ausblenden  und automatisches Einblenden unterbinden (Sponsorbanner)
            self.displayShare(false, false);
        };
    }

    function setStation(station, isLivestream) {
        var bumpers = [];
        var openers = [];
        var closers = [];
        if (!self.lastStation || station !== self.lastStation) {
            if (angular.isArray(PlayerHelperService.getAdvertisements().items) && PlayerHelperService.getAdvertisements().items.length > 0) {
                angular.forEach(PlayerHelperService.getAdvertisements().items, function (ad) {
                    if (ad.station === station) {
                        //wenn isLivestream, bumper als Ad-Closer verwenden.
                        if (ad.type === 'bumper') bumpers.push({'url': ad.url});
                        if (ad.type === 'preclip') openers.push({'url': ad.url});
                        if (ad.type === 'postclip' && !isLivestream) closers.push({'url': ad.url});
                        if (ad.type === 'bumper' && isLivestream) closers.push({url: ad.url});
                    }
                });
            }


            self.setStationCmd = {
                'type': 'SET_STATION', 'data': {
                    'angebot': station + 'now',
                    'station': station,
                    'clips': {
                        'bumper': bumpers,
                        'opener': openers,
                        'closer': closers
                    },
                    'colors': self.playerColors
                }
            };
            self.lastStation = station;
            $log.debug('service_player setStation()', {'self.setStationCmd': self.setStationCmd});
        }
        else {
            self.setStationCmd = false;
        }
    }

    function decodeData(encodedData) {
        var data = null;
        try {
            data = unescape(encodedData);
            data = $.parseJSON(data);
        }
        catch (err) {
            $log.log(err);
        }
        return data;
    }

    function getCurrentMovieId() {
        var currentMovie = PlayerHelperService.getCurrentMovie();
        if (false === currentMovie) {
            return 0;
        }
        return currentMovie.id;
    }

    function getPrice() {
        var currentMovie = PlayerHelperService.getCurrentMovie();
        if (false === currentMovie) {
            return 0;
        }
        if (true !== angular.isUndefined(currentMovie.free) && true === currentMovie.free) {
            return 0;
        }
        var paymentPayTypes = currentMovie.paymentPaytypes;
        if (true === angular.isUndefined(paymentPayTypes)) {
            return 0;
        }
        return paymentPayTypes.items[0].price;
    }

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function getCompleteTime() {
        var movie = PlayerHelperService.getMovieObject();
        return moment.duration(movie.duration, 'HH:mm:ss').asSeconds();
    }

    function getCurrentTime() {
        return Math.floor(self.getTimeCode()[0].time);
    }

    function getTimePercentage(currentTime) {
        var percentage = ((currentTime) ? currentTime : self.getCurrentTime()) / self.getCompleteTime();
        percentage = Math.ceil(percentage * 100);
        percentage = self.clamp(percentage, 0, 100);
        return percentage;
    }

    function getSpecialTag() {
        return self.specialTag;
    }

    function unregisterEvents() {
        $log.debug('unregisterEvents', broadcastSubscriptions.length);
        angular.forEach(broadcastSubscriptions, function (event) {
            $log.debug('unregister Event');
            event();
        });
    }

    function pausedOverlay() {
        var configuration = {
            text: "PAUSE",
            circleText: "Weiter ansehen",
            movie: PlayerHelperService.getCurrentMovie(),
            fullscreen: PlayerHelperService.getFullscreenStatus(),
            breakad: (AppConfig.webclient === "mobile") ? false : !(self.adslot),
            circleFunction: circlePlayInfoBox
        };

        if (PlayerHelperService.getCurrentMovie().isLivestream) {
            configuration = {
                text: "LIVESTREAM STARTEN",
                fullscreen: PlayerHelperService.getFullscreenStatus(),
                circleCustomIcon: 'play',
                circleFunction: circlePlayInfoBox
            };
        }
        InfoBoxService.show(configuration);

    }

    function playerLogData() {
        var data = {
            bandwidth_http: 0,
            timecode: self.getTimeCode()[0].time,
            feedback: 3,
            usersession: 0,
            pageurl: $location.href,
            loginfo: self.currentVideoplayer.getLogFiles()
        }, datastring = $httpParamSerializer(data);

        return datastring;
    }


    function helpOverlay() {
        var headers = {
            'X-CLIENT-VERSION': undefined,
            'transformscope': undefined,
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        for (var prop in $http.defaults.headers.common) {
            if ($http.defaults.headers.common.hasOwnProperty(prop)) {
                headers[prop] = undefined;
            }
        }
        var token, analyzing = {
                text: $filter('translate')('player.feedback.headline'),
                textSmall: $filter('translate')('player.feedback.analyzing')
            },
            conf = {
                headers: headers
            },
            resume = {
                text: $filter('translate')('player.feedback.headline'),
                textSmall: $filter('translate')('player.feedback.thankyoutext'),
                buttons: [
                    {
                        text: 'FORTSETZEN',
                        cls: 'center',
                        cb: function () {
                            circlePlayInfoBox();
                        }
                    }
                ]
            };
        InfoBoxService.show(analyzing);
        $http.post('https://streamingerror.rtl.de/now_html5player_helpdesk.php', self.playerLogData(), conf).then(
            function (value) {
                token = value.data;
                if (value && value.data) {
                    InfoBoxService.show({
                        text: $filter('translate')('player.feedback.headline'),
                        textSmall: $filter('translate')('player.feedback.analyzed'),
                        buttons: [
                            {
                                text: 'WEITER',
                                cls: 'left',
                                cb: function () {
                                    $window.open('https://hilfe.tvnow.de/hc/de/requests/new?ticket_form_id=27632&ftoken=' + token, '_blank');
                                    InfoBoxService.show(resume);
                                }
                            },
                            {
                                text: 'ABBRECHEN',
                                cls: 'right',
                                cb: function () {
                                    circlePlayInfoBox();
                                }
                            }
                        ]
                    });
                }
            },
            function (error) {
                InfoBoxService.show({
                    text: 'Wir konnten leider keine technischen Infos über das laufende Video sammeln',
                    textSmall: 'Möchtest du trotzdem Feedback an unseren Support Senden?',
                    buttons: [
                        {
                            text: 'Ja',
                            cls: 'left',
                            cb: function () {
                                $window.open('https://hilfe.tvnow.de/hc/de/requests/new?ticket_form_id=27632', '_blank');
                                InfoBoxService.show(resume);
                            }
                        },
                        {
                            text: 'Abbrechen',
                            cls: 'right',
                            cb: function () {
                                circlePlayInfoBox();
                            }
                        }
                    ]
                });
            });
    }

    function continuousPlayOverlay() {

        $rootScope.$broadcast('html5::expandVideobar');

        var configuration = {
            text: 'WEITER GEHT ES MIT',
            circleButtons: []
        };

        var content = VideobarService.getCurrentVideobarContent();
        var movies = [];

        angular.forEach(content.items, function (item) {
            if (PlayerHelperService.getCurrentMovie().playPreview === true) {
                movies.push(item.movie);
            } else if (item.movie.id !== PlayerHelperService.getCurrentMovie().id) {
                movies.push(item.movie);
            }
        });
        if (movies.length > 0) {
            var nextMovie = movies[0];
            if (!nextMovie.free && !Accounting.isLoggedIn()) {
                configuration.circleButtons = [];
                configuration.circleButtons.push({
                    text: 'jetzt tv now plus Buchen',
                    custom: 'pay',
                    nextFormatTitle: nextMovie.format.title,
                    nextEpisodenTitle: nextMovie.title,
                    circleFunction: function () {
                        $location.search('premium', 'plusbarauto');
                    }
                });

                var nextItems = movies.slice(1, movies.length);
                angular.forEach(nextItems, function (item) {
                    if (configuration.circleButtons.length < 2 && PlayerHelperService.getCurrentMovie().id !== item.movie.id) {
                        if (item.movie.free) {
                            configuration.circleButtons.push({
                                text: 'Jetzt anschauen ',
                                custom: 'play',
                                nextFormatTitle: item.movie.format.title,
                                nextEpisodenTitle: item.movie.title,
                                circleFunction: function () {
                                    VideobarService.setCurrentVideobarContentType('playnow');
                                    PlayerHelperService.setAutomaticVideostart(false);
                                    PlayerHelperService.setPlaylistVideostart(false);
                                    $rootScope.$broadcast('html5::videobarPlayMovie', item);
                                    InfoBoxService.hide();
                                }
                            });
                        }
                    }
                });
            } else {
                configuration = {
                    text: 'WEITER GEHT ES MIT',
                    circleText: "JETZT ANSEHEN",
                    contentEnd: true,
                    movie: nextMovie,
                    circleFunction: function () {
                        InfoBoxService.hide();
                        PlayerHelperService.setAutomaticVideostart(false);
                        PlayerHelperService.setPlaylistVideostart(false);
                        $rootScope.$broadcast('html5::videobarPlayMovie', {movie: nextMovie});
                    }
                };
            }

            startCountdownInterval(10, function () {
                PlayerHelperService.setAutomaticVideostart(true);
                PlayerHelperService.setPlaylistVideostart(false);
                $rootScope.$broadcast('html5::videobarPlayMovie', {movie: nextMovie});
                InfoBoxService.hide();
            }, 0);

            InfoBoxService.show(configuration);
            if (!$rootScope.$$phase) $rootScope.$apply();
        } else {
            self.stop();
        }
    }

    function initEvents() {
        var allowedIssuer = [
            'ui-button',
            'ui-overlay',
            'ui-content-click',
            'ui-seek',
            'controls-content-click',
            'controls-button',
            'controls-keyboard',
            'controls-overlay',
            'controls-seek'
        ];


        broadcastSubscriptions.push($rootScope.$on('player::NOWTV_PLAYER_SHARE', onPlayerShare));
        broadcastSubscriptions.push($rootScope.$on('player::NOWTV_VIDEO_COMPLETE', onPlayerVideoComplete));

        broadcastSubscriptions.push($rootScope.$on('html5::onInitialStart', function (event, data) {
            PlayerHelperService.setCurrentState("loading");
            $log.debug('html5::onInitialStart', event, data);
            PlayerHelperService.setLastChapter(1);
            self.firstPlay = false;
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onPlay', function (event, data) {
            if (!self.firstPlay && (bowser.tablet === true || bowser.mobile === true)) {
                self.firstContentStarted = true;
                $rootScope.$broadcast('player::html5Play', '', {part: 0});
                self.firstPlay = true;
            }
            PlayerHelperService.setCurrentState("playing");
            $log.debug('html5::onPlay', event, data);

            killCountdown();
            InfoBoxService.hide();
            $log.debug('aktuelles video Objekt', PlayerHelperService.getMovieObject());

        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onContentStart', function (event, data) {

            if (!streamCheckTimeout) {
                self.queryStreamcheck();
            }

            if (!PlayerHelperService.getCurrentMovie().isLivestream && Optimizely.isActive()) {
                $window['optimizely'].push({
                    type: "event",
                    eventName: "content-start_tvnow"
                });
            }

            PlayerHelperService.setCurrentState("playing");
            $log.debug('html5::onContentStart', event, data);
            ;
            self.adslot = false;

            onPlayerContentStart(PlayerHelperService.getLastChapter());
        }));
        broadcastSubscriptions.push($rootScope.$on('html5::onContentEnd', function (event, data) {
            PlayerHelperService.setCurrentState("stopped");
            $log.debug('html5::onContentEnd', event, data);

            onPlayerContentEnd();
            onPlayerVideoComplete();
            self.cancelStreamcheck();
        }));
        broadcastSubscriptions.push($rootScope.$on('html5::onChapterSwitch', function (event, data) {
            $log.debug('html5::onChapterSwitch', event, data);

            PlayerHelperService.setLastChapter(data.part);
            if (data.issuer === 'click') {
                $rootScope.$broadcast('player::html5Play', '', {part: (data.part - 1)});
            }
            else if (data.issuer === 'contentEnd') {
                //configuration for chapter switch inclusive counter must be placed in onChapterSwitch
                var configuration = {
                    text: "Kapitel " + data.part,
                    circleText: "Direkt Ansehen",
                    movie: PlayerHelperService.getMovieObject(),
                    countDownText: "Sekunden bis zum Start",
                    chapterSwitch: true,
                    circleFunction: function () {
                        onPlayerUserPlay(data.part);
                        resume();
                    }
                };
                InfoBoxService.show(configuration);

                startCountdownInterval(10, function () {
                    circlePlayInfoBox();
                }, 1);

            }
        }));


        broadcastSubscriptions.push($rootScope.$on('html5::onPaused', function (event, data) {
            PlayerHelperService.setCurrentState("paused");
            $log.debug('html5::onPaused ', event, data);
            if (data.issuer === 'ui-button'
                || data.issuer === 'ui-content-click'
                || data.issuer === 'ui-overlay'
                || data.issuer === 'ui-shortcut'
                || data === 'premium_open') {
                pausedOverlay();
                if (allowedIssuer.indexOf(data.issuer) > -1) {
                    onPlayerContentPause();
                }

                if (!PlayerHelperService.getCurrentMovie().isLivestream && self.adslot === false) {
                    $rootScope.$broadcast('html5::showBreakad');

                }
            }
        }));

        $rootScope.$on('account::togglefulfillment', function (event, data) {
            $log.debug('premium open', event, data);
            if (PlayerHelperService.getCurrentState() === "playing") {
                pause();
            }
            $rootScope.$broadcast('html5::onPaused', 'premium_open');
        });

        broadcastSubscriptions.push($rootScope.$on('html5::onSessionStart', function (event, data) {
            $log.debug('html5::onSessionStart', event, data);
            PlayerHelperService.setCurrentState("loading");

        }));
        broadcastSubscriptions.push($rootScope.$on('html5::onSessionEnd', function (event, data) {
            PlayerHelperService.setCurrentState("stopped");
            $log.debug('html5::onSessionEnd', event, data);
            continuousPlayOverlay();
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onPlay', function (event, data) {
            PlayerHelperService.setCurrentState("playing");
            $log.debug('html5::onPlay', event, data);
            if (allowedIssuer.indexOf(data.issuer) > -1) {
                onPlayerContentResume();
            }
        }));
        broadcastSubscriptions.push($rootScope.$on('html5::onFullscreenEnter', function (event, data) {
            $log.debug('html5::onFullscreenEnter', event, data);
            PlayerHelperService.setLastsize('full');
            PlayerHelperService.setFullscreenStatus(true);
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onFullscreenExit', function (event, data) {
            $log.debug('html5::onFullscreenExit', event, data);
            PlayerHelperService.setLastsize('small');
            PlayerHelperService.setFullscreenStatus(false);
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onAdSlotStarted', function (event, data) {
            $log.debug('html5::onAdSlotStarted', event, data);
            self.adslot = true;
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onAdStarted', function (event, data) {
            $log.debug('html5::onAdStarted', event, data);
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onAdFinished', function (event, data) {
            $log.debug('html5::onAdFinished', event, data);
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onAdSlotFinished', function (event, data) {
            $log.debug('html5::onAdSlotFinished', event, data);
            self.adslot = false;
            $log.debug('html5::liveStreamPreroll::livestream Preroll', PlayerHelperService.getLiveStreamPreroll());
            if (PlayerHelperService.getCurrentMovie().isLivestream) {
                PlayerHelperService.setLiveStreamPreroll(false);
            }

        }));
        broadcastSubscriptions.push($rootScope.$on('html5::onTimeChanged', function () {
            var code = self.getTimeCode();
            if (!code) {
                code = self.lastCode;
            }
            MyProgrammeService.updateMovieStatistic(self.getCurrentMovieId(), code[0].percent, Math.floor(code[0].time), null, true);
            self.lastCode = code;
        }));


        broadcastSubscriptions.push($rootScope.$on('html5::onInfoShow', function (event, data) {
            $log.debug('html5::onInfoShow', event, data);
            var configuration;
            switch (data.issuer) {
                case 'geoBlocking':
                    configuration = {text: $filter('translate')('player.geoblockingtext')};
                    break;
                case 'adBlocker':
                    configuration = {text: $filter('translate')('player.adblockertext.reload')};
                    break;
                case 'concurrentStream':
                    configuration = {text: $filter('translate')('player.max-concurrent-streams')};
                    break;
                case 'playerSupport':
                    configuration = {text: data.text};
                    break;
            }
            InfoBoxService.show(configuration);
        }));

        broadcastSubscriptions.push($rootScope.$on('html5::onError', function (event, data) {
            $log.debug('html5::onError', event, data);
            if (data.message.indexOf('DRM') !== -1) {
                var configuration = {text: $filter('translate')('player.drm.general')};
                InfoBoxService.show(configuration);
            }
            self.cancelStreamcheck();
        }));


        function onPlayerShare(event, eventname, data) {
            if (angular.isDefined(data.data.action) && data.data.action === 'show') {
                self.showShare = true;
            }
            else {
                self.showShare = !self.showShare;
            }
            if (!$rootScope.$$phase) $rootScope.$apply();
        }

        function onPlayerVideoComplete() {
            Optimizely.trackEvent('player__videoend_' + movieCount);
        }

        function onPlayerContentResume() {
            self.saveTimeCodeInterval(true);
        }

        function onPlayerContentPause() {
            self.saveTimeCodeInterval(false);
        }

        function onPlayerContentEnd() {
            self.saveTimeCodeInterval(false);
        }

        function onPlayerUserPlay(part) {
            PlayerHelperService.setLastChapter(part);
        }

        function onPlayerContentStart() {
            $sessionStorage.trackingSessionVideoplays = ($sessionStorage.trackingSessionVideoplays) ? $sessionStorage.trackingSessionVideoplays + 1 : 1;
            self.firstContentStarted = true;
            $log.debug('service_player onPlayerContentStart getCurrentMovie()', PlayerHelperService.getCurrentMovie());
            $log.debug('service_player onPlayerContentStart firstLivestreamStarted', self.firstLivestreamStarted);
            if (PlayerHelperService.getCurrentMovie() && PlayerHelperService.getCurrentMovie().isLivestream) {
                self.firstLivestreamStarted = true;
                $log.debug('service_player onPlayerContentStart firstLivestreamStarted', self.firstLivestreamStarted);
            }
        }
    }

    function setPlayerCovered(covered) {
        if (covered) {
            self.pause();
            pausedOverlay();
        } else {
            circlePlayInfoBox();
        }
    }

    function compareVersionNumbers(v1, v2) {
        var v1parts = v1.split('.');
        var v2parts = v2.split('.');

        $log.debug('compare version number v1', v1);
        $log.debug('compare version number v2', v2);

        // First, validate both numbers are true version numbers
        function validateParts(parts) {
            for (var i = 0; i < parts.length; ++i) {
                if (!/^\d+$/.test(parts[i])) {
                    return false;
                }
            }
            return true;
        }

        if (!validateParts(v1parts) || !validateParts(v2parts)) {
            return NaN;
        }
        while (v1parts.length < v2parts.length) v1parts.push('0');
        while (v2parts.length < v1parts.length) v2parts.push('0');
        v1parts = v1parts.map(Number);
        v2parts = v2parts.map(Number);

        for (var i = 0; i < v1parts.length; ++i) {
            if (v2parts.length === i) {
                return 1;
            }
            if (v1parts[i] === v2parts[i]) {
                continue;
            }
            if (v1parts[i] > v2parts[i]) {
                return 1;
            }
            return -1;
        }

        return 0;
    }

    function activateHTML5Mode(movie) {
        var blacklisted = false;
        var whitelisted = true;
        var deferred = $q.defer();
        var config = AppConfig.settings.nowtv[STAGE.stage].player.html5.test;
        movie = movie || PlayerHelperService.getMovieObject();
        var liveStreamAllowedStations = (config.livestream && config.livestream.stations && angular.isArray(config.livestream.stations)) ? config.livestream.stations : false;

        var html5PlayerLibrary = AppConfig.settings.nowtv[STAGE.stage].player.html5.library;
        if ($window.env.prependVersionBeforeAssets) {
            html5PlayerLibrary = AppConfig.clientversion + '/' + html5PlayerLibrary;
        }

        if (!movie.isLivestream) {
            var formatids = (angular.isArray(config.formatids)) ? config.formatids : false;
            var vodAllowedStations = (angular.isArray(config.stations)) ? config.stations : false;
            var formatid = (angular.isObject(movie.format)) ? movie.format.id : false;
            $log.debug('platform', platform, platform.os.toString());

            var excludedPlatforms = (angular.isObject(config.excludedPlatforms)) ? config.excludedPlatforms : false;
            angular.forEach(excludedPlatforms, function (version, family) {
                $log.debug('platform family, version', family, version);
                if (family === platform.os.family && compareVersionNumbers(platform.os.version, version) === 0) {
                    blacklisted = true;
                    $log.debug('platform compareVersionNumbers(platform.os.version, version) === 0, blacklisted', compareVersionNumbers(platform.os.version, version) === 0, blacklisted);
                }
            });
            var supportedPlatforms = (angular.isObject(config.supportedPlatforms)) ? config.supportedPlatforms : false;
            angular.forEach(supportedPlatforms, function (version, family) {
                $log.debug('platform family, version', family, version);
                if (family === platform.os.family && compareVersionNumbers(platform.os.version, version) < 0) {
                    whitelisted = false;
                    $log.debug('platform compareVersionNumbers(platform.os.version, version) < 0, whitelisted', compareVersionNumbers(platform.os.version, version) < 0, whitelisted);
                }
            });
        }

        if (
            (
                !movie.isLivestream &&
                bowser.check(config.supportedBrowsers) && !blacklisted &&
                whitelisted
            )
        ) {
            if (!self.html5PlayerLoaded) {
                $ocLazyLoad
                    .load(html5PlayerLibrary)
                    .then(function () {
                        $log.debug('activateHTML5Mode', 'active');
                        self.html5PlayerLoaded = true;
                        deferred.resolve();
                    });
            } else {
                deferred.resolve();
            }
            // LIVESTREAM
        } else if (
            movie.isLivestream &&
            bowser.check(config.livestream.supportedBrowsers)
        ) {
            if (!self.html5PlayerLoaded) {
                $ocLazyLoad
                    .load(html5PlayerLibrary)
                    .then(function () {
                        $log.debug('activateHTML5Mode', 'active');

                        self.html5PlayerLoaded = true;
                        deferred.resolve();
                    });
            } else {
                deferred.resolve();
            }
        } else {
            $log.debug('activateHTML5Mode', 'deactivate');
            PlayerHelperService.setHTML5Mode(false);
            deferred.resolve();
        }

        return deferred.promise;
    }

    function logExternalError(e) {
        $log.error('HTML5 Player Error', e);
    }

    function isAd() {
        return self.adslot;
    }


}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .directive('nowPlayerInfobox', nowPlayerInfobox);

nowPlayerInfobox.$inject = ['InfoBoxService'];

function nowPlayerInfobox(InfoBoxService) {


    return {
        restrict: 'E',
        //replace: true,
        templateUrl: 'templates/player_info_box.html',
        link: link
    };


    function link(scope) {

        var fullscreen = false;
        scope.$on('html5::countdown', function (event, data) {
            scope.countdown = (data > 0) ? data : false;
        });
        scope.$on('html5::onFullscreenExit', function () {
            $('.text').removeAttr('style');
            $('.breakad_wrapper').removeAttr('style');
            fullscreen = false;
        });
        scope.$on('html5::onFullscreenEnter', function () {
            fullscreen = true;
        });

        scope.displayBox = InfoBoxService.isDisplayed();

        scope.$watch(function () {
            return InfoBoxService.getConfiguration();
        },function(config){
            scope.configuration = config;
        },true);

        scope.$watch(function () {
            if (scope.displayBox === true && fullscreen === true) {
                if (fullscreen === true) {
                    $('.breakad_wrapper').attr('style', 'left:510px; top:370px;');
                }
            }
            return InfoBoxService.isDisplayed();

        }, function (newState) {
            if (newState) {
                scope.configuration = InfoBoxService.getConfiguration();
            }
            scope.displayBox = newState;

        })


    }
}

})();

(function() {

'use strict';

angular
    .module('NowPlayerHTML5')
    .directive('nowplayer', nowplayer);

nowplayer.$inject = ['$window', 'PlayerService','PlayerConfigService', 'AppConfig', '$log', '$timeout', 'STAGE', 'Accounting', '$sessionStorage', '$rootScope', 'VideobarService', '$filter', '$location', '$document', 'PlayerHelperService', "InfoBoxService"];

function nowplayer($window, PlayerService, PlayerConfigService,  AppConfig, $log, $timeout, STAGE, Accounting, $sessionStorage, $rootScope, VideobarService, $filter, $location, $document, PlayerHelperService, InfoBoxService) {

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/player.html',
        link: link
    };

    function getPlayersize() {
        if ($window.innerWidth >= 1560) {
            return {'width': 1280, 'height': 720};
        } else if ($window.innerWidth >= 1260) {
            return {'width': 960, 'height': 540};
        } else {
            return {'width': 640, 'height': 360};
        }
    }

    function link(scope) {
        scope.spacer = (AppConfig.webclient !== 'mobile');

        function getLayoutsize() {
            if ($window.innerWidth >= 1560) {
                return 'l';
            } else if ($window.innerWidth >= 1260) {
                return 'm';
            } else {
                return 's';
            }
        }


        function embedHTML5Player() {
            $log.debug('embedHTML5Player', $document[0].getElementById('player_container'), $('#player_wrapper'));
            var conf = {
                location: {
                    ui: ($window.env.prependVersionBeforeAssets ? AppConfig.clientversion + '/' : '') + AppConfig.settings.nowtv[STAGE.stage].player.html5.controls.js,
                    ui_css: ($window.env.prependVersionBeforeAssets ? AppConfig.clientversion + '/' : '') + AppConfig.settings.nowtv[STAGE.stage].player.html5.controls.css
                },
                playback: {
                    autoplay: true,
                    muted: false
                },
                logging: false, // (STAGE.isProduction) ? false : true,
                advertising: {
                    playAds: true
                },
                errorReporting: {
                    exception: PlayerService.logExternalError,
                    clientId: Accounting.isLoggedIn() ? $sessionStorage.user.id : 0,
                    device: Accounting.getDeviceId()
                }
            };

            var vp = new CBCVideoplayer('player_container', conf);

            if (vp.isSupportedPlatform()) {
                initHTML5Player(vp);
            } else {
                PlayerService.displayUnsupportedPlatform(function() {
                    initHTML5Player(vp);
                });
            }
        }

        function initHTML5Player(vp) {
            PlayerService.setDOMElement($('#player_container'));
            PlayerService.setPlayer(vp);

            PlayerService.handleEvents('NOWTV_INITIALIZED');
        }

        function deleteHTML5Player() {
            $log.debug('deleteHTML5Player', PlayerService.currentVideoplayer);
            if (angular.isObject(PlayerService.currentVideoplayer) && angular.isFunction(PlayerService.currentVideoplayer.destroy)) {
                PlayerService.currentVideoplayer.destroy();
            }
            PlayerService.currentVideoplayer = false;
            PlayerHelperService.setPlaylistVideostart(false);
        }

        PlayerHelperService.setSize(getLayoutsize());
        scope.playerWrapperShow = false;
        scope.show = false;
        scope.showBar = function () {
            if (PlayerHelperService.getFullscreenStatus()) {
                scope.$broadcast('videobar::show');
            }
        };

        scope.isTablet = (bowser.tablet && !bowser.msie) ? true : false;
        scope.isAndroid = (bowser.android) ? true : false;
        scope.forced = false;
        scope.exitPlayer = function () {
            if ($location.url() === PlayerHelperService.getReturnPage()) {
                var url = $filter('geturl')(PlayerHelperService.getCurrentMovie().format, 'isformat');
                PlayerHelperService.setReturnPage(url.split('?')[0]);
            }
            VideobarService.setCurrentChannel(false);
            PlayerService.handleEvents('NOWTV_PLAYER_EXIT');
        };

        scope.$watch(function () {
            return PlayerHelperService.getCurrentState();
        }, function (currentstate) {
            if (currentstate === 'stopped' && PlayerHelperService.getFullscreenStatus() === true) {
                $rootScope.$broadcast('html5::expandVideobar');
            }
        });

        var init = false;


        scope.$watch('playerWrapperShow', function (show, before) {
            if (show) {
                embedHTML5Player();
                $window.scrollTo(0, 1);
            } else if (!show && before) {
                deleteHTML5Player();
            }
        });


        scope.$watch(function () {
                return PlayerService.show;
            },
            function (show) {

                if (!show) {
                    scope.playerWrapperShow = false;
                }
                if (show && !init) {

                    init = true;
                    scope.playerWrapperShow = true;
                }
                else if (init) {
                    init = false;
                    $('body').removeClass('player');
                }
                scope.show = show;

                PlayerHelperService.setSize(getLayoutsize());

                $('#videoplayer').css(getPlayersize());
                if (!$rootScope.$$phase) scope.$apply();
            }
        );

        scope.$on('resize::resize', function (event, data, test) {
            $('#videobar,.now-playerlayer .bar').css({'width': '100%'});

        });

        scope.$on('resize::jump', function (event, size, innerWidth, playersize) {
            if (scope.forced) {
                //console.log('FORCED TO SIZE CANT CHANGE SIZE!');
                return true;
            }
            $log.debug('resize::resize', event, size, innerWidth, playersize);
            $('#videobar,.now-playerlayer .bar').css({'width': '100%'});
            $('.now-playerlayer .content').css({'width': playersize.width + 210});
            $('#videoplayer').css(playersize);

            PlayerHelperService.setSize(size);
        });

        scope.$on('resize::force', function (event, width, height) {
            //console.log('RESIZE FORCED', width, height);
            scope.forced = true;

            PlayerHelperService.setSize('custom');

            $('.now-playerlayer .content').css({'width': width + 210});
            $('.now-playerlayer .player_box').css({'width': width, 'min-height': height});
            $('#videoplayer').css({'width': width, 'height': height});
        });

        scope.$on('resize::forceReset', function () {
            scope.forced = false;

            PlayerHelperService.setSize(getLayoutsize());

            var playersize = getPlayersize();
            $('#videoplayer').css(playersize);
            $('.now-playerlayer .content, .now-playerlayer .player_box').removeAttr('style');
        });

    }

}

})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .directive('nowVideobar', nowVideobar);

nowVideobar.$inject = ['VideobarService', 'PlayerService', '$timeout', 'Accounting', '$rootScope', 'AppConfig', '$log', 'PlayerHelperService'];

function nowVideobar(VideobarService, PlayerService, $timeout, Accounting, $rootScope, AppConfig, $log, PlayerHelperService) {
    return {
        restrict: 'E',
        //replace: true,
        scope: {
            exit: '=',
            exitText: '@'
        },
        templateUrl: 'templates/player_videobar.html',
        link: link
    };


    function link(scope) {
        scope.hidden = false;
        scope.fadeout = false;
        scope.showMenu = true;
        scope.countdownFirst = false;
        scope.countdownSeccond = false;
        scope.isTablet = (bowser.tablet && !bowser.msie) ? true : false;

        scope.exitText = (bowser.mobile === true) ? scope.exitText || 'Schließen' : scope.exitText || 'Player schließen';

        scope.isCountdown = isCountdown;
        scope.play = play;
        scope.arrows = function () {
            if (AppConfig.webclient === 'mobile' || (bowser.tablet && !bowser.msie)) {
                return false;
            } else {
                return true;
            }
        };


        initEvents(scope);
        reset();
        var init = false,
            barLeaveTimeout,
            pause = false,
            countdownFirst = false,
            countdownSeccond = false,
            videobarShowListener;

        function initShowListener() {
            return scope.$on('videobar::show', function () {
                scope.hidden = false;
                scope.fadeout = false;
            });
        }

        scope.close = function () {
            scope.hidden = true;
            scope.expand = false;
            scope.exit();
        };

        scope.onBarLeave = function () {
            barLeaveTimeout = $timeout(function () {
                scope.expand = false;
            }, 4000);
        };
        scope.killBarLeaveTimeout = function () {
            if (barLeaveTimeout) {
                $timeout.cancel(barLeaveTimeout);
            }
            if (Accounting.isLoggedIn()) {
                scope.$broadcast('forcereload');
            }
        };


        function reset() {
            scope.expand = false;
            scope.title = "Empfehlungen";
            scope.loading = true;
            scope.ad = false;
            scope.currentTeasers = [];
            scope.teasers = [];
            scope.channel = false;
            scope.showMenu = true;
            countdownFirst = false;
            countdownSeccond = false;
        }


        function play(index) {
            if (index > 0) {
                scope.expand = false;
                $timeout(function () {
                    $rootScope.$broadcast('html5::videobarPlayMovie', scope.teasers[index]);
                    $('.videobar .teasers').slick('unslick');
                }, 500);

                PlayerHelperService.setAutomaticVideostart(false);
                PlayerHelperService.setPlaylistVideostart(true);
                if (!scope.channel) {
                    VideobarService.setCurrentVideobarContentType('reco');
                    VideobarService.setNowPlayingContentType('reco');
                } else {
                    VideobarService.setCurrentVideobarContentType('channels');
                    VideobarService.setNowPlayingContentType('channels');
                }

            } else {
                if (PlayerService.currentState === "playing") {

                    $('.videobar .teaser:nth(0) .circleicon').removeClass().addClass('icon circleicon icon_circle_pause');
                    PlayerService.pause();
                    $rootScope.$broadcast('html5::onPaused', 'premium_open');
                    //pause = true;
                } else {
                    if (PlayerHelperService.getCurrentMovie().timecode > 0 && PlayerHelperService.getCurrentState() === "stopped") {
                        PlayerService.resumeMyMovie();
                    } else {
                        PlayerService.resume();
                    }
                    $('.videobar .teaser:nth(0) .circleicon').removeClass().addClass('icon circleicon icon_circle_play');
                    //pause = false;
                }
            }

        }


        function slickIt() {

            var slickOptions = {
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true,
                infinite: false,
                speed: 300,
                touchThreshold: 15,
                swipeToSlide: true,
                nextArrow: $('.videobar .ar'),
                prevArrow: $('.videobar .al')
            };

            $('.videobar .teasers')
                .slick(slickOptions);
        }


        function loadVideobarContent() {

            if (!init && !PlayerHelperService.getCurrentMovie().isLiveStream) {
                init = true;
                VideobarService.setNewVideobarInUse(true);
                scope.channel = false;

                if (VideobarService.getCurrentChannel()) {
                    scope.title = "Channels";
                    scope.channel = true;
                    scope.live = false;

                } else if (PlayerService.showLive) {
                    scope.title = "Live";
                    scope.live = true;
                    scope.channel = false;
                } else {
                    scope.title = "Empfehlungen";
                    scope.channel = false;
                    scope.live = false;
                }

                if (!scope.live) {
                    VideobarService.loadContent().then(
                        function (data) {
                            angular.forEach(data.items, function (teaser, index) {
                                if (PlayerHelperService.getCurrentMovie().playPreview === true) {
                                    scope.teasers.push(teaser);
                                } else if (index === 0 || teaser.movie.id !== PlayerHelperService.getCurrentMovie().id) {
                                    scope.teasers.push(teaser);
                                }
                            });

                            scope.loading = false;
                            $timeout(function () {
                                slickIt();
                            }, 1000);

                        },
                        function () {
                            $log.error("ERROR");
                        }
                    );
                }
            }

            if (PlayerHelperService.getCurrentMovie().isLiveStream) {
                scope.showMenu = false;
            }
        }

        function isCountdown(i) {
            if (i === 0 && countdownFirst === true) {
                scope.expand = true;
                return true;
            }
            if (i === 1 && countdownSeccond === true) {
                scope.expand = true;
                return true;
            }
            return false;
        }

        function resetCountdownCss(i) {
            if (i === 0) {
                countdownFirst = false;
            }
            if (i === 1) {
                countdownSeccond = false;
            }
            $('.videobar .teaser:nth(i) .circleicon').removeClass().addClass('icon circleicon icon_circle_play');
        }

        function initEvents() {
            var resume = false;
            scope.$on('html5::countdown', function (event, data, type) {
                scope.countdown = (data > 0) ? data : false;

                if (resume === true) {
                    if (data > 0 && type != 1) {
                        countdownFirst = true;
                        $('.videobar .teaser:nth(0) .active .circleicon').removeClass().addClass('icon circleicon icon_circle_countdown icon_circle_countdown_' + data);
                        resetCountdownCss(1);
                    } else {
                        resetCountdownCss(0);
                        scope.expand = false;
                    }
                } else {
                    if (data > 0 && type != 1) {
                        countdownSeccond = true;
                        $('.videobar .teaser:nth(1) .circleicon').removeClass().addClass('icon circleicon icon_circle_countdown icon_circle_countdown_' + data);
                        resetCountdownCss(0);
                    } else {
                        resetCountdownCss(1);
                    }
                }
            });

            scope.$on('html5::onResumeOverlay', function () {
                if (!PlayerHelperService.getCurrentMovie().isLiveStream) {
                    countdownFirst = false;
                    $('.videobar .teaser:nth(0) .circleicon').removeClass().addClass('icon circleicon icon_circle_play');
                    resume = true;
                    scope.expand = true;
                    loadVideobarContent();
                }
            });

            scope.$on('html5::onFullscreenEnter', function () {
                scope.fadeout = false;
                scope.hidden = false;
                videobarShowListener = initShowListener();
            });

            scope.$on('html5::onFullscreenExit', function () {
                if (scope.live === true && scope.expand === true) {
                    scope.close();
                    if (!$rootScope.$$phase) scope.$apply();
                } else {
                    scope.hidden = false;
                    scope.fadeout = false;
                }
            });

            scope.$on('html5::onSessionStart', function () {
                if (resume === false) {
                    loadVideobarContent();
                } else {
                    resume = false;
                }
            });

            scope.$on('html5::onAdSlotStarted', function () {
                scope.ad = true;
                scope.expand = false;
            });

            scope.$on('html5::onAdSlotFinished', function () {
                scope.ad = false;
                if (!$rootScope.$$phase) scope.$apply();
            });

            scope.$on('html5::resetVideobar', function () {
                reset();
            });

            scope.$on('html5::expandVideobar', function () {
                scope.ad = false;
                scope.expand = true;
            });

            scope.$on('html5::onSessionEnd', function () {
                scope.hidden = false;
                scope.fadeout = false;
            });

            scope.$on('html5::onPlay', function () {
                scope.expand = false;
                resetCountdownCss(1);
                resetCountdownCss(0);
                if (!$rootScope.$$phase) $rootScope.$apply();
            });

            scope.$on('html5::onHideControls', function () {
                if (AppConfig.webclient === 'mobile' || PlayerHelperService.getFullscreenStatus()) {
                    if (scope.expand === false) {
                        scope.hidden = true;
                    }
                    if (!$rootScope.$$phase) $rootScope.$apply();
                }
            });

            scope.$on('html5::onShowControls', function () {
                if (AppConfig.webclient === 'mobile' || PlayerHelperService.getFullscreenStatus()) {
                    if (scope.expand === true) {
                        scope.expand = false;
                    }
                    scope.hidden = false;
                    if (!$rootScope.$$phase) $rootScope.$apply();
                }
            });

            scope.$on('html5::onContentStart', function () {
                scope.ad = false;
            });

            videobarShowListener = initShowListener();

            scope.$on('videobar::fadeout', function () {
                if (scope.expand === true && scope.live === true) {
                    $log.debug('nothing');
                } else {
                    scope.hidden = false;
                    scope.fadeout = true;
                }
            });

            scope.$on('videobar::hide', function () {
                scope.hidden = true;
                scope.fadeout = false;
                videobarShowListener();
            });

        }


    }

}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .service('AgeCheck', AgeCheck);

AgeCheck.$inject = [
    '$q',
    '$http'
];

/**
 *@constructor
 */
function AgeCheck($q, $http) {
    var self = this;

    self.doAgeCheck = doAgeCheck;

    return self;

    function doAgeCheck(movie) {
        return $q(function (resolve, reject) {
            var checkfile = '';

            if (!movie.fsk12 && !movie.fsk16 && !movie.fsk18) {
                return resolve();
            }

            if (movie.fsk12) {
                checkfile = '/12.php';
            } else if (movie.fsk16) {
                checkfile = '/16.php';
            } else {
                checkfile = '/18.php';
            }

            $http({
                method: 'GET',
                url: checkfile,
            }).then(function successCallback(data) {
                if (data.data.hasOwnProperty('blocked') && data.data.hasOwnProperty('age') && data.data.blocked === false) {
                    resolve(data.data);
                } else {
                    reject();
                }
            }, function errorCallback() {
                reject();
            });
        });
    }
}

})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .service('InfoBoxService', InfoBoxService);

InfoBoxService.$inject = [
    '$rootScope'
];

/**
 *@constructor
 */
function InfoBoxService($rootScope) {
    var self = this;

    self.show = show;
    self.hide = hide;
    self.isDisplayed = isDisplayed;
    self.getConfiguration = getConfiguration;
    self.resetBoxToDefault = resetBoxToDefault;
    self.configuration = {};
    self.displayBox = false;

    return self;

    function show(configuration) {

        if (configuration) {
            self.configuration = configuration;
        }
        self.displayBox = true;
        if (!$rootScope.$$phase) $rootScope.$apply();
    }

    function hide() {
        self.resetBoxToDefault();
    }

    function isDisplayed() {
        return self.displayBox;
    }

    function getConfiguration() {
        return self.configuration;
    }

    function resetBoxToDefault() {
        self.configuration = {};
        self.displayBox = false;
    }
}

})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .service('LiveStreamService', LiveStreamService);

LiveStreamService.$inject = [
    'NowApi',
    '$q',
    '$log',
    'StationMonitor',
    '$route'
];

/**
 *@constructor
 */
function LiveStreamService(NowApi, $q, $log, StationMonitor, $route) {
    var self = this;

    self.loadLive = loadLive;
    self.loadLiveStation = loadLiveStation;
    self.fetchLiveStreams = fetchLiveStreams;
    self.getLiveStreamMovie = getLiveStreamMovie;
    self.getLiveSzm = getLiveSzm;
    self.getPageSzm = getPageSzm;

    self.livestreamUrls = [];
    self.liveStreams = [];
    self.szm = {};

    return self;

    function getLiveStreamMovie(station) {
        return $q(function (resolve) {
            self.fetchLiveStreams().then(function (livestreams) {
                $log.debug('service_livestream getLiveStreamMovie', livestreams, station);
                resolve(createLiveStreamMovie(livestreams[station]));
            });
        });
    }

    function loadLive() {
        return NowApi.getEpgs().retrieveNowAndNextMovies({
            'fields': '*,nowNextEpgTeasers.*,nowNextEpgMovies.*'
        });
    }

    function loadLiveStation(station, maxPerPage) {
        return NowApi.getEpgs().retrieveNowAndNextMoviesByStation({
            'station': station,
            'limit': maxPerPage,
            'fields': '*,epgFormat,movie.*,movie.format,epgFormat.format'
        });
    }

    function fetchLiveStreams() {
        return $q(function (resolve) {
            self.loadLive().then(function (data) {
                var stationAlias;
                angular.forEach(data.items, function (value) {
                    if (value.nowNextEpgTeasers && value.nowNextEpgTeasers.now) {
                        $log.debug('service_livestream fetchLiveStreams', value);
                        stationAlias = StationMonitor.getAlias(value.name);
                        self.livestreamUrls[stationAlias] =
                            self.liveStreams[stationAlias] = {
                                id: value.id,
                                station: value.name,
                                movieid: value.nowNextEpgTeasers.now.livestreamMovieId,
                                hds: value.nowNextEpgTeasers.now.manifest.hds,
                                dash: value.nowNextEpgTeasers.now.manifest.dash,
                                hls: value.nowNextEpgTeasers.now.manifest.hlsfairplay
                            };
                    }
                });
                resolve(self.liveStreams);
            });
        });
    }

    function getLiveSzm(station) {
        return {
            player: {
                angebot: getLivestreamAngebot(),
                ivw: getLivestreamIvwTag(station),
                agof2_video: getLivestreamAgofVideoTag(station),
                agof2_bild: getLivestreamAgofBildTag(station),
                videoPlazaAdTag: getLivestreamVideoplazaTag(station)
            }
        };
    }

    function getPageSzm(station) {
        return {
            player: {
                angebot: getLivestreamAngebot(),
                ivw: getPageIvwTag(station),
                agof2_video: getLivestreamAgofVideoTag(station),
                agof2_bild: getLivestreamAgofBildTag(station),
                videoPlazaAdTag: getLivestreamVideoplazaTag(station)
            }
        };
    }

    function createLiveStreamMovie(livestream) {
        //alert(TrackingHelper.getFullVideoIvwComment(movie.format.szm.player.ivw));
        $log.debug('service_livestream createLiveStreamMovie', {livestream: livestream, '$route': $route});
        self.szm = self.getLiveSzm(livestream.station);

        return {
            id: livestream.movieid,
            title: '',
            isLivestream: true,
            geoblocked: false,
            playPreview: false,
            free: false,
            timeType: 1,
            productPlacement: 0,
            dontCall: 0,
            aspectRatio: '16:9',
            cornerLogo: 'none',
            refplanningId: 0,
            duration: '05:00:00',
            format: {
                station: livestream.station,
                title: StationMonitor.getStationName(livestream.station) + ' Livestream',
                metaTitle: StationMonitor.getStationName(livestream.station) + ' Livestream',
                szm: self.szm,
                videoPlazaAdTag: getLivestreamVideoplazaTag(livestream.station)
            },
            files: {
                items: [
                    {
                        type: 'video/livestream',
                        path: livestream.hds
                    }
                ]
            },
            manifest: {
                dash: livestream.dash,
                hds: livestream.hds,
                hlsfairplay: livestream.hls
            }
        };
    }

    function getLivestreamAngebot() {
        return 'tvnow';
    }

    function getLivestreamIvwTag(station) {
        /*var ivw = '/tv_now_de' + $route.current.locals.page.szm.static.ivw;
         return ivw.replace('nowtv_now/', '');*/

        //hardcoded, weil beim livestreamstart per videobar nicht die page abgerufen wird und die daten nicht zur verfügung stehen
        var streamIvwTags = {
            rtl: '/rtl_now/videoabrufe_live',
            vox: '/vox_now/videoabrufe_live',
            rtl2: '/rtl_2_now/videoabrufe_live',
            superrtl: '/super_rtl_now/videoabrufe_live',
            nitro: '/rtl_nitro_now/videoabrufe_live',
            ntv: '/ntv_now/videoabrufe_live',
            rtlplus: '/rtl_plus_now/videoabrufe_live',
            toggoplus: '/toggo_plus_now/videoabrufe_live',
            nowus: '/now_us/videoabrufe_live'
        };

        return streamIvwTags[station];
    }

    function getPageIvwTag(station) {
        /*var ivw = '/tv_now_de' + $route.current.locals.page.szm.static.ivw;
         return ivw.replace('nowtv_now/', '');*/

        //hardcoded, weil beim livestreamstart per videobar nicht die page abgerufen wird und die daten nicht zur verfügung stehen
        var streamIvwTags = {
            rtl: '/rtl_now/live_tv',
            vox: '/vox_now/live_tv',
            rtl2: '/rtl_2_now/live_tv',
            superrtl: '/super_rtl_now/live_tv',
            nitro: '/rtl_nitro_now/live_tv',
            ntv: '/ntv_now/live_tv',
            rtlplus: '/rtl_plus_now/live_tv',
            toggoplus: '/toggo_plus_now/live_tv',
            nowus: '/now_us/live_tv'

        };

        return streamIvwTags[station];
    }

    function getLivestreamAgofVideoTag(station) {
        //return ($route.current.locals.page.szm.static.agof2_video !== 'dbrsowf_ten_default') ? $route.current.locals.page.szm.static.agof2_video : $route.current.locals.page.agof;
        //hardcoded, weil beim livestreamstart per videobar nicht die page abgerufen wird und die daten nicht zur verfügung stehen
        var streamAgofTags = {
            rtl: 'dvrsowf_ten_rnlivetv',
            vox: 'dvrsowf_ten_vnlivetv',
            rtl2: 'dvrsowf_ten_r2nlivetv',
            superrtl: 'dvrsowf_ten_srnlivetv',
            nitro: 'dvrsowf_ten_rnnlivetv',
            ntv: 'dvrsowf_ten_nnlivetv',
            rtlplus: 'dvrsowf_ten_rpnlivetv',
            toggoplus: 'dvrsowf_ten_tpnlivetv',
            nowus: 'dvrsowf_ten_nuslivetv'
        };

        return streamAgofTags[station];
    }

    function getLivestreamAgofBildTag(station) {
        //hardcoded, weil beim livestreamstart per videobar nicht die page abgerufen wird und die daten nicht zur verfügung stehen
        var streamAgofTags = {
            rtl: 'dbrsowf_ten_rnlivetv',
            vox: 'dbrsowf_ten_vnlivetv',
            rtl2: 'dbrsowf_ten_r2nlivetv',
            superrtl: 'dbrsowf_ten_srnlivetv',
            nitro: 'dbrsowf_ten_rnnlivetv',
            ntv: 'dbrsowf_ten_nnlivetv',
            rtlplus: 'dbrsowf_ten_rpnlivetv',
            toggoplus: 'dbrsowf_ten_tpnlivetv',
            nowus: 'dbrsowf_ten_nuslivetv'
        };

        return streamAgofTags[station];
    }

    function getLivestreamVideoplazaTag(station) {
        var streamVideoplazaTags = {
            rtl: 'now_rtlnow/livestream',
            vox: 'now_voxnow/livestream',
            rtl2: 'now_rtl2now/livestream',
            superrtl: 'now_superrtlnow/livestream',
            nitro: 'now_rtlnitronow/livestream',
            ntv: 'now_ntvnow/livestream',
            rtlplus: 'now_rtlplusnow/livestream',
            nowus: 'now_nowus/livestream',
            toggoplus: 'now_toggoplusnow/livestream'
        };

        return streamVideoplazaTags[station];
    }
}

})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowPlayer')
    .service('PlayerConfigService', PlayerConfigService);

PlayerConfigService.$inject = ['$sessionStorage', 'Accounting', '$window', 'StationMonitor', 'moment', 'TrackingHelper', '$log', 'AppConfig', 'STAGE', '$filter', 'AdControlService', '$location', 'ContentblockerService', 'PlayerTrackingService', 'PlayerHelperService', 'Optimizely'];

/**
 *@constructor
 */
function PlayerConfigService($sessionStorage, Accounting, $window, StationMonitor, moment, TrackingHelper, $log, AppConfig, STAGE, $filter, AdControlService, $location, ContentblockerService, PlayerTrackingService, PlayerHelperService, Optimizely) {
    var self = this;
    self.automaticVideostart = false;
    self.currentMovie = false;

    self.logoPosition = {
        'rtl': 0,
        'rtl2': 3,
        'superrtl': 0,
        'nitro': 0,
        'vox': 0,
        'nowus': 0,
        'ntv': 3,
        'rtlplus': 0,
        'toggoplus': 0
    };
    self.logoBasewidth = {
        'ar43': {
            'rtl': 1440,
            'rtl2': 1440,
            'superrtl': 1440,
            'nitro': 1440,
            'vox': 1440,
            'ntv': 1440,
            'rtlplus': 1440,
            'nowus': 1440,
            'toggoplus': 1440
        },
        'ar169': {
            'rtl': 1920,
            'rtl2': 1920,
            'superrtl': 1920,
            'nitro': 1920,
            'vox': 1920,
            'ntv': 1920,
            'rtlplus': 1920,
            'nowus': 1920,
            'toggoplus': 1920
        },
        'ar219': {
            'rtl': 1920,
            'rtl2': 1920,
            'superrtl': 1920,
            'nitro': 1920,
            'vox': 1920,
            'ntv': 1920,
            'rtlplus': 1920,
            'nowus': 1920,
            'toggoplus': 1920
        }
    };

    self.getStationLogos = getStationLogos;
    self.getDefaultUserdata = getDefaultUserdata;
    self.createConfig = createConfig;
    self.getReferrerUrlAdCall = getReferrerUrlAdCall;

    function getReferrerUrlAdCall() {
        return $location.protocol() + '://' + $location.host() + '/' + StationMonitor.getStation();
    }

    function getStationLogos() {
        return {
            'rtl': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.rtl,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtl/cornerlogo_21zu9.png',
                    'position': self.logoPosition.rtl
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.rtl,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtl/cornerlogo_16zu9.png',
                    'position': self.logoPosition.rtl
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.rtl,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtl/cornerlogo_4zu3.png',
                    'position': self.logoPosition.rtl
                },
            },
            'rtl2': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.rtl2,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtl2/cornerlogo_21zu9.png',
                    'position': self.logoPosition.rtl2
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.rtl2,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtl2/cornerlogo_16zu9.png',
                    'position': self.logoPosition.rtl2
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.rtl2,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtl2/cornerlogo_4zu3.png',
                    'position': self.logoPosition.rtl2,
                }
            },
            'superrtl': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.superrtl,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/superrtl/cornerlogo_21zu9.png',
                    'position': self.logoPosition.superrtl,
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.superrtl,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/superrtl/cornerlogo_16zu9.png',
                    'position': self.logoPosition.superrtl,
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.superrtl,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/superrtl/cornerlogo_4zu3.png',
                    'position': self.logoPosition.superrtl,
                }
            },
            'nitro': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.nitro,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/nitro/cornerlogo_21zu9.png',
                    'position': self.logoPosition.nitro,
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.nitro,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/nitro/cornerlogo_16zu9.png',
                    'position': self.logoPosition.nitro,
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.nitro,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/nitro/cornerlogo_4zu3.png',
                    'position': self.logoPosition.nitro,
                }
            },
            'vox': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.vox,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/vox/cornerlogo_21zu9.png',
                    'position': self.logoPosition.vox,
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.vox,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/vox/cornerlogo_16zu9.png',
                    'position': self.logoPosition.vox,
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.vox,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/vox/cornerlogo_4zu3.png',
                    'position': self.logoPosition.vox
                }
            },
            'ntv': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.ntv,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/ntv/cornerlogo_21zu9.png',
                    'position': self.logoPosition.ntv
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.ntv,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/ntv/cornerlogo_16zu9.png',
                    'position': self.logoPosition.ntv
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.ntv,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/ntv/cornerlogo_4zu3.png',
                    'position': self.logoPosition.ntv
                }
            },
            'rtlplus': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.rtlplus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtlplus/cornerlogo_21zu9.png',
                    'position': self.logoPosition.rtlplus
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.rtlplus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtlplus/cornerlogo_16zu9.png',
                    'position': self.logoPosition.rtlplus
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.rtlplus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/rtlplus/cornerlogo_4zu3.png',
                    'position': self.logoPosition.rtlplus,
                }
            },
            'toggoplus': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.toggoplus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/toggoplus/cornerlogo_21zu9.png',
                    'position': self.logoPosition.toggoplus,
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.toggoplus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/toggoplus/cornerlogo_16zu9.png',
                    'position': self.logoPosition.toggoplus
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.toggoplus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/toggoplus/cornerlogo_4zu3.png',
                    'position': self.logoPosition.toggoplus
                }
            },
            'nowus': {
                '21:9': {
                    'basewidth': self.logoBasewidth.ar219.nowus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/nowus/cornerlogo_21zu9.png',
                    'position': self.logoPosition.nowus
                },
                '16:9': {
                    'basewidth': self.logoBasewidth.ar169.nowus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/nowus/cornerlogo_16zu9.png',
                    'position': self.logoPosition.nowus
                },
                '4:3': {
                    'basewidth': self.logoBasewidth.ar43.nowus,
                    'url': 'https://tvnowstatic-a.akamaihd.net/tvnow/styles/images/cornerlogos/nowus/cornerlogo_4zu3.png',
                    'position': self.logoPosition.nowus
                }
            }
        };
    }

    function getDefaultUserdata() {
        return {
            email: 'alluser@rtl.de',
            password: 'password',
            token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE0ODY0Njc1MzUsImlzcyI6Imh0dHBzOlwvXC9hcGkudHZub3cuZGVcL3R2bm93XC93ZWIiLCJhdWQiOiJvM2kydWhyb3doaWVmaXNlZmh1c2xpZWpmaGxrc2RoZmtqc2RmIiwidWlkIjozMTMzNjQzMSwicm9sZXMiOlsidXNlciJdLCJwYWNrYWdlcyI6W10sImhhc0FjcXVpcmVkUGFja2FnZXMiOmZhbHNlLCJyaCI6ImE2NTc1NzZiYmRkZDA0OTNiNGQ5MjBmYzE3ZTIwZjQ5IiwiY2siOiIwNzkxNzgzZTZlYjhlNjhhYjllNzAzMDY5MmU5NDMzNiIsInN1YnNjcmlwdGlvbiI6bnVsbH0.RBcfycowqO55UBacbIAbFIgGSrcaXOFFp4YS2qlcR8I'
        }
    }

    function createConfig(movie) {
        self.currentMovie = movie;
        var bumpers = [],
            openers = [],
            closers = [],
            noad, movieDuration, midrollcounter;

        if (PlayerHelperService.getAdvertisements() && angular.isArray(PlayerHelperService.getAdvertisements().items) && PlayerHelperService.getAdvertisements().items.length > 0) {
            angular.forEach(PlayerHelperService.getAdvertisements().items, function (ad) {
                if (ad.station === movie.format.station) {
                    //wenn isLivestream, bumper als Ad-Closer verwenden.
                    if (ad.type === 'bumper') bumpers.push({url: ad.url});
                    if (ad.type === 'preclip') openers.push({url: ad.url});
                    if (ad.type === 'postclip' && !movie.isLivestream) closers.push({url: ad.url});
                    if (ad.type === 'bumper' && movie.isLivestream) closers.push({url: ad.url});
                }
            });
        }

        //Content Bumper aus dem Format überschreibt den AdvertisementBumper.
        if (angular.isObject(movie.format.contentBumper)) {
          bumpers = [];
          bumpers.push({url: movie.format.contentBumper.online});
        }

        var user = self.getDefaultUserdata();
        if (Accounting.isLoggedIn()) {
            user = $sessionStorage.user;
        }

        noad = !!(movie.ignoreAd);
        movieDuration = (!movie.playPreview) ? movie.duration + ':00' : '00:02:00:00';

        PlayerHelperService.setLastChapter(false);

        var conf = {
            style: {
                button: {
                    airPlay: function () {
                        if (bowser.tablet || bowser.mobile) {
                            $window.open(AppConfig.ffc + '/?premium=extscreen', '_blank');
                        }
                    },
                    chromeCast: function () {
                        if (bowser.tablet || bowser.mobile) {
                            $window.open(AppConfig.ffc + '/?premium=extscreen', '_blank');
                        }
                    },
                    help: false
                },
                info: {
                    productPlacement: (movie.productPlacementType === 'pp'),
                    contest: (movie.productPlacementType === 'gb'),
                    dontCall: !!(movie.dontCall),
                    fsk: (movie.fsk !== null && !movie.isLivestream) ? ('ab ' + movie.fsk) : ''
                }
            },
            tracking: PlayerTrackingService.generateTrackingObj(movie),
            advertising: {
                homad: {
                    show: !!(PlayerHelperService.getSVM()),
                    clientConfig: 'https://cdn.static-fra.de/now/homadConfigSmartclip-tvnow.json'
                },
                adCall: {
                    category: movie.format.videoPlazaAdTag,
                    referrerUrl: self.getReferrerUrlAdCall(),
                    defaultTags: ['fwd_j4=1:2','fwd_j5=0:1:2:3:4:5','fwd_c1=1:2:3:4:5:6:7','fwd_c4=2:3:4:5','fwd_c5=3:4','fwd_b9=2','fwd_h8=3:4','fwd_n0=3:4','fwd_g4=3:4','fwd_j3=3:4','fwd_a1=2','fwd_b4=2','fwd_b8=2','fwd_b6=2','fwd_n8=3:4','fwd_m1=1:2:3','fwd_k1=1','fwd_k2=1','fwd_k3=1','fwd_k4=1','fwd_k5=1','fwd_f1=1','fwd_f2=1','fwd_f3=1','fwd_f4=1','fwd_f5=1','fwd_f6=1','fwd_f7=1','fwd_n5=3:4','fwd_n1=3:4','fwd_n7=3:4','fwd_a9=2','fwd_h5=3:4'],
                    fixParams: AdControlService.getSXPKeys(movie.isLivestream)
                },
                clips: {
                    bumpers: bumpers,
                    openers: openers,
                    closers: closers
                },
                playAds: (movie.playPreview) ? true : !noad,
                playPreroll: (movie.isLivestream) ? PlayerHelperService.getLiveStreamPreroll() : true,
                playMidroll: true,
                playPostroll: true,
                companionAds: !movie.isLivestream
            },
            geoBlocking: {
                block: (!!movie.geoblocked),
                text: $filter('translate')('player.geoblockingtext')
            },
            downscaling: {
                block: ContentblockerService.getAbc(movie.format),
                text: $filter('translate')('player.adblockertext.reload')
            },
            livestream: !!(movie.isLivestream),
            errorReporting: {
                exception: function (error) {
                    if ($window.Bugsnag) {
                        $window.Bugsnag.notify('HTML5Player', 'Configuration error', error, 'error');
                    }
                }
            },
            user: {
                id: '' + (Accounting.isLoggedIn() ? $sessionStorage.user.id : 0),
                loggedIn: Accounting.isLoggedIn(),
                status: Accounting.getStates().indexOf(Accounting.getSubscriptionState())
            }
        };

        if (Accounting.getClientId()) {
            conf.user.hashedEMail = Accounting.getClientId();
        }

        if (angular.isObject($window.optimizely)) {
            conf.user.activeExperimentNames = (Optimizely.getActiveExperimentNames() !== '') ? Optimizely.getActiveExperimentNames() : 'na';
            conf.user.variationNames = (Optimizely.getVariationNames() !== '') ? Optimizely.getVariationNames() : 'na';
        }

        if (angular.isObject($window.thcObj) && $window.thcObj.technic) {
            conf.user.smartDataId = $window.thcObj.technic;
        }else{
            conf.user.smartDataId = 'na';
        }

        if (Accounting.isLoggedIn() && movie.timecode > 0) {
            conf.startType = 3;
        }

        midrollcounter = 1;
        if (movie.breakpoints && !movie.playPreview) {
            conf.advertising.defaultMidrollOffsets = movie.breakpoints.items.map(function (breakpoint) {
                if (Accounting.isPremiumUser()) {
                    if (breakpoint.type === 's' && midrollcounter++ % 2 === 0) {
                        return moment.duration(breakpoint.time.substring(0, 8), 'HH:mm:ss').asSeconds();
                    }
                }
                else {
                    if (breakpoint.type === 'a') {
                        return moment.duration(breakpoint.time.substring(0, 8), 'HH:mm:ss').asSeconds();
                    }
                }
            }).filter(function (item) {
                return angular.isDefined(item);
            });
            if (!Accounting.isPremiumUser()) {
                conf.playerParts = {
                    start: 1,
                    sections: []
                };
                conf.playerParts.sections = movie.breakpoints.items.map(function (breakpoint) {
                    if (breakpoint.type === 's') {
                        return moment.duration(breakpoint.time.substring(0, 8), "HH:mm:ss").asSeconds();
                    }
                }).filter(function (item) {
                    return angular.isDefined(item);
                });
                $log.log("HTML 5 PARTS", conf.playerParts);
            }
            $log.log("HTML 5 BREAKPOINTS", conf.advertising.defaultMidrollOffsets);
        }

        var logos = getStationLogos();
        var logo = null;
        if (logos[StationMonitor.getStation()]) {
            logo = logos[StationMonitor.getStation()][movie.aspectRatio];
            logo.aspectRatio = movie.aspectRatio;
        }

        if (logo && movie.cornerLogo !== 'none' && movie.cornerLogo !== 'watchbox') {
            conf.style.logo = {
                aspectRatioOld: (movie.aspectRatio === '4:3'),
                url: logo.url,
                position: (self.logoPosition[StationMonitor.getStation()] === 0) ? 'topLeft' : 'bottomRight',
                basewidth: logo.basewidth
            }
        }

        conf.concurrentStream = {
            check: Accounting.isPremiumUser(),
            startUrl: AppConfig.settings.nowtv.player.concurrentcheck,
            heartbeatUrl: AppConfig.settings.nowtv.player.concurrentcheck_heartbeat,
            stopUrl: AppConfig.settings.nowtv.player.concurrentcheck_stop,
            sessionKey: Accounting.getDeviceId(),
            jwt: user.token,
            text: $filter('translate')('player.max-concurrent-streams')
        };

        var movieIvwConf = movie.format.szm.player.ivw;
        if (!movieIvwConf.match(/tv_now_de/)) movieIvwConf = TrackingHelper.getFullVideoIvwComment(movie.format.szm.player.ivw, movie.isLivestream ? 'live' : '')

        conf.source = {
            videoId: movie.id,
            length: moment.duration(movieDuration, 'HH:mm:ss').asSeconds(),
            options: {
                startTime: movie.timecode
            },
            pay: !movie.free,
            title: !movie.isLivestream ? movie.title : movie.format.title,
            format: (!movie.playPreview) ? ((!movie.isLivestream) ? movie.format.title : '') : 'Vorschau: ' + movie.format.title,
            description: !movie.isLivestream ? $filter('statustext')(movie) : '',
            refPlanningId: movie.refplanningId,
            previewStart: movie.broadcastPreviewStartDate,
            startDate: movie.broadcastStartDate,
            agof: movie.format.szm.player.agof2_video,
            ivw: movieIvwConf,
            payStatus: (!movie.playPreview) ? movie.timeType : 9,
            startType: PlayerHelperService.isAutomaticVideostart() ? 1 : (PlayerHelperService.isPlaylistVideostart() ? 2 : 0),
            webonly: (["watchbox", "nowus", "tvnow"].indexOf(StationMonitor.getStation()) > -1)
        };


        if (bowser.mobile || (bowser.tablet && !bowser.msie)) {

            if (
                AppConfig.settings.nowtv[STAGE.stage].player.html5.mobilesource
                && AppConfig.settings.nowtv[STAGE.stage].player.html5.mobilesource.length > 0
            ) {
                var settings = AppConfig.settings.nowtv[STAGE.stage].player.html5.mobilesource;

                angular.forEach(settings, function (setting) {
                    conf.source[setting.format] = movie.manifest[setting.manifest];
                    if (setting.append) {
                        conf.source[setting.format] = conf.source[setting.format] + setting.append;
                    }
                    if (setting.replace) {
                        conf.source[setting.format] = conf.source[setting.format].replace(setting.replace.search, setting.replace.string);
                    }
                });
            } else {
                conf.source.dash = movie.manifest.dashclear;
                conf.source.hls = movie.manifest.dashclear.replace(/\.mpd/, 'fairplay.m3u8');
            }
        } else {
            conf.source.hls = (!movie.playPreview) ? movie.manifest.hlsfairplay : movie.trailers.items[0].manifest.hls;
            conf.source.dash = (!movie.playPreview) ? movie.manifest.dash : movie.trailers.items[0].manifest.dash;
            conf.source.drm = {
                userToken: user.token
            };
        }

        return conf;
    }
}

})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowPlayer')
    .service('PlayerHelperService', PlayerHelperService);

PlayerHelperService.$inject = [];

/**
 *@constructor
 */
function PlayerHelperService () {
    var self = this;

    self.fullscreen = false;
    self.currentState = "stopped";
    self.returnPage = false;
    self.currentMovie = false;
    self.movieObject = false;
    self.currentSize = 'undefined';
    self.automaticVideostart = false;
    self.playlistVideostart = false;
    self.autostartCountdown = 0;
    self.lastsize = 'small';
    self.lastChapter = false;
    self.advertisements = false;
    self.advertisementsClips = false;
    self.liveStreamPreroll = true;
    self.recoInfo = false;

    self.getLiveStreamPreroll = getLiveStreamPreroll;
    self.setLiveStreamPreroll = setLiveStreamPreroll;

    self.getFullscreenStatus = getFullscreenStatus;
    self.setFullscreenStatus = setFullscreenStatus;

    self.setCurrentState = setCurrentState;
    self.getCurrentState = getCurrentState;

    self.setReturnPage = setReturnPage;
    self.getReturnPage = getReturnPage;

    self.setCurrentMovie = setCurrentMovie;
    self.getCurrentMovie = getCurrentMovie;

    self.getSVM = getSVM;

    self.getMovieObject = getMovieObject;
    self.setMovieObject = setMovieObject;

    self.setSize = setSize;
    self.getSize = getSize;

    self.setAutomaticVideostart = setAutomaticVideostart;
    self.isAutomaticVideostart = isAutomaticVideostart;

    self.setPlaylistVideostart = setPlaylistVideostart;
    self.isPlaylistVideostart = isPlaylistVideostart;

    self.setAutostartCountdown = setAutostartCountdown;
    self.getAutostartCountdown = getAutostartCountdown;

    self.setLastsize = setLastsize;
    self.getLastsize = getLastsize;

    self.setLastChapter = setLastChapter;
    self.getLastChapter = getLastChapter;

    self.setAdvertisements = setAdvertisements;
    self.getAdvertisements = getAdvertisements;

    self.setRecoInfo = setRecoInfo;
    self.getRecoInfo = getRecoInfo;

    function getRecoInfo() {
        return self.recoInfo;
    }

    function setRecoInfo(info) {
        self.recoInfo = info;
    }

    function getLiveStreamPreroll() {
        return self.liveStreamPreroll;
    }

    function setLiveStreamPreroll(preroll) {
        self.liveStreamPreroll = preroll;
    }

    function setAdvertisements(advertisment) {
        self.advertisements = advertisment;
    }

    function getAdvertisements() {
        return self.advertisements;
    }

    function setLastChapter(chapter) {
        self.lastChapter = chapter
    }

    function getLastChapter() {
        return self.lastChapter;
    }

    function setLastsize(size) {
        self.lastsize = size;
    }

    function getLastsize() {
        return self.lastsize;
    }

    function setAutostartCountdown(countdown) {
        self.autostartCountdown = countdown;
    }

    function getAutostartCountdown() {
        return self.autostartCountdown;
    }

    function setAutomaticVideostart(videostart) {
        self.automaticVideostart = videostart;
    }

    function isAutomaticVideostart() {
        return self.automaticVideostart;
    }

    function setPlaylistVideostart(videostart) {
        self.playlistVideostart = videostart;
    }

    function isPlaylistVideostart() {
        return self.playlistVideostart;
    }

    function setSize(size) {
        self.currentSize = size;
    }

    function getSize() {
        return self.currentSize;
    }

    function setMovieObject(movieObj) {
        self.movieObject = movieObj;
    }

    function getMovieObject() {
        return self.movieObject;
    }

    function getSVM() {
        return 1;
    }

    function setCurrentMovie(movie) {
        self.currentMovie = movie;
    }

    function getCurrentMovie() {
        return self.currentMovie;
    }

    function getFullscreenStatus() {
        return self.fullscreen;
    }

    function setFullscreenStatus(status) {
        return self.fullscreen = status;
    }

    function getCurrentState() {
        return self.currentState;
    }

    function setCurrentState(state) {
        return self.currentState = state;
    }

    function setReturnPage(url) {
        self.returnPage = url;
    }

    function getReturnPage() {
        return self.returnPage;
    }
}

})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowPlayer')
    .service('PlayerTrackingService', PlayerTrackingService);

PlayerTrackingService.$inject = ['$rootScope', 'Accounting', 'TrackingHelper', '$log', 'AppConfig', 'STAGE', 'NowGoogleAnalytics', 'PlayerHelperService', '$route'];

/**
 *@constructor
 */
function PlayerTrackingService($rootScope, Accounting, TrackingHelper, $log, AppConfig, STAGE, NowGoogleAnalytics, PlayerHelperService, $route) {
    var self = this;
    self.trackingUserAction = false;

    self.generateTrackingObj = generateTrackingObj;
    self.getMoviePayStatusAsText = getMoviePayStatusAsText;
    self.returnFullVideoIvw = returnFullVideoIvw;
    self.getPlaytypeForTracking = getPlaytypeForTracking;
    self.getPlayersizeForTracking = getPlayersizeForTracking;
    self.setTrackingUserAction = setTrackingUserAction;


    function setTrackingUserAction(action) {
        self.trackingUserAction = action;
    }

    function getPlaytypeForTracking() {
        return ($route.current.$$route.controller === 'NowLiveTvController') ? 'live_tv_player' : 'vod_player';
    }

    function getPlayersizeForTracking() {
        return (PlayerHelperService.getLastsize() === 'full') ? 'fullscreen_player' : 'embedded_player';
    }

    function returnFullVideoIvw(movie) {
        return TrackingHelper.getFullVideoIvwComment(movie.format.szm.player.ivw, movie.isLivestream ? 'live' : '');
    }

    function getMoviePayStatusAsText(movie) {
        if (!movie) {
            movie = PlayerHelperService.getCurrentMovie();
        }
        var states = ['na', 'free_preview', 'free_justmissed', 'free_archive', 'pay_preview', 'pay_justmissed', 'pay_archive'];
        if (movie.playPreview) {
            return 'free_trailer';
        }
        if (movie.isLivestream) {
            return 'livestream';
        }
        return states[movie.timeType] || false
    }

    function generateTrackingObj(movie) {
        var station = movie.format.station;
        $log.debug('userstatus new', Accounting.getStates().indexOf(Accounting.getSubscriptionState()));

        var movieIvw = movie.format.szm.player.ivw;
        $log.debug('html5::movieIVW', movieIvw);
        var trackingObj = {
            angebot: station + 'now',
            videoservice: 'now',
            nielsen: {
                vcId: AppConfig.settings[movie.format.station][STAGE.stage].player.reporting.nielsen.vcid,
                sfCode: AppConfig.settings[movie.format.station][STAGE.stage].player.reporting.nielsen.sfcode,
                prod: AppConfig.settings[movie.format.station][STAGE.stage].player.reporting.nielsen.prod,
                apId: AppConfig.settings[movie.format.station][STAGE.stage].player.reporting.nielsen.apid
            },
            googleanalytics: {
                googleAnalyticsId: NowGoogleAnalytics.getGoogleAnalyticsId()
            },
            nurago: {},
            heartbeat: {}
        };

        $log.debug('isLivestream', movie.isLivestream);
        if (movie.isLivestream === true) {
            trackingObj.videoservice = AppConfig.settings.nowtv.player.livestream.service[movie.format.station];
        }

        return trackingObj;
    }
}

})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowPlayer')
    .service('VideobarService', VideobarService);

VideobarService.$inject = [
    'NowApi',
    '$rootScope',
    '$log',
    '$filter',
    'AutoimgUrlHelper',
    'MyProgrammeService',
    '$q',
    'RecommendationService',
    'NowGoogleAnalytics',
    'StationMonitor',
    'LiveStreamService',
    '$route',
    'Accounting',
    'Optimizely',
    'AppConfig',
    'PlayerHelperService'
    ];

/**
 *@constructor
 */
function VideobarService(NowApi, $rootScope, $log, $filter, AutoimgUrlHelper, MyProgrammeService, $q, RecommendationService, NowGoogleAnalytics, StationMonitor, LiveStreamService, $route, Accounting, Optimizely, AppConfig,PlayerHelperService) {
    var self = this,
        broadcastSubscriptions = [];

    self.setPlayerService = setPlayerService;
    self.getCurrentChannelTag = getCurrentChannelTag;
    self.setCurrentChannelTag = setCurrentChannelTag;
    self.getCurrentChannel = getCurrentChannel;
    self.getPlayingMenu = getPlayingMenu;
    self.setCurrentChannel = setCurrentChannel;
    self.voidfunc = voidfunc;
    self.reset = reset;
    self.alertLogin = alertLogin;
    self.initEvents = initEvents;
    self.unregisterEvents = unregisterEvents;
    self.getTrackingNameForVideobar = getTrackingNameForVideobar;
    self.loadChannels = loadChannels;
    self.loadChannelMovies = loadChannelMovies;
    self.loadMorePosition = loadMorePosition;
    self.loadMore = loadMore;
    self.loadTop20Teasers = loadTop20Teasers;
    self.updateReco = updateReco;
    self.getRecoEntryTeaser = getRecoEntryTeaser;
    self.getRecoEntry = getRecoEntry;
    self.doRecommendationClick = doRecommendationClick;
    self.preloadRecommendations = preloadRecommendations;
    self.handleRecommendations = handleRecommendations;
    self.generateEpgMovieTeaser = generateEpgMovieTeaser;
    self.generateMovieTeaser = generateMovieTeaser;
    self.generateSubmenuEntry = generateSubmenuEntry;
    self.playNewMovie = playNewMovie;
    self.playLivestream = playLivestream;
    self.trackVideobarClick = trackVideobarClick;
    self.getLivestreamLiveSzm = getLivestreamLiveSzm;
    self.getLivestreamPageSzm = getLivestreamPageSzm;
    self.findNextMovies = findNextMovies;

    self.preloadAllTabs = preloadAllTabs;
    self.loadRecoTab = loadRecoTab;
    self.isNewVideobarInUse = isNewVideobarInUse;
    self.setNewVideobarInUse = setNewVideobarInUse;
    self.getCurrentVideobarContentType = getCurrentVideobarContentType;
    self.setCurrentVideobarContentType = setCurrentVideobarContentType;
    self.getCurrentVideobarContent = getCurrentVideobarContent;
    self.loadContent = loadContent;
    self.isLiveStream = isLiveStream;
    self.setLiveStream = setLiveStream;
    self.getNowPlayingContentType = getNowPlayingContentType;
    self.setNowPlayingContentType = setNowPlayingContentType;


    self.reset = reset;

    self.playerService = false;
    self.currentChannel = null;
    self.liveMovies = [];
    self.newPlayingMenuFree = '';
    self.currentChannelTag = '';
    self.maxPerPage = 20;
    self.recommendationService = RecommendationService;
    self.isDirectStart = false;
    self.live = false;
    self.isInUse = false;

    self.globalMovieContainer = {
        'reco': [], 'more': [], 'channels': []
    };
    self.videobarData = {
        'reco': [], 'more': [], 'channels': [], 'live': []
    };
    self.playingMenu = '';
    self.playingChannel = 0;
    self.playingStation = 0;
    self.displayingMenu = '';
    self.displayingChannel = 0;
    self.displayingStation = 0;

    self.currentVideobarContent = [];

    self.currentVideobarContentType = "reco";
    self.nowPlayingContentTyp = "";


    return self;

    function isLiveStream() {
        return self.live;
    }

    function setLiveStream(live) {
        self.live = live;
    }
    function setNewVideobarInUse (inUse){
        self.isInUse = inUse;
    }

    function isNewVideobarInUse() {
        return self.isInUse;
    }

    function getCurrentVideobarContent() {
        return self.currentVideobarContent;
    }

    function getCurrentVideobarContentType() {
        return self.currentVideobarContentType;
    }

    function setCurrentVideobarContentType(contentType) {
        self.currentVideobarContentType = contentType;
    }

    function getNowPlayingContentType() {
        return self.nowPlayingContentTyp;
    }

    function setNowPlayingContentType(nowPlayingType) {
        self.nowPlayingContentTyp = nowPlayingType;
    }


    function setPlayerService(service) {
        self.playerService = service;
    }

    function trackVideobarClick(button, videobarId) {
        $rootScope.trackingUserAction = true;
        NowGoogleAnalytics.trackEvent('videobar', button, self.getTrackingNameForVideobar(videobarId));
    }

    function unregisterEvents() {
        $log.debug('unregisterEvents', broadcastSubscriptions.length);
        angular.forEach(broadcastSubscriptions, function (event) {
            $log.debug('unregister Event');
            event();
        });
    }

    function initEvents() {

    }

    function getTrackingNameForVideobar(which) {
        switch (which) {
            case 'more':
                return 'mehr_episoden';
            case 'channels':
                return 'kanaele';
            case 'reco':
                return 'empfehlungen';
            case 'live':
                return 'live_tv';
            default:
                $log.debug('undefined: getTrackingNameForVideobar(' + which + ')');
                return '(undefiniert)';
        }
    }


    function loadChannels() {
        return NowApi.getChannels().retrieveChannelsByStation({
            'station': 'rtl', 'filter': {'Active': true}, 'fields': '*', 'page': 1, 'maxPerPage': 100
        });
    }

    function loadChannelMovies(submenu, page) {
        return NowApi.getChannels().retrieveMoviesByChannelId({
            'id': submenu,
            'fields': '*,format,pictures,paymentPaytypes,packages',
            'page': page,
            'maxPerPage': self.maxPerPage
        });
    }

    function loadMorePosition(filter) {
        return NowApi.getMovie().context({
            'fields': 'broadcastStartDate',
            'filter': filter,
            'order': 'BroadcastStartDate asc',
            'page': 1,
            'maxPerPage': 300
        });
    }

    function loadMore(id) {
        return NowApi.getMovie().context({
            'fields': '*,format,pictures,paymentPaytypes,packages',
            'id': id
        });
    }

    function loadTop20Teasers() {
        return NowApi.getTeasersets().retrieveTeaserSetById({
            'id': 203,
            'fields': '*,teaserSetInformations.id,teaserSetInformations.movie.*,teaserSetInformations.movie.format.*,teaserSetInformations.movie.pictures,teaserSetInformations.movie.paymentPaytypes'
        });
    }

    function updateReco(recoEntries) {
        var newItems = [];
        $log.debug('recoEntries',recoEntries);
        recoEntries.forEach(function (entry) {
            var movie = false;
            try {
                movie = self.generateMovieTeaser(entry.movie);
            } catch (e) {
                movie = false;
                $log.debug('wrong reco');
            }
            if (movie) {
                newItems.push(movie);
            }
        });
    }

    function getRecoEntryTeaser(teaser) {
        $log.debug('Reco::RecoEntryTeaser::Teaser',teaser);
        return {
            id: teaser.movie.id, pay: !(teaser.movie.free || teaser.movie.payed), teaser: teaser, movie: teaser.movie
        };
    }

    function getRecoEntry(movie) {
        return {
            id: movie.id, pay: !(movie.free || movie.payed), movie: movie
        };
    }

    function preloadRecommendations() {
        self.recommendationService.getRecommendationsForVideoBar(
            self.playerService.getCurrentMovieId(),
            function (data) {
                data.items.forEach(function (element, index) {
                    $log.debug('Reco::preloadReco::Element',element);
                    var recommendationItem = self.getRecoEntryTeaser(element);
                    $log.debug('Reco::preloadReco::Item',recommendationItem);
                    self.globalMovieContainer.reco[index + 1] = (recommendationItem);
                });
                self.updateReco(self.globalMovieContainer.reco);
            }
        );
    }

    function doRecommendationClick(movieId) {
        if (0 === self.globalMovieContainer.reco.length) {
            return;
        }
        self.globalMovieContainer.reco.forEach(function (recoEntry) {
            if (movieId === recoEntry.id && false === angular.isUndefined(recoEntry.teaser)) {
                self.recommendationService.fireEventRecClick(recoEntry.teaser);
            }
        });
    }

    function handleRecommendations() {
        if (false === RecommendationService.isReceivingEnabled()) {
            self.updateReco(self.globalMovieContainer.reco);
            return;
        }
        self.preloadRecommendations();
    }

    function generateEpgMovieTeaser(epgMovie, type) {
        AutoimgUrlHelper.setParams(null, null, null, '240x135', null, epgMovie.id);
        var pictureurl = AutoimgUrlHelper.getAutoimgUrl();
        return ({
            'id': epgMovie.livestreamMovieId,
            'image': pictureurl,
            'title': (epgMovie.movie) ? epgMovie.movie.title : epgMovie.title,
            'format': (epgMovie.movie) ? ((epgMovie.movie && epgMovie.movie.format) ? epgMovie.movie.format.title : (epgMovie.epgFormat.format) ? epgMovie.epgFormat.format.title : epgMovie.epgFormat.name) : epgMovie.title,
            'statustext': (epgMovie.movie) ? $filter('statustext')(epgMovie.movie) : $filter('statustext')(epgMovie),
            'startDateIso': epgMovie.startDateIso,
            'type': type,
            'station': epgMovie.station,
            'options': 'none'
        });
    }

    function generateMovieTeaser(movie) {

        if (movie.id && movie.format && movie.format.id) {
            AutoimgUrlHelper.setParams(movie.id, movie.format.id, 'formatlogo', '240x135');
            var pictureurl = AutoimgUrlHelper.getAutoimgUrl();
            var settingShow = (AppConfig.settings.nowtv.videobar && AppConfig.settings.nowtv.videobar.favorites && AppConfig.settings.nowtv.videobar.favorites.showicon && AppConfig.settings.nowtv.videobar.favorites.showicon === 'true');
            var usericon = (settingShow) ? ((MyProgrammeService.checkIfFormatsExists(movie.format.id)) ? 'remove' : 'add') : 'none';
            return ({
                'id': movie.id,
                'formatid': movie.format.id,
                'percent': MyProgrammeService.getMovieStatistic(movie.id, 'progress'),
                'image': pictureurl,
                'title': movie.title,
                'format': movie.format,
                'statustext': $filter('statustext')(movie),
                'type': (movie.free || movie.payed) ? 'free' : 'pay',
                'station': movie.format.station,
                'options': usericon,
                'movie': movie
            });
        }
    }

    function generateSubmenuEntry(data, submenupos, prefix, key) {
        $log.debug('player::videobar::generateSubmenuEntry', data, submenupos, prefix, key);
        var entry = {};
        entry.id = prefix + '_' + data.id;
        entry.label = data.title;
        if (data.id === submenupos || (!submenupos && key === 0)) {
            entry.active = true;
            if (prefix === 'channel') {
                $log.debug('player::videobar::generateSubmenuEntry currentChannelTag', data.ivw);
                self.currentChannelTag = data.ivw;
            }
        }

        return (entry);
    }

    function playNewMovie(id, payid, isCountdown) {
        NowApi.getMovie().list({
            'fields': '*,format,files,manifest,breakpoints,paymentPaytypes',
            'id': id
        }).then(function (movie) {
            var cb = function () {
                self.playerService.play(payid, isCountdown);
            };
            self.playerService.addProgressToMovie(movie);
            $log.debug('player::videobar::playNewMovie > loadMovieToPlayer');
            self.playerService.loadMovieToPlayer('', '', movie, cb);
        });
    }

    function findNextMovies() {
        var movie = PlayerHelperService.getCurrentMovie();
        var newPlayingMenuPay = '';
        var newPlayingMenuFree = '';
        var i, j;
        var playNext = false;
        var playNextFreeId = 0;
        var playNextPayId = 0;

        if (self.playingMenu === 'more') {
            for (i in self.globalMovieContainer.more) {
                if (playNext && playNextFreeId === 0 && angular.isDefined(self.globalMovieContainer.more[i].pay)) {
                    if (!self.globalMovieContainer.more[i].pay) {
                        playNextFreeId = self.globalMovieContainer.more[i].id;
                        newPlayingMenuFree = 'more';
                        break;
                    }
                    else if (playNextPayId === 0) {
                        playNextPayId = self.globalMovieContainer.more[i].id;
                        newPlayingMenuPay = 'more';
                    }
                }
                if (self.globalMovieContainer.more[i].id === movie.id) {
                    playNext = true;
                }
            }
        }
        if (self.playingMenu === 'channels') {
            for (j in self.globalMovieContainer.channels) {
                for (i in self.globalMovieContainer.channels[j]) {
                    if (playNext && playNextFreeId === 0 && angular.isDefined(self.globalMovieContainer.channels[j][i].pay)) {
                        if (!self.globalMovieContainer.channels[j][i].pay) {
                            playNextFreeId = self.globalMovieContainer.channels[j][i].id;
                            newPlayingMenuFree = 'channels';
                            break;
                        }
                        else if (playNextPayId === 0) {
                            playNextPayId = self.globalMovieContainer.channels[j][i].id;
                            newPlayingMenuPay = 'channels';
                        }
                    }
                    if (self.globalMovieContainer.channels[j][i].id === movie.id) {
                        playNext = true;
                    }
                }
            }
        }
        if ((playNext && !playNextFreeId) || self.playingMenu === 'reco') {
            if (playNext && !playNextFreeId) {
                $log.debug('player::videobar::playNextMovie fallback reco', self.globalMovieContainer.reco);
            }
            for (i in self.globalMovieContainer.reco) {
                if (playNext && playNextFreeId === 0 && angular.isDefined(self.globalMovieContainer.reco[i].pay)) {
                    if (!self.globalMovieContainer.reco[i].pay) {
                        playNextFreeId = self.globalMovieContainer.reco[i].id;
                        newPlayingMenuFree = 'reco';
                        break;
                    }
                    else if (playNextPayId === 0) {
                        playNextPayId = self.globalMovieContainer.reco[i].id;
                        newPlayingMenuPay = 'reco';
                    }
                }
                if (self.globalMovieContainer.reco[i].id === movie.id) {
                    playNext = true;
                }
            }
        }
        if (movie.playPreview) {
            playNextPayId = movie.id;
            newPlayingMenuPay = '';
        }
        $log.debug('player::videobar::playNextMovie result', playNext, playNextFreeId, playNextPayId, newPlayingMenuPay, newPlayingMenuFree, self.playingMenu);

        return {
            'freeId': playNextFreeId,
            'payId': playNextPayId,
            'menuFree': newPlayingMenuFree,
            'menuPay': newPlayingMenuPay
        };
    }


    function playLivestream(station) {
        LiveStreamService.getLiveStreamMovie(station).then(function (movie) {
            var cb = function () {
                self.playerService.play(false, false);
            };
            //self.setLiveSzm(LiveStreamService.getLivestreamLiveSzm());
            $log.debug('player::videobar::playLivestream > loadMovieToPlayer');
            self.playerService.loadMovieToPlayer('', '', movie, cb);
        });
    }

    function getLivestreamLiveSzm(station) {
        return LiveStreamService.getLiveSzm(station);
    }

    function getLivestreamPageSzm(station) {
        return LiveStreamService.getPageSzm(station);
    }

    function getCurrentChannelTag() {
        return self.currentChannelTag;
    }

    function getCurrentChannel() {
        return self.currentChannel;
    }

    function setCurrentChannelTag(channeltag) {
        $log.debug('player::videobar::setCurrentChannelTag', channeltag);
        self.currentChannelTag = channeltag;
    }

    function getPlayingMenu() {
        return self.playingMenu;
    }

    function setCurrentChannel(channel) {
        $log.debug('player::videobar::setCurrentChannel', channel.id);
        self.currentChannel = channel;
        self.playingChannel = channel.id;
        self.displayingChannel = channel.id;
    }



    function alertLogin(callback) {
        $log.debug('player::videobar::alertLogin');
        var top = $('.now-login-button').position().top;
        var alertLoginListener = $rootScope.$on('account::login', function () {
            if (self.playerService.show) {
                $log.debug('player::videobar::alertLogin alertLoginListener', callback);
                if (callback) {
                    callback();
                }
                $('.now-login-button').css('top', top + 'px');
                self.playerService.resume();
            }
        });
        $rootScope.$on('$destroy', alertLoginListener);
        var alertCloseListener = $rootScope.$on('account::closeAll', function () {
            if (self.playerService.show) {
                $log.debug('player::videobar::alertLogin alertCloseListener');
                $('.now-login-button').css('top', top + 'px');
                self.playerService.resume();
            }
        });
        $rootScope.$on('$destroy', alertCloseListener);
        Accounting.showPremiumOverlay();
        if (!$rootScope.$$phase) $rootScope.$apply();
        $('.now-login-button').css('top', top + 120 + 'px').css('position', 'relative');
        $('.now-overlay').css('top', '195px');
    }

    function reset() {
        $log.debug('player::videobar::reset');
        self.playingMenu = '';
        self.displayingMenu = '';
        self.playingChannel = 0;
        self.playingStation = 0;
        self.displayingChannel = 0;
        self.displayingStation = 0;
        $rootScope.$broadcast('html5::resetVideobar');
    }

    function voidfunc() {
    }

    function preloadAllTabs() {
        $log.debug('videobar preloadAllTabs');
        var promises = [];
        var deferred = $q.defer();

        promises.push(loadRecoTab(1).then(function (results) {
            $log.debug('videobar preloadAllTabs loadRecoTab then', results);
        }));
        promises.push(loadChannelTab(1, self.displayingChannel).then(function (results) {
            $log.debug('videobar preloadAllTabs loadChannelTab then', results);
        }));

        $q.all(promises).then(function () {
            deferred.resolve();
        });

        return deferred.promise;
    }

    function loadRecoTab(page) {
        var movieObject;
        $log.debug('videobar loadRecoTab');
        var tabname = 'reco', result, deferred = $q.defer();
        $log.debug('videobar loadRecoTab', self.videobarData[tabname][page], angular.isObject(self.videobarData[tabname][page]), angular.isArray(self.videobarData[tabname][page]));
        self.loadMore(PlayerHelperService.getMovieObject().id).then(function (movies) {
            $log.debug('videobar loadRecoTab movies', movies);
            if (movies.items  && movies.items.length > 0) {
                var i = 0;
                while(i < movies.items.length && movies.items[0].id != PlayerHelperService.getMovieObject().id){
                    movies.items.push(movies.items.shift());
                }

                if (PlayerHelperService.getMovieObject().originalMovie) {
                    movieObject = PlayerHelperService.getMovieObject().originalMovie;
                    movies.items.unshift(movieObject);
                }

                var result = processMovies(tabname, page, movies);

                if (page === 1 && self.playingMenu !== 'live') {
                    self.globalMovieContainer.reco.unshift(self.getRecoEntry(PlayerHelperService.getCurrentMovie()));
                    result.items.unshift(self.generateMovieTeaser(PlayerHelperService.getCurrentMovie()));
                }


                $log.debug('videobar loadRecoTab result', self.globalMovieContainer.reco, result);
                self.videobarData[tabname][page] = result;
                self.handleRecommendations();
                self.currentVideobarContent = result;
                deferred.resolve(result);
            } else {
                self.handleRecommendations();
            }
        });

        return deferred.promise;
    }

    function reorderVideobarMovies(result) {
        for (var i = 0; i < result.items.length; i++) {
            if (self.playerService.getCurrentMovieId() !== result.items[0].id) {
                result.items.push(result.items.shift());
            } else {
                break;
            }
        }
        return result;
    }

    function loadChannelTab(page, channelId) {

        self.setCurrentVideobarContentType('channels');
        $log.debug('videobar loadChannelTab', page, channelId);
        var tabname = 'channels', result, deferred = $q.defer();

        if (angular.isDefined(channelId) && angular.isObject(self.videobarData[tabname]['c' + channelId]) && angular.isObject(self.videobarData[tabname]['c' + channelId][page])) {
            $log.debug('videobar loadChannelTab load from cache');

            result = self.videobarData[tabname]['c' + channelId][page];

            result = reorderVideobarMovies(result);

            self.currentVideobarContent = result;
            deferred.resolve(result);
        }


        self.loadChannels().then(function () {
            self.loadChannelMovies(channelId, page).then(function (data) {
                var result = processMovies(tabname, page, data, channelId);

                result = reorderVideobarMovies(result);

                self.currentVideobarContent = result;
                deferred.resolve(result);
            });
        });

        return deferred.promise;
    }


    function processMovies(tabname, page, data, channelId) {
        $log.debug('videobar processMovies', tabname, page, data, channelId);
        var items = [];
        var globalIndex = 0;

        angular.forEach(data.items, function (value, key) {
            if (null !== value) {
                var movie = self.generateMovieTeaser(value);
                if (movie) {
                    movie.channelId = channelId || 0;
                    items.push(movie);
                    globalIndex = (page - 1) * self.maxPerPage + key;
                    if (angular.isDefined(channelId)) {
                        if (!angular.isArray(self.globalMovieContainer[tabname][channelId])) {
                            self.globalMovieContainer[tabname][channelId] = [];
                        }
                        self.globalMovieContainer[tabname][channelId][globalIndex] = self.getRecoEntry(value);
                    } else {
                        self.globalMovieContainer[tabname][globalIndex] = self.getRecoEntry(value);
                    }
                }
            }
        });

        var totalpages = (data.total) ? Math.ceil(data.total / self.maxPerPage) : 0;
        $log.debug('videobar processMovies result', items, totalpages);

        return {page: page, items: items, totalpages: totalpages};
    }


    function loadContent() {
        if (self.currentChannel && self.currentChannel.id > 0) {
            return loadChannelTab(1, self.currentChannel.id);
        } else {
            return loadRecoTab(1);
        }
    }
}

})();

(function() {



})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .controller('NowPlayerController', NowPlayerController);

NowPlayerController.$inject = ['$scope', '$rootScope', '$location', 'PlayerService', 'PageHistory', '$sessionStorage', 'movie', 'advertisements', '$log', 'AppConfig', 'RecommendationService', 'MyProgrammeService', 'Optimizely',  '$filter', 'InfoBoxService', 'Metadata','PlayerHelperService','NowTagCommander'];

function NowPlayerController($scope, $rootScope, $location, PlayerService, PageHistory, $sessionStorage, movie, advertisements, $log, AppConfig, RecommendationService, MyProgrammeService, Optimizely, $filter, InfoBoxService, Metadata, PlayerHelperService,NowTagCommander) {
    var vm = $scope;
    vm.loading = true;
    if (!movie) {
        return false;
    }

    PageHistory.setPage('player');

    RecommendationService.fireEventViewMovie(movie.id);

    vm.loading = false;
    Metadata.setMobileAltEnable(true);
    PlayerService.initEvents();
    PlayerService.saveSourcePage();
    PlayerService.bindPlayerEventHandler();

    PlayerService.bindGlobalPlayerFunctions();
    PlayerService.showPlayer(movie);
    PlayerHelperService.setAdvertisements(advertisements);

    $log.debug('current Player Movie',movie);
    NowTagCommander.addToDatalayer("content_format", movie.format.title,true);
    NowTagCommander.addToDatalayer("content_video_id", movie.id,true);
    NowTagCommander.addToDatalayer("content_video_title", movie.title,true);
    NowTagCommander.addToDatalayer("content_season", movie.season,true);
    NowTagCommander.addToDatalayer("content_type", (movie.free)? "free" : "plus",true);
    NowTagCommander.addToDatalayer("env_template", 'player');

    initEvents();
    init();

    Optimizely.trackEvent('pageview__player');

    function init() {
    }

    function initEvents() {
        vm.$on('$destroy', onDestroy);
        vm.$on('player::NOWTV_ITEM_PAY', onPlayerItemPay);
        vm.$on('player::NOWTV_INITIALIZED', onPlayerInitialized);
        vm.$on('player::NOWTV_PLAYER_EXIT', onPlayerExit);
        vm.$on('player::NOWTV_PLAYER_MENU_OPEN', onPlayerMenuOpen);
        vm.$on('player::NOWTV_PLAYER_MENU_CLOSE', onPlayerMenuClose);
        vm.$on('player::playingRefresh', saveTimeCode);
        vm.$on('html5::onPaused', saveTimeCode);
        vm.$on('html5::onStopped', saveTimeCode);
        vm.$on('html5::videobarPlayMovie', videobarPlayMovie);
    }


    function videobarPlayMovie(event, teaser) {
        var url = $filter('geturl')(teaser.movie, 'player');
        if (bowser.tablet === true && teaser.movie.free === false) {
            $location.search('premium', 'plusbarauto');
        } else {
            PlayerHelperService.setReturnPage(url.split('?')[0]);
            PlayerService.stop();
            InfoBoxService.hide();
        }


    }


    function onDestroy() {
        PlayerService.unregisterEvents();
    }

    function onPlayerMenuOpen() {
        $('#videobar_wrapper').css('height', '202px');
    }

    function onPlayerMenuClose() {
        $('#videobar_wrapper').css('height', '50px');
    }

    function onPlayerItemPay(event, eventname, data) {
        $log.debug('NOWTV_ITEM_PAY', data);
        if (data.id > 0) {
            PlayerService.pause();
            $location.search('premium');
            if (!$rootScope.$$phase) $rootScope.$apply();
        }
    }

    function onPlayerInitialized() {
        $log.debug('NOWTV_INITIALIZED', movie);

        if (!movie) {
            PlayerService.hidePlayer();
            return;
        }

        PlayerService.playCurrentRoute(movie);
    }

    function onPlayerExit() {
        saveTimeCode(function () {
            PlayerService.hidePlayer();
            InfoBoxService.hide();
        });
    }

    function saveTimeCode(cb) {
        if(!PlayerService.isAd()){
            var code = PlayerService.getTimeCode();
            var movie = PlayerHelperService.getCurrentMovie();
            if (!movie.playPreview && !movie.isLivestream && !(movie.livestreamEvent && movie.livestreamEvent.videochat) && code && code[0].percent) {
                if ($sessionStorage.user && $sessionStorage.user.id && AppConfig.settings.nowtv.player.statistic.save === 'true') {
                    if (movie.id > 0) {
                        MyProgrammeService
                            .updateMovieStatistic(movie.id, code[0].percent, Math.floor(code[0].time))
                            .then(function () {

                                if (angular.isFunction(cb)) {
                                    cb();
                                }
                            }, function () {

                                if (angular.isFunction(cb)) {
                                    cb();
                                }
                            });
                    } else if (angular.isFunction(cb)) {
                        cb();
                    }
                } else {
                    if (angular.isFunction(cb)) {
                        cb();
                    }
                }
            } else {
                if (angular.isFunction(cb)) {
                    cb();
                }
            }
        }else{
            if (angular.isFunction(cb)) {
                cb();
            }
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowPlayer')
    .config(routing);
routing.$inject = ['$routeProvider'];
function routing($routeProvider) {
    var playerroute = {
        templateUrl: 'templates/player_view.html',
        controller: 'NowPlayerController',
        reloadOnSearch: false,
        data: {
            pagetype: 'player'
        }, resolve: {
            movie: resolveMovie,
            advertisements: returnAdvertisements
        }
    }, playerRedirectSeoRoute = {
        template: '<div></div>',
        data: {
            navTarget: 'player'
        },
        controller: redirectPlayerPreviewController
    }, previewRedirectSeoRoute = {
        template: '<div></div>',
        data: {
            navTarget: 'preview'
        },
        controller: redirectPlayerPreviewController
    };

    var previewroute = angular.copy(playerroute);
    previewroute.data.preview = true;

    $routeProvider.when('/:station/:format/:episode/player', playerroute);

    $routeProvider.when('/:station/:format/list/:staffelname/:episode/player', playerRedirectSeoRoute);
    $routeProvider.when('/:station/:format/jahr/:jahr/:monat/:episode/player', playerRedirectSeoRoute);
    //$routeProvider.when('/:station/:format/special/:staffelname/:episode/player', playerroute);

    $routeProvider.when('/:station/:format/:episode/preview', previewroute);

    $routeProvider.when('/:station/:format/list/:staffelname/:episode/preview', previewRedirectSeoRoute);
    $routeProvider.when('/:station/:format/jahr/:jahr/:monat/:episode/preview', previewRedirectSeoRoute);
    //$routeProvider.when('/:station/:format/special/:staffelname/:episode/preview', previewroute);
    resolveMovie.$inject = ['$route', 'NowApi', '$log', '$location', 'StationMonitor', 'Metadata', 'AgeCheck', 'AdControlService', 'PlayerService', 'Accounting'];
    function resolveMovie($route, NowApi, $log, $location, StationMonitor, Metadata, AgeCheck, AdControlService, PlayerService, Accounting) {

        if (bowser.tablet && Accounting.isPremiumUser()) {
            Accounting.logout();
        }

        AdControlService.setAdEnvironment('player');

        return NowApi.getMovie().retrieveMovieBySeoLink({
            formatSeoLink: $route.current.params.format,
            movieSeoLink: $route.current.params.episode,
            station: StationMonitor.getStation(),
            fields: '*,format,files,manifest,breakpoints,paymentPaytypes,trailers,packages,isLiveStream'
        }).then(function (movie) {


            function checkMovie(movie) {
                if (!movie.free && !movie.payed && !$route.current.$$route.data.preview) {
                    var newurl = $location.path().replace('/player', '?premium');
                    $log.error('Error movie not payed', newurl);
                    $location.url(newurl);
                    return false;
                }
                if ($route.current.$$route.data.preview) {
                    var originalMovie = angular.copy(movie);
                    movie.playPreview = true;
                    movie.free = true;
                    movie.originalMovie = originalMovie;
                }
                return PlayerService.activateHTML5Mode(movie).then(function () {
                    return movie
                });
            }

            Metadata.setOgMovie(movie);
            //Disable age check
            var age = false;
            if (age && (movie.fsk12 || movie.fsk16 || movie.fsk18)) {
                return AgeCheck.doAgeCheck(movie).then(function () {
                    return checkMovie(movie);
                }, function () {
                    $log.info('AgeCheck failed');
                    $location.url('/jugendschutz');
                    return false;
                });
            } else {
                return checkMovie(movie);
            }
        }, function () {
            $log.error('Error movie not found');
            var redirectPath = '/' + StationMonitor.getStation(true) + '/' + $route.current.params.format;
            Metadata.setSeoRedirect(redirectPath);
            $location.path(redirectPath);
            return false;
        });
    }

    returnAdvertisements.$inject = ['NowApi', '$log'];
    function returnAdvertisements(NowApi, $log) {
        return NowApi.getPlayoutelements().retrieveAdvertisements({
            filter: '{"Active":true}',
            page: 1,
            maxPerPage: 200
        }).then(function (advertisements) {
            return advertisements;
        }, function () {
            $log.error('Error advertisements not found');
            return false;
        });
    }

    redirectPlayerPreviewController.$inject = ['$route', '$location', 'Metadata', 'StationMonitor'];
    function redirectPlayerPreviewController($route, $location, Metadata, StationMonitor) {
        var uri = $route.current.params.format + '/' + $route.current.params.episode + '/' + $route.current.$$route.data.navTarget;

        Metadata.setSeoRedirect('http://' + $location.host() + '/' + StationMonitor.getStation() + '/' + uri);
        $location.path('/' + StationMonitor.getStation(true) + '/' + uri);
        $location.replace();
    }
}

})();

(function() {





})();

(function() {



})();

(function() {

angular.module('NowAccount', []);

})();

(function() {

'use strict';

/**
 * @ngdoc service
 * @name NowAccount.Accounting
 * @description
 * Service for Accounting
 */
angular
    .module('NowAccount')
    .service('Accounting', Accounting);

Accounting.$inject = ['NowApi', '$sessionStorage', '$rootScope', '$filter', '$http', '$log', '$location', 'AppConfig', 'uuid4', '$cookies', '$localStorage', 'moment', '$window', '$timeout'];

/**
 *@constructor
 */
function Accounting(NowApi, $sessionStorage, $rootScope, $filter, $http, $log, $location, AppConfig, uuid4, $cookies, $localStorage, moment, $window, $timeout) {
    var passwordtoken = '';
    var alert = false;
    var self = this;


    this.setPasswordToken = setPasswordToken;
    this.getPasswordToken = getPasswordToken;
    this.alertUser = alertUser;
    this.getAlert = getAlert;
    this.resendRegmail = resendRegmail;
    this.agbQuestion = agbQuestion;
    this.refreshToken = refreshToken;
    this.setHeaderToken = setHeaderToken;
    this.removeHeaderToken = removeHeaderToken;
    this.setUserSession = setUserSession;
    this.loginUser = loginUser;
    this.isLoggedIn = isLoggedIn;
    this.isPremiumUser = isPremiumUser;
    this.showPremiumOverlay = showPremiumOverlay;
    this.setTokenAndCheckRefresh = setTokenAndCheckRefresh;
    this.validateLoggedInUser = validateLoggedInUser;
    this.getDeviceId = getDeviceId;
    this.getUserId = getUserId;
    this.getClientId = getClientId;
    this.getSubscriptionState = getSubscriptionState;
    this.logout = logout;
    this.getStates = getStates;
    this.getTokenTiming = getTokenTiming;
    this.checkTokenTimingTimeout = checkTokenTimingTimeout;


    this.tokenRefreshTimeout = false;


    function logout() {
        removeHeaderToken();
        $localStorage.$reset();
        $sessionStorage.$reset();
        $location.path('/');
    }


    function getUserId() {
        return $sessionStorage.user.id;
    }

    function getClientId() {
        if (isLoggedIn()) {
            $cookies.put('clientId', $sessionStorage.user.clientId);
        }
        if ($cookies.get('clientId')) {
            return $cookies.get('clientId');
        }
        return false;
    }

    function getStates() {
        var states = ['old', 'old', 'old', 'free', 'trial', 'plus', 'voucher', 'whitelisted'];
        return states;
    }

    function getSubscriptionState() {

        /*
         3 - free
         4 - trial
         5 - plus
         6 - voucher
         7 - whitelisted
         */
        if (isLoggedIn() && getStates()[$sessionStorage.user.subscriptionState]) {
            $log.debug('user States', getStates()[$sessionStorage.user.subscriptionState]);
            return getStates()[$sessionStorage.user.subscriptionState];
        }
        $log.debug('user States', getStates()[3]);
        return getStates()[3];
    }

    function generateDeviceId() {
        $sessionStorage.deviceId = uuid4.generate();
    }

    function getDeviceId() {
        if (!$sessionStorage.deviceId) {
            generateDeviceId();
        }
        return $sessionStorage.deviceId;
    }

    function setTokenAndCheckRefresh() {
        $log.debug('refreshtoken', $sessionStorage.user.ck);
        self.setHeaderToken($sessionStorage.user.token, $sessionStorage.user.ck);

        var token = jwt_decode($sessionStorage.user.token);
        $sessionStorage.user.jwtDecoded = token;

        //token.iat = create date of token (unixtimestamp)
        if (token.iat) {
            //schedule next refresh
            self.checkTokenTimingTimeout();
            //check if token is older than allowed refresh expire time from settings
            if (token.iat + self.getTokenTiming() < moment().unix()) {
                self.refreshToken(token);
            }
        }
    }

    function checkTokenTimingTimeout() {
        if (!self.tokenRefreshTimeout) {
            self.tokenRefreshTimeout = $timeout(function () {
                self.setTokenAndCheckRefresh();
            }, (30 + self.getTokenTiming()) * 1000);
        }
    }

    function getTokenTiming() {
        var timing = (!AppConfig.settings.nowtv.accounting || !AppConfig.settings.nowtv.accounting.tokenvalidation) ? 6400 : AppConfig.settings.nowtv.accounting.tokenvalidation;
        return parseInt(timing);
    }

    function setPasswordToken(token) {
        passwordtoken = token;
    }

    function getPasswordToken() {
        return passwordtoken;
    }

    function alertUser(icon, message, buttons, callbacks, fullscreen, closeafter) {
        alert = {
            icon: icon,
            message: message,
            buttons: buttons,
            callbacks: callbacks,
            fullscreen: fullscreen,
            closeafter: closeafter
        };
    }

    function getAlert() {
        var userAlert = angular.copy(alert);
        alert = false;
        return userAlert;
    }

    function resendRegmail() {
        return NowApi.getBackend().registrationmailByPost();
    }

    function agbQuestion() {
        self.alertUser({'icon-nowperson': true}, $filter('translate')('account.login.agbquestion'),
            {
                agb: true,
                custom: {
                    'text': 'ZUSTIMMEN',
                    'callback': callback
                }
            }, {
                close: function () {
                    $rootScope.$broadcast('account::doLogout', function () {
                        //Accounting.alertUser({'icon-nowperson': true}, 'Da Sie die AGB nicht bestätigt haben wurden Sie ausgeloggt.', {login: true});
                    });

                }
            }, true);

        function callback() {
            //console.log('CALLBACK AGB!');
            NowApi.getUsers().updatePrivacy(
                {
                    id: getUserId(),
                    'REQUEST_BODY': {
                        agb: true
                    }
                }
            ).then(
                function () {
                    $sessionStorage.user.user.agb = true;
                    self.alertUser({'icon-nowperson': true}, $filter('translate')('account.login.ok'));

                },
                function () {
                    self.alertUser({'icon-nowperson': true}, $filter('translate')('account.login.agbfail'), {login: true}, {
                        close: function () {
                            $rootScope.$broadcast('account::doLogout', function () {
                                //Accounting.alertUser({'icon-nowperson': true}, 'Da Sie die AGB nicht bestätigt haben wurden Sie ausgeloggt.', {login: true});
                            });
                        }
                    });
                }
            )
        }
    }

    function refreshToken(token) {
        $log.debug('Token älter als 2 Minuten -> Refresh', token);
        if (self.isLoggedIn()) {
            NowApi.getBackend().loginByToken(
                {
                    fields: '["*","user",["agb","receivePersonalizedEmails","receiveMarketingEmails","marketingsettingsDone","receiveGroupMarketingEmails","receiveRTLIIMarketingEmails"]]'
                }
            ).then(
                function (user) {
                    self.setUserSession(user);
                    $timeout.cancel(self.tokenRefreshTimeout);
                    self.tokenRefreshTimeout = false;
                    self.checkTokenTimingTimeout();
                },
                function () {
                    $timeout.cancel(self.tokenRefreshTimeout);
                    self.tokenRefreshTimeout = false;
                    self.checkTokenTimingTimeout();
                    $log.error('LOGIN COULD NOT BE REFRESHED');
                }
            );
        }
    }

    function setHeaderToken(token, ck) {
        $log.debug('setHeaderToken', ck, token);
        if (token) {
            $http.defaults.headers.common['X-AUTH-TOKEN'] = token;
        }
        if (ck) {
            $http.defaults.headers.common['X-CK'] = ck;
        }
    }

    function removeHeaderToken() {
        if ($http.defaults.headers.common['X-AUTH-TOKEN']) {
            delete $http.defaults.headers.common['X-AUTH-TOKEN'];
        }
        if ($http.defaults.headers.common['X-CK']) {
            delete $http.defaults.headers.common['X-CK'];
        }
    }

    function setUserSession(user) {
        $log.debug('Accounting / setUserSession $sessionStorage.user', user.ck);
        $sessionStorage.user = user;
        self.setTokenAndCheckRefresh();
    }

    function loginUser(user) {
        $log.debug('Accounting / loginUser $sessionStorage.user', user.ck);
        $sessionStorage.user = user;
        self.setHeaderToken(user.token, user.ck);

        $rootScope.$broadcast('account::login');
    }

    /**
     * @ngdoc
     * @name NowAccount.Accounting#isPremiumUser
     * @methodOf NowAccount.Accounting
     *
     * @description
     * check if user has a package
     * @example
     * Accounting.isPremiumUser()
     * @returns {bool} user has premium rights
     */
    function isPremiumUser() {
        return !!($sessionStorage.user && $sessionStorage.user.jwtDecoded && $sessionStorage.user.jwtDecoded.packages.length > 0);
    }

    /**
     * @ngdoc
     * @name NowAccount.Accounting#isPremiumUser
     * @methodOf NowAccount.Accounting
     *
     * @description
     * check if user has a package
     * @example
     * Accounting.isPremiumUser()
     * @returns {bool} user has premium rights
     */
    function isLoggedIn() {
        return !!($sessionStorage.user && $sessionStorage.user.jwtDecoded);
    }

    /**
     * @ngdoc
     * @name NowAccount.Accounting#validateLoggedInUser
     * @methodOf NowAccount.Accounting
     *
     * @description
     * check if user has valid login
     * @example
     * Accounting.validateLoggedInUser()
     */
    function validateLoggedInUser() {
        if ($sessionStorage.user && (!$sessionStorage.user.token || $sessionStorage.user.token.length === 0)) {
            if ($window.Bugsnag) {
                $window.Bugsnag.notify('Sessionerror', 'Something bad happened here', $sessionStorage, 'error');
            }
            $rootScope.$broadcast('account::doLogout', function () {
                $location.path('/error');
            });
        }
    }

    /**
     * @ngdoc
     * @name NowAccount.Accounting#showPremiumOverlay
     * @methodOf NowAccount.Accounting
     *
     * @description
     * opens premium overlay
     * @example
     * Accounting.showPremiumOverlay()
     */
    function showPremiumOverlay() {
        $log.debug('service_account showPremiumOverlay() opening premium');
        $location.search('premium');
    }

}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .directive('nowfulfillmentiframe', nowfulfillmentiframe);

nowfulfillmentiframe.$inject = ['$rootScope', '$sce', '$window', '$location'];

function nowfulfillmentiframe($rootScope, $sce, $window, $location) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div class="now-fulfillment-overlay" ng-show="allowedTypes.indexOf(type) > -1"><iframe class="now-fulfillment-iframe" ng-src="{{url}}" frameborder="0" id="now-fulfillment-overlay-iframe"></iframe></div>',
        link: link,
        controller: 'NowAccountLoginController'
    };

    function link(scope, element) {
        var ffcHost = $window.env.ffc;

        var tablet = bowser.tablet;

        var loginUrl = ffcHost + '/login';
        var logoutUrl = ffcHost + '/logout';
        var autologoutUrl = ffcHost + '/autologout';
        var registrationUrl = ffcHost + '/registration';
        var profileUrl = ffcHost + '/profile';
        var newsletterUrl = ffcHost + '/?newsletter';
        var emailverifyUrl = ffcHost + '/?emailverify';
        var verifyemailUrl = ffcHost + '/?verifyemail';
        var contactsettingsUrl = ffcHost + '/contactsettings';
        var passwordUrl = ffcHost + '/login?password';
        var passwordrecoverUrl = ffcHost + '/login?passwordrecover&token=';
        var premiumUrl = ffcHost + '/';
        var loyaltyUrl = ffcHost + '/?loyalty';
        var deletesuccessUrl = ffcHost + '/?deletesuccess';

        var blank = '/blank.html'; //is not redundant, really

        scope.url = blank;
        scope.allowedTypes = [
            'login',
            'logout',
            'autologout',
            'registration',
            'account',
            'newsletter',
            'payment',
            'emailverify',
            'verifyemail',
            'contactsettings',
            'password',
            'passwordrecover',
            'premium',
            'loyalty',
            'deletesuccess'
        ];

        repos();

        var accountffc = $rootScope.$on('account::togglefulfillment', onToggleFF);
        $rootScope.$on('$destroy',accountffc);
        scope.$watch('showff', watchShowFF);
        scope.$on('resize::resize', repos);

        function repos() {
            $(element).css({
                top: 100,
                left: Math.round($(window).width() / 2) - ($('.now-fulfillment-iframe').width() / 2),
                height: Math.round($(window).height() - 125)
            });
        }

        function watchShowFF(show) {
            if (show) {
                $('body').css({
                    overflow: 'hidden'
                });
                $('.now-header-fixed').css({
                    overflow: 'visible'
                });

                $('.now-navigation').hide();
            } else {
                $('body').css({
                    overflow: 'auto'
                });
                $('.now-header-fixed').css({
                    overflow: 'hidden'
                });
                $('.now-navigation').show();
            }

        }

        function onToggleFF(event, showFF, type) {
            var url = '/blank.html';
            if (showFF) {
                if (type === 'login') {
                    url = loginUrl;
                } else if (type === 'registration') {
                    url = premiumUrl;
                } else if (type === 'account') {
                    url = profileUrl;
                } else if (type === 'newsletter') {
                    url = newsletterUrl;
                } else if (type === 'emailverify') {
                    url = emailverifyUrl;
                } else if (type === 'verifyemail') {
                    url = verifyemailUrl;
                } else if (type === 'contactsettings') {
                    url = contactsettingsUrl;
                } else if (type === 'premium' || type === 'payment') {
                    if (angular.isString($location.search()['premium']) === true) {
                        url = premiumUrl + '?' + type + '=' + $location.search()['premium'];
                    } else {
                        url = premiumUrl;
                    }
                } else if (type === 'loyalty') {
                    url = loyaltyUrl;
                } else if (type === 'deletesuccess') {
                    url = deletesuccessUrl;
                } else if (type === 'password') {
                    url = passwordUrl;
                } else if (type === 'passwordrecover') {
                    url = passwordrecoverUrl + scope.passwordtoken;
                } else if (type === 'logout') {
                    url = logoutUrl;
                } else if (type === 'autologout') {
                    url = autologoutUrl;
                }
            }
            if (tablet === true) {
                if (url !== '/blank.html') {
                    $window.open(url, '_blank');
                    $rootScope.$broadcast('close::togglefulfillment');
                }

            } else {
                if(type==='registration'){
                    $window.open(url, '_blank');
                    $rootScope.$broadcast('close::togglefulfillment');
                }else {
                    scope.url = $sce.trustAsResourceUrl(url);
                }
            }

        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .directive('mobileLoginRedirect', mobileLoginRedirect);

mobileLoginRedirect.$inject = ['$location', 'AppConfig', '$window'];

function mobileLoginRedirect($location, AppConfig, $window) {
    return {
        restrict: 'A',
        link: link
    };

    function link() {
        var redirect = false;
        if ($location.search()['login']) {
            redirect = AppConfig.ffc + "/login";
        } else if ($location.search()['registrierung'] || $location.search()['registration']) {
            redirect = AppConfig.ffc;
        }
        if(redirect){
            $window.location.href = redirect;
        }

    }
}



})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .directive('myworldcheckbox', myworldcheckbox);

myworldcheckbox.$inject = ['$timeout'];

function myworldcheckbox() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            'mymodel': '=ngModel',
            'label': '=label'
        },
        templateUrl: 'templates/account_checkbox.html',
        link: link
    };

    function link(scope) {
        var id = 'now-shared-free-' + Math.floor((Math.random() * 1337) + 1);
        var checkbox = $(element).find('input');
        var label = $(element).find('label');
        label.attr('id', id);
        checkbox.attr('for', id);

        $(element).on('click', function () {
            scope.$apply(function () {
                scope.mymodel = !checkbox.prop('checked');
            });
        });
    }
}


})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .directive('myworldinput', myworldinput);

myworldinput.$inject = ['$timeout'];

function myworldinput() {
    return {
        restrict: 'E',
        replace: true,

        scope: {
            'mymodel': '=ngModel',
            'placeholder': '@placeholder',
            'type': '@type',
            'success': '=success',
            'error': '=error',
            'icon': '@icon'
        },
        templateUrl: 'templates/account_input.html',
        link: link
    };

    function link(element) {
        element.find('input').bind('focus', function () {
            element.addClass('active');

        });
        element.find('input').bind('blur', function () {
            element.removeClass('active');
        });

    }
}


})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .directive('accountoverlay', accountoverlay);

accountoverlay.$inject = ['$window', '$timeout', '$filter', 'Accounting'];

function accountoverlay($window, $timeout, $filter, Accounting) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/overlay_account_main.html',
        link: link
    };

    function link(scope) {
        if (!history.pushState) {
            //console.log('NO PUSHSTATE');
            $timeout(function () {
                Accounting.alertUser({'icon-nowalert': true}, $filter('translate')('account.browser.old'));
                //console.log('ALERT USER PUSHSTATE');
            }, 4000);
        }

        var fixed = true,
            overlayDarkLogin = $('.now-overlay-dark-login');
        scope.isTabletRegister = (bowser.tablet && !bowser.msie) ? true : false;

        initWatchers();

        function reposOverlay() {
            if (scope.show === false) {
                return false;
            }

            var myworldOverlay = $('.now-overlay-myworld'),
                loginButton = $('.now-login-button'),
                headerFixed = $('.now-header-fixed'),
                header = $('.now-header');

            myworldOverlay.css({
                top: loginButton.position().top + 75,
                left: loginButton.position().left - myworldOverlay.width() + loginButton.width()
            });

            if (myworldOverlay.height() > $(window).height() - 150) {
                headerFixed.removeClass('now-header-fixed');
                fixed = false;
                if ($('body').scrollTop() <= 80) {
                    overlayDarkLogin.css({
                        'top': (80 - $(window).scrollTop() >= 0) ? 80 - $(window).scrollTop() : 0
                    });
                } else {
                    overlayDarkLogin.css({
                        'top': 0
                    });
                }
            } else if (headerFixed.length === 0) {
                header.addClass('now-header-fixed');
                fixed = true;
                overlayDarkLogin.css({
                    'top': 80
                });
            } else {
                overlayDarkLogin.css({
                    'top': 80
                });
            }
        }

        function initWatchers() {
            scope.$watch('type', watchType);
            scope.$watch('show', watchShow);

            function watchType(show) {
                reposOverlay();
                if (scope.alert.fullscreen) {
                    overlayDarkLogin.css({
                        'top': 0
                    });
                }

                if (!scope.trackingInitialIgnoreStatusReiter && show && show !== 'password') {
                    scope.trackEvent('reiter', show);
                }
                scope.trackingInitialIgnoreStatusReiter = false;
            }

            function watchShow(show) {
                if (show) {
                    if (scope.alert.fullscreen) {
                        overlayDarkLogin.css({
                            'top': 0
                        });
                    }
                    reposOverlay();
                    $timeout(function () {
                        reposOverlay();
                    }, 2000);
                    if (!fixed) {
                        $window.scrollTo(0, 0);
                    }
                    angular.element($window).on('resize', reposOverlay);
                    angular.element($window).on('scroll', reposOverlay);
                    if (!bowser.tablet) {
                        $('.now-content-inner').css('marginLeft', '-13px');
                    }
                } else {
                    overlayDarkLogin.css({
                        'top': 80
                    });
                    angular.element($window).off('resize', reposOverlay);
                    angular.element($window).off('scroll', reposOverlay);
                    if (!bowser.tablet) {
                        $('.now-content-inner').css('marginLeft', '0px');
                    }
                }
            }
        }
    }
}



})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .controller('NowAccountLoginController', NowAccountLoginController);

NowAccountLoginController.$inject = ['$scope', 'NowApi', '$sessionStorage', '$localStorage', '$location', '$rootScope', '$filter', '$route', 'Accounting', '$timeout', '$window'];

function NowAccountLoginController($scope, NowApi, $sessionStorage, $localStorage, $location, $rootScope, $filter, $route, Accounting, $timeout, $window) {
    var vm = $scope;

    vm.doLogin = doLogin;
    vm.gotoPassword = gotoPassword;

    vm.login = {
        'email': '',
        'password': ''
    };
    vm.error = {
        message: '',
        email: false,
        password: false

    };

    initWatchers();
    checkUserInSessionStorage();
    showMarketingSettings();

    function initWatchers() {
        $scope.$watch('login.email', checkform);
        $scope.$watch('login.password', checkform);
        var accountLogin =  $rootScope.$on('account::login', function () {
            if ($window.Bugsnag) {
                $window.Bugsnag.user = {
                    id: $sessionStorage.user.id
                };
            }
        });

        $window.addEventListener('message', function (event) {
            var allowedOrigins = ['tvnow.de', 'tvnow.at', 'tvnow.ch', 'nowtv.de', 'rtl.de'];
            angular.forEach(allowedOrigins, function (allowedOrigin) {
                if (event.origin.indexOf(allowedOrigin) > -1 && event.data) {
                    try {
                        var data = angular.fromJson(event.data);
                        //$log.debug('eventListener message with',event.data);
                        if (data.login && data.user) {
                            checkUserInSessionStorage(data.user);
                            vm.$apply();
                        }
                    } catch (e) {
                        //console.log(e);
                    }
                }
            });
        }, false);

        $rootScope.$on('$destroy',accountLogin);
    }

    function checkform() {
        var email = $scope.login.email;
        var password = $scope.login.password;

        if (angular.isUndefined(email)) {
            vm.error.email = true;
            vm.error.message = 'Überprüfen Sie Ihre E-Mail Adresse';
        } else {
            vm.error.email = false;
        }

        if (password.length > 0 && password.length < 5) {
            vm.error.password = true;
            vm.error.message = 'Überprüfen Sie Ihr Passwort';
        } else {
            vm.error.password = false;
        }

        if (vm.error.password && vm.error.email) {
            vm.error.message = 'Überprüfen Sie Ihre Angaben';
        } else if (!vm.error.password && !vm.error.email) {
            vm.error.message = '';
        }

        return (vm.error.message.length === 0);
    }

    function gotoPassword() {
        $location.search({});
        $location.search('password', true);
        vm.trackEvent('passwort_vergessen', 'login');
    }

    function doLogin() {
        if (checkform() && (vm.login.email && vm.login.email.length !== 0)) {
            NowApi
                .getBackend()
                .login(
                    {
                        'REQUEST_BODY': vm.login,
                        'fields': '["*","user",["agb","receivePersonalizedEmails","receiveMarketingEmails","marketingsettingsDone","receiveGroupMarketingEmails","receiveRTLIIMarketingEmails"]]'
                    }
                )
                .then(
                    function (data) {
                        $sessionStorage.user = data;
                        $localStorage.user = data;
                        checkUserInSessionStorage();
                        vm.loggedin = true;
                        $route.reload();
                        if (!data.user.agb) {
                            Accounting.agbQuestion();
                        }
                        else if (data.emailVerified > 0) {
                            Accounting.alertUser({'icon-nowperson': true}, $filter('translate')('account.login.ok'), null, null, null, 2500);
                        } else {
                            Accounting.alertUser({'icon-nowenvelop': true}, $filter('translate')('account.login.mailquestion'), {
                                'ok': true,
                                'regmail': true
                            });
                        }

                        vm.trackEvent('login_erfolgreich', 'login');
                    },
                    function (err) {
                        vm.error.message = $filter('translate')(err.body.error.message);
                        if (err.body.error.code === 400) {
                            vm.error.message = $filter('translate')('backend.user.authentication.failed');
                        }

                        vm.error.mail = true;
                        vm.error.password = true;

                        vm.trackEvent('login_fehlgeschlagen', 'login');
                    }
                );
        }
    }

    function checkUserInSessionStorage(user) {
        if (user) {
            $localStorage.user = user;
            $sessionStorage.user = user;
        }

        if (!$localStorage.user) {
            $localStorage.user = null;
        }

        if (!$sessionStorage.user && $localStorage.user) {
            $sessionStorage.user = $localStorage.user;
        }

        if ($sessionStorage.user && $sessionStorage.user.token) {
            vm.loggedin = true;
            Accounting.setTokenAndCheckRefresh($sessionStorage.user.token);
            $rootScope.$broadcast('account::login');
        }
    }

    function showMarketingSettings() {
        var search = $location.search();

        if (!$sessionStorage.user || !$sessionStorage.user.token || !$sessionStorage.user.user || $sessionStorage.user.user.marketingsettingsDone || search.emailverify) {
            return;
        }

        //$sessionStorage.user.tokenDec.packages && $sessionStorage.user.tokenDec.packages.length > 0

        //user hat marketingsettings noch nicht erledigt
        $timeout(function () {
            $location.search('contactsettings', true);
        }, 1000);
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowAccount')
    .controller('NowAccountController', NowAccountController);

NowAccountController.$inject = ['$scope', '$rootScope', 'Accounting', '$q', '$location', '$sessionStorage', '$localStorage', '$route', '$filter', '$timeout', 'NowGoogleAnalytics', '$log', '$window'];

function NowAccountController($scope, $rootScope, Accounting, $q, $location, $sessionStorage, $localStorage, $route, $filter, $timeout, NowGoogleAnalytics, $log, $window) {
    var vm = $scope,
        params = $location.search(),
        allowedTypes = [
            'login',
            'logout',
            'autologout',
            'registration',
            'password',
            'passwordrecover',
            'account',
            'payment',
            'alert',
            'alertlogin',
            'emailverify',
            'verifyemail',
            'contactsettings',
            'newsletter',
            'premium',
            'loyalty',
            'deletesuccess'
        ],
        allowedPopupTypes = ['alert', 'alertlogin'],
        checkpopups = allowedTypes.concat(['az']),
        trackingLastVmType,
        checkOverlayPopupStateInProgress = false;

    vm.show = false;
    vm.val = true;
    vm.showdark = false;
    vm.type = false;
    vm.loggedin = false;
    vm.allowedPopupTypes = allowedPopupTypes;
    vm.logginButtonType = 'login';
    vm.showff = false;
    vm.alertText = 'LOREM IPSUM';
    vm.alert = false;
    vm.lastProduct = false;

    vm.doLogout = doLogout;
    vm.gotoAGB = gotoAGB;
    vm.trackEvent = trackEvent;
    vm.trackEventFF = trackEventFF;
    vm.resendRegmail = resendRegmail;
    vm.showFulfillment = showFulfillment;
    vm.closeAll = closeAll;
    vm.showRegistration = showRegistration;
    vm.showAccount = showAccount;
    vm.isTablet = isTablet;
    vm.trackHeaderButton = trackHeaderButton;
    init();

    function isTablet() {
        if (bowser.tablet === true && !bowser.msie) {
            return false;
        } else {
            return true;
        }
    }

    function showRegistration() {
        vm.loginbuttontext = true;
        if (vm.type !== 'registration') {
            vm.type = 'registration';
            vm.showdark = true;
            vm.show = true;
            $rootScope.$broadcast('account::togglefulfillment', true, vm.type, vm.val);
        } else {
            vm.showdark = !vm.showdark;
            vm.show = !vm.show;
        }
    }

    function showAccount() {
        vm.loginbuttontext = true;
        if (vm.type !== vm.logginButtonType) {
            vm.type = vm.logginButtonType;
            vm.loginbuttontext = true;
            vm.showdark = true;
            vm.show = true;
            $rootScope.$broadcast('account::togglefulfillment', true, vm.type, vm.val);
        } else {
            vm.showdark = !vm.showdark;
            vm.show = !vm.show;
        }
    }


    function checkLoggedInViewState() {
        if (vm.loggedin && (params.login || params.registration || params.password || params.passwordrecover)) {
            resetLoginTypes();
            vm.show = false;
            vm.showdark = false;
        }
    }

    function resetLoginTypes() {
        $log.debug('Account/controller resetLoginTypes() resetting all $location.search');
        angular.forEach(allowedTypes, function (type) {
            $location.search(type, null);
        });
    }

    function doLogout(callback) {
        $sessionStorage.$reset();
        $localStorage.$reset();

        vm.loggedin = false;
        vm.type = 'login';
        vm.logginButtonType = 'login';
        $rootScope.$broadcast('account::logout');
        Accounting.removeHeaderToken();
        $window.location.href = '/';
        closeAll();
        if (callback) {
            callback();
        }
    }

    function showFulfillment() {
        vm.type = 'account';
    }

    function gotoAGB() {
        doLogout();
        $location.path('/agb');
    }

    function closeAll() {
        $log.debug('Account/controller closeAll() been called');
        vm.alert = false;
        vm.type = false;
        vm.show = false;
        vm.showff = false;
        vm.showdark = false;
        for (var i = 0; i < allowedTypes.length; i++) {
            $log.debug('Account/controller closeAll() resetting all $location.search(allowedTypes) refresh?');
            if ($location.search()[allowedTypes[i]] && allowedTypes[i] !== 'autologout' && allowedTypes[i] !== 'logout') {
                Accounting.refreshToken('closeAll');
            }
            $location.search(allowedTypes[i], null);
        }

        if (vm.alert.callbacks && vm.alert.callbacks.close) {
            vm.alert.callbacks.close();
            vm.alert.callbacks.close = false;
        }
        $rootScope.$broadcast('account::closeAll');
    }

    function resendRegmail() {
        Accounting.resendRegmail().then(
            function () {
                Accounting.alertUser({'icon-nowenvelop': true}, $filter('translate')('account.login.mailquestion'), {
                    'ok': true
                });
            },
            function () {
                Accounting.alertUser({'icon-nowenvelop': true}, $filter('translate')('account.login.mailfail'), {'profil': true});
            }
        )
    }

    function checkShowFF(type) {
        var types = [
            'login',
            'logout',
            'autologout',
            'registration',
            'account',
            'newsletter',
            'payment',
            'emailverify',
            'verifyemail',
            'contactsettings',
            'password',
            'passwordrecover',
            'premium',
            'loyalty',
            'deletesuccess'
        ];
        if (types.indexOf(type) !== -1) {
            vm.showff = true;
        }
    }

    function checkProductIdInParams(type) {
        if (type === 'payment') {
            vm.lastProduct = $location.search()['payment'];
        }
    }

    function checkOverlayPopupState() {
        $log.debug('Account/controller checkOverlayPopupState() been called');
        $log.debug('account/controller checkOverlayPopupState $loc.search()', $location.search());

        if (checkOverlayPopupStateInProgress) {
            return true;
        }
        checkOverlayPopupStateInProgress = true;

        if ($sessionStorage.loginMessage) {
            vm.loginMessage = $sessionStorage.loginMessage;
            delete $sessionStorage.loginMessage;
        } else {
            vm.loginMessage = '';
        }
        var promises = [];
        var found = false;
        promises.push(angular.forEach(allowedTypes, function (type) {
            $log.debug('account/controller checkOverlayPopupState checking type', {type: type, 'location.search()[type]': $location.search()[type], '$location.search()': $location.search()});
            if ($location.search()[type]) {
                found = true;
                if (type !== vm.type) {
                    vm.show = true;
                    vm.type = type;
                    vm.showdark = true;
                }
            }
        }));

        if (vm.show) {
            $log.debug('account/controller checkOverlayPopupState calls now checkShowFF', vm.type);
            checkShowFF(vm.type);
        }

        if (vm.type === 'alert' && vm.alert === false) {
            $location.search('alert', null);
            $log.debug('account/controller checkOverlayPopupState calls now vm.closeAll, reset $location.search(alert)');
            vm.closeAll();
            checkOverlayPopupStateInProgress = false;
            return false;
        }

        $q.all(promises).then(function () {
            if (vm.type !== false && found === false) {
                vm.type = false;
                vm.showdark = false;
                vm.show = false;
            }
            if (found === false) {
                $log.debug('account/controller checkOverlayPopupState calls now closeAll after solving all promises');
                closeAll();
            }
            checkOverlayPopupStateInProgress = false;
        });
    }

    function initWatchers() {
        $window.addEventListener('message', onReceiveWindowMessage, false);
        var accountLogin = $rootScope.$on('account::login', onAccountLogin);
        var accountRefreshToken = $rootScope.$on('account::refreshtoken', onAccountRefreshtoken);
        var accountdoLogout = $rootScope.$on('account::doLogout', onAccountLogout);
        var routeUpdate = $rootScope.$on('$routeUpdate', onRouteUpdate);
        var routeChangeSuccess = $rootScope.$on('$routeChangeSuccess', onRouteChangeSuccess);
        var closeffc = $rootScope.$on('close::togglefulfillment', function () {
            vm.closeAll();
        });
        $scope.$watch('showff', onWatchShowff);
        $scope.$watch('type', onWatchType);
        $scope.$watch('show', onWatchShow);
        $scope.$watch(Accounting.getAlert(), onWatchAlert);

        function onRouteUpdate(event, data) {
            $log.debug('Account/controller onRouteUpdate()', {event: event, data: data});
            checkOverlayPopupState();

        }

        function onRouteChangeSuccess(event, data) {
            $log.debug('Account/controller onRouteChangeSuccess()', {event: event, data: data});
            Accounting.validateLoggedInUser();
            if ($sessionStorage.user && $sessionStorage.user.user && !$sessionStorage.user.user.agb && data && data.params && data.params.station && ['agb', 'datenschutzbestimmungen'].indexOf(data.params.station) === -1) {
                //Accounting.agbQuestion();
                $location.search('account');
            }
            if (angular.isFunction($window.usabilla_live)) {
                var loginstate = Accounting.isLoggedIn() ? (Accounting.isPremiumUser() ? 'eingeloggt_plus' : 'eingeloggt') : 'uneingeloggt';
                $log.debug('Account/controller onRouteChangeSuccess() loginstate', loginstate);
                $window.usabilla_live('data', {'custom': {'loginstate': loginstate}});
            }
            checkOverlayPopupState();
        }

        function onAccountLogin() {
            vm.loggedin = true;
            vm.logginButtonType = 'account';
            /*
             //everest: das ffc weiss schon längst, dass der user eingeloggt ist, weil er sich da ja eingeloggt hat.
             var loginarray = {
             accountLogin: true,
             user: $sessionStorage.user
             };
             document.getElementById('now-fulfillment-overlay-iframe').contentWindow.postMessage(angular.toJson(loginarray), STAGE.postMessageDomain);
             */
        }

        function onAccountRefreshtoken(event, token) {
            Accounting.refreshToken(token);
        }

        function onAccountLogout(event, callback) {
            doLogout(callback);
        }

        function onReceiveWindowMessage(event) {
            $log.debug('Account/controller onReceiveWindowMessage()', event);
            var allowedOrigins = ['tvnow.de', 'tvnow.at', 'tvnow.ch', 'nowtv.de', 'rtl.de'];
            angular.forEach(allowedOrigins, function (allowedOrigin) {
                if (event.origin.indexOf(allowedOrigin) > -1 && event.data) {
                    try {
                        var data = angular.fromJson(event.data);
                        if (data.updateUser) {
                            $localStorage.user = data.user;
                            $sessionStorage.user = data.user;
                            Accounting.setTokenAndCheckRefresh(data.user.token);
                        } else if (data.closeFF) {
                            $log.debug('Account/controller eventListener(message): FFC wants to close itself, calling closeAll');
                            vm.closeAll();
                            if (data.url) {
                                $location.search({});
                                $location.path(data.url);
                            } else {
                                $route.reload();
                            }
                            vm.$apply();
                        } else if (data.logout) {
                            doLogout();
                            if (data.autologout) {
                                $location.search('autologout');
                            }
                            vm.$apply();
                        } else if (data.accountDeleted) {
                            doLogout();
                            $location.search('deletesuccess');
                            vm.$apply();
                        }
                    } catch (e) {
                        //$log.debug(e);
                    }
                }
                delete(event.data);
            });
            if(event.origin.indexOf('tagcommander')>-1){
                if(event.data.indexOf('setCat')>-1){
                    $timeout(function () {
                        $window.location.reload();
                    },500);
                }
            }
        }

        function onWatchShowff(val) {
            $log.debug('Account/controller watch showff toggles fulfillment now');
            $rootScope.$broadcast('account::togglefulfillment', val, vm.type, vm.val);
        }

        function onWatchType(type, oldtype) {
            $log.debug('Account/controller watch type has fired', {type: type, oldtype: oldtype});
            checkProductIdInParams(type);

            if (type === 'emailverify') {
                if ($sessionStorage.user) {
                    $sessionStorage.user.emailVerified = 1;
                }
                if ($localStorage.user) {
                    $localStorage.user.emailVerified = 1;
                }
            }

            if (type === 'alert' && vm.alert === false) {
                $location.search('alert', null);
                return false;
            }

            if (type !== false) {
                vm.val = ($location.search()[type]) ? $location.search()[type] : true;

                if (type === 'passwordrecover' && $location.search().token) {
                    Accounting.setPasswordToken($location.search().token);
                }

                for (var i = 0; i < checkpopups.length; i++) {
                    if (type !== checkpopups[i]) {
                        $location.search(checkpopups[i], null);
                    }
                }
                $location.search(type, vm.val);
                if (angular.isString(oldtype) && oldtype.length > 0) {
                    $location.search(oldtype, null);
                }
            }
            checkLoggedInViewState();
        }

        function onWatchShow(val) {
            vm.trackingInitialIgnoreStatusReiter = true;
            vm.trackingInitialIgnoreStatusFulfillment = true;

            if (val && angular.isString(vm.type)) {
                $location.search(vm.type, vm.val);
            } else {
                vm.loginbuttontext = false;
                $location.search(vm.type, null);
            }

            $log.debug('Account/controller watch show will now open or close the ffc');

            if (angular.isDefined(val) && (vm.type || trackingLastVmType)) {
                trackEventFF((val) ? 'oeffnen' : 'schliessen');

                /*if (vm.type === 'account' || (!vm.type && trackingLastVmType === 'account') ||
                 vm.type === 'payment' || (!vm.type && trackingLastVmType === 'payment')) {
                 trackEventFF((val) ? 'oeffnen' : 'schliessen');
                 } else {
                 $log.debug('trackEvent ANMELDE FLYOUT',vm.type,vm.loggedin,vm.loginbuttontext);
                 var label = (vm.type === 'registration' && !vm.loggedin && vm.loginbuttontext) ? 'anmelden_button' : '';
                 trackEvent((val) ? 'ausklappen' : 'zuklappen', label);
                 }*/
            }
            if (vm.type) trackingLastVmType = vm.type;
        }

        function onWatchAlert(alert) {
            if (alert !== false && alert) {
                $log.debug('Account/controller initWatchers Accounting.getAlert() returns !false, opening premium', alert);
                $location.search('premium');
                /*vm.alert = alert;
                 vm.type = 'alert';
                 vm.show = true;
                 vm.showdark = true;
                 if (alert.closeafter > 0) {
                 $timeout(function () {
                 if (vm.type === 'alert' && vm.show) {
                 vm.closeAll();
                 }
                 }, alert.closeafter)
                 }*/
            }

        }


        $rootScope.$on('$destroy', accountLogin);
        $rootScope.$on('$destroy', accountRefreshToken);
        $rootScope.$on('$destroy', accountdoLogout);
        $rootScope.$on('$destroy', routeUpdate);
        $rootScope.$on('$destroy', routeChangeSuccess);
        $rootScope.$on('$destroy', closeffc);

    }


    function init() {
        initWatchers();
        angular.forEach(allowedTypes, function (type) {
            if (params[type]) {
                vm.show = true;
                vm.type = type;
                vm.showdark = true;
                if (type === 'passwordrecover' && $location.search().token) {
                    vm.passwordtoken = $location.search().token;
                }
                checkProductIdInParams(type);
                checkShowFF(type);
            }
        });

        //show validation window upon site reload / visit when user is logged in but not yet validated
        $timeout(function () {
            if (vm.loggedin && !vm.show && !$sessionStorage.user.emailVerified) {
                $location.search('verifyemail');
            }
        }, 2000);
    }

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('anmelde_flyout', action, label);
    }

    function trackEventFF(action, label) {
        NowGoogleAnalytics.trackEvent('fulfillment_center', action, label);
    }

    function trackHeaderButton(action) {
        var label = 'registrieren';

        if(action==='login'){
            if(vm.loggedin===true){
                label = 'mein_profil';
            }else{
                label = 'einloggen';
            }
        }

        NowGoogleAnalytics.trackEvent('header_button',action,label);
    }
}


})();

(function() {





})();

(function() {



})();

(function() {

angular.module('NowTracking', []);

})();

(function() {

'use strict';

angular.module('NowTracking')
    .service('NowAdformTracking', NowAdformTracking);

NowAdformTracking.$inject = ['$window', '$log', 'Metadata'];

/**
 *@constructor
 */
function NowAdformTracking($window, $log, Metadata) {
    var adformClientId = 299160;

    this.trackPageImpression = trackPageImpression;

    function trackPageImpression(ivw) {
        if (!ivw || !$window.adf || Metadata.isSearchEngine()) {
            return;
        }

        var trackingPointName = ivw.substr(1).replace(/\//g, '|');

        if ($window.location.host.match(/staging\./i) || $window.location.host.match(/local\./i)) {
            trackingPointName = 'TEST|' + trackingPointName;
        }

        $log.debug('NowAdformTracking.trackPageImpression', ivw, trackingPointName);
        $window.adf.track(adformClientId, encodeURIComponent(trackingPointName));
    }
}

})();

(function() {

'use strict';

angular
    .module('NowTracking')
    .service('NowGoogleAnalytics', NowGoogleAnalytics);

NowGoogleAnalytics.$inject = ['$rootScope', 'STAGE', '$window', '$cookies', '$log', 'Metadata', 'Accounting', 'Optimizely', '$document', '$http'];

/**
 *@constructor
 */
function NowGoogleAnalytics($rootScope, STAGE, $window, $cookies, $log, Metadata, Accounting, Optimizely, $document, $http) {
    var currentStation = 'rtl',
        self = this,
        init = false,
        lastIVW = null,
        redirectref = false,
        googleAnalyticsAccount = (STAGE.isProduction) ? 'UA-48267743-15' : 'UA-48267743-16',
        disableStr = 'ga-disable-' + googleAnalyticsAccount;

    if ($cookies.get('redirectref')) {
        redirectref = $cookies.get('redirectref');
    }

    if (STAGE.isProduction && (bowser.mobile || (bowser.tablet && !bowser.msie))) {
        googleAnalyticsAccount = "UA-48267743-29";
    }


    self.setup = setup;
    self.initGA = initGA;
    self.trackPageImpression = trackPageImpression;
    self.trackEvent = trackEvent;
    self.gaOptout = gaOptout;
    self.gaOptoutStatus = gaOptoutStatus;
    self.getGoogleAnalyticsId = getGoogleAnalyticsId;



    return self;

    function setup() {
        $rootScope.on('site::changedstation', function (event, station) {
            if (station !== currentStation) {
                currentStation = station;
                self.initGA();
            }
        });

        $rootScope.on('account::login', function () {
            self.initGA();
        });
    }

    function gaOptoutStatus() {
        if ($document.cookie && $document.cookie.indexOf(disableStr + '=true') > -1) {
            return true;
        } else {
            return false;
        }
    }

    function getGoogleAnalyticsId() {
        return googleAnalyticsAccount;
    }

    function gaOptout(val) {
        if (val === true) {
            $document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
            $window[disableStr] = true;
        } else {
            $window[disableStr] = false;
            $document.cookie = disableStr + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }

    }

    function initGA() {

$log.debug('initGA');
        if ($window.ga) {
            $window.ga('create', googleAnalyticsAccount, 'auto', {
                'name': 'nowTracking',
                'allowLinker': true
            });
            $window.ga('nowTracking.require', 'linker');
            $window.ga('nowTracking.require', 'ec');
            $window.ga('nowTracking.linker:autoLink', 'tvnow.de');
            $window.ga('nowTracking.set', 'anonymizeIp', true);
            if (redirectref) {
                $window.ga('nowTracking.set', 'referrer', redirectref);
            }
            if (Accounting.getClientId()) {
                $window.ga('nowTracking.set', 'userId', Accounting.getClientId());
            }

            var testGoogleAnalyticsAccount = "UA-48267743-42";

            if (STAGE.isProduction && (bowser.mobile || (bowser.tablet && !bowser.msie))) {
                testGoogleAnalyticsAccount = "UA-48267743-41";
            }

            $window.ga('create', testGoogleAnalyticsAccount, 'auto', {
                'name': 'nowTestTracking',
                'allowLinker': true
            });
            $window.ga('nowTestTracking.require', 'linker');
            $window.ga('nowTestTracking.require', 'ec');
            $window.ga('nowTestTracking.linker:autoLink', 'tvnow.de');
            $window.ga('nowTestTracking.set', 'anonymizeIp', true);
            if (redirectref) {
                $window.ga('nowTestTracking.set', 'referrer', redirectref);
            }
            if (Accounting.getClientId()) {
                $window.ga('nowTestTracking.set', 'userId', Accounting.getClientId());
            }

            if ($window.ga.getAll && $window.ga.getAll().length > 0) {
                $http.defaults.headers.common['X-GOOGLE-ID'] = $window.ga.getAll()[0].get('clientId');
            }
        }

    }

    function trackPageImpression(ivw) {
        if (!$window.ga || Metadata.isSearchEngine()) {
            return;
        }
        if (ivw) {
            lastIVW = ivw;
        }

        if (!init) {
            self.initGA();
        }

        var dimensions = generateCustomDimensions();
        var level = 2;
        var ivws = ivw.split('/');
        for (var i = 0; i < ivws.length; i++) {
            if (ivws[i].length > 0) {
                dimensions['dimension' + level++] = ivws[i];
            }
        }

        $log.debug('service_google trackPageImpression()', {page: $window.location.pathname});

        if (level > 2) {
            $window.ga('nowTracking.set', 'page', $window.location.pathname);
            $window.ga('nowTracking.send', 'pageview', dimensions);
            deleteRefCookie();
        }

    }

    function trackEvent(trackCategory, trackAction, trackLabel, trackValue, customValues) {
        var eventdata = {
            hitType: 'event',
            eventCategory: trackCategory,
            eventAction: trackAction,
            eventLabel: trackLabel,
            eventValue: trackValue
        };

        if (!init) {
            self.initGA();
        }


        var dimensions = generateCustomDimensions();
        if (lastIVW) {
            var level = 2;
            var ivws = lastIVW.split('/');
            for (var i = 0; i < ivws.length; i++) {
                if (ivws[i].length > 0) {
                    dimensions['dimension' + level++] = ivws[i];
                }
            }
        }

        if (angular.isObject(dimensions)) {
            angular.forEach(dimensions, function (value, key) {
                eventdata[key] = value;
            });
        }
        if (angular.isObject(customValues)) {
            angular.forEach(customValues, function (value, key) {
                eventdata[key] = value;
            });
        }


        //track google events with Analytics Universal. trackLabel and trackValue are optional.
        $log.debug('service_google trackEvent() ~~~~~~~~~~~~~~~~~~~~~ GA EVENT TRACKING', {
            eventdata: eventdata,
            '$window.ga': $window.ga,
            'Metadata.isSearchEngine()': Metadata.isSearchEngine()
        });

        if (!$window.ga || Metadata.isSearchEngine()) {
            return;
        }

        if (angular.isUndefined(trackCategory) || angular.isUndefined(trackAction)) {
            $log.error('service_google trackEvent(): trackCategory and trackAction have to be set');
            return false;
        }

        if (angular.isDefined(trackValue) && !angular.isNumber(trackValue)) {
            $log.error('trackValue cannot be of anything else than number.');
            return false;
        }

        deleteRefCookie();
        return $window.ga('nowTracking.send', eventdata);
    }


    function generateCustomDimensions() {
        var dimensions = {};
        dimensions['dimension1'] = bowser.mobile ? 'Smartphone' : ((bowser.tablet && !bowser.msie) ? 'Tablet' : 'Online');
        dimensions['dimension8'] = (Accounting.isLoggedIn()) ? 'eingeloggt' : 'nicht_eingeloggt';
        dimensions['dimension21'] = Accounting.getClientId() || 'na';

        dimensions['dimension10'] = Accounting.getSubscriptionState();
        //dimensions[''] = '';
        if (angular.isObject($window.optimizely)) {
            dimensions['dimension11'] = Optimizely.getActiveExperimentNames();
            dimensions['dimension12'] = Optimizely.getVariationNames();
        }
        if($window.ga && $window.ga.getAll && $window.ga.getAll().length > 0) {
            dimensions['dimension22'] =  $window.ga.getAll()[0].get('clientId');
        }
        if (angular.isObject($window.thcObj) && $window.thcObj.technic) {
            dimensions['dimension23'] = $window.thcObj.technic;
        }else{
            dimensions['dimension23'] = "na";
            $log.error('technical service cookie not set or readable');
        }



        return dimensions;
    }

    function deleteRefCookie() {
        if ($cookies.get('redirectref')) {
            redirectref = $cookies.get('redirectref');
            $document.cookie = "redirectref=;expires=Thu, 01 Jan 1970 00:00:00;domain=.tvnow.de;path=/";
        }
    }
}


})();

(function() {

'use strict';

angular.module('NowTracking')
    .service('Optimizely', Optimizely);

Optimizely.$inject = ['STAGE', '$window', '$log'];

/**
 *@constructor
 */
function Optimizely(STAGE, $window, $log) {
    var self = this;
    //optimizelyProjectId = 5069060333;

    self.init = init;
    self.trackEvent = trackEvent;
    self.isActiveExperiment = isActiveExperiment;
    self.getVariationForExperiment = getVariationForExperiment;
    self.getActiveExperiments = getActiveExperiments;
    self.getActiveExperimentNames = getActiveExperimentNames;
    self.getVariationNames = getVariationNames;
    self.isActive = isActive;

    init();

    return self;

    function init() {
        $window['optimizely'] = $window['optimizely'] || [];
        if (angular.isObject($window.optimizely) && !STAGE.isProduction && $window.optimizely.verbose) {
            $window.optimizely.verbose();
        }
        $window.optimizelyReady = true;
    }

    function trackEvent(eventName) {
        $log.debug('Optimizely - trackEvent() - eventName', eventName);
        $window.optimizely.push(['trackEvent', eventName]);
        if (eventName.indexOf('pageview__') !== -1) {
            $window.optimizelyEvent = eventName;
        }
    }

    function isActiveExperiment(id) {
        if (!angular.isString(id)) id = id.toString();
        $log.debug('Optimizely - isActiveExperiment() - id + result', id, (isActive && self.getActiveExperiments().indexOf(id) !== -1));
        return (self.getActiveExperiments().indexOf(id) !== -1);
    }

    function getVariationForExperiment(id) {
        if (!angular.isString(id)) id = id.toString();
        $log.debug('Optimizely - getVariationForExperiment() - id + result', id, $window.optimizely.variationNamesMap[id]);
        return $window.optimizely.variationNamesMap[id];
    }

    function getActiveExperiments() {
        var experiments = [];
        if (isActive()) {
            if ($window.optimizely.activeExperiments) {
                experiments = $window.optimizely.activeExperiments
            }
        }
        $log.debug('Optimizely - getActiveExperiments() - experiments', experiments);
        return experiments;
    }

    function getActiveExperimentNames() {
        var experimentNames = '',
            experiments = [];
        if (isActive()) {
            var allExperiments = self.getActiveExperiments();
            angular.forEach(allExperiments, function (key) {
                experiments.push($window.optimizely.allExperiments[key].name);
            });
            experimentNames = experiments.toString();
            $log.debug('Optimizely - getActiveExperimentNames() - experimentNames', experimentNames);
        }
        return experimentNames;
    }

    function getVariationNames() {
        var variationNames = '',
            variations = [];
        if (isActive()) {
            var allExperiments = self.getActiveExperiments();
            angular.forEach(allExperiments, function (key) {
                variations.push($window.optimizely.variationNamesMap[key]);
            });
            variationNames = variations.toString();
            $log.debug('Optimizely - getActiveExperimentNames() - variationNames', variationNames);
        }
        return variationNames;
    }

    function isActive() {
        return ($window.optimizelyReady && angular.isObject($window.optimizely));
    }
}


})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowTracking')
    .service('NowTagCommander', NowTagCommander);

NowTagCommander.$inject = [
    '$rootScope',
    '$log',
    '$ocLazyLoad',
    'STAGE',
    '$window',
    'AppConfig',
    '$location'
];

/**
 *@constructor
 */
function NowTagCommander($rootScope, $log, $ocLazyLoad, STAGE, $window, AppConfig, $location) {
    var self = this,
        dataLayer = {},
        removeableProperties = [],
        isLoaded = false,
        footerScript = (STAGE.isProduction) ? "//cdn.tagcommander.com/3996/tc_TVNOW_footer_20.js" : "//cdn.tagcommander.com/3996/uat/tc_TVNOW_footer_20.js";

    self.initCommander = initCommander;
    self.addToDatalayer = addToDatalayer;
    self.removeFromDataLayer = removeFromDataLayer;
    self.reloadDatalayer = reloadDatalayer;
    self.getCountry = getCountry;
    self.execEvent = execEvent;

    function initCommander() {
        $log.info("initCommander");

        self.addToDatalayer("env_work", STAGE.isProduction ? "production" : "staging");
        self.addToDatalayer('env_currency', 'EUR');
        self.addToDatalayer('env_device', (bowser.tablet && !bowser.msie) ? 'Tablet' : (AppConfig.webclient === 'mobile') ? 'Smartphone' : 'Online');
        self.addToDatalayer('env_country', self.getCountry());

        $window.tc_vars = dataLayer;

        $rootScope.$on('contentUpdated', function (event, teaserset, element) {
            $log.info("tag contentUpdated", teaserset, element);

            if (tc_events_21) {
                //tc_events_21(this, "track_google_ecommerce_content", {element: element});
            }
            if (angular.isDefined(window.cbc.ga.ec)) {
                window.cbc.ga.ec.contentLoaded({element: element});
            }
        });

        $rootScope.$on('$routeChangeSuccess', function () {
            if (tc_events_21 && isLoaded) {
                $log.info("tag commander update page", $window.tc_vars);
                tc_events_21(this, "newPage", dataLayer);

                //tc_events_21(this, "track_google_ecommerce_start", dataLayer);
                if (angular.isDefined(window.cbc.ga.ec)) {
                    window.cbc.ga.ec.init();
                }
            } else {
                isLoaded = true;
                $log.info("tag commander load", $window.tc_vars);
                $ocLazyLoad
                    .load(footerScript)
                    .then(function () {
                        $log.info("tag commander loaded");
                        if (tc_events_21) {
                            //tc_events_21(this, "track_google_ecommerce_start", dataLayer);
                        }
                        if (angular.isDefined(window.cbc.ga.ec)) {
                            window.cbc.ga.ec.init();
                        }
                    });
            }
        });

        $rootScope.$on('$routeChangeStart', function () {
            if (removeableProperties.length > 0) {
                angular.forEach(removeableProperties, function (property) {
                    delete dataLayer[property];
                });
                removeableProperties = [];
            }
        });
    }

    function addToDatalayer(key, value, notPersistent) {
        $log.info("addToDatalayer");
        dataLayer[key] = value;
        if (notPersistent) {
            removeableProperties.push(key);
        }
    }

    function removeFromDataLayer() {
        $log.info("removeFromDatayer");
    }

    function reloadDatalayer() {
        $log.info("reloadDatalayer");
    }

    function getCountry() {
        if ($location.host().indexOf('ch') !== -1) {
            return 'CH';
        } else if ($location.host().indexOf('at') !== -1) {
            return 'AT';
        } else {
            return 'DE';
        }
    }

    function execEvent(scope, event, params) {
        if (tc_events_21) {
            tc_events_21(scope, event, params);
        }
    }

}


})();

(function() {

/* eslint angular/no-private-call: 0 */
'use strict';

angular
    .module('NowTracking')
    .service('NowTracking', NowTracking);

NowTracking.$inject = [
    '$rootScope',
    '$log',
    '$route',
    'AdControlService',
    'NowGoogleAnalytics',
    'PlayerService',
    'Metadata',
    'TrackingHelper',
    'StationMonitor',
    'LiveStreamService',
    '$cookies',
    'PageHistory',
    '$window',
    'LastRoute',
    'PlayerHelperService',
    'NowTagCommander',
    'Accounting',
    '$sessionStorage',
    'Optimizely',
    'moment'
];

/**
 *@constructor
 */
function NowTracking($rootScope, $log, $route, AdControlService, NowGoogleAnalytics, PlayerService, Metadata, TrackingHelper, StationMonitor, LiveStreamService, $cookies, PageHistory, $window, LastRoute, PlayerHelperService, NowTagCommander, Accounting, $sessionStorage, Optimizely, moment) {
    var self = this,
        listener = [],
        teasersets = [];


    self.ivwOfferPrefix = '/tv_now_de';

    //Teaserset Tracking
    self.setCurrentTeasersets = setCurrentTeasersets;
    self.getTeasersetPosition = getTeasersetPosition;
    self.appendToCurrentTeasersets = appendToCurrentTeasersets;

    self.getCurrentMovie = getCurrentMovie;
    self.trackPageImpression = trackPageImpression;
    self.isInfonlineTrackingDisabledByUser = isInfonlineTrackingDisabledByUser;
    self.toggleInfonlineTrackingByUser = toggleInfonlineTrackingByUser;

    listener[listener.length] = $rootScope.$on('$routeChangeSuccess', onRouteChangeSuccess);
    listener[listener.length] = $rootScope.$on('player::html5Play', onPlayerUserPlay);
    listener[listener.length] = $rootScope.$on('livePlayerDirective::manualStart', onLivestreamManualStart);

    return self;

    /**
     * Register the teaseretes to follow
     *
     * @param set
     */
    function setCurrentTeasersets(set) {
        teasersets = [];
        if (angular.isArray(set)) {
            set.forEach(function (teaserset) {
                if (teaserset.automaticType === "recommendation") {
                    teasersets.push(teaserset);
                } else if (angular.isObject(teaserset.teaserSetInformations) && angular.isArray(teaserset.teaserSetInformations.items)) {
                    if (teaserset.teaserSetInformations.items[0].customTeaserType !== "html") {
                        teasersets.push(teaserset);
                    }
                }
            })
        }
    }

    /**
     * Get the ROW Position of the tracked teaserser
     *
     * @param teaserset
     * @return number
     */
    function getTeasersetPosition(teaserset) {
        if (angular.isArray(teasersets) && teasersets.length > 0) {
            return teasersets.indexOf(teaserset) + 1;
        } else {
            return 0;
        }
    }

    function appendToCurrentTeasersets(teaserset) {
        teasersets.push(teaserset);
    }

    function onLivestreamManualStart() {
        collectLivestreamData(true, onPlayerUserPlay);
    }

    function onRouteChangeSuccess(event, currentRoute) {
        if (Metadata.isSearchEngine()) {
            return;
        }

        var pagetype,
            data = {},
            channel = '',
            format = currentRoute.locals.format,
            movie = self.getCurrentMovie();
        $log.debug('service_tracking onRouteChangeSuccess', {'$route': $route, current: currentRoute});


        pagetype = checkTrackingType(currentRoute);
        $log.debug("service_tracking onRouteChangeSuccess > pagetype", pagetype);


        if (Accounting.isLoggedIn()) {
            NowTagCommander.addToDatalayer("user_id", $sessionStorage.user.id);
            NowTagCommander.addToDatalayer("user_gender", $sessionStorage.user.sex);
            NowTagCommander.addToDatalayer("user_age", moment().diff($sessionStorage.user.birthday, 'years'));
        }

        NowTagCommander.addToDatalayer("user_paytype", Accounting.getSubscriptionState());
        NowTagCommander.addToDatalayer("user_logged", (Accounting.isLoggedIn()) ? 'eingeloggt' : 'nicht_eingeloggt');
        NowTagCommander.addToDatalayer("env_pagetype", pagetype);
        NowTagCommander.addToDatalayer("user_client_id", Accounting.getClientId());

        switch (pagetype) {
            case 'video':
                if (!PlayerHelperService.isAutomaticVideostart() && !(bowser.mobile || (bowser.tablet && !bowser.msie))) {
                    data = collectVideoData(movie, {});
                }
                break;
            case 'livestream':
                data = collectLivestreamData(false);
                if (data && data.ivw) {
                    NowGoogleAnalytics.trackPageImpression(data.ivw);
                }
                break;
            default:
                data = collectPageData(currentRoute, pagetype);
                if (data && data.ivw) {
                    $log.debug('service_tracking onRouteChangeSuccess > page', data);
                    NowGoogleAnalytics.trackPageImpression(data.ivw);
                } else {
                    $log.debug('service_tracking onRouteChangeSuccess > page > IVW NOT Defined, do not track!?', data);
                }
        }
        if (data && data.ivw) {
            NowTagCommander.execEvent(this, "page_view", {
                agof_offer: data.angebot,
                agof_comment: data.ivw,
                agof_code: data.agof,
                isAutomaticVideostart: PlayerHelperService.isAutomaticVideostart(),
                agof_fragebogen: data.fragebogen,
                current_station: StationMonitor.getStation(),
                isInitialRoute: LastRoute.isInitialRoute(),
                optimizely_active_experiment_names: Optimizely.getActiveExperimentNames(),
                optimizely_variation_names: Optimizely.getVariationNames()

            });
        }

        if (pagetype !== 'static' && movie) {
            format = movie.format;
        }
        //when removing dependencies in mobile.js, adcontrol.reconfigure() can be easily replaced by the following broadcast. see also service_adcontrol.js
        AdControlService.reconfigure({}, format, channel);
    }

    function onPlayerUserPlay(event, eventname, data) {


        $log.debug('onPlayerUserPlay', event, eventname, data, PlayerService.firstContentStarted, PlayerHelperService.getCurrentMovie());

        if (PlayerService.firstContentStarted || PlayerHelperService.getCurrentMovie().isLivestream) {
            var movie = PlayerHelperService.getCurrentMovie();
            $log.debug('service_tracking onPlayerUserPlay > video', collectVideoData(movie, data));
            var dataVideo = collectVideoData(movie, data);
            if (PlayerHelperService.getCurrentMovie().isLivestream) {
                dataVideo = collectLivestreamData(false);
            }

            NowTagCommander.execEvent(this, "video_start", {
                agof_offer: dataVideo.angebot,
                agof_comment: dataVideo.ivw,
                agof_code: dataVideo.agof,
                isAutomaticVideostart: PlayerHelperService.isAutomaticVideostart(),
                agof_fragebogen: dataVideo.fragebogen,
                current_station: StationMonitor.getStation(),
                isInitialRoute: LastRoute.isInitialRoute(),
                optimizely_active_experiment_names: Optimizely.getActiveExperimentNames(),
                optimizely_variation_names: Optimizely.getVariationNames()
            });


        }
    }

    function checkTrackingType(currentRoute) {
        $log.debug('service_tracking checkTrackingType()', {currentRoute: currentRoute});
        var pagetype = (currentRoute.$$route.data) ? currentRoute.$$route.data.pagetype : false;
        if (currentRoute.locals.page && currentRoute.locals.page.path === 'live-tv') {
            // live-tv page
            return 'livestream';
        }
        if (currentRoute.locals.movie && currentRoute.locals.movie.isLivestream) {
            // in-player live-tv
            return 'livestream';
        }
        if (pagetype === 'player') {
            return 'video';
        }
        return pagetype;
    }

    function getCurrentMovie() {
        var movie;
        if ($route.current.locals && $route.current.locals.movie) {
            movie = $route.current.locals.movie;
            $log.debug('service_tracking getCurrentMovie() from route');
        } else if (PlayerHelperService.getCurrentMovie()) {
            movie = PlayerHelperService.getCurrentMovie();
            $log.debug('service_tracking getCurrentMovie() from player service');
        }

        return movie;
    }


    function collectPageData(currentRoute, pagetype) {
        $log.debug('service_tracking collectPageData()', {current: currentRoute, pagetype: pagetype});

        var szm = {};
        var channel = '',
            format = currentRoute.locals.format,
            movie = currentRoute.locals.movie;

        if (pagetype !== 'static' && (format || movie)) {
            if (movie) {
                format = movie.format;
            }
            szm = format.szm[pagetype];
            szm.ivw = szm.ivw.replace('_now/', '_now/formate/');
        }
        else if (currentRoute.locals.page && currentRoute.locals.page.szm) {
            szm = currentRoute.locals.page.szm.static;
        }

        if ((szm.hasOwnProperty('angebot'))) {
            szm.ivw = self.ivwOfferPrefix + szm.ivw;
        } else {
            szm = {angebot: null, agof2_bild: null, ivw: null};
            $log.error('Now Tracking: Page not configured in Admin disabled IVW and Google-Tracking for Pagecall');
        }


        szm.ivw = szm.ivw.replace('nowus_now', 'now_us');


        //Broadcast IVW::ready to application. For example player will initialize after receiving broadcast.
        $rootScope.$broadcast('ivw::ready', szm, format, channel);

        var ivwParts = szm.ivw.split("/");
        $log.log("ivw", szm.ivw);
        for (var i = 0; i < ivwParts.length; i++) {
            if (ivwParts[i] && ivwParts[i].length > 0) {
                NowTagCommander.addToDatalayer("page_ivw_level_" + i, ivwParts[i], true);
            }
        }

        NowTagCommander.addToDatalayer("agof_offer", szm.angebot);
        NowTagCommander.addToDatalayer("agof_code", szm.agof2_bild);

        return {
            angebot: szm.angebot,
            agof: szm.agof2_bild,
            fragebogen: 'in',
            ivw: szm.ivw,
            log: 'reloadIvw'
        };
    }

    function collectVideoData(movie, data, cb) {
        var teilivw, fullIvw, ivwLevels, ivw, szm;

        if (!movie) $log.error('service_tracking collectVideoData NO MOVIE!!!');

        if (movie) {
            if (data !== null && angular.isUndefined(data.part) === false) {
                teilivw = '/teil_' + (data.part + 1);
            } else {
                teilivw = '/teil_1';
            }
            var format = movie.format;
            szm = format.szm['player'];
            fullIvw = TrackingHelper.getFullVideoIvwComment(szm.ivw, PlayerService.getSourcePage(), PlayerService.getSpecialTag());
            $log.debug('service_tracking collectVideoData movie fullIvw', movie, fullIvw);
            ivwLevels = fullIvw.split('/');
            ivwLevels.shift(); // /
            ivwLevels.shift(); // tv_now_de
            var stationId = ivwLevels.shift(); // sender
            if (Accounting.isPremiumUser()) {
                ivw = self.ivwOfferPrefix + '/' + stationId + '/' + 'videoabrufe_vod' + '/' + ivwLevels.join('/');
            } else {
                ivw = self.ivwOfferPrefix + '/' + stationId + '/' + 'videoabrufe_vod' + '/' + ivwLevels.join('/') + teilivw;
            }

        }

        $log.debug('tracking_service collectVideoData() szm', szm);
        if (ivw) {
            if (angular.isFunction(cb)) {
                cb(szm.angebot, szm.agof2_video, 'ke', ivw, ' reloadIvw');
            }
            return {
                angebot: szm.angebot,
                agof: szm.agof2_video,
                fragebogen: 'ke',
                ivw: ivw,
                log: 'reloadIvw'
            };
        }
    }

    function collectLivestreamData(autostart, cb) {
        var szm, ivw, agof2, fragebogen;

        var isLivePlayer = !!(autostart || TrackingHelper.getLivestreamAutostart() || (self.getCurrentMovie() && self.getCurrentMovie().isLivestream));
        if (isLivePlayer) {
            szm = LiveStreamService.getLiveSzm(StationMonitor.getStation())['player'];
            agof2 = szm.agof2_video;
            fragebogen = 'ke';
        } else {
            szm = LiveStreamService.getPageSzm(StationMonitor.getStation())['player'];
            agof2 = szm.agof2_bild;
            fragebogen = 'in'
        }
        ivw = self.ivwOfferPrefix + szm.ivw;

        $log.debug('service_tracking collectLivestreamData result', isLivePlayer, {
            szm: szm,
            ivw: ivw,
            agof2: agof2,
            fragebogen: fragebogen
        });

        if (angular.isFunction(cb)) {
            cb(szm.angebot, agof2, fragebogen, ivw, ' reloadIvw');
        }

        return {
            angebot: szm.angebot,
            agof: agof2,
            fragebogen: fragebogen,
            ivw: ivw,
            log: 'reloadIvw'
        };
    }

    function trackPageImpression(angebot, seitencode, fragebogen, kommentar, log) {
    }

    function isInfonlineTrackingDisabledByUser() {
        //check if user has voted to opt out in /datenschutz

        //refresh cookie if present
        refreshInfonlineTrackingCookie();

        return getInfonlineTrackingCookie();
    }

    function toggleInfonlineTrackingByUser() {
        if (getInfonlineTrackingCookie()) {
            //re-enable tracking and return new status
            setInfonlineTrackingCookie(false);
            return false;
        } else {
            //disable tracking and return new status
            setInfonlineTrackingCookie(true);
            return true;
        }
    }

    function getInfonlineTrackingCookie() {
        var status = $cookies.get('now-infonline-optout');
        if (angular.isUndefined(status) || status === null) {
            return null;
        }
        return (status === 'true');
    }

    function setInfonlineTrackingCookie(val) {
        var cookieLifetime = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
        return $cookies.put('now-infonline-optout', val, {expires: cookieLifetime, secure: false, path: '/'});
    }

    function refreshInfonlineTrackingCookie() {
        var status = getInfonlineTrackingCookie();
        if (status === null) {
            return;
        }
        return setInfonlineTrackingCookie(status);
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowTracking')
    .directive('gecTrack', gecTrackDirective);

gecTrackDirective.$inject = ["NowTracking", "moment"];

function gecTrackDirective(NowTracking, moment) {
    return {
        restrict: 'A',
        scope: {
            format: '=',
            movie: '=',
            livestream: '=',
            teaser: '=',
            listname: '=',
            position: '='
        },
        link: link
    };

    function link(scope, el) {
        var parentTeaserSet = (scope.$parent.parentTeaserSet) ? scope.$parent.parentTeaserSet : scope.$parent.teaserset;
        var source = (!parentTeaserSet) ? null : ((parentTeaserSet.automaticType === 'recommendation' || parentTeaserSet.automaticType === 'recommendation-series') ? 'yusp' : 'na');
        $(el).addClass("cbc-gec-teaser");

        if (scope.format && scope.format.title) {
            $(el).attr("data-cbc-gec-brand", scope.format.title);
        }
        $(el).attr("data-cbc-gec-category", "teaser");

        if (parentTeaserSet && parentTeaserSet.headline) {
            $(el).attr("data-cbc-gec-list", parentTeaserSet.headline);
            var rowPosition = NowTracking.getTeasersetPosition(parentTeaserSet);
            $(el).attr("data-cbc-gec-row-position", (rowPosition === 0) ? 1 : rowPosition);
            $(el).attr("data-cbc-gec-row-id", parentTeaserSet.id);
            var items = parentTeaserSet.teaserSetInformations.items;
            if (angular.isArray(items)) {
                if (items.indexOf(scope.teaser) === -1) {
                    //Genre Übersichtsseite Check Format
                    if (angular.isObject(parentTeaserSet.formats) && angular.isArray(parentTeaserSet.formats.items)) {
                        items = parentTeaserSet.formats.items;
                        var formatItem = items.find(function (val, index) {
                            val.positionCalc = index + 1;
                            return scope.format.id === val.id;
                        });
                        if (angular.isDefined(formatItem)) {
                            $(el).attr("data-cbc-gec-position", formatItem.positionCalc);
                        }
                    }
                    if (angular.isObject(parentTeaserSet.teaserSetInformations.items[0])){
                        $(el).attr("data-cbc-gec-row-id", parentTeaserSet.teaserSetInformations.items[0].id);
                    }

                } else {
                    $(el).attr("data-cbc-gec-position", (items && items.length > 1) ? (items.indexOf(scope.teaser) + 1) : 1);
                }
            }

            //Top Liste
            if (parentTeaserSet.layout === 10) {
                $(el).attr("data-cbc-gec-category", "top_liste");
                //Mobile bekommt eine Extra Listennamen ABTest
                if (angular.isString(scope.listname) && scope.listname.length > 0) {
                    $(el).attr("data-cbc-gec-list", scope.listname);
                }
            }
            //Aufmacher - Leadteaser
            if (parentTeaserSet.layout === 200) {
                $(el).attr("data-cbc-gec-category", "aufmacher");

                //Reco Teaser im Aufmacher
                if (scope.teaser.reco === true) {
                    source = 'yusp';
                    $(el).attr("data-cbc-gec-position", scope.position);
                }

            }
            if (parentTeaserSet.layout === 8) {
                $(el).attr("data-cbc-gec-category", "flex_modul");
            }
        } else {
            if (angular.isString(scope.listname) && scope.listname.length > 0) {
                $(el).attr("data-cbc-gec-list", scope.listname);
            }
            if (scope.position) {
                $(el).attr("data-cbc-gec-position", scope.position);
            }
        }

        // Movie Paid-Status überschreibt Format Paid-Status
        if (scope.movie && angular.isDefined(scope.movie.free)) {
            $(el).attr("data-cbc-gec-variant", (scope.movie.free) ? "free" : "paid");
        } else if (scope.format && scope.format.icon) {
            $(el).attr("data-cbc-gec-variant", (scope.format.icon === "free") ? "free" : "paid");
        }

        if (scope.teaser && scope.teaser.id) {
            $(el).attr("data-cbc-gec-id", "custom_" + scope.teaser.id);

            if (angular.isObject(scope.teaser.custom) && angular.isObject(scope.teaser.custom.data)) {
                if (angular.isString(scope.teaser.custom.data.headline1)) {
                    $(el).attr("data-cbc-gec-name", scope.teaser.custom.data.headline1);
                }
                if (angular.isString(scope.teaser.custom.data.internalName)) {
                    $(el).attr("data-cbc-gec-name", scope.teaser.custom.data.internalName);
                }
            }
            if (angular.isString(scope.teaser.customTeaserType) && scope.teaser.customTeaserType.length > 0) {
                //$(el).attr("data-cbc-gec-category", scope.teaser.customTeaserType);
                if (scope.teaser.customTeaserType === "image") {
                    $(el).attr("data-cbc-gec-category", "bild_modul");
                }
                if (scope.teaser.customTeaserType === "stopper") {
                    $(el).attr("data-cbc-gec-category", "stopper");
                }
            }
        }

        if (scope.movie && scope.format) {
            $(el).attr("data-cbc-gec-teasertype", "movie");
            $(el).attr("data-cbc-gec-id", "movie_" + scope.movie.id);
            if (scope.movie.episode > 0) {
                //Episode Title
                $(el).attr("data-cbc-gec-name", scope.movie.format.title + " - Folge " + scope.movie.episode + " | " + moment(scope.movie.broadcastStartDate).format('dd. DD.MM.YYYY HH:mm'));
            } else {//Movie Title
                $(el).attr("data-cbc-gec-name", scope.movie.format.title + " | " + moment(scope.movie.broadcastStartDate).format('dd. DD.MM.YYYY HH:mm'));
            }

        } else if (scope.livestream) { // LIVESTREAM Teaser
            var title = 'na';
            var nowDateTime = 'na';

            if (angular.isString(scope.teaser.custom.data.now.broadcastStartDate)) {
                nowDateTime = moment(scope.teaser.custom.data.now.broadcastStartDate).format('HH:mm');
            }

            if (angular.isString(scope.teaser.custom.data.now.title)) {
                title = scope.teaser.custom.data.now.title.substring(0, 60);
            }

            $(el).attr("data-cbc-gec-teasertype", "livestream");
            $(el).attr("data-cbc-gec-name", nowDateTime + ' | ' + title);
            $(el).attr("data-cbc-gec-category", 'teaser');
            $(el).attr("data-cbc-gec-brand", title);


        } else if (!scope.movie && scope.format) {
            $(el).attr("data-cbc-gec-teasertype", "format");
            $(el).attr("data-cbc-gec-name", scope.format.title);
            $(el).attr("data-cbc-gec-id", "format_" + scope.format.id);
        } else {
            $(el).attr("data-cbc-gec-teasertype", "info");
        }

        if (source) {
            $(el).attr("data-cbc-gec-source", source);
        }
    }
}


})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowTracking')
    .factory('TrackingHelper', TrackingHelper);

TrackingHelper.$inject = [
    'VideobarService'
];

/**
 *@constructor
 */
function TrackingHelper(VideobarService) {
    var self = this;

    self.getFullVideoIvwComment = getFullVideoIvwComment;
    self.setLivestreamAutostart = setLivestreamAutostart;
    self.getLivestreamAutostart = getLivestreamAutostart;

    return self;

    function getFullVideoIvwComment(ivw, sourcepage, specialtag) {
        ivw = ivw.replace('now_us', 'nowus_now');

        var source = VideobarService.getNowPlayingContentType();

        if (source === '') {
            source = sourcepage;
        }

        if (source > 0) {
            ivw = ivw.replace('_now/', '_now/channels/');
        } else {
            switch (source) {
                case 'channel':
                case 'channels':
                    ivw = ivw.replace('_now/', '_now/channels/');
                    break;
                case 'specials':
                    ivw = ivw.replace('_now/', '_now/' + specialtag + '/');
                    break;
                case 'more':
                    ivw = ivw.replace('_now/', '_now/mehr_episoden/');
                    break;
                case 'reco':
                    ivw = ivw.replace('_now/', '_now/unsere_empfehlungen/');
                    break;
                case 'playnow':
                    ivw = ivw.replace('_now/', '_now/unsere_empfehlungen_tafel/');
                    break;
                case 'live':
                    ivw = ivw.replace('_now/', '_now/');
                    break;
                default:
                    ivw = ivw.replace('_now/', '_now/formate/');
            }
        }
        ivw = '/tv_now_de' + ivw;
        ivw = ivw.replace('nowtv_now/', '');
        ivw = ivw.replace('nowus_now', 'now_us');

        return ivw;
    }

    function setLivestreamAutostart(isLivestream) {
        self.isLivestream = isLivestream;
    }

    function getLivestreamAutostart() {
        return self.isLivestream;
    }
}


})();

(function() {





})();

(function() {



})();

(function() {

angular.module('NowMyProgramme', ['NowApi', 'ngRoute', 'angular-sortable-view', 'NowAppBase', 'NowAccount']);

})();

(function() {

'use strict';

/**
 * @ngdoc service
 * @name NowMyProgramme.MyProgrammeService
 * @description
 * Service for dealing with favorites and views
 */

angular
    .module('NowMyProgramme')
    .service('MyProgrammeService', MyProgrammeService);

MyProgrammeService.$inject = ['NowApi', 'Accounting', '$log', '$q', '$rootScope'];

/**
 *@constructor
 */
function MyProgrammeService(NowApi, Accounting, $log, $q, $rootScope) {
    var self = this;

    var savedFormatIds = [];
    var movieStatistics = [];
    var counterFormats = 0;
    var loadingState = false;

    this.getCount = getCount;
    this.checkIfFormatsExists = checkIfFormatsExists;
    this.getAdditionalMovies = getAdditionalMovies;
    this.getUserFormats = getUserFormats;
    this.addFormatEntryForUser = addFormatEntryForUser;
    this.removeFormatEntryForUser = removeFormatEntryForUser;
    this.checkSavedFormats = checkSavedFormats;
    this.getFormatids = getFormatids;
    this.checkMovieStatistics = checkMovieStatistics;
    this.getMovieStatistic = getMovieStatistic;
    this.updateMovieStatistic = updateMovieStatistic;
    this.getUserLastSeenContent = getUserLastSeenContent;
    this.refreshSingleMovie = refreshSingleMovie;
    this.isLoading = isLoading;
    this.deleteAll = deleteAll;
    initWatchers();

    return this;

    function getFormatids() {
        return savedFormatIds;
    }

    function isLoading() {
        return loadingState;
    }

    function getCount() {
        return counterFormats;
    }

    function checkIfFormatsExists(id) {
        return (savedFormatIds.indexOf(id) >= 0);
    }

    function getUserMovieStatistic() {
        return NowApi.getUsers().retrieveMovieStatistics({
            'fields': 'progress,timecode,movieId,hidden',
            'id': Accounting.getUserId(),
            'page': 1,
            'maxPerPage': 100,
            'order': 'LastDate desc'
        });
    }

    function getAdditionalMovies(formatId, page) {
        return NowApi.getMovie().retrieve({
            'fields': '["id","containerId","title","episode","broadcastStartDate","articleShort","blockadeText","replaceMovieInformation","free","seoUrl","picture","paymentPaytypes","packages","format",["id", "station", "title","seoUrl"]]',
            'filter': '{"FormatId":  ' + formatId + ' }',
            'order': 'BroadcastStartDate desc',
            'page': (page > 1) ? page : 1,
            'maxPerPage': 5
        });
    }

    function getSingleMovieStatistic(movieId, userId) {
        return NowApi.getMovie().retrieveMovieStatistic({
            'fields': '*',
            'id': movieId,
            'userId': userId
        });
    }

    function getUserFormats() {
        return NowApi.getMyProgramme().retrieveFormatsByUserId({
            'fields': '*,format',
            'userId': Accounting.getUserId(),
            'page': 1,
            'maxPerPage': 100
        });
    }

    function addFormatEntryForUser(formatId, success, error) {
        if (Accounting.isLoggedIn()) {

            var suc = function () {
                savedFormatIds.push(formatId);
                success();
                self.checkSavedFormats();
            };
            NowApi.getMyProgramme().createFormatEntry({
                REQUEST_BODY: {
                    'userId': Accounting.getUserId(),
                    'formatId': formatId
                }
            }).then(suc, error);
        } else {
            error('login');
        }
    }

    function removeFormatEntryForUser(formatId, success, error) {
        if (Accounting.isLoggedIn()) {

            var suc = function () {
                savedFormatIds.splice(savedFormatIds.indexOf(formatId), 1);
                self.checkSavedFormats();
                success();
            };
            NowApi.getMyProgramme().removeFormatEntry({
                'userId': Accounting.getUserId(),
                'formatId': formatId
            }).then(suc, error);
        } else {
            error('login');
        }
    }

    function checkSavedFormats() {
        var formatIds = []
        counterFormats = 0;
        self.loadingState = true;
        self.getUserFormats().then(function (formats) {
            if (formats && formats.total > 0) {
                for (var i = 0; i < formats.items.length; i++) {
                    formatIds.push(formats.items[i].formatId);
                }
                savedFormatIds = formatIds;
                self.loadingState = false;
            }
        });
    }

    function mapToMovieStatistic(movies) {
        angular.forEach(movies, function (entry) {
            movieStatistics[entry.movieId] = entry
        });
    }


    function checkMovieStatistics() {
        getUserMovieStatistic().then(function (data) {
                mapToMovieStatistic(data.items);
            },
            function (err) {
                $log.debug('checkMovieStatistics', err);
            });
    }

    function getUserLastSeenContent(all) {
        var deferred = $q.defer();
        var promise = [];
        promise.push(
            getUserMovieStatistic()
                .then(function (data) {
                        var promises2 = [];
                        mapToMovieStatistic(data.items);
                        angular.forEach(data.items, function (entry) {
                            //$log.debug('progress', entry, entry.progress, (entry.progress > 0.01 && entry.progress < 0.99));
                            if (!entry.hidden && entry.progress > 0.01) {
                                if (all || entry.progress < 0.99) {
                                    promises2.push(
                                        NowApi
                                            .getMovie().list({
                                            'fields': '*,format,files,manifest,breakpoints,paymentPaytypes,packages,pictures',
                                            'id': entry.movieId
                                        }).then(function (movie) {
                                            return movie;
                                        }, function () {
                                            $log.debug('getUserLastSeenContent - error calling movie');
                                        }));
                                }
                            }
                        });

                        $q.all(promises2).then(function (data) {
                            var movies = data.filter(angular.isObject);
                            movies = movies.slice(0, 20);
                            deferred.resolve(movies);
                        }, function () {
                            deferred.reject();
                        });
                    },
                    function () {
                        deferred.reject();
                    }
                ));

        return deferred.promise;
    }

    /**
     * @ngdoc
     * @name NowMyProgramme.MyProgrammeService#refreshSingleMovie
     * @methodOf NowMyProgramme.MyProgrammeService
     *
     * @description
     * fetch users timecode or progress of a movie
     * @example
     * MyProgrammeService.refreshSingleMovie(123)
     * @param {number=} id Id of movie
     */
    function refreshSingleMovie(id) {
        var deferred = $q.defer();
        if (Accounting.isLoggedIn()) {
            getSingleMovieStatistic(id, Accounting.getUserId()).then(function (data) {
                movieStatistics[id] = data;
                deferred.resolve();
            }, function () {
                deferred.resolve();
            });

        } else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    /**
     * @ngdoc
     * @name NowMyProgramme.MyProgrammeService#getMovieStatistic
     * @methodOf NowMyProgramme.MyProgrammeService
     *
     * @description
     * fetch users timecode or progress of a movie
     * @example
     * MyProgrammeService.getMovieStatistic(123, 'progress')
     * @param {number=} id Id of movie
     * @param {string=} type  progress or timecode
     */
    function getMovieStatistic(id, type) {
        if (!type || ['progress', 'timecode'].indexOf(type) === -1) {
            type = "progress";
        }
        if (movieStatistics[id] && Accounting.isPremiumUser()) {
            return movieStatistics[id][type];
        } else {
            return 0;
        }
    }

    function updateMovieStatistic(id, progress, timecode, hidden, soft) {

        if (movieStatistics[id]) {
            movieStatistics[id].progress = progress;
        } else {
            movieStatistics[id] = {progress: progress};
        }


        if (!soft && Accounting.isLoggedIn()) {
            var requestBody = {
                userId: Accounting.getUserId()
            };
            if (progress) {
                requestBody.progress = progress;
            }
            if (timecode) {
                requestBody.timecode = timecode;
            }
            if (hidden) {
                requestBody.hidden = hidden;
            }
            return NowApi.getMovie().saveOrUpdateMovieStatistic({
                id: id, fields: 'id', REQUEST_BODY: requestBody
            });
        }
    }

    function deleteAll() {
        return NowApi.getUsers().hideAllMovieStatistics({
            id: Accounting.getUserId()
        });
    }

    function initWatchers() {
        var accountLogin = $rootScope.$on('account::login', function () {
            self.checkSavedFormats();
            self.checkMovieStatistics();
        });

         var accountLogout = $rootScope.$on('account::logout', function () {
            counterFormats = 0;
            movieStatistics = [];
        });

        $rootScope.$on('$destroy',accountLogin);
        $rootScope.$on('$destroy',accountLogout);

    }
}





})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMyProgramme')
    .directive('nowfavoritebutton', nowfavoritebutton);

nowfavoritebutton.$inject = ['$timeout', '$window', '$compile', '$document', 'MyProgrammeService', '$sessionStorage', '$location', '$rootScope', 'RecommendationService', '$log', 'NowGoogleAnalytics'];

function nowfavoritebutton($timeout, $window, $compile, $document, MyProgrammeService, $sessionStorage, $location, $rootScope, RecommendationService, $log, NowGoogleAnalytics) {
    return {
        restrict: 'E',
        replace: true,
        template: '<span class="now-favorite-button-add icon" ng-class=\'{"icon_add_favorit_selected": (checkFormatFav(item) || done), "icon_add_favorit":!isResume, "icon_close2":isResume}\'></span>',
        scope: {
            'item': '=',
            'onshow': '&onshow',
            'onhide': '&onhide',
            'completeadd': '&completeadd',
            'completeremove': '&completeremove',
            'hideformat': '='
        },
        link: link
    };

    function link(scope, element) {
        var mypos = {
                top: 0,
                left: 0
            },
            alertLoginListener = false;

        scope.addFormatEntryForUser = addFormatEntryForUser;
        scope.removeFormatEntryForUser = removeFormatEntryForUser;
        scope.hideFromResume = hideFromResume;
        scope.checkFormatFav = checkFormatFav;
        var parent = scope.$parent.$parent.parentTeaserSet;
        scope.isResume = (parent && (parent.automaticType === 'lastseencontent' || parent.automaticType === 'allseencontent'));
        scope.loggedin = ($sessionStorage.user && $sessionStorage.user.id);

        var timeoutPromise = false,
            body = $document.find('body').eq(0),
            overlay = false,
            overlayListener = false;

        $(element).on('click', onClick);


        function pulse() {

            $('.now-header .icon_menu_playlist').addClass('pulse icon_menu_playlist_full');
            $timeout(function () {
                $('.pulse').removeClass('pulse icon_menu_playlist_full');
            }, 4000);


        }

        function alertLogin(callback) {
            alertLoginListener = $rootScope.$on('account::login', function () {
                if (callback) {
                    callback();
                    alertLoginListener();
                }
            });
            $log.debug('MyProgramme/directive_button alertLogin() opening premium');
            $location.search('premium', true);
        }

        function onClick() {
            $log.debug('directive_button scope', scope);

            trackEvent('aufklappen');

            scope.removeOverlay = remove;


            if (!overlay) {
                $rootScope.$broadcast('fav::overlay');
                var html = ''
                    + '<div class="arrow"></div>'
                    + '<div class="content">'
                    + ' <div ng-hide="hideformat || isResume">'
                    + '     <span ng-hide="checkFormatFav(item)">Zur Merkliste</span>'
                    + '     <span ng-show="checkFormatFav(item)">Von der Merkliste</span>'
                    + '     <div class="now-bookmark-button" ng-hide="checkFormatFav(item)" ng-click="addFormatEntryForUser(item)"><span class="icon icon_add_favorit"></span>HINZUFÜGEN</div>'
                    + '     <div class="now-bookmark-button" ng-show="checkFormatFav(item)" ng-click="removeFormatEntryForUser(item);removeOverlay();"><span class="icon icon_add_favorit_selected"></span>ENTFERNEN</div>'
                    + '     <div ng-show="isResume" class="now-bookmark-line"></div>'
                    + '</div>'
                    + ' <div ng-show="isResume">'
                    + '     <span>Folge aus dieser Liste</span>'
                    + '     <div class="now-bookmark-button" ng-click="hideFromResume(item);removeOverlay();"><span class="icon icon_delete"></span>ENTFERNEN</div>'
                    + '</div>'
                    + '</div>';
                overlay = angular.element('<div class="now-overlay now-bookmark-overlay"/>');
                overlay.append(html);
                $compile(overlay)(scope);
                body.append(overlay);
                overlay = $(overlay);
                //$('body').append(overlay);

                var self = this;
                mypos = $(self).offset();

                angular.element($window).on('resize', pos);
                angular.element($window).on('scroll', pos);

                timeoutPromise = $timeout(remove, 4000);
                overlay
                    .on('mouseleave', function () {
                        timeoutPromise = $timeout(remove, 2000);

                    })
                    .on('mouseenter', function () {
                        if (timeoutPromise) {
                            $timeout.cancel(timeoutPromise)
                        }
                    })
                    .show();

                if (scope.onshow) {
                    scope.onshow();
                }
                pos();
                scope.$apply();
                overlayListener = $rootScope.$on('fav::overlay', function () {
                    remove();
                });
            } else {
                remove();
            }

            function pos() {
                //console.log('POSITION', $(self).offset(), $(self).position());
                if (overlay && overlay.css) {
                    overlay.css({
                        top: $(self).offset().top - $(window).scrollTop() - 10,
                        left: $(self).offset().left - 228
                    });
                }
            }

            function remove() {
                if (overlayListener) {
                    overlayListener();
                    overlayListener = false;
                }
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                    timeoutPromise = false;
                }

                if (overlay) {
                    if (scope.onhide) {
                        scope.onhide();
                    }
                    //console.log(overlay);
                    overlay.remove();
                    overlay = false;
                    angular.element($window).off('resize', pos);
                    angular.element($window).off('scroll', pos);
                }
            }
        }

        function checkFormatFav(item) {
            if (!item || !scope.loggedin) {
                return false;
            }
            var id = (item.format) ? item.format.id : item.id;
            return MyProgrammeService.checkIfFormatsExists(id)
        }

        function removeFormatEntryForUser(item) {
            trackEvent('favorit_entfernen');

            var id = (item.format) ? item.format.id : item.id;
            MyProgrammeService.removeFormatEntryForUser(id, success, error);

            function success() {
                scope.done = false;
            }

            function error(err) {
                if (err === 'login') {
                    alertLogin();
                }
            }
        }

        function hideFromResume(item) {
            trackEvent('resumeteaser_entfernen');
            MyProgrammeService.updateMovieStatistic(item.id, null, null, true).then(function () {
                scope.$emit('forcereload', {page: scope.$parent.$parent.$parent.page});
            }, function () {
                scope.$emit('forcereload', {page: scope.$parent.$parent.$parent.page});
            });
        }

        function addFormatEntryForUser(item) {
            trackEvent('zu_favoriten');

            var self = this;
            var id = (item.format) ? item.format.id : item.id;
            RecommendationService.fireEventAddToFavorites(id);
            MyProgrammeService.addFormatEntryForUser(id, success, error);

            function success() {
                pulse();
                scope.done = true;

            }

            function error(err) {
                if (err === 'login') {
                    alertLogin(function () {
                        self.addFormatEntryForUser(id);
                    });
                }
            }
        }

        function trackEvent(what) {
            NowGoogleAnalytics.trackEvent('plus_symbol', what);
        }
    }
}

})();

(function() {

'use strict';

angular
    .module('NowMyProgramme')
    .directive('nowfavoritecounter', nowfavoritecounter);

nowfavoritecounter.$inject = ['MyProgrammeService'];

function nowfavoritecounter(MyProgrammeService) {
    return {
        restrict: 'E',
        replace: true,
        template: '<span class="now-badge" ng-show="(favcount > 0)">{{favcount}}</span>',
        link: link
    };

    function link(scope) {
        scope.$watch(function () {
                return MyProgrammeService.getCount();
            },
            function (count) {
                scope.favcount = count;
            }
        );
    }
}

})();

(function() {

'use strict';

angular
    .module('NowMyProgramme')
    .directive('myprogrammeFormats', NowMyProgrammeFormats);

NowMyProgrammeFormats.$inject = ['NowTeaser'];

function NowMyProgrammeFormats(NowTeaser) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/myprogramme_formats.html',
        link: link
    };

    function link(scope) {

        var teaserset = {
            headline: 'Meine Favoriten',
            automaticType: 'favoriteformats',
            layout: 7,
            automaticConfiguration: {'default': true}
        };
        NowTeaser.appendToCurrentTeasersets(teaserset);
        scope.teaserset = teaserset;
    }
}

})();

(function() {

'use strict';

angular
    .module('NowMyProgramme')
    .directive('myprogrammeMovies', NowMyProgrammeMovies);

NowMyProgrammeMovies.$inject = ['MyProgrammeService', 'NowTeaser'];

function NowMyProgrammeMovies(MyProgrammeService, NowTeaser) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/myprogramme_movies.html',
        link: link
    };

    function link(scope) {
        scope.deleteAll = deleteAll;

        var teaserset = {
            headline: 'Zuletzt gesehen',
            automaticType: 'allseencontent',
            layout: 6,
            automaticConfiguration: {'default': true}
        };

        NowTeaser.appendToCurrentTeasersets(teaserset);
        scope.teaserset = teaserset;


        function deleteAll() {
            MyProgrammeService.deleteAll().then(function () {
                scope.$emit('forcereload');
            }, function () {
                scope.$emit('forcereload');
            });
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMyProgramme')
    .controller('NowMyProgrammeController', NowMyProgrammeController);

NowMyProgrammeController.$inject = ['$scope', '$rootScope', 'BreadcrumbHelper', 'NowTeaser', 'MyProgrammeService', '$log', 'myformats', '$location', 'page', 'RecommendationService', 'NowGoogleAnalytics', 'PageHistory', 'Accounting','NowTagCommander'];

function NowMyProgrammeController($scope, $rootScope, BreadcrumbHelper, NowTeaser, MyProgrammeService, $log, myformats, $location, page, RecommendationService, NowGoogleAnalytics, PageHistory, Accounting,NowTagCommander) {
    var vm = $scope;

    NowTeaser.setCurrentTeasersets([]);
    vm.trackEventFavoriten = trackEventFavoriten;
    vm.showLogin = showLogin;
    vm.showRegistration = showRegistration;

    vm.myformats = myformats;
    vm.loggedin = Accounting.isLoggedIn();
    vm.isPremiumUser = Accounting.isPremiumUser();
    vm.userInfoText = "myprogramm.login.required";
    if (vm.loggedin && !vm.isPremiumUser) {
        vm.userInfoText = "myprogramm.premium.required";
    }
    NowTagCommander.addToDatalayer("env_template", 'myprogramme');

    vm.newpage = page === false;
    vm.page = (page === false) ? {} : page;
    vm.hasRecommendation = RecommendationService.isReceivingEnabled();
    vm.$rootScope = $rootScope;
    vm.teasers = [];
    if (page.teaserSets && page.teaserSets.items.length > 0) {
        vm.teasersets = page.teaserSets.items;
    } else {
        vm.teasersets = [];
    }

    vm.teaserset = {
        headline: 'Empfehlungen',
        layout: 6,
        row: 1,
        analyticsTeasersetNo: 1,
        automaticType: 'none',
        movies: {
            items: []
        },
        formats: {
            items: []
        },
        teaserSetInformations: {
            items: []
        }
    };

    PageHistory.setPage('myprogramme', {});

    BreadcrumbHelper.setItems({
        'title': 'Meine Merkliste',
        'url': 'meine-merkliste'
    });

    initWatchers();

    getRecommendations();

    vm.$watch(function () {
        return MyProgrammeService.getFormatids();
    }, function (oldval, newval) {
        if (newval !== oldval) {
            if (newval.length > oldval.length) {
                vm.loadingnewformats = true;
            }
            MyProgrammeService.getUserFormats().then(
                function (formats) {
                    vm.loadingnewformats = false;
                    vm.myformats = formats[0];
                }
            );
        }
    });


    function getFavouriteIds() {
        var ids = [];
        if (vm.myformats && vm.myformats.items && vm.myformats.items.length > 0) {
            angular.forEach(vm.myformats.items, function (format) {
                if (format.movies && format.movies.items && format.movies.items.length > 0) {
                    angular.forEach(format.movies.items, function (movie) {
                        ids.push(RecommendationService.getSuffixedMovieId(movie.id));
                    });
                }
            });
        }

        return ids;
    }

    function getPlaylistIds() {
        var ids = [];
        angular.forEach(vm.movies, function (movie) {
            ids.push(RecommendationService.getSuffixedMovieId(movie.id));
        });
        return ids;
    }

    function getRecommendations() {
        var itemInPlaylist = getPlaylistIds();
        var itemInFavourites = getFavouriteIds();
        RecommendationService.getRecommendationsForMyProgramme(
            itemInPlaylist,
            itemInFavourites,
            function (data) {
                vm.teaserset.teaserSetInformations = {
                    items: data.items
                };
                vm.teasers = data.items;

                NowTeaser.appendToCurrentTeasersets(vm.teaserset);
            }
        );
    }

    function initWatchers() {
        var accountLogin = $rootScope.$on('account::login', function () {
            MyProgrammeService.getUserFormats().then(function (formats) {
                vm.myformats = formats[0];
            });
            vm.loggedin = true;
        });

        var accountLogout = $rootScope.$on('account::logout', function () {
            vm.loggedin = false;
        });

        $rootScope.$on('$destroy',accountLogin);
        $rootScope.$on('$destroy',accountLogout);
    }

    function showLogin() {
        $location.search('login');
    }

    function showRegistration() {
        $location.search('registration');
    }

    function trackEventFavoriten(action) {
        NowGoogleAnalytics.trackEvent('meine_merkliste', action, 'favoriten');
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowMyProgramme')
    .config(routing);

routing.$inject = ['$routeProvider', 'AppConfigProvider'];
function routing($routeProvider, AppConfigProvider) {

    var route = {
        controller: 'NowMyProgrammeController',
        templateUrl: templateUrl,
        reloadOnSearch: false,
        data: {
            pagetype: 'static'
        },
        resolve: {
            myformats: resolveMyformats,
            page: resolvePage
        }
    };

    $routeProvider
        .when('/:station/meine-merkliste', route)
        .when('/meine-merkliste', route);

    function templateUrl() {
        var template = 'templates/myprogramme_view.html';

        if (AppConfigProvider.getConfig().mode === 'edit') {
            template = 'templates/myprogramme_view_edit.html';
        }

        return template;
    }

    resolveMyformats.$inject = ['$sessionStorage', 'MyProgrammeService'];
    function resolveMyformats($sessionStorage, MyProgrammeService) {
        if ($sessionStorage.user && $sessionStorage.user.id) {
            return MyProgrammeService.getUserFormats().then(
                function (formats) {
                    return formats[0];
                }
            );
        }
        else {
            return false;
        }
    }

    resolvePage.$inject = ['$route', 'NowApi', 'StationMonitor', 'Metadata', '$location'];
    function resolvePage($route, NowApi, StationMonitor, Metadata, $location) {
        var station = (!$route.current.params.station) ? 'nowtv' : $route.current.params.station;

        if ($route.current.params.station && StationMonitor.getStationsOrdered().indexOf(station) !== -1) {
            $location.path('/meine-merkliste', false);
            return false;
        }

        if (['nowtv'].concat(StationMonitor.getStationsOrdered()).indexOf(station) === -1) {
            Metadata.tryGlobalRedirect($location.path()).then(function () {
                return true;
            }, function(){
                Metadata.setSeoStatuscode(404);
                $location.path(AppConfigProvider.getConfig().notFoundPage);
            });
        }

        return NowApi.getPage().retrievePagesByStationAndPath({
            station: station,
            pagepath: 'mein-programm',
            fields: ['*',
                'teaserSets.*',
                'teaserSets.teaserSetInformations.*',
                'teaserSets.teaserSetInformations.custom.*',
                'teaserSets.teaserSetInformations.custom.page.*,',
                'teaserSets.teaserSetInformations.custom.format.*,',
                'teaserSets.teaserSetInformations.custom.movie.*,',
                'teaserSets.teaserSetInformations.movie.*',
                'teaserSets.teaserSetInformations.movie.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.format.*',
                'teaserSets.teaserSetInformations.format.*',
                'teaserSets.teaserSetInformations.format.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.pictures',
                'teaserSets.teaserSetInformations.movie.packages'
            ].join(',')
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }
}

})();

(function() {




})();

(function() {



})();

(function() {

angular.module('NowChannel', []);


})();

(function() {

'use strict';

angular
    .module('NowChannel')
    .service('channelService', NowChannel);

NowChannel.$inject = ['$q', 'NowApi', 'StationMonitor'];

function NowChannel($q, NowApi, StationMonitor) {
    this.getChannel = getChannel;
    this.getChannels = getChannels;

    var allowedStations = StationMonitor.getStationsWithAlias();

    return this;

    function getChannel(id) {
        return NowApi.getChannels().retrieveChannelById({
            id: id,
            fields: '["*","movies",["id","title","episode","broadcastStartDate","blockadeText","free","replaceMovieInformation","seoUrl","pictures",["*"],"packages",["*"],"format",["id", "station", "title","seoUrl","defaultDvdImage"]]]'
        });
    }

    function getChannels(filter) {
        return NowApi.getChannels().retrieveChannelsByStation({
            'fields': '*',
            'station': 'rtl',
            'filter': filter,
            'page': 1,
            'maxPerPage': 50
        }).then(function (channels) {
            var promises = [];
            angular.forEach(channels.items, function (channel, key) {
                promises.push(NowApi.getChannels().retrieveMoviesByChannelId({
                        id: channel.id,
                        fields: '["id","title","episode","broadcastStartDate","blockadeText","free","replaceMovieInformation","seoUrl","pictures",["*"],"packages",["*"],"format",["id", "station", "title","seoUrl","defaultDvdImage"]]',
                        page: 1,
                        maxPerPage: 25
                    }).then(function (data) {
                        //console.log(data);
                        channels.items[key].movies = data;
                        channels.items[key].teasers = data.items.filter(function (movie) {
                            return (movie.format && allowedStations.indexOf(movie.format.station) > -1);
                        }).map(function (movie) {
                            return {type: 'movie', movie: movie, station: movie.format.station, movieId: movie.id}
                        });
                    }, function () {
                    })
                );
            });

            return $q.all(promises).then(function () {
                return channels;
            }, function () {
                return false;
            });

        }, function () {
            return true;
        });
    }
}


})();

(function() {

'use strict';

angular
    .module('NowChannel')
    .directive('channelteaser', NowChannelTeaser);

NowChannelTeaser.$inject = ['$location', 'Moviehelper', '$log', '$timeout', '$window', 'VideobarService'];

function NowChannelTeaser($location, Moviehelper, $log, $timeout, $window, VideobarService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            channel: '=',
            station: '='
        },
        templateUrl: 'templates/channel_teaser.html',
        link: link
    };

    function link(scope, element) {
        var cssClass = '.now-channel-' + scope.channel.id;

        scope.loadingteasers = true;

        scope.changeTeaser = changeTeaser;
        scope.slick = slick;
        scope.trackChannelPlay = trackChannelPlay;
        scope.trackChannelTeaserClick = trackChannelTeaserClick;
        scope.trackChannelDetailClick = trackChannelDetailClick;
        scope.unslick = unslick;
        scope.getChannelName = getChannelName;
        scope.broadCastChannelClick = broadCastChannelClick;

        scope.channel.teasers.map(function (current, index) {
            scope.channel.teasers[index]['customClickCB'] = broadCastChannelClick;
        });

        initWatchers();
        init();

        function slick() {
            var teasercount = 3;
            if (($window.innerWidth < 1560 && $window.innerWidth >= 1260)) {
                teasercount = 2;
            } else if ($window.innerWidth < 1260) {
                teasercount = 1;
            }

            $(cssClass + ' .channelSlide').on('init', function () {
                $(cssClass + ' .channelSlide').css('visibility', 'visible');
                $(cssClass + ' .channelSlideLoader').hide();
            }).on('afterChange', function (slick, currentSlide) {
                $log.debug('Format ' + currentSlide.currentSlide + ' aktivieren');
                $(cssClass + ' .now-channel-format').removeClass('active');
                $(cssClass + ' .now-channel-format').eq(currentSlide.currentSlide).addClass('active');
            }).slick({
                arrows: true,
                touchMovie: false,
                infinite: true,
                draggable: false,
                slidesToShow: teasercount,
                slidesToScroll: 1,
                nextArrow: $(cssClass + ' .now-teaser-arrow-right'),
                prevArrow: $(cssClass + ' .now-teaser-arrow-left')
            });
        }

        function initWatchers() {
            scope.$on('ngRepeatFinished', function () {
                scope.slick();
            });

            scope.$on('resize::jump', function (object, size) {
                var sizes = {
                    l: 3,
                    m: 2,
                    s: 1
                };
                $(cssClass + ' .channelSlide').slick('slickSetOption', 'slidesToShow', sizes[size], true);
            });
        }

        function init() {
            $(element).find('.imagehover').on('click', function () {
                var search = Moviehelper.getMoviePlayerSearch(scope.entry.movie);
                search['channel'] = scope.channel.id;
                $location.search(search).path(Moviehelper.getMoviePlayerPath(scope.entry.movie));
                scope.$apply();
            });

            $timeout(function () {
                //scope.slick();
            }, 1000);
        }

        function trackChannelPlay(channel) {
            channel = channel.toLowerCase().replace(' & ', '_').replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss');
            scope.$parent.trackEvent('play', channel);
        }

        function trackChannelTeaserClick() {
            scope.$parent.trackChannelTeaserClick();
        }

        function broadCastChannelClick() {
            VideobarService.setCurrentChannel(scope.channel);
            VideobarService.setCurrentVideobarContentType('channel');

        }

        function trackChannelDetailClick() {
            scope.$parent.trackChannelDetailClick();
        }

        function getChannelName() {
            return scope.channel.ivw;
        }

        function changeTeaser(index) {
            $log.debug('changeTeaser()');
            var cssClass = '.now-channel-' + scope.channel.id;
            $(cssClass + ' .channelSlide').slick('slickGoTo', index, true);
        }

        function unslick() {
            $(cssClass + ' .channelSlide').slick('unslick');
        }
    }
}


})();

(function() {

'use strict';

angular
    .module('NowChannel')
    .controller('NowChannelController', NowChannelController);

NowChannelController.$inject = ['$scope', 'channels', 'BreadcrumbHelper', 'NowGoogleAnalytics', '$route', 'PageHistory', '$filter','NowTagCommander'];

function NowChannelController($scope, channels, BreadcrumbHelper, NowGoogleAnalytics, $route, PageHistory, $filter,NowTagCommander) {
    var vm = $scope;
    vm.channels = channels;
    channels.items.map(function (current, index) {
        var title = $filter('slugify')($filter('latinize')(current.title.replace(/ß/g, 'ss').replace(/&/g, 'und')));
        vm.channels.items[index]['detailUri'] = '/channels/' + title + '/' + current.id;
    });
    vm.loading = false;
    vm.station = $route.current.params.station;
    vm.scrollbars = [];

    vm.trackEvent = trackEvent;
    vm.trackChannelTeaserClick = trackChannelTeaserClick;
    vm.trackChannelDetailClick = trackChannelDetailClick;

    BreadcrumbHelper.setItems({
        'title': 'Channels',
        'url': 'channels'
    });

    PageHistory.setPage('channels');
    NowTagCommander.addToDatalayer("env_template", 'channels');

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('kanaele', action, label);
    }

    function trackChannelTeaserClick() {
        NowGoogleAnalytics.trackEvent('kanaele', 'klick', 'channelteaser');
    }

    function trackChannelDetailClick() {
        NowGoogleAnalytics.trackEvent('kanaele', 'klick', 'details');
    }
}

})();

(function() {

'use strict';

angular
    .module('NowChannel')
    .controller('NowChannelDetailController', NowChannelDetailController);

NowChannelDetailController.$inject = ['$scope', 'channel', 'BreadcrumbHelper', 'NowGoogleAnalytics', 'page', 'PageHistory', 'VideobarService'];

function NowChannelDetailController($scope, channel, BreadcrumbHelper, NowGoogleAnalytics, page, PageHistory, VideobarService) {
    var vm = $scope;

    vm.trackEvent = trackEvent;
    vm.getChannelName = getChannelName;

    vm.channel = channel;
    vm.loading = false;
    vm.scrollbars = [];
    vm.newpage = page === false;
    vm.page = (page === false) ? {} : page;
    vm.teasers = channel.movies.items.filter(cbFilterFunction).map(cbMapFunction);

    if (page.teaserSets && page.teaserSets.items.length > 0) {
        vm.teasersets = page.teaserSets.items;
    } else {
        vm.teasersets = [];
    }

    PageHistory.setPage('channels', {'channelid': channel.id, 'channeltag': channel.ivw});

    BreadcrumbHelper.setItems([{
            'title': 'Channels',
            'url': 'channels'
        }, {
            'title': channel.title,
            'url': channel.id
        }]
    );

    function cbFilterFunction(movie) {
        return (movie.id && movie.format && movie.format.station) || false;
    }

    function cbMapFunction(movie) {
        return {
            type: 'movie', movie: movie, station: movie.format.station, movieId: movie.id, customClickCB: function () {
                VideobarService.setCurrentChannel(channel);
                VideobarService.setCurrentVideobarContentType('channel');

            }
        }
    }

    function trackEvent(action, label) {
        NowGoogleAnalytics.trackEvent('kanaele', action, label);
    }

    function getChannelName() {
        return vm.channel.ivw;
    }
}


})();

(function() {

'use strict';

angular
    .module('NowChannel')
    .config(routing);
routing.$inject = ['$routeProvider', 'AppConfigProvider'];

function routing($routeProvider, AppConfigProvider) {

    var cahnnelListRoute = {
        controller: 'NowChannelController',
        templateUrl: 'templates/channel_view.html',
        reloadOnSearch: false,
        data: {
            pagetype: 'static'
        },
        resolve: {
            channels: resolveChannel,
            page: resolvePage
        }
    }, channelDetailRoute = {
        controller: 'NowChannelDetailController',
        templateUrl: templateUrlDetail,
        reloadOnSearch: false,
        data: {
            pagetype: 'static'
        },
        resolve: {
            channel: resolveChannelDetail,
            page: resolvePageDetail
        }
    };

    $routeProvider
        .when('/channels', cahnnelListRoute)
        .when('/channels/:channelid', channelDetailRoute)
        .when('/channels/:headline/:channelid', channelDetailRoute);

    resolveChannel.$inject = ['channelService'];
    function resolveChannel(channelService) {
        return channelService.getChannels({'Active': true});
    }

    resolvePage.$inject = ['NowApi'];
    function resolvePage(NowApi) {
        return NowApi.getPage().retrievePagesByStationAndPath({
            station: 'nowtv',
            pagepath: 'kanaele',
            fields: '*'
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }

    function templateUrlDetail() {
        var template = 'templates/channel_detailview.html';
        if (AppConfigProvider.getConfig().mode === 'edit') {
            template = 'templates/channel_detailview_edit.html';
        }
        return template;
    }

    resolveChannelDetail.$inject = ['$route', 'channelService', '$location'];
    function resolveChannelDetail($route, channelService, $location) {
        return channelService.getChannel($route.current.params.channelid).then(function (channel) {
            return channel;
        }, function () {
            $location.path('/channels');
        });
    }

    resolvePageDetail.$inject = ['$route', 'NowApi'];
    function resolvePageDetail($route, NowApi) {
        var path = 'channel' + $route.current.params.channelid;
        return NowApi.getPage().retrievePagesByStationAndPath({
            station: 'nowtv',
            pagepath: path,
            fields: ['*',
                'teaserSets.*',
                'teaserSets.teaserSetInformations.*',
                'teaserSets.teaserSetInformations.custom.*',
                'teaserSets.teaserSetInformations.custom.page.*,',
                'teaserSets.teaserSetInformations.custom.format.*,',
                'teaserSets.teaserSetInformations.custom.movie.*,',
                'teaserSets.teaserSetInformations.movie.*',
                'teaserSets.teaserSetInformations.movie.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.format.*',
                'teaserSets.teaserSetInformations.format.*',
                'teaserSets.teaserSetInformations.format.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.pictures',
                'teaserSets.teaserSetInformations.movie.packages'
            ].join(',')
        }).then(function (data) {
            return data;
        }, function () {
            return false;
        });
    }
}

})();

(function() {



})();

(function() {

angular.module('NowLiveTv', []);

})();

(function() {

'use strict';

angular
    .module('NowLiveTv')
    .directive('nowLiveEpg', nowLiveEpg);

nowLiveEpg.$inject = [
    'AppConfig',
    'STAGE',
    '$route',
    'LiveTvEpgService',
    'PlayerService',
    'NowGoogleAnalytics',
    '$location',
    '$log',
    'StationMonitor'
];


function nowLiveEpg(AppConfig, STAGE, $route, LiveTvEpgService, PlayerService, NowGoogleAnalytics, $location,$log,StationMonitor) {


    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/live_epg.html',
        link: link
    };


    function link(scope) {
        var vm = scope;
        vm.loading = false;
        vm.entries = {};
        vm.activestation = $route.current.params.station;
        vm.stations = angular.copy(AppConfig.settings.nowtv[STAGE.stage].stations.epg);
        vm.selectStation = selectStation;


        LiveTvEpgService.refreshLiveEpg().then(function (data) {
            $log.debug('refreshLiveEpg',data);
            vm.entries = data;
        });


        function selectStation(station) {
            if(station!==StationMonitor.getStation()) {
                PlayerService.hidePlayer();
                NowGoogleAnalytics.trackEvent('live_tv', station, 'sender');
                $location.path('/' + station + '/live-tv').search({autostart: true});
            }
        }


    }
}

})();

(function() {

'use strict';

angular
    .module('NowLiveTv')
    .directive('nowliveplayer', nowliveplayer);

nowliveplayer.$inject = ['$window', 'PlayerService', 'PlayerConfigService', 'AppConfig', '$log', 'Accounting', '$route', '$rootScope', '$location', 'NowGoogleAnalytics', 'STAGE', 'PageHistory', '$sessionStorage', '$timeout', '$document','PlayerHelperService'];

function nowliveplayer($window, PlayerService, PlayerConfigService, AppConfig, $log, Accounting, $route, $rootScope, $location, NowGoogleAnalytics, STAGE, PageHistory, $sessionStorage, $timeout, $document,PlayerHelperService) {
    var rand = Math.floor((Math.random() * 999) + 1),
        videoBarTimeout;

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/live_player.html',
        scope: {
            urlPreviewPic: '=previewpic',
            smallText: '=smalltext',
            largeText: '=largetext',
            showPreviewPic: '=showpreview'
        },
        link: link
    };


    function getPlayersize() {
        return {'width': 640, 'height': 360};
    }

    function getLayoutsize() {
        return 's';
    }



    function embedHTML5Player() {
        $log.debug('embedHTML5Player', $document[0].getElementById('liveplayer_container'), $('#liveplayer_wrapper'));


        var lastPage = PageHistory.getLastPage();
        var autoplay = ((lastPage && lastPage.pagetype === 'live-tv') || $location.search()['autostart']) ? true : false;

        var conf = {
            location: {
                ui: ($window.env.prependVersionBeforeAssets ? AppConfig.clientversion + '/' : '') + AppConfig.settings.nowtv[STAGE.stage].player.html5.controls.js,
                ui_css: ($window.env.prependVersionBeforeAssets ? AppConfig.clientversion + '/' : '') + AppConfig.settings.nowtv[STAGE.stage].player.html5.controls.css
            },
            playback: {
                autoplay: autoplay,
                muted: false
            },
            logging: false, // (STAGE.isProduction) ? false : true,
            advertising: {
                playAds: true
            },
            errorReporting: {
                exception: PlayerService.logExternalError,
                clientId: Accounting.isLoggedIn() ? $sessionStorage.user.id : 0,
                device: Accounting.getDeviceId()
            }
        };

        var vp = new CBCVideoplayer('liveplayer_container', conf);

        if (vp.isSupportedPlatform()) {
            initHTML5Player(vp);
        } else {
            PlayerService.displayUnsupportedPlatform(function() {
                initHTML5Player(vp);
            });
        }
    }

    function initHTML5Player(vp) {
        PlayerService.setDOMElement($('#liveplayer_container'));
        PlayerService.setPlayer(vp);

        PlayerService.handleEvents('NOWTV_INITIALIZED');
    }

    function deleteHTML5Player() {
        $log.debug('deleteHTML5Player', PlayerService.currentVideoplayer);
        if (angular.isObject(PlayerService.currentVideoplayer) && angular.isFunction(PlayerService.currentVideoplayer.destroy)) {
            PlayerService.currentVideoplayer.destroy();
        }
        PlayerService.currentVideoplayer = false;
        PlayerHelperService.setPlaylistVideostart(false);
        // $('#liveplayer_container, #liveplayer_wrapper').empty();
    }

    function link(scope) {
        var init = false;

        PlayerHelperService.setSize(getLayoutsize());
        scope.show = PlayerService.show;
        scope.forced = false;
        scope.station = $route.current.params.station;
        scope.startPlayer = startPlayer;


        scope.exitPlayer = function () {
            PlayerService.exitFullscreen();
        };

        scope.showBar = function () {
            killVideoBarTimeout();
            if (scope.fullscreen === true) {
                scope.$broadcast('videobar::show');
                videoBarTimeout = $timeout(function () {
                    scope.$broadcast('videobar::fadeout');
                }, 4000);
            }
        };

        function killVideoBarTimeout() {
            if (videoBarTimeout) {
                $timeout.cancel(videoBarTimeout);
            }
        }

        scope.$watch(function () {
                return PlayerHelperService.fullscreen;
            },
            function (fullscreen) {
                scope.fullscreen = fullscreen;
            }
        );

        scope.$watch(function () {
                return PlayerService.showLive;
            },
            function (show) {
                if (show && !init) {

                    init = true;
                    rand = Math.floor((Math.random() * 999) + 1);
                    $log.debug('new rand', rand);

                    embedHTML5Player();

                    $location.search('autostart', null);
                }
                else if (init) {
                    init = false;
                    deleteHTML5Player();
                }
                scope.show = show;
                PlayerHelperService.setSize(getLayoutsize());
                $('#liveplayer').css(getPlayersize());
            }
        );

        function startPlayer() {

            if (Accounting.isPremiumUser()) {
                scope.showPreviewPic = false;
                PlayerService.queryStreamcheck();
                PlayerService.getPlayer().player.play();
                $rootScope.$broadcast('livePlayerDirective::manualStart');
            } else {
                Accounting.showPremiumOverlay();
            }
        }
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowLiveTv')
    .service('LiveTvEpgService', LiveTvEpgService);

LiveTvEpgService.$inject = [
    'NowApi',
    '$log',
    '$q',
    'StationMonitor',
    '$route',
    'moment'
];

/**
 *@constructor
 */
function LiveTvEpgService(NowApi, $log, $q, StationMonitor, $route, moment) {
    var self = this,
        entries = [],
        loading=false;


    self.refreshLiveEpg = refreshLiveEpg;
    self.getCurrentInfos = getCurrentInfos;
    self.currentInfos = {
        largeText: '',
        smallText: '',
        urlPreviewPic: ''
    };

    return self;


    function getCurrentInfos() {
        return self.currentInfos
    }


    function refreshLiveEpg() {
        var deferred = $q.defer();
        loading = true;
        var stationAlias;
        $log.debug('NowLiveTvController liveTv::refresh',loading);
        NowApi.getEpgs().retrieveNowAndNextMovies({
            'fields': '*,nowNextEpgTeasers'
        }).then(function (data) {
            angular.forEach(data.items, function (station) {
                if (station.nowNextEpgTeasers && station.nowNextEpgTeasers.now) {
                    stationAlias = StationMonitor.getAlias(station.name);
                    entries[stationAlias] = {};
                    angular.forEach(station.nowNextEpgTeasers, function (item, ikey) {
                        if (item && item.broadcastStartDate) {
                            item.time = moment(item.broadcastStartDate).format('HH:mm');
                            entries[stationAlias][ikey] = item;
                            if (ikey === 'next') {
                                var startDate = moment(entries[stationAlias].now.broadcastStartDate),
                                    endDate = moment(entries[stationAlias].next.broadcastStartDate),
                                    percentage_complete = (moment() - startDate) / (endDate - startDate) * 100;
                                entries[stationAlias].now.percentage = (Math.round(percentage_complete * 100) / 100);
                            }
                            if (stationAlias === $route.current.params.station && ikey === 'now') {
                                if (item.image) {
                                    self.currentInfos.urlPreviewPic = item.image.replace('http:', 'https:');
                                }
                                self.currentInfos.largeText = item.title;
                                self.currentInfos.smallText = item.subTitle;

                            }
                        }
                    });
                }
            });
            deferred.resolve(entries);
            loading = false;
        }, function () {
            loading = false;
            deferred.resolve(entries);
        });
        return deferred.promise;
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowLiveTv')
    .controller('NowLiveTvController', NowLiveTvController);

NowLiveTvController.$inject = [
    '$interval',
    '$scope',
    '$location',
    '$route',
    'PlayerService',
    'BreadcrumbHelper',
    'advertisements',
    '$log',
    '$filter',
    'Accounting',
    'page',
    'LiveStreamService',
    'LiveTvEpgService',
    'Metadata',
    'TrackingHelper',
    'PageHistory',
    'PlayerHelperService',
    'NowTagCommander'
];

function NowLiveTvController($interval, $scope, $location, $route, PlayerService, BreadcrumbHelper, advertisements, $log, $filter, Accounting, page, LiveStreamService, LiveTvEpgService, Metadata, TrackingHelper, PageHistory, PlayerHelperService, NowTagCommander) {
    var vm = $scope;

    vm.loading = false;
    vm.entries = {};
    vm.activestation = $route.current.params.station;
    vm.largeText = '';
    vm.smallText = '';
    vm.urlPreviewPic = '//aistvnow-a.akamaihd.net/' + $filter('stationalias')($route.current.params.station) + 'now/0/640x360/default.jpg';
    vm.showPreviewPic = true;

    vm.newpage = page === false;
    vm.page = (page === false) ? {} : page;
    vm.teasersets = (page.teaserSets && page.teaserSets.items.length > 0) ? page.teaserSets.items : [];

    PlayerService.initEvents();
    PlayerService.bindPlayerEventHandler();
    PlayerService.bindGlobalPlayerFunctions();
    PlayerService.showLivePlayer();
    PlayerHelperService.setAdvertisements(advertisements);


    initEvents();
    init();

    function init() {
        BreadcrumbHelper.setItems({
            'title': 'Live TV', 'url': 'live-tv'
        });
        PageHistory.setPage('live-tv');

        if (page.metaTitle && page.metaTitle.length > 0) {
            Metadata.setTitleAndMeta(
                page.metaTitle,
                page.metaDescription
            );
        }

        vm.refreshInterval = $interval(function () {
            if ($location.path().indexOf('live-tv')) {
                vm.$broadcast('liveTv::refresh');
            }
            else {
                $interval.cancel(vm.refreshInterval);
            }
        }, (60000 / 2));

        if ($location.search()['autostart'] && Accounting.isPremiumUser()) {
            vm.showPreviewPic = false;
            TrackingHelper.setLivestreamAutostart(true);
        } else {
            TrackingHelper.setLivestreamAutostart(false);
        }

        vm.$watch(function () {
            return LiveTvEpgService.getCurrentInfos();
        }, function (infos) {
            vm.largeText = infos.largeText;
            vm.smallText = infos.smallText;
            vm.urlPreviewPic = infos.urlPreviewPic;
        }, true);
        NowTagCommander.addToDatalayer("env_template", 'livetv');

    }

    function initEvents() {
        vm.$on('player::NOWTV_INITIALIZED', function () {
            $log.debug('NOWTV_INITIALIZED - LIVEPLAYER', {'vm.activestation': vm.activestation});
            switchStationPlayer(vm.activestation);
        });

        vm.$on('$destroy', function () {
            PlayerService.unregisterEvents();
            if (PlayerService.getPlayer().player) {
                PlayerService.getPlayer().player.destroy();
            }
        });

        vm.$on('player::NOWTV_PLAYER_EXIT', function () {
            PlayerService.hidePlayer();
        });

    }


    function switchStationPlayer(station) {
        $log.debug('LiveTv/controller switchStationPlayer', station);
        LiveStreamService
            .getLiveStreamMovie(station)
            .then(function (movie) {
                $log.debug('switchStationPlayer', movie, PageHistory.getLastPage());
                PlayerHelperService.setAutostartCountdown(0);
                PlayerService.loadMovieToPlayer('', '', movie, function () {
                    PlayerService.play(false, false);
                });
            });
    }
}

})();

(function() {



})();

(function() {

'use strict';

angular
    .module('NowLiveTv')
    .config(routing);

routing.$inject = ['$routeProvider'];

function routing($routeProvider) {
    $routeProvider
        .when('/live-tv', {
            redirectTo: '/rtl/live-tv'
        })
        .when('/:station/live-tv', {
            templateUrl: 'templates/live_view.html',
            controller: 'NowLiveTvController',
            controllerAs: 'vm',
            reloadOnSearch: false,
            data: {
                pagetype: 'player',
                headerCls: 'live',
                embedded: true
            },
            resolve: {
                page: resolvePage,
                advertisements: resolveAdvertisements
            }
        })
        .when('/:station/live-tv/player', {
            templateUrl: 'templates/player_view.html',
            controller: 'NowPlayerController',
            controllerAs: 'vm',
            reloadOnSearch: false,
            data: {
                pagetype: 'player',
                headerCls: 'live',
                livestream: true
            }, resolve: {
                advertisements: resolveAdvertisements,
                movie: movie
            }
        });


    movie.$inject = ['$route', 'LiveStreamService'];
    function movie($route, LiveStreamService) {
        return LiveStreamService.getLiveStreamMovie($route.current.params.station);
    }

    resolvePage.$inject = ['$route', 'NowApi', '$location', 'StationMonitor', '$filter', 'PlayerService', 'LiveStreamService'];
    function resolvePage($route, NowApi, $location, StationMonitor, $filter, PlayerService, LiveStreamService) {
        var station = $route.current.params.station;
        if (StationMonitor.getStationsOrdered().indexOf(station) === -1) {
            $location.path('/rtl/live-tv');
            $location.replace();
            return true;
        }
        // GET PAGE
        var path = 'live-tv';
        return NowApi.getPage().retrievePagesByStationAndPath({
            station: $filter('stationalias')(station),
            pagepath: path,
            fields: ['*',
                'teaserSets.*',
                'teaserSets.teaserSetInformations.*',
                'teaserSets.teaserSetInformations.custom.*',
                'teaserSets.teaserSetInformations.custom.page.*,',
                'teaserSets.teaserSetInformations.custom.format.*,',
                'teaserSets.teaserSetInformations.custom.movie.*,',
                'teaserSets.teaserSetInformations.movie.*',
                'teaserSets.teaserSetInformations.movie.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.format.*',
                'teaserSets.teaserSetInformations.format.*',
                'teaserSets.teaserSetInformations.format.paymentPaytypes.*',
                'teaserSets.teaserSetInformations.movie.pictures',
                'teaserSets.teaserSetInformations.movie.packages'
            ].join(',')
        }).then(function (data) {
            return LiveStreamService.getLiveStreamMovie($route.current.params.station).then(function (movie) {
                return PlayerService.activateHTML5Mode(movie).then(function () {
                    return data
                });
            });


        }, function () {
            return false;
        });
    }

    resolveAdvertisements.$inject = ['NowApi', '$log'];
    function resolveAdvertisements(NowApi, $log) {
        return NowApi.getPlayoutelements().retrieveAdvertisements({
            filter: '{"Active":true}',
            page: 1,
            maxPerPage: 200
        }).then(function (advertisements) {
            return advertisements;
        }, function () {
            $log.error('Error advertisements not found');
        });
    }
}

})();

(function() {




})();

(function() {



})();

(function() {

//angular.module('NowIntro', ['angular-intro']);
angular.module('NowIntro', []);


})();

(function() {

'use strict';

angular
    .module('NowIntro')
    .directive('introbutton', introbutton);

introbutton.$inject = ['Accounting', '$window', '$localStorage', 'NowGoogleAnalytics', '$timeout','introJs', '$log'];

function introbutton(Accounting, $window, $localStorage, NowGoogleAnalytics, $timeout, introJs, $log) {
    var intro;
    return {
        restrict: 'E',
        link: link,
        replace: true,
        templateUrl: 'templates/intro_button.html'
    };

    function link(scope) {
        intro = introJs();
        scope.hide = true;

        scope.help = openHelp;
        scope.later = later;
        scope.never = never;
        scope.start = start;

        if ($localStorage.dontShowTour) {
            scope.hide = true;
        }

        intro.setOptions(introGetOptions());

        intro.oncomplete(function (step) {
            $log.debug('Intro::oncomplete',step);
            logGA('complete');
        });

        intro.onexit(function (step) {
            $log.debug('Intro::onexit',step);
            logGA('exit');
        });

        intro.onbeforechange(function (targetElement) {
            if (targetElement.href) {
                $timeout(function () {
                    intro.refresh();
                }, 100);
            }
        });

        function openHelp() {
            $window.open('https://hilfe.tvnow.de', '_blank');
        }

        function later() {
            logGA('later');
            scope.hide = true;
        }

        function never() {
            logGA('never');
            scope.hide = true;
            $localStorage.dontShowTour = true;
        }

        function start() {
            intro.start();
            scope.hide = true;
            logGA('start');
        }


        function introGetOptions() {
            var steps = [
                {
                    element: '.now-header-logo',
                    intro: '<b>Willkommen bei TV NOW!</b><br><br> Unter TV NOW haben wir das Angebot von RTL, VOX, RTL II, RTL NITRO, SUPER RTL, n-tv, RTLplus und TOGGO plus übersichtlich für dich zusammengefasst. ',
                    position: 'right'
                },
                {
                    element: '.now-home-toolbar',
                    intro: '<b>TV NOW bietet dir 8 Sender<br>auf einen Blick.</b><br><br>Hier kannst du dir das Angebot deines Lieblingssenders anzeigen lassen.',
                    position: 'bottom'
                },
                {
                    element: '.now-header-search',
                    intro: 'Mit unserer Suche erzielst du Ergebnisse aus der <b>gesamten<br> TV NOW-Familie</b> und kannst so bequem deine Lieblingssendung finden.',
                    position: 'left'
                }, {
                    element: '.now-login-button',
                    intro: '<b>Jetzt deinen NOW-Account auf TV NOW PLUS upgraden!</b><br><br> Übertrage deine bestehenden Sendungs- und App-Abos und nutze zusätzlich <b>30 Tage kostenlos</b> das gesamte PLUS-Angebot!',
                    position: 'left'
                }
            ];

            if (!Accounting.isLoggedIn()) {
                steps.push({
                    element: '.now-register-button',
                    intro: '<b>Jetzt registrieren und <br>30 Tage kostenlos alle Vorteile von TV NOW PLUS testen! </b><br><br>Umfangreiches Archiv, Sendungen vor TV-Ausstrahlung, weniger Werbung, 8 Sender im Livestream und das alles sowohl im Web, als auch mobil mit der TV NOW App.',
                    position: 'left'
                });
            }
            steps.push({
                    element: '.now-navigation-button-az',
                    intro: '<b>Hier findest du alle Sendungen der TV NOW-Familie.</b><br><br> Du kannst nach Sendern und Genres filtern oder dir ausschließlich das kostenlose Angebot anzeigen lassen. ',
                    position: 'bottom'
                }
                , {
                    element: '.now-navigation-button-missed',
                    intro: '<b>Du hast eine Sendung im TV verpasst?</b><br><br> Hier findest du alle verfügbaren Sendungen der letzten 7 Tage. ',
                    position: 'bottom'
                }, {
                    element: '.now-navigation-button-live',
                    intro: 'Als TV NOW PLUS Kunde hast du rund um die Uhr Zugriff auf die <br><b>8 Livestreams</b> von RTL, VOX, RTL II, RTL NITRO, SUPER RTL, n-tv, RTLplus und TOGGO plus im Web sowie in der App! Jetzt registrieren und<br><b>30 Tage kostenlos</b> testen.',
                    position: 'bottom'
                }
                , {
                    element: '.now-navigation-button-epg',
                    intro: '<b>Du möchtest wissen, was morgen läuft?</b><br><br> Hier findest du das Programm der nächsten <br>7 Tage.',
                    position: 'bottom'
                }
                , {
                    element: '.now-navigation-button-channel',
                    intro: '<b>Du interessierst dich für Lifestyle, Kochen oder Dokus?</b><br><br> Dann starte einen unserer Themenchannels, lehne dich zurück und genieße Programm ganz nach deinem Geschmack. ',
                    position: 'bottom'
                }
                , {
                    element: '.now-navigation-button-myprogramm',
                    intro: '<b>Verpasse nie wieder eine Folge deiner Lieblingssendung!</b><br><br>Hier verwaltest du deine Sendungsfavoriten.',
                    position: 'bottom'
                }
                , {
                    element: '.now-favorite-button-add',
                    intro: '<b>Du möchtest deine Merkliste befüllen?</b><br><br> Einloggen und über den Merklisten-Button unkompliziert deine Sendungsfavoriten erstellen!',
                    position: 'left'
                }
                , {
                    element: '.tour-help-contact',
                    intro: '<b>Du hast noch Fragen?</b><br><br> Nutze unseren umfangreichen Hilfebereich, gerne sind wir für dich da.',
                    position: 'top'
                });
            return {
                skipLabel: 'Beenden',
                nextLabel: 'Weiter',
                prevLabel: 'Zurück',
                doneLabel: 'Fertig',
                scrollToElement: true,
                keyboardNavigation: false,
                showProgress: true,
                showBullets: false,
                steps: steps
            };
        }
    }

    function logGA(event) {
        $log.debug('Intro::logGA',event);
        NowGoogleAnalytics.trackEvent('event', 'tour', 'event');
    }
}


})();

(function() {




angular.module('NowAppTestEnv', []);

angular.module('NowAppBase', [
    'ngRoute',
    'ngDropdowns',
    'ngTinyScrollbar',
    'pascalprecht.translate',
    'ngStorage',
    'ngCookies',
    'infinite-scroll',
    'angular.filter',
    'swfobject',
    'angularMoment',
    'NowShared',
    'angular-loading-bar',
    'uuid4',
    '720kb.tooltips',
    'NowAppTestEnv'
]);
angular.module('NowAppBase').provider('AppConfig', function () {
    if (!window.env) {
        window.env = {
            api: '//api.tvnow.de',
            assets: '//tvnowstatic-a.akamaihd.net/tvnow/',
            adcontrol: '//tvnowstatic-a.akamaihd.net/ip/js/adcontrol/tvnow/adcontrol.min.js',
            ffc: '//my.tvnow.de'
        };
    }
    var AppConfig = {
        mode: 'site',
        notFoundPage: '/seite-nicht-gefunden',
        api: window.env.api,
        apigw: window.env.apigw,
        ffc: window.env.ffc,
        assets: window.env.assets,
        stage: nowStage,
        stationsOrdered: ['rtl', 'vox', 'rtl2', 'rtlnitro', 'superrtl', 'ntv', 'rtlplus', 'toggoplus', 'nowus', 'tvnow'],
        clientversion: '1.4.0',
        settings: {
            nowtv: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true,
                ad: {
                    page: true,
                    player: true
                }
            },
            rtl: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            vox: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            rtl2: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            nitro: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            ntv: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            superrtl: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            rtlplus: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            toggoplus: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            nowus: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            },
            watchbox: {
                player: {
                    abtest: false,
                    abr: true
                },
                payment: true
            }
        }
    };

    this.$get = [function () {
        var q = jQuery.ajax({
            type: 'GET',
            url: AppConfig.api + '/v3/settings',
            cache: false,
            async: false,
            contentType: 'application/json',
            dataType: 'json'
        });
        if (q.status === 200) {
            angular.extend(AppConfig, angular.fromJson(q.responseText));
            if (AppConfig.settings.nowtv[nowStage].stations) {
                AppConfig.stationsOrdered = AppConfig.settings.nowtv[nowStage].stations.orderd;
            }

            var settings = AppConfig.settings.nowtv;
            if (window.Bugsnag && settings.debug && settings.debug.bugsnag && settings.debug.bugsnag.filter && settings.debug.bugsnag.filter.length > 0) {
                window.Bugsnag.filter = settings.debug.bugsnag.filter;
            }

        }
        if (bowser.tablet && !bowser.msie) {
            AppConfig.settings.nowtv.ad.page = false;
        }
        return AppConfig;
    }];
    this.getConfig = function () {
        return AppConfig;
    };
});

angular.module('NowApp', [
    'NowAppBase',
    'NowTemplates',
    'NowIntro',
    'NowEpg',
    'NowMissed',
    'NowChannel',
    'NowMyProgramme',
    'NowLiveTv',
    'NowSearch',
    'NowGenre',
    'NowAz',
    'NowHome',
    'NowMovielist',
    'NowMoviedetail',
    'NowTeaser',
    'NowStation',
    'NowHeader',
    'NowFooter',
    'NowApi',
    'NowAccount',
    'NowTracking',
    'NowAd',
    'NowPlayer'
])
    .constant('STAGE', {
        stage: nowStage,
        isProduction: nowIsProduction,
        isStaging: nowIsStaging,
        editMode: false,
        postMessageDomain: (window.location.hostname.match(/local\./i)) ? 'http://local.nowtv.de:9001' : window.location.protocol + '//' + window.location.hostname
    });

})();

(function() {

angular.module('NowApp').run(dropdown);
dropdown.$inject = ['$templateCache'];
function dropdown($templateCache) {
    $templateCache.put('ngDropdowns/templates/dropdownSelect.html', [
            '<div class="wrap-dd-select button now-dropdown">',
            '<span>{{dropdownModel["label"]}}</span><span class="icon icon_arrow_down"></span>',
            '<div class="dropdown" scrollbar="{trackSize:210,thumbSize:50}">',
            '<ul class="dropdowncontent">',
            '<li ng-repeat="item in dropdownSelect"',
            ' class="dropdown-item"',
            ' dropdown-select-item="item"',
            ' dropdown-item-label="labelField">',
            '</li>',
            '</ul>',
            '</div>'
        ].join('')
    );
    $templateCache.put('ngDropdowns/templates/dropdownSelectItem.html', [
        '<li ng-class="{divider: (dropdownSelectItem.divider && !dropdownSelectItem[dropdownItemLabel]), \'divider-label\': (dropdownSelectItem.divider && dropdownSelectItem[dropdownItemLabel])}">',
        '<a href="" class="dropdown-item"',
        ' ng-if="!dropdownSelectItem.divider"',
        ' ng-href="{{dropdownSelectItem.href}}"',
        ' ng-click="selectItem()">',
        '<span class="icon"><span ng-show="dropdownSelectItem[dropdownItemLabel] == $parent.$parent.dropdownModel.text"  class="icon icon_check"></span>&nbsp;</span>',
        '{{dropdownSelectItem[dropdownItemLabel]}}',
        '</a>',
        '<span ng-if="dropdownSelectItem.divider">',
        '{{dropdownSelectItem[dropdownItemLabel]}}',
        '</span>',
        '</li>'
    ].join(''));
}

})();

(function() {

'use strict';
angular.module('NowApp')
    .run(go);
go.$inject = ['$rootScope', '$location'];
function go($rootScope, $location) {
    $rootScope.go = function (url) {
        $location.path(url).replace();
        $rootScope.$apply();
    };
}

})();

(function() {

'use strict';
angular.module('NowApp').run(run);

run.$inject = ['$http', 'AppConfig', '$window', 'RecommendationService'];

function run($http, AppConfig, $window, RecommendationService) {
    $http.defaults.headers.common["X-CLIENT-VERSION"] = AppConfig.clientversion;
    $http.defaults.headers.common["transformscope"] = "web";

    if (angular.isObject($window.thcObj) && $window.thcObj.technic) {
        $http.defaults.headers.common['X-SMART-COOKIE-ID'] = $window.thcObj.technic;
    }
    if ($window.yasp && $window.yasp === true && RecommendationService.getCookieId()) {
        $http.defaults.headers.common['X-YUSP-ID'] = RecommendationService.getCookieId();
    }
    if ($window.document.referrer) {
        $http.defaults.headers.common['X-CLIENT-REFERRER'] = $window.document.referrer;
    }
}

})();

(function() {

'use strict';
angular
    .module('NowApp')
    .run(runner);

runner.$inject = ['$route', '$rootScope', '$location', 'GarbageCollector', 'STAGE', '$window', '$log'];

function runner($route, $rootScope, $location, GarbageCollector, STAGE, $window, $log) {
    $window.addEventListener("message", function (event) {
        if (event.origin.indexOf('nowtv.de') > -1 && event.data) {
            try {
                var data = angular.fromJson(event.data);
                if (data.redirect) {
                    $location.search({});
                    $location.path(data.redirect);
                    $rootScope.$apply();
                    return true;
                }
            } catch (e) {
                $log.log(e);
            }
        }
    }, false);

    var original = $location.path;

    //original $location.path replaced for angular 1.4 to avoid refreshing of whole view when subroute has changed
    $location.path = function (path, reload) {
        if (reload === false) {
            var lastRoute = $route.current;
            var un = $rootScope.$on('$locationChangeSuccess', function () {
                $route.current = lastRoute;
                un();
            });
        }
        return original.apply($location, [path]);
    };


    var locationChangeStart = $rootScope.$on('$locationChangeStart', function () {
        if (!STAGE.editMode) {
            GarbageCollector.cleanDom();
        }
    });

    $rootScope.$on('$destroy',locationChangeStart);
}

})();

(function() {

'use strict';
angular.module('NowApp')
    .run(momentConfig);
momentConfig.$inject = ['amMoment'];

function momentConfig(amMoment) {
    amMoment.changeLocale('de');
}

})();

(function() {

'use strict';
angular.module('NowApp')
    .run(nitro);
nitro.$inject = ['Metadata', '$location'];
function nitro(Metadata, $location) {
    if ($location.path().indexOf('/rtlnitro/') === 0) {
        var redirectUri = $location.path().replace('/rtlnitro/', '/nitro/')
        Metadata.setSeoRedirect('http://' + $location.host() + redirectUri);
        $location.path(redirectUri);
    }
}

})();

(function() {

'use strict';

angular.module('NowApp').run(RecommendationServiceConfig);

RecommendationServiceConfig.$inject = ['RecommendationService'];

function RecommendationServiceConfig(RecommendationService) {
    RecommendationService.run();
}

})();

(function() {

'use strict';
angular.module('NowApp')
    .run(tablet);
tablet.$inject = ['$rootScope', '$location', 'Accounting'];
function tablet($rootScope, $location, Accounting) {
    if (bowser.tablet && Accounting.isPremiumUser()) {
        Accounting.logout();
    }
}

})();

(function() {

'use strict';
angular.module('NowApp')
    .factory('NowTranslation', NowTranslation)
    .config(['$translateProvider', config]);

config.$inject = ['$translateProvider'];


var defaultTranslations = {
    DIALOGS_ERROR: "Fehler",
    DIALOGS_ERROR_MSG: "An unknown error has occurred.",
    DIALOGS_CLOSE: "Close",
    DIALOGS_PLEASE_WAIT: "Bitte warten",
    DIALOGS_PLEASE_WAIT_ELIPS: "Bitte warten...",
    DIALOGS_PLEASE_WAIT_MSG: "Bitte warten bis Prozess beendet ist",
    DIALOGS_PERCENT_COMPLETE: "% fertig",
    DIALOGS_NOTIFICATION: "Hinweis",
    DIALOGS_NOTIFICATION_MSG: "Unbekannter Hinweis.",
    DIALOGS_CONFIRMATION: "Bestätgigen",
    DIALOGS_CONFIRMATION_MSG: "Bitte bestätigen:",
    DIALOGS_OK: "OK",
    DIALOGS_YES: "Ja",
    DIALOGS_NO: "Nein"
};

function config($translateProvider) {

    $translateProvider.useLoader('NowTranslation').fallbackLanguage('nowtv');
    $translateProvider.preferredLanguage('nowtv');
    $translateProvider.useSanitizeValueStrategy(null);
}

NowTranslation.$inject = ['NowApi'];

function NowTranslation(NowApi) {
    return function (options) {
        return NowApi.getLocalizations()
            .retrieveRegionsByStationAndCountry({
                    station: (options.key === "nowtv" || options.key === "tvnow") ? 'none' : options.key,
                    country: 'DE'
                }
            )
            .then(
                function (data) {
                    return angular.merge({}, defaultTranslations, data.translations)
                },
                function () {
                    return options.key;
                }
            );
    };
}

})();

(function() {



})();

(function() {

'use strict';
angular.module('NowApp').config(run);

run.$inject = ['$cookiesProvider'];

function run($cookiesProvider) {
    $cookiesProvider.defaults.domain = "tvnow.de";

}

})();

(function() {

/* eslint angular/window-service: 0 */
'use strict';

angular.module('NowApp').factory('ErrorHttpInterceptor', ErrorHttpInterceptor);

ErrorHttpInterceptor.$inject = ['$q', '$window', 'AppConfig', '$localStorage', '$sessionStorage'];

function ErrorHttpInterceptor($q, $window, AppConfig, $localStorage, $sessionStorage) {
    return {
        response: function (response) {
            return response;
        },
        responseError: function (response) {
            if (response.status === 503) {
                $window.location.href = '/wartung.html';
            } else if (response.status === 401 && AppConfig.mode !== 'edit') {
                $localStorage.$reset();
                $sessionStorage.$reset();
                $window.location.href = '/?autologout=true';
            }
            return $q.reject(response);
        }
    };
}

angular.module('NowApp').config(errorinterceptor);
errorinterceptor.$inject = ['$httpProvider'];
function errorinterceptor($httpProvider) {
    $httpProvider.interceptors.push('ErrorHttpInterceptor');
}


})();

(function() {

/* eslint angular/window-service: 0 */
'use strict';
angular.module('NowApp').config(run);

run.$inject = ['$logProvider'];

function run($logProvider) {
    if (window.location.hostname.match(/staging\./i) || window.location.hostname.match(/local\./i) || window.location.hostname.match(/abnahme\./i)) {
        $logProvider.debugEnabled(true);
    } else {
        $logProvider.debugEnabled(false);
    }
}

})();

(function() {

/* eslint angular/window-service: 0 */
'use strict';
angular.module('NowApp').config(run);

run.$inject = ['$compileProvider'];

function run($compileProvider) {

    if (window.location.hostname.match(/staging\./i) || window.location.hostname.match(/local\./i) || window.location.hostname === "localhost") {
        $compileProvider.debugInfoEnabled(true);
    } else {
        $compileProvider.debugInfoEnabled(false);
    }
}

})();

(function() {

'use strict';
angular.module('NowApp').config(run);

run.$inject = ['$locationProvider'];

function run($locationProvider) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
}

})();

(function() {




})();